
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iT5dz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ServiceDeskSlaSettingsPage", () => $3970cfcbb4e5480b$export$47a681980ac80b10);
$parcel$export(module.exports, "default", () => $3970cfcbb4e5480b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $frZnw = parcelRequire("frZnw");

var $2RidI = parcelRequire("2RidI");

var $6M8Uw = parcelRequire("6M8Uw");

var $3A1jw = parcelRequire("3A1jw");
const $3970cfcbb4e5480b$export$47a681980ac80b10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RidI.default), {
        appName: (0, $frZnw.APP_NAMES).SLA_SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3A1jw.ServiceDeskSlaSettingsView), null))));
var $3970cfcbb4e5480b$export$2e2bcd8739ae039 = $3970cfcbb4e5480b$export$47a681980ac80b10;

});
parcelRegister("2RidI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3141fb0b4d3f9503$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $iVSJI = parcelRequire("iVSJI");

var $frZnw = parcelRequire("frZnw");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $1IzB8 = parcelRequire("1IzB8");
const $3141fb0b4d3f9503$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IzB8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $frZnw.toPackageName)(appName),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, children))));
var $3141fb0b4d3f9503$export$2e2bcd8739ae039 = $3141fb0b4d3f9503$var$ServiceDeskAppBase;

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("1IzB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $edeca50de0b85084$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");


var $bsgfb = parcelRequire("bsgfb");

var $1fuiA = parcelRequire("1fuiA");
const $edeca50de0b85084$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $10fdS.useCurrentRoute)().path.includes(`${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const Gate = isSettingsRoute ? (0, $1fuiA.default) : (0, $bsgfb.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Gate, null, children);
};
var $edeca50de0b85084$export$2e2bcd8739ae039 = $edeca50de0b85084$var$AccessCheck;

});
const $2df94debed157361$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';

parcelRegister("bsgfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d02215a42a3332$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fz8wa = parcelRequire("fz8wa");

var $lB25E = parcelRequire("lB25E");

var $11C4f = parcelRequire("11C4f");
const $a7d02215a42a3332$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $fz8wa.useApplicationPermissions)();
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11C4f.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira"
    });
};
var $a7d02215a42a3332$export$2e2bcd8739ae039 = $a7d02215a42a3332$var$ProductAccessCheck;

});
parcelRegister("11C4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2544b3bfea70255$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $jyTef = parcelRequire("jyTef");


var $6tW8V = parcelRequire("6tW8V");
const $a2544b3bfea70255$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $lB25E.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $jyTef.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $6tW8V.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: `${(0, $2df94debed157361$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $a2544b3bfea70255$export$2e2bcd8739ae039 = $a2544b3bfea70255$var$AgentCheck;

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});

parcelRegister("6tW8V", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $5107715f0b974007$export$ddaebe4928e793cb);

const $5107715f0b974007$var$RESTRICTED_ACCESS_CODES = [
    (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
    (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef),
    (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)
];
const $5107715f0b974007$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $5107715f0b974007$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;




parcelRegister("1fuiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0788b3e6146363c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Ba2b = parcelRequire("2Ba2b");

var $jyTef = parcelRequire("jyTef");

var $6tW8V = parcelRequire("6tW8V");
const $0788b3e6146363c4$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $jyTef.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $6tW8V.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return null;
};
var $0788b3e6146363c4$export$2e2bcd8739ae039 = $0788b3e6146363c4$var$SettingsAccessCheck;

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});





parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("3A1jw", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskSlaSettingsView", () => $abc0dd7cf10fa2f8$export$49be6ea7669b5ea3);

var $eUqFw = parcelRequire("eUqFw");

var $4NwGu = parcelRequire("4NwGu");

var $2d7Sj = parcelRequire("2d7Sj");

var $51Ia6 = parcelRequire("51Ia6");

var $ifUq1 = parcelRequire("ifUq1");
const $abc0dd7cf10fa2f8$export$49be6ea7669b5ea3 = ()=>{
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const { projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName } = projectContext || {};
    return(// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: "",
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "sla"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4NwGu.SlaSettingsApp), null)));
};

});
parcelRegister("4NwGu", function(module, exports) {

$parcel$export(module.exports, "SlaSettingsApp", () => $9f6d7319a5fb1994$export$9f3f26afaef13537);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $be3PE = parcelRequire("be3PE");

var $2Ba2b = parcelRequire("2Ba2b");

var $iJHZm = parcelRequire("iJHZm");

var $4nnPJ = parcelRequire("4nnPJ");

var $jwvob = parcelRequire("jwvob");

var $3dV2M = parcelRequire("3dV2M");
const $9f6d7319a5fb1994$export$9f3f26afaef13537 = ()=>{
    const [{ loading: loading, error: error, data: data }] = (0, $jwvob.useMetricResource)();
    if (error) {
        (0, $4nnPJ.GlobalPageLoadExperience).failure({
            force: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    }
    if (loading === true || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "jsdSlaSettings",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dV2M.SlaSettingsAppMain), {
        source: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null));
};

});
parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("jwvob", function(module, exports) {

$parcel$export(module.exports, "useMetricResource", () => $6ea845c4ecd3de65$export$1b89a292c73104b);

var $g2JMk = parcelRequire("g2JMk");

var $lB25E = parcelRequire("lB25E");
const $6ea845c4ecd3de65$export$1b89a292c73104b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $lB25E.useResource)((0, $g2JMk.slaMetricsDataResource));
    return [
        {
            data: data,
            loading: loading,
            error: error
        },
        {
            refresh: refresh,
            update: update
        }
    ];
};

});

parcelRegister("3dV2M", function(module, exports) {

$parcel$export(module.exports, "SlaSettingsAppMain", () => $c7f14055ae93e44a$export$7213ebfcdf9e5845);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $5yh8X = parcelRequire("5yh8X");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $be3PE = parcelRequire("be3PE");

var $51Ia6 = parcelRequire("51Ia6");

var $jyTef = parcelRequire("jyTef");

var $6vO9v = parcelRequire("6vO9v");

var $60L6K = parcelRequire("60L6K");

var $hIjKU = parcelRequire("hIjKU");

var $c4rDP = parcelRequire("c4rDP");

var $lNJ2n = parcelRequire("lNJ2n");

var $7sqns = parcelRequire("7sqns");

var $x4bpI = parcelRequire("x4bpI");

var $8SQGz = parcelRequire("8SQGz");

var $7Dl2q = parcelRequire("7Dl2q");

var $63Joe = parcelRequire("63Joe");

var $ZK4eF = parcelRequire("ZK4eF");
const $c7f14055ae93e44a$var$fetchHierarchicalGoalsEnabledPerServiceDeskIds = ()=>(0, $1ybV0.getFeatureFlagValue)('jsm-sla-enable-hierarchical-goals-per-service-desk', {
        enabledServiceDeskIds: []
    });
const $c7f14055ae93e44a$export$4ffba16e6b0d1e5d = ({ intl: { formatMessage: formatMessage }, source: source })=>{
    const { metrics: metrics, canManageFields: canManageFields } = (0, $eUqFw.useMemo)(()=>(0, $60L6K.transformToState)(source, formatMessage), [
        formatMessage,
        source
    ]);
    const [isCalendarModalOpen, onToggleCalendarModal] = (0, $NqqMP.usePopupController)();
    const [{ metricMode: metricMode }, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const onAdd = (0, $eUqFw.useCallback)(()=>{
        updatePath(null, (0, $6vO9v.NEW_MODE));
    }, [
        updatePath
    ]);
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    const [{ data: serviceDeskContext }] = (0, $jyTef.useServiceDeskContext)();
    const { serviceDeskId: serviceDeskId } = serviceDeskContext || {};
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const { projectId: projectId } = pageContextData?.projectContext || {};
    const { enabledServiceDeskIds: slaHierarchicalGoalsEnabledServiceDeskIds = [] } = $c7f14055ae93e44a$var$fetchHierarchicalGoalsEnabledPerServiceDeskIds();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }, { updateSLAHierarchicalGoalsEnabledFF: updateSLAHierarchicalGoalsEnabledFF }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    // If the enabledServiceDeskIds list has first entry as -1,
    // -> It implies that the SLA Hierarchical goals is enabled for all projects.
    // If the enabledServiceDeskIds list has multiple Ids,
    // -> We need to see if the current projectId is present in the list.
    // [-1] => Enable for all Service desks
    // [2, 3] => Enable for only 2 & 3
    // [-1, 2, 3] => Ignore -1 & enable for 2 & 3
    // [] => no projects are enabled with Hierarchical goals.
    if (slaHierarchicalGoalsEnabledServiceDeskIds.length > 0 && (slaHierarchicalGoalsEnabledServiceDeskIds.length === 1 && slaHierarchicalGoalsEnabledServiceDeskIds[0] === -1 || // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.ts(2345)
    slaHierarchicalGoalsEnabledServiceDeskIds.includes(serviceDeskId))) updateSLAHierarchicalGoalsEnabledFF(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [_, { fetchPriorities: fetchPriorities }] = (0, $7sqns.useFetchPrioritiesService)();
    (0, $eUqFw.useEffect)(()=>{
        fetchPriorities(baseUrl, projectId, formatMessage);
    }, [
        fetchPriorities,
        baseUrl,
        projectId,
        formatMessage
    ]);
    const [, actions] = (0, $c4rDP.useGoalCounter)();
    (0, $eUqFw.useEffect)(()=>{
        const calculateTotalNumberOfGoalsInProject = ()=>{
            let goalCount = 0;
            let subGoalCount = 0;
            Object.keys(metrics).forEach((key)=>{
                const { goals: goals } = metrics[key].config;
                goalCount += Object.keys(goals).length;
                Object.values(goals).forEach((goal)=>{
                    if (goal.subGoals) subGoalCount += goal.subGoals.length;
                });
            });
            actions.setGoalCounter(goalCount - Object.keys(metrics).length);
            return {
                goalCount: goalCount,
                subGoalCount: subGoalCount
            };
        };
        const { goalCount: goalCount, subGoalCount: subGoalCount } = calculateTotalNumberOfGoalsInProject();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaSettingsPage viewed', {
            slaCount: Object.keys(metrics).length,
            totalGoalCount: goalCount,
            totalSubGoalCount: subGoalCount
        });
    }, [
        createAnalyticsEvent,
        metrics,
        actions,
        metricMode
    ]);
    if (!source) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    if (Object.keys(metrics).length > 0 || metricMode === (0, $6vO9v.NEW_MODE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "sla-settings-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Dl2q.Header), {
        showActions: true,
        onToggleCalendarPopup: onToggleCalendarModal,
        showBanner: isSLAHierarchicalGoalsEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $63Joe.MetricList), {
        metrics: metrics,
        canManageFields: canManageFields
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZK4eF.CalendarModalWithTwoTabs), {
        isCalendarModalOpen: isCalendarModalOpen,
        onToggleCalendarModal: onToggleCalendarModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), {
        metricKey: (0, $6vO9v.METRICS_PAGE_ID),
        withMarks: [
            (0, $5yh8X.appBundleReadyMark)
        ],
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $x4bpI.slaConfigurationPageLoad)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Dl2q.Header), {
        showActions: false,
        onToggleCalendarPopup: onToggleCalendarModal,
        showBanner: isSLAHierarchicalGoalsEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SQGz.default), {
        onAdd: onAdd
    }));
};
const $c7f14055ae93e44a$export$7213ebfcdf9e5845 = (0, $giAhk.injectIntlV2)($c7f14055ae93e44a$export$4ffba16e6b0d1e5d);

});
parcelRegister("7d1RI", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $7c0a5b8b9305ec46$export$682ebac4d54e1a69);

var $51Ia6 = parcelRequire("51Ia6");

var $6vrw7 = parcelRequire("6vrw7");
const $7c0a5b8b9305ec46$export$682ebac4d54e1a69 = (usePageContext = (0, $51Ia6.usePageContext))=>{
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { baseUrl: baseUrl, locale: locale } = tenantContext || {};
    return {
        baseUrl: baseUrl !== undefined ? (0, $6vrw7.toBaseUrl)(baseUrl) : baseUrl,
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $6vrw7.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $6vrw7.toProjectId)(projectId.toString()) : projectId,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});


parcelRegister("NqqMP", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $fa19abd3eff42ee5$export$55fb67b4e2c495d8);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");
const $fa19abd3eff42ee5$var$usePopupControllerV1 = (defaultState = false)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultState);
    const togglePopup = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const closePopup = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};
/** convenience boolean hook for controlling @atlaskit/popup
 * https://atlassian.design/components/popup/
 */ const $fa19abd3eff42ee5$var$usePopupControllerV2 = (defaultState = false)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultState);
    const togglePopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((pendingIsOpen)=>!pendingIsOpen);
    }, [
        setIsOpen
    ]);
    const closePopup = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};
const $fa19abd3eff42ee5$export$55fb67b4e2c495d8 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('jsw_nav4_new_sprint_controls_in_boards_blu-3256'), $fa19abd3eff42ee5$var$usePopupControllerV2, $fa19abd3eff42ee5$var$usePopupControllerV1);

});

parcelRegister("6vO9v", function(module, exports) {

$parcel$export(module.exports, "VIEW_MODE", () => $47976c77ed301efa$export$858ccfeb21c48320);
$parcel$export(module.exports, "EDIT_MODE", () => $47976c77ed301efa$export$7925fddf359eacb);
$parcel$export(module.exports, "NEW_MODE", () => $47976c77ed301efa$export$44966d0424f02fe5);
$parcel$export(module.exports, "COLLAPSED_MODE", () => $47976c77ed301efa$export$47c60a5726d4f09f);
$parcel$export(module.exports, "COPY_MODE", () => $47976c77ed301efa$export$a0626f62df6ba734);
$parcel$export(module.exports, "CLONE_MODE", () => $47976c77ed301efa$export$7f65ec8773b8eef0);
$parcel$export(module.exports, "OTHER_PROJECT_CALENDARS_EDIT_MODE", () => $47976c77ed301efa$export$7502814c58c7b6da);
$parcel$export(module.exports, "MINUTE", () => $47976c77ed301efa$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $47976c77ed301efa$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "MAX_GOAL_HOUR", () => $47976c77ed301efa$export$cb43db7ad0047c9c);
$parcel$export(module.exports, "INVALID_FORMAT", () => $47976c77ed301efa$export$27943ab2929841e7);
$parcel$export(module.exports, "METRICS_PAGE_ID", () => $47976c77ed301efa$export$5721fd5d6ba543ca);
const $47976c77ed301efa$export$858ccfeb21c48320 = 'view';
const $47976c77ed301efa$export$7925fddf359eacb = 'edit';
const $47976c77ed301efa$export$44966d0424f02fe5 = 'new';
const $47976c77ed301efa$export$47c60a5726d4f09f = 'collapsed';
const $47976c77ed301efa$export$a0626f62df6ba734 = 'copy'; // copy mode is when copying calendars from other projects
const $47976c77ed301efa$export$7f65ec8773b8eef0 = 'clone'; // clone mode is when copying calendars from the current project
const $47976c77ed301efa$export$7502814c58c7b6da = 'other_project_calendars_edit_mode'; // edit mode for other project calendars
const $47976c77ed301efa$export$f4aba04677f37907 = 60000; // 1 minute in milliseconds
const $47976c77ed301efa$export$1bf939ebcf31ef0e = 60 * $47976c77ed301efa$export$f4aba04677f37907;
const $47976c77ed301efa$export$cb43db7ad0047c9c = 10000 * $47976c77ed301efa$export$1bf939ebcf31ef0e;
const $47976c77ed301efa$export$27943ab2929841e7 = 'INVALID_FORMAT';
const $47976c77ed301efa$export$5721fd5d6ba543ca = 'servicedesk.sla.list';
const $47976c77ed301efa$export$7fc61fdf6a87c2a8 = 'Asia/Kolkata';

});

parcelRegister("60L6K", function(module, exports) {

$parcel$export(module.exports, "transformToState", () => $96d0b065baff45e0$export$8cb32b57a7b5c89a);


var $6TYc5 = parcelRequire("6TYc5");
const $96d0b065baff45e0$export$8cb32b57a7b5c89a = (data, formatMessage)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    const calendars = data.calendarRefs;
    data.timeMetrics.forEach((metric)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const goals = {};
        metric.config.goals.forEach((goal)=>{
            const { id: id, duration: duration, subGoals: subGoals = [], ...values } = goal;
            const calendar = calendars.find(({ id: calId })=>calId === (goal.calendarId ?? -1));
            const transformedSubGoals = subGoals.map((subGoal)=>{
                const subGoalCalendar = calendars.find(({ id: calId })=>calId === (subGoal.calendarId ?? -1));
                return {
                    ...subGoal,
                    calendarName: subGoalCalendar?.name,
                    calendarId: subGoalCalendar?.id,
                    duration: (0, $6TYc5.durationToHumanReadable)(subGoal.duration, formatMessage)
                };
            });
            goals[id] = {
                ...values,
                metricId: metric.id,
                duration: (0, $6TYc5.durationToHumanReadable)(duration, formatMessage),
                calendarName: calendar?.name,
                subGoals: transformedSubGoals
            };
        });
        const slaDisplayFormat = metric.config.slaDisplayFormat ?? (0, $feae9f437bfca243$export$13ecaaf97b049384);
        const config = {
            definition: metric.config.definition,
            goals: goals,
            slaDisplayFormat: slaDisplayFormat
        };
        metrics[metric.id] = {
            name: metric.name,
            config: config
        };
    });
    return {
        canManageFields: data.canManageFields,
        calendarRefs: data.calendarRefs,
        metrics: metrics
    };
};

});
const $feae9f437bfca243$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $feae9f437bfca243$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("6TYc5", function(module, exports) {

$parcel$export(module.exports, "durationToMilliseconds", () => $8139bb440a628718$export$1d689b82373d532e);
$parcel$export(module.exports, "durationToHumanReadable", () => $8139bb440a628718$export$4749c3b3f9722bea);

var $8blac = parcelRequire("8blac");

var $3fphB = parcelRequire("3fphB");

var $ldoFd = parcelRequire("ldoFd");

var $6vO9v = parcelRequire("6vO9v");

var $lCrVL = parcelRequire("lCrVL");
const $8139bb440a628718$var$escapeRegex = (rawString)=>rawString.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
const $8139bb440a628718$var$durationWithTextRegex = (hourSymbol, minuteSymbol)=>new RegExp(`^\\s*((\\d+)?\\s*${hourSymbol})?\\s*((\\d+)?\\s*(${minuteSymbol})?)?\\s*$`, 'i');
const $8139bb440a628718$var$durationWithColonsRegex = new RegExp('^\\s*(\\d+)?\\s*:?\\s*(\\d+)?\\s*$', 'i');
const $8139bb440a628718$var$parseDurationInt = (durationText)=>durationText !== undefined ? parseInt(durationText, 10) : 0;
const $8139bb440a628718$var$getValueFromTimeGoalExpression = (inputValue, formatMessage)=>{
    let result;
    const hourSymbol = $8139bb440a628718$var$escapeRegex(formatMessage((0, $lCrVL.default).durationInHours, {
        duration: ''
    }).trim().toLowerCase());
    const minuteSymbol = $8139bb440a628718$var$escapeRegex(formatMessage((0, $lCrVL.default).durationInMinutes, {
        duration: ''
    }).trim().toLowerCase());
    let matches = $8139bb440a628718$var$durationWithColonsRegex.exec(inputValue);
    let hours;
    let minutes;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(matches)) {
        const { '1': h, '2': m } = matches;
        hours = h;
        minutes = m;
    } else {
        matches = $8139bb440a628718$var$durationWithTextRegex(hourSymbol, minuteSymbol).exec(inputValue);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(matches)) {
            const { '2': h, '4': m } = matches;
            hours = h;
            minutes = m;
        }
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(hours) || !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(minutes)) {
        result = ($8139bb440a628718$var$parseDurationInt(hours) * 60 + Math.round($8139bb440a628718$var$parseDurationInt(minutes))) * 60000;
        return result;
    }
    return undefined;
};
const $8139bb440a628718$export$1d689b82373d532e = (inputValue, formatMessage)=>{
    let ms;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(inputValue)) {
        // check duration value whether is a valid number
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(Number(inputValue))) {
            const goalValue = parseFloat(inputValue);
            const hours = Math.floor(goalValue);
            let mins = goalValue - hours;
            mins = Math.round(mins * 60);
            ms = (hours * 60 + mins) * 60000;
        } else ms = $8139bb440a628718$var$getValueFromTimeGoalExpression(inputValue.toLowerCase(), formatMessage);
    }
    return ms;
};
const $8139bb440a628718$export$4749c3b3f9722bea = (timeGoalValueInMs, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
formatMessage)=>{
    if (!((0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(timeGoalValueInMs) && timeGoalValueInMs !== 0)) return '';
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const hours = Math.floor(timeGoalValueInMs / (0, $6vO9v.HOUR));
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const minutes = timeGoalValueInMs % (0, $6vO9v.HOUR) / (0, $6vO9v.MINUTE);
    const formatted = [];
    if (hours > 0) formatted.push(formatMessage((0, $lCrVL.default).durationInHours, {
        duration: hours
    }));
    if (minutes > 0) formatted.push(formatMessage((0, $lCrVL.default).durationInMinutes, {
        duration: minutes
    }));
    return formatted.join(' ');
};

});
parcelRegister("3fphB", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $25d6627b2429993c$var$nativeIsFinite = $c1MCs.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $25d6627b2429993c$var$isFinite(value) {
    return typeof value == 'number' && $25d6627b2429993c$var$nativeIsFinite(value);
}
module.exports = $25d6627b2429993c$var$isFinite;

});

parcelRegister("lCrVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5aa0bf0ff320f1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5e5aa0bf0ff320f1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    durationInHours: {
        "id": "servicedesk-sla-settings.common.utils.duration.duration-in-hours",
        "defaultMessage": "{duration}h"
    },
    durationInMinutes: {
        "id": "servicedesk-sla-settings.common.utils.duration.duration-in-minutes",
        "defaultMessage": "{duration}m"
    }
});

});



parcelRegister("hIjKU", function(module, exports) {

$parcel$export(module.exports, "useSLAHierarchicalGoalsEnabled", () => $2cb7b7fdf9b5f9e0$export$b977b35fcb826d30);

var $WBLbN = parcelRequire("WBLbN");
const $2cb7b7fdf9b5f9e0$var$store = (0, $WBLbN.createStore)({
    initialState: {
        isSLAHierarchicalGoalsEnabled: false,
        isPriorityNameChanged: {},
        prioritiesSelected: {}
    },
    actions: {
        updateSLAHierarchicalGoalsEnabledFF: (value)=>async ({ setState: setState })=>{
                setState({
                    isSLAHierarchicalGoalsEnabled: value
                });
            },
        updateIsPriorityNameChanged: (metricId, goalId, value)=>async ({ setState: setState, getState: getState })=>{
                const { isPriorityNameChanged: isPriorityNameChanged } = getState();
                // @ts-expect-error TS-7053
                const isPriorityChangedForMetricId = isPriorityNameChanged?.[metricId] || {};
                if (value && !isPriorityChangedForMetricId?.[goalId]) setState({
                    isPriorityNameChanged: {
                        ...isPriorityNameChanged,
                        [metricId]: {
                            ...isPriorityChangedForMetricId,
                            [goalId]: value
                        }
                    }
                });
            },
        updatePrioritiesConsumed: (metricId, goalId, value = [])=>({ setState: setState, getState: getState })=>{
                const { prioritiesSelected: prioritiesSelected } = getState();
                setState({
                    prioritiesSelected: {
                        ...prioritiesSelected,
                        [metricId]: {
                            // @ts-expect-error - TS7053
                            ...prioritiesSelected[metricId],
                            [goalId]: [
                                ...value
                            ]
                        }
                    }
                });
            }
    }
});
const $2cb7b7fdf9b5f9e0$export$b977b35fcb826d30 = (0, $WBLbN.createHook)($2cb7b7fdf9b5f9e0$var$store);

});

parcelRegister("c4rDP", function(module, exports) {

$parcel$export(module.exports, "useGoalCounter", () => $c3066a22ae206197$export$776a93c19ac82168);

var $WBLbN = parcelRequire("WBLbN");
const $c3066a22ae206197$export$c71e62940611a973 = (0, $WBLbN.createStore)({
    initialState: {
        goalsCount: 0,
        yellowFlagForGoalCount: false,
        redFlagForGoalCount: false,
        shouldFocusOnAddSlaButton: false
    },
    actions: {
        incrementGoalCounter: (goalCount)=>({ setState: setState, getState: getState })=>{
                setState({
                    goalsCount: getState().goalsCount + goalCount
                });
            },
        setGoalCounter: (goalCount)=>({ setState: setState })=>{
                setState({
                    goalsCount: goalCount
                });
            },
        resetGoalCounter: ()=>({ setState: setState })=>{
                setState({
                    goalsCount: 0
                });
            },
        decrementGoalCounter: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    goalsCount: getState().goalsCount - 1
                });
            },
        setYellowFlagGoalCounter: (currentState)=>({ setState: setState })=>{
                setState({
                    yellowFlagForGoalCount: currentState
                });
            },
        setRedFlagForGoalCount: (currentState)=>({ setState: setState })=>{
                setState({
                    redFlagForGoalCount: currentState
                });
            },
        setShouldFocusOnAddSlaButton: (currentState)=>({ setState: setState })=>{
                setState({
                    shouldFocusOnAddSlaButton: currentState
                });
            }
    }
});
const $c3066a22ae206197$export$776a93c19ac82168 = (0, $WBLbN.createHook)($c3066a22ae206197$export$c71e62940611a973);

});

parcelRegister("lNJ2n", function(module, exports) {

$parcel$export(module.exports, "useMetricActions", () => $5b8bb593d06b1917$export$db16c7e166f529fe);

var $7d1RI = parcelRequire("7d1RI");

var $lB25E = parcelRequire("lB25E");

var $6vO9v = parcelRequire("6vO9v");

var $dXthl = parcelRequire("dXthl");
const $5b8bb593d06b1917$export$db16c7e166f529fe = ()=>{
    const [{ match: { params: params, params: { id: selectedMetricId } } }, { push: push, replace: replace }] = (0, $lB25E.useRouter)();
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    // @ts-expect-error - TS2322 - Type '"collapsed"' is not assignable to type 'Mode'.
    let metricMode = (0, $6vO9v.COLLAPSED_MODE);
    if (params['0'] === (0, $6vO9v.NEW_MODE)) metricMode = (0, $6vO9v.NEW_MODE);
    if (selectedMetricId != null) metricMode = (0, $6vO9v.VIEW_MODE);
    if (params['1'] === (0, $6vO9v.EDIT_MODE)) metricMode = (0, $6vO9v.EDIT_MODE);
    const updatePath = (metricId, mode)=>{
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        const url = (0, $dXthl.getSlaPath)(baseUrl, projectKey, metricId, mode);
        push(url);
    };
    const replacePath = ()=>{
        // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        const url = (0, $dXthl.getSlaPath)(baseUrl, projectKey);
        replace(url);
    };
    return [
        {
            selectedMetricId: selectedMetricId,
            metricMode: metricMode
        },
        {
            updatePath: updatePath,
            replacePath: replacePath
        }
    ];
};

});
parcelRegister("dXthl", function(module, exports) {

$parcel$export(module.exports, "getSlaPath", () => $84a64f3849990339$export$45d0e8c919129dc);
$parcel$export(module.exports, "getValidationErrorMessage", () => $84a64f3849990339$export$7ab04d4c9584557d);

var $7byHA = parcelRequire("7byHA");

var $fV97Z = parcelRequire("fV97Z");

var $6vO9v = parcelRequire("6vO9v");
const $84a64f3849990339$export$45d0e8c919129dc = (baseUrl, projectKey, metricId = null, mode = (0, $6vO9v.VIEW_MODE))=>{
    let url = `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/sla`;
    if (metricId != null) url += `/custom/${metricId}`;
    if (mode === (0, $6vO9v.EDIT_MODE)) url += `/${0, $6vO9v.EDIT_MODE}`;
    if (mode === (0, $6vO9v.NEW_MODE)) url += `/${0, $6vO9v.NEW_MODE}`;
    return url;
};
const $84a64f3849990339$export$7ab04d4c9584557d = (error)=>{
    if (error instanceof (0, $7byHA.ValidationError) && error.errors.length > 0) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const validationError = error.errors[0].error;
        return validationError.errorMessage || null;
    }
    if (error instanceof (0, $fV97Z.JsdFetchError)) return error.message;
    return null;
};

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7byHA.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});



parcelRegister("7sqns", function(module, exports) {

$parcel$export(module.exports, "useFetchPrioritiesService", () => $d09a2540b7b20fe6$export$bd1346126e635fc4);

var $WBLbN = parcelRequire("WBLbN");

var $6zLzG = parcelRequire("6zLzG");

var $8M99H = parcelRequire("8M99H");
const $d09a2540b7b20fe6$var$store = (0, $WBLbN.createStore)({
    initialState: {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        values: [],
        loading: false,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        error: null
    },
    actions: {
        fetchPriorities: (baseUrl, projectId, formatMessage)=>async ({ setState: setState })=>{
                setState({
                    loading: true
                });
                try {
                    const rawResponse = await fetch((0, $8M99H.getUrl)(baseUrl, projectId));
                    const textResponse = await rawResponse.text();
                    const data = textResponse ? JSON.parse(textResponse) : null;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const options = data.values.map((value)=>({
                            label: value.name,
                            value: value.name,
                            icon: value.iconUrl
                        }));
                    const optionsWithNone = [
                        ...options,
                        {
                            label: formatMessage((0, $6zLzG.default).none),
                            value: 'EMPTY',
                            icon: ''
                        }
                    ];
                    setState({
                        values: optionsWithNone
                    });
                } catch (e) {
                    setState({
                        error: e
                    });
                } finally{
                    setState({
                        loading: false
                    });
                }
            }
    },
    name: 'Priorities'
});
const $d09a2540b7b20fe6$export$bd1346126e635fc4 = (0, $WBLbN.createHook)($d09a2540b7b20fe6$var$store);

});
parcelRegister("6zLzG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d7a2b851c3d0ce1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d7a2b851c3d0ce1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "servicedesk-sla-settings.services.fetch-priorities.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("8M99H", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $d5fa1110c02a6d67$export$94df0e59ebebf4a7);
const $d5fa1110c02a6d67$export$94df0e59ebebf4a7 = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/priority/search?projectId=${projectId}&operation=fetchPrioritiesPerProject`;

});


parcelRegister("x4bpI", function(module, exports) {

$parcel$export(module.exports, "slaConfigurationPageLoad", () => $8754342a4175303e$export$fc2d65f4647727f9);

var $lNfG4 = parcelRequire("lNfG4");
const $8754342a4175303e$export$fc2d65f4647727f9 = (0, $lNfG4.metrics).pageLoad({
    key: 'service-management.sla.list'
});

});

parcelRegister("8SQGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $855c7f082094eb0b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $eI5EY = parcelRequire("eI5EY");

var $kMPFn = parcelRequire("kMPFn");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r3ei = parcelRequire("4r3ei");

var $5M925 = parcelRequire("5M925");
const $855c7f082094eb0b$var$MAX_IMAGE_SIZE = 600;
const $855c7f082094eb0b$var$MAX_IMAGE_WIDTH = 202;
const $855c7f082094eb0b$var$MAX_IMAGE_HEIGHT = 246;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$855c7f082094eb0b$export$2e2bcd8739ae039 = ({ onAdd: onAdd })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $eI5EY.fg)('consolidate_bumblebee_jfe_assets')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: "",
        size: "wide",
        maxImageWidth: $855c7f082094eb0b$var$MAX_IMAGE_WIDTH,
        maxImageHeight: $855c7f082094eb0b$var$MAX_IMAGE_HEIGHT,
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $kMPFn.default)),
        isLoading: false,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            isDisabled: false,
            onClick: onAdd,
            testId: "servicedesk-sla-settings.ui.empty-view.add-sla"
        }, formatMessage((0, $5M925.default).addSla))
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: "",
        size: "wide",
        maxImageWidth: $855c7f082094eb0b$var$MAX_IMAGE_SIZE,
        maxImageHeight: $855c7f082094eb0b$var$MAX_IMAGE_SIZE,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4r3ei))),
        isLoading: false,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            isDisabled: false,
            onClick: onAdd,
            testId: "servicedesk-sla-settings.ui.empty-view.add-sla"
        }, formatMessage((0, $5M925.default).addSla))
    }));
};

});
parcelRegister("kMPFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48d079c6b20bb5b$export$2e2bcd8739ae039);
/* eslint-disable import/no-duplicates */ /* eslint-disable jira/import/no-duplicates */ 
var $9TZf5 = parcelRequire("9TZf5");

var $d2YtD = parcelRequire("d2YtD");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $e48d079c6b20bb5b$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($d2YtD)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($d2YtD))
});
var $e48d079c6b20bb5b$export$2e2bcd8739ae039 = $e48d079c6b20bb5b$var$Illustration;
// for advanced use only
const $e48d079c6b20bb5b$export$a179c88182cb9d56 = [
    0,
    0,
    202,
    246
];

});
parcelRegister("d2YtD", function(module, exports) {
module.exports = new URL("empty-no-clock.09305c72.svg", import.meta.url).toString();

});


parcelRegister("4r3ei", function(module, exports) {
module.exports = new URL("sla-empty-background.5e924dae.svg", import.meta.url).toString();

});

parcelRegister("5M925", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdfdec59c2b9637b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fdfdec59c2b9637b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addSla: {
        "id": "servicedesk-sla-settings.empty-view.add-sla",
        "defaultMessage": "Add SLA"
    }
});

});


parcelRegister("7Dl2q", function(module, exports) {

$parcel$export(module.exports, "Header", () => $5cf43d87fd485bf9$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $kMHOY = parcelRequire("kMHOY");

var $3a8wJ = parcelRequire("3a8wJ");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $6vO9v = parcelRequire("6vO9v");

var $flFqI = parcelRequire("flFqI");

var $c4rDP = parcelRequire("c4rDP");

var $lNJ2n = parcelRequire("lNJ2n");

var $e6vZR = parcelRequire("e6vZR");

var $81Na8 = parcelRequire("81Na8");

var $2yEFZ = parcelRequire("2yEFZ");
const $5cf43d87fd485bf9$var$LEARN_MORE_ABOUT_IMPROVED_SLAS = 'https://support.atlassian.com/jira-service-management-cloud/docs/use-priority-to-group-slas-early-access-feature/';
const $5cf43d87fd485bf9$var$headerActions = ({ onNewMetrickClick: onNewMetrickClick, formatMessage: formatMessage, onToggleCalendarPopup: onToggleCalendarPopup, ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        onClick: onNewMetrickClick,
        testId: "servicedesk-sla-settings.ui.header.add-new-sla"
    }, formatMessage((0, $2yEFZ.default).addNewSla)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onToggleCalendarPopup,
        testId: "servicedesk-sla-settings.ui.header.calendar",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            label: formatMessage((0, $2yEFZ.default).calendarSelection)
        })
    }));
const $5cf43d87fd485bf9$export$5be6d1e4b3a88225 = ({ intl: { formatMessage: formatMessage }, onToggleCalendarPopup: onToggleCalendarPopup, showActions: showActions, showBanner: showBanner })=>{
    const [, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const handleNewMetricClick = (e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'newSla');
        updatePath(null, (0, $6vO9v.NEW_MODE));
    };
    const onClickLearnAboutImprovedSLAs = ()=>{
        window.open($5cf43d87fd485bf9$var$LEARN_MORE_ABOUT_IMPROVED_SLAS, '_blank');
    };
    const addSlaButtonRef = (0, $eUqFw.useRef)(null);
    const [{ shouldFocusOnAddSlaButton: isFocus }, actions] = (0, $c4rDP.useGoalCounter)();
    (0, $eUqFw.useEffect)(()=>{
        if (isFocus) {
            addSlaButtonRef?.current?.focus();
            actions.setShouldFocusOnAddSlaButton(false);
        }
    }, [
        actions,
        isFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        actions: showActions && $5cf43d87fd485bf9$var$headerActions({
            ref: addSlaButtonRef,
            onNewMetrickClick: handleNewMetricClick,
            formatMessage: formatMessage,
            onToggleCalendarPopup: onToggleCalendarPopup
        })
    }, formatMessage((0, $2yEFZ.default).slaTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.ExplanationContainer), null, formatMessage((0, $2yEFZ.default).slaDescriptionJsm)), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e6vZR.AwarenessBannerForHierarchicalGoals), {
        formatMessage: formatMessage,
        onClickLearnAboutImprovedSLAs: onClickLearnAboutImprovedSLAs
    }), showActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81Na8.Goal), null));
};
const $5cf43d87fd485bf9$export$8b251419efc915eb = (0, $giAhk.injectIntlV2)($5cf43d87fd485bf9$export$5be6d1e4b3a88225);

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("flFqI", function(module, exports) {

$parcel$export(module.exports, "ExplanationContainer", () => $413ce56dd38f207e$export$bf296cafc65900a9);
$parcel$export(module.exports, "tableColumnNew", () => $413ce56dd38f207e$export$fa316c7b201874e5);
$parcel$export(module.exports, "Header", () => $413ce56dd38f207e$export$8b251419efc915eb);
$parcel$export(module.exports, "Row", () => $413ce56dd38f207e$export$b59bdbef9ce70de2);
$parcel$export(module.exports, "DayColumn", () => $413ce56dd38f207e$export$1213300ca74857e3);
$parcel$export(module.exports, "Column", () => $413ce56dd38f207e$export$816b5d811295e6bc);
$parcel$export(module.exports, "Grid", () => $413ce56dd38f207e$export$ef2184bd89960b14);
$parcel$export(module.exports, "ReusableSlaCalendarTooltipStyles", () => $413ce56dd38f207e$export$3ba8b40eda73331f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4pEpX = parcelRequire("4pEpX");
const $413ce56dd38f207e$export$bf296cafc65900a9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$fa316c7b201874e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invisible: invisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1bto1l2s",
            __cmplp.invisible ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$1213300ca74857e3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_i0dldh1d _1p1d1dk0",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$816b5d811295e6bc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$c7fec3461ace37ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4pEpX.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bpi _2rko1b66 _syaz15cr _vchh18uv _19bv12x7 _u5f312x7 _ca0qv77o _4t3i1ejb _18u01ejb",
            __cmplp.className
        ])
    });
});
const $413ce56dd38f207e$export$3ba8b40eda73331f = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($413ce56dd38f207e$export$c7fec3461ace37ea, {
        ...props,
        ref: ref
    }));

});

parcelRegister("e6vZR", function(module, exports) {

$parcel$export(module.exports, "AwarenessBannerForHierarchicalGoals", () => $4ed5f423b11215b3$export$ef90529f374dbff2);

var $eUqFw = parcelRequire("eUqFw");

var $l2ZYW = parcelRequire("l2ZYW");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");


var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $51Ia6 = parcelRequire("51Ia6");

var $dWLk9 = parcelRequire("dWLk9");

var $8WGQx = parcelRequire("8WGQx");
const $4ed5f423b11215b3$export$ef90529f374dbff2 = ({ formatMessage: formatMessage, onClickLearnAboutImprovedSLAs: onClickLearnAboutImprovedSLAs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const { projectId: projectId } = pageContextData?.projectContext || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $8WGQx.default).sectionMessageTitle),
        appearance: "discovery",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l2ZYW))), {
                label: "",
                primaryColor: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$export$b48405b95304b5a1)})`
            }),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: "updatedLearnMoreAboutImprovedSLAs",
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                        actionSubject: 'link',
                        actionSubjectId: 'learnMoreAboutHierarchicalGoalLinkClick',
                        action: 'clicked'
                    }), 'learnMoreAboutHierarchicalGoalLinkClick', {
                        tenantId: cloudId,
                        projectId: projectId
                    });
                    onClickLearnAboutImprovedSLAs();
                }
            }, formatMessage((0, $8WGQx.default).learnMoreAboutImprovedSla))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8WGQx.default).sectionMessageDescription)));
};

});
parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});


parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("8WGQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6835dacb1a8103f1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6835dacb1a8103f1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sectionMessageTitle: {
        "id": "servicedesk-sla-settings.header.awareness-banner.section-message-title",
        "defaultMessage": "This service project has improved SLAs"
    },
    sectionMessageDescription: {
        "id": "servicedesk-sla-settings.header.awareness-banner.section-message-description",
        "defaultMessage": "Improved SLAs allows you to add many priority-based time targets to a single goal. You can now reconfigure your SLAs based around priority to increase your overall SLA goal capacity."
    },
    learnMoreAboutImprovedSla: {
        "id": "servicedesk-sla-settings.header.awareness-banner.learn-more-about-improved-sla",
        "defaultMessage": "Learn how to configure SLAs by priority"
    }
});

});


parcelRegister("81Na8", function(module, exports) {

$parcel$export(module.exports, "Goal", () => $944e065e28f9fb7b$export$462e530a9b3886e4);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $giAhk = parcelRequire("giAhk");

var $53c4R = parcelRequire("53c4R");

var $c4rDP = parcelRequire("c4rDP");

var $5n7TZ = parcelRequire("5n7TZ");
const $944e065e28f9fb7b$export$272a51540d0cba61 = ({ intl: { formatMessage: formatMessage, formatNumber: formatNumber } })=>{
    const [{ goalsCount: allGoals }, actions] = (0, $c4rDP.useGoalCounter)();
    const safeLimitForNumberOfGoals = 0.75;
    const [maxGoalsPerSD, setMaxGoalsPerSD] = (0, $eUqFw.useState)((0, $53c4R.LIMIT_DEFAULTS)[0, $53c4R.MAX_SLA_GOALS_PER_SD]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        async function fetchMaxGoalsPerSD() {
            setIsLoading(true);
            await (0, $53c4R.getLimit)((0, $53c4R.MAX_SLA_GOALS_PER_SD)).then((limit)=>{
                setMaxGoalsPerSD(limit || (0, $53c4R.LIMIT_DEFAULTS)[0, $53c4R.MAX_SLA_GOALS_PER_SD]);
            }).catch(()=>{
                setMaxGoalsPerSD((0, $53c4R.LIMIT_DEFAULTS)[0, $53c4R.MAX_SLA_GOALS_PER_SD]);
            });
            setIsLoading(false);
        }
        fetchMaxGoalsPerSD();
    }, []);
    const SAFE_LIMIT_FOR_NUMBER_OF_GOALS = Math.floor(safeLimitForNumberOfGoals * maxGoalsPerSD);
    const textForGoalCounter = `${formatNumber(allGoals)} ${formatMessage((0, $5n7TZ.default).goalCounterTextDesc)} ${formatNumber(maxGoalsPerSD)}`;
    let goalCounterColor = 'blueLight';
    if (allGoals < SAFE_LIMIT_FOR_NUMBER_OF_GOALS) {
        goalCounterColor = 'blueLight';
        actions.setYellowFlagGoalCounter(false);
        actions.setRedFlagForGoalCount(false);
    } else if (allGoals >= SAFE_LIMIT_FOR_NUMBER_OF_GOALS && allGoals < maxGoalsPerSD) {
        goalCounterColor = 'yellowLight';
        actions.setYellowFlagGoalCounter(true);
        actions.setRedFlagForGoalCount(false);
    } else {
        goalCounterColor = 'redLight';
        actions.setYellowFlagGoalCounter(false);
        actions.setRedFlagForGoalCount(true);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h5", null, formatMessage((0, $5n7TZ.default).goalCounterText), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: textForGoalCounter,
        color: goalCounterColor
    })));
};
const $944e065e28f9fb7b$export$462e530a9b3886e4 = (0, $giAhk.injectIntlV2)($944e065e28f9fb7b$export$272a51540d0cba61);

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTagComponent);
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = $02a667cb3800fd5a$var$SimpleTag;

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
function $98c5a9f7a5ded4f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $jFsza.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$i6wnX.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$baseStyles : $98c5a9f7a5ded4f8$var$baseStylesOld,
            isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $98c5a9f7a5ded4f8$var$focusRingStyles : $98c5a9f7a5ded4f8$var$focusRingStylesOld),
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? isLink && $98c5a9f7a5ded4f8$var$interactiveStyles : undefined,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && isInteractive && $98c5a9f7a5ded4f8$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.borderColor]: $i6wnX.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $fc0da2a7c84ba49c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$73a5c9d720aa66e1$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$73a5c9d720aa66e1$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$73a5c9d720aa66e1$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$73a5c9d720aa66e1$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$73a5c9d720aa66e1$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$73a5c9d720aa66e1$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$73a5c9d720aa66e1$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$73a5c9d720aa66e1$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$73a5c9d720aa66e1$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$73a5c9d720aa66e1$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$73a5c9d720aa66e1$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$73a5c9d720aa66e1$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$73a5c9d720aa66e1$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$73a5c9d720aa66e1$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$73a5c9d720aa66e1$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$73a5c9d720aa66e1$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$73a5c9d720aa66e1$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$73a5c9d720aa66e1$export$8754fc7e6d8b3000})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$73a5c9d720aa66e1$export$4b84fd0e2c617bd})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$2837b5a1a71d5c02})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $70eddb948b5989f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70eddb948b5989f5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $70eddb948b5989f5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $XHGTv.fg)('platform-component-visual-refresh') ? $70eddb948b5989f5$var$beforeElementStyles : $70eddb948b5989f5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $jFsza = parcelRequire("jFsza");
function $154b7edc63fec879$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $154b7edc63fec879$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$linkStyles : $154b7edc63fec879$var$linkStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$baseStyles : $154b7edc63fec879$var$baseStylesOld,
            !(0, $XHGTv.fg)('platform-component-visual-refresh') && elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && (0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStyles : undefined,
            isRemovable && !(0, $XHGTv.fg)('platform-component-visual-refresh') ? $154b7edc63fec879$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("53c4R", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $d0467ae3b0b1cf99$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $d0467ae3b0b1cf99$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $d0467ae3b0b1cf99$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $d0467ae3b0b1cf99$export$cb3888a8c43147d2);
$parcel$export(module.exports, "MAX_NUM_TEAM_PRIORITY_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$801a603585fb94d8);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $d0467ae3b0b1cf99$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $d0467ae3b0b1cf99$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $d0467ae3b0b1cf99$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $d0467ae3b0b1cf99$export$c5d8aa8a650e690f);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $d0467ae3b0b1cf99$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $d0467ae3b0b1cf99$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $d0467ae3b0b1cf99$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $d0467ae3b0b1cf99$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $d0467ae3b0b1cf99$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $d0467ae3b0b1cf99$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $d0467ae3b0b1cf99$export$5ed1d2ac050e39d = {
    [$d0467ae3b0b1cf99$export$dca2c2105b681490]: 30,
    [$d0467ae3b0b1cf99$export$a48ac34d39e0fc22]: 30,
    [$d0467ae3b0b1cf99$export$2e0ba662d5bb7742]: 300,
    [$d0467ae3b0b1cf99$export$eb69982aa3a172b4]: 30,
    [$d0467ae3b0b1cf99$export$cb3888a8c43147d2]: 20,
    [$d0467ae3b0b1cf99$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d0467ae3b0b1cf99$var$limitCache = {};
const $d0467ae3b0b1cf99$export$c419786abd6faaad = (limitProperty)=>{
    delete $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
const $d0467ae3b0b1cf99$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$d0467ae3b0b1cf99$var$limitCache[limitProperty]) $d0467ae3b0b1cf99$var$limitCache[limitProperty] = (0, $2OdyW.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $d0467ae3b0b1cf99$export$c419786abd6faaad(limitProperty);
        (0, $gUUjF.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
class $d0467ae3b0b1cf99$export$9989835030ecd317 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $d0467ae3b0b1cf99$export$5ed1d2ac050e39d[limitProperty];
        $d0467ae3b0b1cf99$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args);
        this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $d0467ae3b0b1cf99$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0467ae3b0b1cf99$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});

parcelRegister("5n7TZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0db294deae35966$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e0db294deae35966$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalCounterText: {
        "id": "servicedesk-sla-settings.header.goal-counter.goal-counter-text",
        "defaultMessage": "Goals in this project:"
    },
    goalCounterTextDesc: {
        "id": "servicedesk-sla-settings.header.goal-counter.goal-counter-text-desc",
        "defaultMessage": "of"
    }
});

});


parcelRegister("2yEFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbf90901d7c21ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0fbf90901d7c21ac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    slaTitle: {
        "id": "servicedesk-sla-settings.header.sla-title",
        "defaultMessage": "Service level agreements"
    },
    slaDescriptionJsm: {
        "id": "servicedesk-sla-settings.header.sla-description-jsm",
        "defaultMessage": "Set time goals with Service Level Agreements (SLAs) to help drive better quality of service across your service project team."
    },
    slaListTitle: {
        "id": "servicedesk-sla-settings.header.sla-list-title",
        "defaultMessage": "SLAs in this project:"
    },
    addNewSla: {
        "id": "servicedesk-sla-settings.header.add-new-sla",
        "defaultMessage": "Add SLA"
    },
    calendarSelection: {
        "id": "servicedesk-sla-settings.header.calendar-selection",
        "defaultMessage": "Calendar selection"
    }
});

});


parcelRegister("63Joe", function(module, exports) {

$parcel$export(module.exports, "MetricList", () => $67d51cce402f3379$export$f80cd730a4e87579);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6vO9v = parcelRequire("6vO9v");

var $c4rDP = parcelRequire("c4rDP");

var $lNJ2n = parcelRequire("lNJ2n");

var $aI8HG = parcelRequire("aI8HG");
const $67d51cce402f3379$export$f80cd730a4e87579 = ({ metrics: metrics, canManageFields: canManageFields })=>{
    const isSingleMetricConfiguredForTheProject = Object.keys(metrics).length === 1;
    const [{ selectedMetricId: selectedMetricId, metricMode: metricMode }, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const isInitialSlaPageLoad = (0, $eUqFw.useRef)(true); // This is used to show Metrics in View Mode on SLA page load when only one metric is configured
    const [, actions] = (0, $c4rDP.useGoalCounter)();
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        const calculateTotalNumberOfGoalsInProject = ()=>{
            let goalCount = 0;
            Object.keys(metrics).forEach((key)=>{
                goalCount += Object.keys(metrics[key].config.goals).length;
            });
            actions.setGoalCounter(goalCount - Object.keys(metrics).length);
        };
        updatePath();
        calculateTotalNumberOfGoalsInProject();
        if (metricMode === (0, $6vO9v.NEW_MODE)) actions.setShouldFocusOnAddSlaButton(true);
    }, [
        updatePath,
        metricMode,
        metrics,
        actions
    ]);
    const setIsInitialSlaPageLoadToFalse = ()=>{
        isInitialSlaPageLoad.current = false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aI8HG.NewMetric), {
        metricMode: metricMode,
        onCancel: onCancel,
        canManageFields: canManageFields
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67d51cce402f3379$var$TimeMetricList, null, Object.keys(metrics).reduce((metricList, metricKey)=>{
        const metric = metrics[metricKey];
        metricList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67d51cce402f3379$var$TimeMetricListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aI8HG.MetricWithSummary), {
            key: metricKey,
            metric: metric,
            metrics: metrics,
            canManageFields: canManageFields,
            id: metricKey,
            isSelected: selectedMetricId === metricKey,
            metricMode: metricMode,
            onCancel: onCancel,
            isSingleMetricConfiguredForTheProject: isSingleMetricConfiguredForTheProject,
            isInitialSlaPageLoad: isInitialSlaPageLoad.current,
            setIsInitialSlaPageLoadToFalse: setIsInitialSlaPageLoadToFalse
        })));
        return metricList;
    }, [])));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $67d51cce402f3379$var$TimeMetricList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $67d51cce402f3379$var$TimeMetricListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _16qs1j00 _vchhusvi _19it13y8 _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aI8HG", function(module, exports) {

$parcel$export(module.exports, "MetricWithSummary", () => $c12eee025c3bce3f$export$6dd31f7ba5a9bc53);
$parcel$export(module.exports, "NewMetric", () => $c12eee025c3bce3f$export$68b36efdf655ae5f);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6vO9v = parcelRequire("6vO9v");

var $lNJ2n = parcelRequire("lNJ2n");

var $b2m53 = parcelRequire("b2m53");

var $ffPFL = parcelRequire("ffPFL");

var $74PJd = parcelRequire("74PJd");

var $eEgrB = parcelRequire("eEgrB");
const $c12eee025c3bce3f$export$6dd31f7ba5a9bc53 = ({ id: id, isSelected: isSelected, metric: metric, metrics: metrics, metricMode: metricMode, canManageFields: canManageFields, onCancel: onCancel, isSingleMetricConfiguredForTheProject: isSingleMetricConfiguredForTheProject, isInitialSlaPageLoad: isInitialSlaPageLoad, setIsInitialSlaPageLoadToFalse: setIsInitialSlaPageLoadToFalse })=>{
    const { name: name, config: config } = metric;
    const modeArray = [
        (0, $6vO9v.EDIT_MODE),
        (0, $6vO9v.NEW_MODE)
    ];
    const [, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const pathNotUpdated = (0, $eUqFw.useRef)(true); // When 'updatePath' is called it causes rerenders. This hook is to prevent multiple renders
    // This method updates url to "/custom/{SLA-id}" when one metric is configured for the project and for first time SLA page load
    const updateUrlForSingleMetricInViewMode = ()=>{
        if (isSingleMetricConfiguredForTheProject && isInitialSlaPageLoad && pathNotUpdated.current) {
            pathNotUpdated.current = false;
            updatePath(id);
        }
    };
    const getMode = ()=>{
        let newMode;
        if (!modeArray.includes(metricMode)) {
            if (isSingleMetricConfiguredForTheProject && isInitialSlaPageLoad) newMode = (0, $6vO9v.VIEW_MODE);
            else newMode = isSelected ? metricMode : (0, $6vO9v.COLLAPSED_MODE);
        } else newMode = isSelected ? metricMode : (0, $6vO9v.COLLAPSED_MODE);
        return newMode;
    };
    const mode = getMode();
    switch(mode){
        case 0, $6vO9v.EDIT_MODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b2m53.MetricForm), {
                metric: metric,
                id: id,
                onCancel: onCancel,
                canManageFields: canManageFields,
                isNew: false
            });
        case 0, $6vO9v.VIEW_MODE:
            updateUrlForSingleMetricInViewMode(); // Update the path when it is view mode, one metric is configured for the project and for first time SLA page load
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74PJd.Summary), {
                name: name,
                id: id,
                mode: mode,
                setIsInitialSlaPageLoadToFalse: setIsInitialSlaPageLoadToFalse,
                config: config,
                metrics: metrics
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffPFL.MetricView), {
                metric: metric
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74PJd.Summary), {
                name: name,
                id: id,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Mode'.
                mode: mode,
                setIsInitialSlaPageLoadToFalse: setIsInitialSlaPageLoadToFalse,
                config: config,
                metrics: metrics
            });
    }
};
const $c12eee025c3bce3f$export$68b36efdf655ae5f = ({ metricMode: metricMode, onCancel: onCancel, canManageFields: canManageFields })=>metricMode === (0, $6vO9v.NEW_MODE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c12eee025c3bce3f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b2m53.MetricForm), {
        metric: (0, $eEgrB.newMetric),
        onCancel: onCancel,
        canManageFields: canManageFields,
        isNew: true
    })) : null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c12eee025c3bce3f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _16qs1j00 _vchhusvi _19it13y8 _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b2m53", function(module, exports) {

$parcel$export(module.exports, "MetricForm", () => $e2f3923d8467c400$export$d0c8ca9ececf3571);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");

var $eSHsi = parcelRequire("eSHsi");

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $jlCQ4 = parcelRequire("jlCQ4");

var $53c4R = parcelRequire("53c4R");

var $6vO9v = parcelRequire("6vO9v");

var $cIHvJ = parcelRequire("cIHvJ");

var $1QELq = parcelRequire("1QELq");

var $aqGE9 = parcelRequire("aqGE9");

var $3J0Lj = parcelRequire("3J0Lj");

var $b87di = parcelRequire("b87di");

var $dFULG = parcelRequire("dFULG");

var $if6GW = parcelRequire("if6GW");

var $dXthl = parcelRequire("dXthl");

var $841u6 = parcelRequire("841u6");

var $hIjKU = parcelRequire("hIjKU");

var $iSEfF = parcelRequire("iSEfF");

var $lNJ2n = parcelRequire("lNJ2n");

var $3ftGR = parcelRequire("3ftGR");

var $jdYrL = parcelRequire("jdYrL");

var $fe54E = parcelRequire("fe54E");

var $hlk8R = parcelRequire("hlk8R");

var $j1pOI = parcelRequire("j1pOI");

var $04OGI = parcelRequire("04OGI");

var $kzSsu = parcelRequire("kzSsu");

var $6VPPR = parcelRequire("6VPPR");

var $58B99 = parcelRequire("58B99");

var $4KIV6 = parcelRequire("4KIV6");
const $e2f3923d8467c400$var$MetricFormView = ({ id: id = '', isNew: isNew, metric: // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'Metric': name, config
metric = {}, canManageFields: canManageFields, onCancel: onCancel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const [{ isFormDirty: isFormDirty }] = (0, $iSEfF.useFormContext)();
    const [{ loading: loading, error: error, data: savedMetric }, { update: updateMetric }] = (0, $fe54E.useUpdateMetricService)({
        baseUrl: // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl,
        projectKey: // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
        projectKey
    });
    const [{ updateResourceMetric: updateResourceMetric }] = (0, $58B99.useUpdateMetricResource)();
    const { name: name = '', config: { goals: goals, definition: definition, slaDisplayFormat: slaDisplayFormat } } = metric;
    const { defaultGoals: defaultGoals, draggableGoals: draggableGoals } = (0, $841u6.splitGoals)(goals);
    const { timeMetricSaveSuccessFlag: timeMetricSaveSuccessFlag } = (0, $dFULG.useSLAConfigActionsFlags)();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled, isPriorityNameChanged: isPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    const onSubmit = (0, $eUqFw.useCallback)(async (formValues)=>{
        (0, $3ftGR.jsmSLASaveExperience).start();
        const formPayload = isNew ? (0, $4KIV6.getPayload)(formValues, formatMessage, isSLAHierarchicalGoalsEnabled) : {
            ...(0, $4KIV6.getPayload)(formValues, formatMessage, isSLAHierarchicalGoalsEnabled),
            name: name
        };
        let updatedMetricData;
        try {
            updatedMetricData = await updateMetric(formPayload, id);
        } catch  {
            (0, $3ftGR.jsmSLASaveExperience).failure();
        }
        if (// @ts-expect-error TS1345: An expression of type 'void' cannot be tested for truthiness.
        updatedMetricData && // @ts-expect-error - TS2339 - Property 'config' does not exist on type 'never'.
        updatedMetricData.config.slaDisplayFormat && // @ts-expect-error - TS2339 - Property 'config' does not exist on type 'never'.
        slaDisplayFormat !== updatedMetricData.config.slaDisplayFormat) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmSlaConfiguration slaDisplayFormatChanged', {
            formatChange: [
                slaDisplayFormat,
                // @ts-expect-error - TS2339 - Property 'config' does not exist on type 'never'.
                updatedMetricData.config.slaDisplayFormat
            ].join(' to ')
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(updatedMetricData)) {
            // @ts-expect-error - TS2345 - Argument of type 'void' is not assignable to parameter of type 'TimeMetric'.
            updateResourceMetric(updatedMetricData);
            (0, $3ftGR.jsmSLASaveExperience).success();
            // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'void'.
            updatePath(`${updatedMetricData.id}`);
            const { name: timeMetricName } = formPayload;
            timeMetricSaveSuccessFlag(timeMetricName);
        // Display the success flag after successfully saving the time metric
        }
    }, [
        isNew,
        name,
        id,
        slaDisplayFormat,
        isSLAHierarchicalGoalsEnabled,
        formatMessage,
        updateMetric,
        updateResourceMetric,
        updatePath,
        timeMetricSaveSuccessFlag,
        createAnalyticsEvent
    ]);
    const formRef = (0, $eUqFw.useRef)(null);
    const saveMetricFromBlockerModal = (0, $eUqFw.useCallback)(()=>{
        if (formRef.current !== null) // https://github.com/final-form/react-final-form/blob/master/docs/faq.md#how-can-i-trigger-a-submit-from-outside-my-form
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        formRef.current.dispatchEvent(new Event('submit', {
            cancelable: true
        }));
    }, []);
    const [{ data: costData, error: costError, loading: costLoading }, { fetch: fetchCost }] = // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $jdYrL.useRecalculationCostService)(baseUrl, projectKey);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!costLoading && !costError && !costData) await fetchCost();
        };
        fetchData();
    }, [
        costData,
        costError,
        fetchCost,
        costLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, getValues: getFormValues, dirty: dirty })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f3923d8467c400$export$762240c6611b6ed2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $e2f3923d8467c400$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eSHsi))), {
            LEGACY_size: "large",
            LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
            label: "",
            color: "currentColor"
        })), name, // @ts-expect-error TS-7053
        isPriorityNameChanged?.[id] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $04OGI.default).errorTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
                size: "medium",
                label: formatMessage((0, $04OGI.default).errorTooltip)
            }),
            appearance: "subtle"
        })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            ref: formRef,
            "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.editable.form.metric-form-${id || ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f3923d8467c400$var$MetricFormViewContainer, null, isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzSsu.Name), {
            name: name,
            canManageFields: canManageFields
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqGE9.GoalTitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53c4R.LimitData), {
            limitProperty: (0, $53c4R.MAX_SLA_GOALS_PER_SD)
        }, (maxSlaGoalsLimit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1pOI.Goals), {
                defaultGoals: defaultGoals,
                draggableGoals: draggableGoals,
                maxSlaGoalsLimit: maxSlaGoalsLimit,
                getFormValues: getFormValues,
                metricId: parseInt(id, 10)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIHvJ.ConditionTitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlk8R.Conditions), {
            conditions: definition
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $if6GW.SlaDisplayFormatTitle), {
            mode: (0, $6vO9v.EDIT_MODE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6VPPR.SlaDisplayFormat), {
            slaDisplayFormat: slaDisplayFormat
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3J0Lj.RecalculationWarning), {
            data: costData,
            loading: costLoading,
            error: costError
        }), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            "data-test-id": "servicedesk-sla-settings.ui.metrics.metric.editable.form.error-message"
        }, (0, $dXthl.getValidationErrorMessage)(error) || formatMessage((0, $04OGI.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f3923d8467c400$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b87di.RecalculationWarningInfo), {
            data: costData,
            error: costError,
            loading: costLoading
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QELq.Footer), {
            type: "submit",
            onCancel: onCancel,
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            isLoading: loading
        })))), !savedMetric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlCQ4.default), {
            onSave: saveMetricFromBlockerModal,
            onDiscard: ()=>{},
            isDirty: isFormDirty || dirty
        })));
};
const $e2f3923d8467c400$export$d0c8ca9ececf3571 = (0, $iSEfF.withFormContextProvider)($e2f3923d8467c400$var$MetricFormView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2f3923d8467c400$var$MetricFormViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt44ar7",
            __cmplp.className
        ])
    });
});
const $e2f3923d8467c400$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2f3923d8467c400$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc _1e0c1txw _4cvresu3 _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e2f3923d8467c400$export$762240c6611b6ed2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1wq8 _syazaj1x _1e0c1txw _4cvr1h6o _19bvpxbi _4t3i8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("jlCQ4", function(module, exports) {

$parcel$export(module.exports, "onUnload", () => $8e4a0c0d92d00403$export$44fbe141af2e9b59);
$parcel$export(module.exports, "default", () => $8e4a0c0d92d00403$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $eCmes = parcelRequire("eCmes");

var $lSAth = parcelRequire("lSAth");

var $kTZFI = parcelRequire("kTZFI");
const $8e4a0c0d92d00403$export$44fbe141af2e9b59 = (beforeNavigateCallback)=>{
    window.addEventListener('beforeunload', beforeNavigateCallback);
    return window.removeEventListener.bind(window, 'beforeunload', beforeNavigateCallback);
};
class $8e4a0c0d92d00403$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            prompt: (0, $lSAth.default).promptText,
            withSaveButton: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDiscard: ()=>{}
        };
    }
    render() {
        if (__SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ registerBlock: registerBlock })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTZFI.default), {
                onRegisterBlock: registerBlock,
                onUnload: $8e4a0c0d92d00403$export$44fbe141af2e9b59,
                ...this.props
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTZFI.default), {
            onRegisterLegacyBlock: this.registerLegacyBlock,
            onUnload: $8e4a0c0d92d00403$export$44fbe141af2e9b59,
            onRejectNavigation: this.navigationBridge.rejectNavigation,
            onConfirmNavigation: this.navigationBridge.confirmNavigation,
            ...this.props
        });
    }
    constructor(...args){
        super(...args);
        this.navigationBridge = (0, $eCmes.createMonolithNavigationBridge)();
        this.registerLegacyBlock = (beforeNavigateCallback)=>{
            this.navigationBridge.block(beforeNavigateCallback);
            return ()=>{
                this.navigationBridge.unblock();
                this.navigationBridge.disable();
                // @ts-expect-error - TS2769 - No overload matches this call.
                window.removeEventListener('beforeunload', beforeNavigateCallback);
            };
        };
    }
}

});
parcelRegister("eCmes", function(module, exports) {

$parcel$export(module.exports, "createMonolithNavigationBridge", () => $1a242bdd80eb6d58$export$e8afb3901df5306d);

var $lFVIh = parcelRequire("lFVIh");
class $1a242bdd80eb6d58$export$dfd89a95c7765d38 {
    cleanUpPromiseCallBack() {
        delete this.resolveFn;
        delete this.rejectFn;
    }
    /**
	 * Calling setBeforeNavigateListener is deferred to here, so that we don't go through a state
	 * where setBeforeNavigateListener fails to register the new listener because there is already
	 * a listener from another page that hasn't finished cleaning up yet.
	 * This is because an instance of the old page and the new page will both be active during a
	 * navigation. I.e. we need componentWillUnmount of the old page to call #disable before setting
	 * the new listener.
	 */ block(beforeNavigateCallback) {
        (0, $lFVIh.RouterManager).deleteBeforeNavigateListener();
        (0, $lFVIh.RouterManager).setBeforeNavigateListener(this.onBeforeNavigate);
        this.beforeNavigateCallback = beforeNavigateCallback;
    }
    unblock() {
        this.beforeNavigateCallback = undefined;
    }
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBeforeNavigate = (fragment)=>{
            if (!this.beforeNavigateCallback) return Promise.resolve(null);
            this.promise = new Promise((resolve, reject)=>{
                this.resolveFn = resolve;
                this.rejectFn = reject;
            });
            this.beforeNavigateCallback(fragment);
            return this.promise;
        };
        this.confirmNavigation = ()=>{
            this.resolveFn && this.resolveFn();
            this.cleanUpPromiseCallBack();
        };
        this.rejectNavigation = ()=>{
            this.rejectFn && this.rejectFn();
            this.cleanUpPromiseCallBack();
        };
        this.disable = ()=>{
            (0, $lFVIh.RouterManager).deleteBeforeNavigateListener();
        };
    }
}
const $1a242bdd80eb6d58$export$e8afb3901df5306d = ()=>new $1a242bdd80eb6d58$export$dfd89a95c7765d38();

});
parcelRegister("lFVIh", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(e, t) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" == typeof window && (n = window);
            }
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                }
                function r() {
                    var t = n();
                    !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                }
                function o() {
                    return n().feRouteFn;
                }
                function i() {
                    delete n().feRouteFn, r();
                }
                function u(e) {
                    o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                }
                function a() {
                    return n().beforeNavigateListener;
                }
                function s(e) {
                    a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                }
                function c() {
                    delete n().beforeNavigateListener, r();
                }
                function l(e) {
                    var t = a();
                    return t ? t(e) : Promise.resolve();
                }
                function g() {
                    delete n().willNavigateListener, r();
                }
                function f() {
                    return n().willNavigateListener;
                }
                function d(e) {
                    f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                }
                function y() {
                    var e = f();
                    if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                    e();
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                }
                function r(e, t) {
                    n()[e] = t;
                }
                function o(e, t, n) {
                    return new Promise(function(r, o) {
                        a(e, t, n, i, r, o);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                var i = 20, u = t.renderFeComponent = function(e, t, r) {
                    var o = n()[e];
                    if (o) return o(t, r);
                    throw new Error("FE component not found: '" + String(e) + "'");
                }, a = function e(t, n, r, o, i, a) {
                    try {
                        var s = u(t, n, r);
                        i(s);
                    } catch (u) {
                        o <= 0 ? a(u) : setTimeout(function() {
                            return e(t, n, r, o - 1, i, a);
                        }, 500);
                    }
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            function r(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return t.default = e, t;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
            var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(y);
            t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n(e, t) {
                    var n = e && e.getPage && e.getPage(t);
                    return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                }
                function r() {
                    return e._jsdLegacyAgentPageRegistry;
                }
                function o(t) {
                    e._jsdLegacyAgentPageRegistry = t;
                }
                function i(e) {
                    return n(r(), e);
                }
                function u() {
                    return e._jsdLegacySettingsPageRegistry;
                }
                function a(t) {
                    e._jsdLegacySettingsPageRegistry = t;
                }
                function s(e) {
                    var t = u();
                    return t ? n(t, e) : Promise.reject("Registry does not exist");
                }
                function c() {
                    e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                }
                function r(e) {
                    return n()[e] || [];
                }
                function o(e, t) {
                    var o = n(), i = r(e);
                    i.push(t), o[e] = i;
                }
                function i(e, t) {
                    if (t) {
                        var o = n(), i = r(e);
                        o[e] = i.filter(function(e) {
                            return e !== t;
                        });
                    } else n()[e] = [];
                }
                function u(e, t) {
                    r(e).forEach(function(e) {
                        return e(t);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.on = o, t.off = i, t.trigger = u;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = t.getLegacyModuleRegistry = function() {
                    return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                };
                t.registerLegacyModule = function(e, t) {
                    n()[e] = t;
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function o(t) {
                    var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                    return "/" === u[0] ? u : "/" + u;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function e(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(1), a = n(2), s = function() {
                    function e() {
                        r(this, e);
                    }
                    return i(e, [
                        {
                            key: "enablePage",
                            value: function(e, t) {
                                (0, u.deleteFeRouteFunction)();
                                try {
                                    return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }
                        },
                        {
                            key: "updatePage",
                            value: function(e, t) {
                                var n = (0, u.getFeRouteFunction)();
                                if (t.feComponentId && n) n(o(e));
                                return Promise.resolve();
                            }
                        },
                        {
                            key: "disablePage",
                            value: function() {
                                (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                            }
                        },
                        {
                            key: "beforeNavigate",
                            value: function(e) {
                                return (0, u.onBeforeNavigate)(e);
                            }
                        }
                    ]), e;
                }();
                t.default = s;
            }).call(t, n(0));
        }
    ]);
});

});


parcelRegister("lSAth", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f18525ae94b508$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80f18525ae94b508$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    promptText: {
        "id": "servicedesk.common.navigation.blocker.messages.prompt-text",
        "defaultMessage": "To continue, <b>Save</b> or <b>Discard</b> your changes - or select <b>Cancel</b> to stay on this page."
    }
});

});

parcelRegister("kTZFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ddd0935f135bf66$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Yimi = parcelRequire("1Yimi");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $j82r4 = parcelRequire("j82r4");

var $1VLyL = parcelRequire("1VLyL");
class $0ddd0935f135bf66$var$NavigationPrompt extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onRejectNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onConfirmNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    componentDidMount() {
        this.registerOnUnloadHandler();
        if (__SPA__) this.registerSpaNavigationHandler();
        else this.registerLegacyNavigationHandler();
    }
    componentWillUnmount() {
        this.unregisterBlock && this.unregisterBlock();
        this.unregisterOnUnload && this.unregisterOnUnload();
    }
    registerOnUnloadHandler() {
        const { onUnload: onUnload } = this.props;
        if (!onUnload) return;
        const beforeNavigateCallback = (e)=>{
            if (!this.props.isDirty) return;
            e.preventDefault(); // Firefox
            // Return value is not shown to user but needs to be not null or undefined for the confirm page unload prompt to be shown
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
            e.returnValue = ''; // Chrome
            return ''; // IE
        };
        this.unregisterOnUnload = onUnload(beforeNavigateCallback);
    }
    registerLegacyNavigationHandler() {
        const { onRegisterLegacyBlock: onRegisterLegacyBlock } = this.props;
        if (onRegisterLegacyBlock) this.unregisterBlock = onRegisterLegacyBlock(()=>{
            if (this.props.isDirty) this.setState({
                showPrompt: true
            });
            else this.continueNavigation();
        });
    }
    registerSpaNavigationHandler() {
        const { onRegisterBlock: onRegisterBlock } = this.props;
        if (onRegisterBlock) this.unregisterBlock = onRegisterBlock(()=>{
            if (!this.props.isDirty) return Promise.resolve(true);
            return new Promise((resolve)=>{
                this.setState({
                    showPrompt: true
                });
                this.navigationResolver = resolve;
            });
        });
    }
    render() {
        const { showPrompt: showPrompt } = this.state;
        const { intl: { formatMessage: formatMessage }, prompt: prompt } = this.props;
        if (!showPrompt) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            onClose: this.onClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $1VLyL.default).unsavedChangesModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage(prompt, {
            b: (...parts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, parts)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, this.renderFooter()))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            showPrompt: false
        };
        this.onSave = (_, analyticsEvent)=>{
            if (this.props.fireOnSaveAnalytics) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'save');
            this.setState({
                showPrompt: false
            });
            this.props.onSave(this.continueNavigation, analyticsEvent);
        };
        this.onClose = (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'close');
            this.setState({
                showPrompt: false
            });
            this.navigationResolver && this.navigationResolver(false);
            this.props.onRejectNavigation();
        };
        this.onDiscard = (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'discard');
            this.setState({
                showPrompt: false
            });
            this.continueNavigation(); // To prevent a scenario whereby the user is on new queues, clicks the new queue button
            // and we re-render the new queues page and re-mount the blocker.
            // If we discard too quickly, the blocker remounts and discards again before the re-render.
            setTimeout(()=>this.props.onDiscard());
        };
        this.continueNavigation = ()=>{
            this.unregisterBlock && this.unregisterBlock();
            this.props.onConfirmNavigation();
            this.navigationResolver && this.navigationResolver(true);
        };
        this.renderFooter = ()=>{
            const { intl: { formatMessage: formatMessage }, withSaveButton: withSaveButton } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ddd0935f135bf66$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, withSaveButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: this.onSave
            }, formatMessage((0, $j82r4.default).save)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "subtle-link",
                onClick: this.onDiscard
            }, formatMessage((0, $j82r4.default).discard))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: this.onDiscard
            }, formatMessage((0, $1VLyL.default).leave)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                onClick: this.onClose
            }, formatMessage((0, $j82r4.default).cancel))));
        };
    }
}
var $0ddd0935f135bf66$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($0ddd0935f135bf66$var$NavigationPrompt);
const $0ddd0935f135bf66$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("j82r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37711b0f8f06c32$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f37711b0f8f06c32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    actions: {
        "id": "servicedesk.common.i18n.actions",
        "defaultMessage": "Actions"
    },
    add: {
        "id": "servicedesk.common.i18n.add",
        "defaultMessage": "Add"
    },
    genericErrorTitle: {
        "id": "servicedesk.common.i18n.ran-into-problem",
        "defaultMessage": "We ran into a problem"
    },
    offlineTitle: {
        "id": "servicedesk.common.i18n.offline-title",
        "defaultMessage": "Looks like you\u2019re offline"
    },
    offlineMessage: {
        "id": "servicedesk.common.i18n.offline-message",
        "defaultMessage": "Check your connection and try again"
    },
    automation: {
        "id": "servicedesk.common.i18n.automation",
        "defaultMessage": "Automation"
    },
    answer: {
        "id": "servicedesk.common.i18n.answer",
        "defaultMessage": "Answer"
    },
    cancel: {
        "id": "servicedesk.common.i18n.cancel",
        "defaultMessage": "Cancel"
    },
    close: {
        "id": "servicedesk.common.i18n.close",
        "defaultMessage": "Close"
    },
    configuration: {
        "id": "servicedesk.common.i18n.configuration",
        "defaultMessage": "Configuration"
    },
    continue: {
        "id": "servicedesk.common.i18n.continue",
        "defaultMessage": "Continue"
    },
    create: {
        "id": "servicedesk.common.i18n.create",
        "defaultMessage": "Create"
    },
    date: {
        "id": "servicedesk.common.i18n.date",
        "defaultMessage": "Date"
    },
    delete: {
        "id": "servicedesk.common.i18n.delete",
        "defaultMessage": "Delete"
    },
    disabled: {
        "id": "servicedesk.common.i18n.disabled",
        "defaultMessage": "Disabled"
    },
    discard: {
        "id": "servicedesk.common.i18n.discard",
        "defaultMessage": "Discard"
    },
    duplicate: {
        "id": "servicedesk.common.i18n.duplicate",
        "defaultMessage": "Duplicate"
    },
    edit: {
        "id": "servicedesk.common.i18n.edit",
        "defaultMessage": "Edit"
    },
    error: {
        "id": "servicedesk.common.i18n.error",
        "defaultMessage": "Error"
    },
    executed: {
        "id": "servicedesk.common.i18n.executed",
        "defaultMessage": "Executed"
    },
    issue: {
        "id": "servicedesk.common.i18n.issue",
        "defaultMessage": "Issue"
    },
    next: {
        "id": "servicedesk.common.i18n.next",
        "defaultMessage": "Next"
    },
    notExecuted: {
        "id": "servicedesk.common.i18n.not-executed",
        "defaultMessage": "Not Executed"
    },
    options: {
        "id": "servicedesk.common.i18n.options",
        "defaultMessage": "Options"
    },
    preference: {
        "id": "servicedesk.common.i18n.preference",
        "defaultMessage": "Preference"
    },
    save: {
        "id": "servicedesk.common.i18n.save",
        "defaultMessage": "Save"
    },
    status: {
        "id": "servicedesk.common.i18n.status",
        "defaultMessage": "Status"
    },
    undo: {
        "id": "servicedesk.common.i18n.undo",
        "defaultMessage": "Undo"
    },
    unknown: {
        "id": "servicedesk.common.i18n.unknown",
        "defaultMessage": "Unknown"
    },
    warning: {
        "id": "servicedesk.common.i18n.warning",
        "defaultMessage": "Warning"
    },
    settings: {
        "id": "servicedesk.common.i18n.settings",
        "defaultMessage": "Settings"
    }
});

});

parcelRegister("1VLyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1c329d9092a788$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b1c329d9092a788$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unsavedChangesModalTitle: {
        "id": "servicedesk.common.navigation.blocker.prompt.messages.unsaved-changes-modal-title",
        "defaultMessage": "You have unsaved changes"
    },
    leave: {
        "id": "servicedesk.common.navigation.blocker.prompt.messages.leave",
        "defaultMessage": "Leave"
    }
});

});



parcelRegister("cIHvJ", function(module, exports) {

$parcel$export(module.exports, "ConditionTitle", () => $58477e5755607aa0$export$836e0b6e562e2d31);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $aJqo6 = parcelRequire("aJqo6");
const $58477e5755607aa0$var$ConditionTitleComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $58477e5755607aa0$var$titleStyles
    }, formatMessage((0, $aJqo6.default).conditions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.ExplanationContainer), null, formatMessage((0, $aJqo6.default).timeCondition)));
};
const $58477e5755607aa0$export$836e0b6e562e2d31 = $58477e5755607aa0$var$ConditionTitleComponent;
const $58477e5755607aa0$var$titleStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300'
});

});
parcelRegister("aJqo6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8c5a06ec360054$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cb8c5a06ec360054$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    conditions: {
        "id": "servicedesk-sla-settings.common.conditions.condition-title.conditions",
        "defaultMessage": "Conditions"
    },
    timeCondition: {
        "id": "servicedesk-sla-settings.common.conditions.condition-title.time-condition",
        "defaultMessage": "Time will be measured between the start and stop conditions below."
    }
});

});


parcelRegister("1QELq", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $14977653caff1a2d$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $7CD1S = parcelRequire("7CD1S");

var $giAhk = parcelRequire("giAhk");

var $8VpgE = parcelRequire("8VpgE");
const $14977653caff1a2d$var$FooterView = ({ intl: { formatMessage: formatMessage }, type: type, onCancel: onCancel, onSave: onSave, isLoading: isLoading, isDisabled: isDisabled, isSecondary: isSecondary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.common.ui.footer.cancel-button",
        appearance: isSecondary ? 'subtle-link' : 'default',
        onClick: onCancel
    }, formatMessage((0, $8VpgE.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '"button" | "reset" | "submit" | undefined'.
        type: type,
        appearance: isSecondary ? 'subtle' : 'primary',
        onClick: onSave,
        isLoading: isLoading,
        isDisabled: isDisabled,
        testId: "servicedesk-sla-settings.common.ui.footer.submit-button"
    }, formatMessage((0, $8VpgE.default).save))));
const $14977653caff1a2d$export$a06f1c675e846f6f = (0, $giAhk.injectIntlV2)($14977653caff1a2d$var$FooterView);

});
parcelRegister("7CD1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $564306fc9833a41c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $564306fc9833a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $564306fc9833a41c$var$formFooterWrapperStyles = {
    name: "1rruhyk",
    styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
};
const $564306fc9833a41c$var$justifyContentStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
function $564306fc9833a41c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("footer", {
        css: [
            $564306fc9833a41c$var$formFooterWrapperStyles,
            align === 'start' && $564306fc9833a41c$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("8VpgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e715a944210a7e42$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e715a944210a7e42$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    save: {
        "id": "servicedesk-sla-settings.common.footer.save",
        "defaultMessage": "Save"
    },
    cancel: {
        "id": "servicedesk-sla-settings.common.footer.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("aqGE9", function(module, exports) {

$parcel$export(module.exports, "GoalTitle", () => $fd08cd15c63a1a7f$export$8a43f353894a9517);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $3hpIP = parcelRequire("3hpIP");
const $fd08cd15c63a1a7f$var$GoalTitleComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $3hpIP.default).goals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.ExplanationContainer), null, formatMessage((0, $3hpIP.default).metricInformationTip)));
};
const $fd08cd15c63a1a7f$export$8a43f353894a9517 = $fd08cd15c63a1a7f$var$GoalTitleComponent;

});
parcelRegister("3hpIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6747732012e5f65f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6747732012e5f65f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goals: {
        "id": "servicedesk-sla-settings.common.goals.goal-title.goals",
        "defaultMessage": "Goals"
    },
    metricInformationTip: {
        "id": "servicedesk-sla-settings.common.goals.goal-title.metric-information-tip",
        "defaultMessage": "Issues will be checked against this list, top to bottom, and assigned a time goal based on the first matching JQL statement."
    }
});

});


parcelRegister("3J0Lj", function(module, exports) {

$parcel$export(module.exports, "RecalculationWarning", () => $fe0b599dc44a842c$export$b93a9429b6cff400);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lRvnl = parcelRequire("lRvnl");

var $giAhk = parcelRequire("giAhk");

var $5WpgF = parcelRequire("5WpgF");
const $fe0b599dc44a842c$var$RecalculationWarningView = ({ data: data, loading: loading, error: error, intl: { formatMessage: formatMessage } })=>{
    if (loading || error || !data || data.shouldWarn === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe0b599dc44a842c$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning",
        title: formatMessage((0, $5WpgF.default).reCalculationCostTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $5WpgF.default).reCalculationCostWarningMessageJsm, {
        issueCount: data.requestCount
    }))));
};
const $fe0b599dc44a842c$export$b93a9429b6cff400 = (0, $giAhk.injectIntlV2)($fe0b599dc44a842c$var$RecalculationWarningView);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe0b599dc44a842c$var$Spaced = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8wo40",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5WpgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d00ab0acafa4d84$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2d00ab0acafa4d84$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reCalculationCostTitle: {
        "id": "servicedesk-sla-settings.common.recalculation-warning-message.re-calculation-cost-title",
        "defaultMessage": "SLA edits may take time to take effect"
    },
    reCalculationCostWarningMessageJsm: {
        "id": "servicedesk-sla-settings.common.recalculation-warning-message.re-calculation-cost-warning-message-jsm",
        "defaultMessage": "There are {issueCount} issues in this service project. Recalculating SLAs for this many issues can take a long time (up to a few days sometimes), during which time SLAs and reports may not be accurate."
    }
});

});


parcelRegister("b87di", function(module, exports) {

$parcel$export(module.exports, "RecalculationWarningInfo", () => $6eff0f8773dcab68$export$c90f35255dacfc17);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $uPy40 = parcelRequire("uPy40");

var $3MV1G = parcelRequire("3MV1G");

var $giAhk = parcelRequire("giAhk");

var $icGWt = parcelRequire("icGWt");
const $6eff0f8773dcab68$export$b93a9429b6cff400 = ({ data: data, loading: loading, error: error, intl: { formatMessage: formatMessage } })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    if (!loading && !error && data && data.shouldWarn === true) return null;
    const toggleOpenDialog = ()=>{
        setIsOpen((prev)=>!prev);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6eff0f8773dcab68$export$bcc505e2cad4b0ee, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: toggleOpenDialog,
        placement: "bottom-start",
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6eff0f8773dcab68$var$WarningDialogBox, null, formatMessage((0, $icGWt.default).reCalculationCostWarningInfoMessage)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                ...triggerProps,
                onClick: toggleOpenDialog,
                spacing: "none",
                appearance: "subtle-link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6eff0f8773dcab68$var$IconMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($uPy40))), {
                LEGACY_primaryColor: "N200",
                label: "",
                color: "currentColor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6eff0f8773dcab68$export$faadb9d3691bb990, null, formatMessage((0, $icGWt.default).reCalculationCostLabel))))
    }));
};
const $6eff0f8773dcab68$export$c90f35255dacfc17 = (0, $giAhk.injectIntlV2)($6eff0f8773dcab68$export$b93a9429b6cff400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6eff0f8773dcab68$var$WarningDialogBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fvle5 _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6eff0f8773dcab68$var$IconMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6eff0f8773dcab68$export$bcc505e2cad4b0ee = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $6eff0f8773dcab68$export$faadb9d3691bb990 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("uPy40", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e9b091e24458ded7dee3b5ff897b055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05cac9e5e766232d$var$_react = $05cac9e5e766232d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05cac9e5e766232d$var$_UNSAFE_baseNew = $05cac9e5e766232d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $05cac9e5e766232d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05cac9e5e766232d$var$InformationIcon = (props)=>/*#__PURE__*/ $05cac9e5e766232d$var$_react.default.createElement($05cac9e5e766232d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$05cac9e5e766232d$var$InformationIcon.displayName = 'InformationIcon';
var $05cac9e5e766232d$var$_default = module.exports.default = $05cac9e5e766232d$var$InformationIcon;

});

parcelRegister("icGWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b952a9201bf8a981$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b952a9201bf8a981$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reCalculationCostLabel: {
        "id": "servicedesk-sla-settings.common.recalculation-warning-message.recalculation-warning-info.re-calculation-cost-label",
        "defaultMessage": "SLA edits can take time to effect"
    },
    reCalculationCostWarningInfoMessage: {
        "id": "servicedesk-sla-settings.common.recalculation-warning-message.recalculation-warning-info.re-calculation-cost-warning-info-message",
        "defaultMessage": "The SLA for each related issue needs recalculation. During this time, SLAs and reports may not be accurate."
    }
});

});


parcelRegister("dFULG", function(module, exports) {

$parcel$export(module.exports, "useSLAConfigActionsFlags", () => $ac8093ab6f4647b9$export$f9667de9f4021b16);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $pasM2 = parcelRequire("pasM2");
const $ac8093ab6f4647b9$export$f9667de9f4021b16 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const calendarSaveSuccessFlag = (0, $eUqFw.useCallback)((calendarName, isNewCalendar)=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const flagTitle = isNewCalendar ? (0, $pasM2.default).createCalendarSuccessTitle : (0, $pasM2.default).editCalendarSuccessTitle;
        const description = isNewCalendar ? [
            (0, $pasM2.default).createCalendarSuccessDescription,
            {
                calendarName: calendarName
            }
        ] : [
            (0, $pasM2.default).editCalendarSuccessDescription,
            {
                calendarName: calendarName
            }
        ];
        showFlag({
            id: flagId,
            type: 'success',
            title: flagTitle,
            description: // @ts-expect-error - TS2322 - Type '(MessageDescriptorV2 | { calendarName: string; })[]' is not assignable to type 'FlagMessage | undefined'.
            description,
            testId: `calendar-save-success-flag-${calendarName}`,
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarSaveFailedFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'warning',
            title: (0, $pasM2.default).calendarSaveFailedTitle,
            description: (0, $pasM2.default).calendarSaveFailedDescription,
            testId: 'calendar-save-failure-flag',
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarImportPartialFailureFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'warning',
            title: (0, $pasM2.default).calendarImportPartialFailureTitle,
            description: (0, $pasM2.default).calendarImportPartialFailureDescription,
            testId: 'calendar-import-partial-failure-flag',
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarImportParserFailureFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'error',
            title: (0, $pasM2.default).calendarImportParserFailureTitle,
            description: (0, $pasM2.default).calendarImportParserFailureDescription,
            testId: 'calendar-import-parser-failure-flag',
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarImportParserServerFailureFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'error',
            title: (0, $pasM2.default).calendarImportParserServerFailureTitle,
            description: (0, $pasM2.default).calendarImportParserServerFailureDescription,
            testId: 'calendar-import-parser-server-failure-flag',
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarImportSuccessFlag = (0, $eUqFw.useCallback)(()=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'success',
            title: (0, $pasM2.default).calendarImportSuccessTitle,
            description: (0, $pasM2.default).calendarImportSuccessDescription,
            testId: 'calendar-import-success-flag',
            actions: [
                {
                    content: (0, $pasM2.default).calendarDismissWithGotIt,
                    onClick: ()=>dismissFlag(flagId)
                }
            ]
        });
    }, [
        dismissFlag,
        showFlag
    ]);
    const calendarDeleteSuccessFlag = (0, $eUqFw.useCallback)((calendarName)=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        showFlag({
            id: flagId,
            type: 'success',
            title: (0, $pasM2.default).deleteCalendarSuccessTitle,
            description: [
                (0, $pasM2.default).deleteCalendarSuccessDescription,
                {
                    calendarName: calendarName
                }
            ],
            testId: 'calendar-delete-success-flag'
        });
    }, [
        showFlag
    ]);
    const timeMetricSaveSuccessFlag = (0, $eUqFw.useCallback)((timeMetricName)=>{
        const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const flagTitle = [
            (0, $pasM2.default).timeMetricSaveSuccessTitle,
            {
                timeMetricName: timeMetricName
            }
        ];
        showFlag({
            id: flagId,
            type: 'success',
            // @ts-expect-error - TS2322 - Type '(MessageDescriptorV2 | { timeMetricName: string; })[]' is not assignable to type 'FlagMessage'.
            title: flagTitle,
            testId: `time-metric-save-success-flag-${timeMetricName}`
        });
    }, [
        showFlag
    ]);
    return {
        calendarImportPartialFailureFlag: calendarImportPartialFailureFlag,
        calendarImportParserFailureFlag: calendarImportParserFailureFlag,
        calendarImportParserServerFailureFlag: calendarImportParserServerFailureFlag,
        calendarImportSuccessFlag: calendarImportSuccessFlag,
        calendarSaveSuccessFlag: calendarSaveSuccessFlag,
        calendarSaveFailedFlag: calendarSaveFailedFlag,
        calendarDeleteSuccessFlag: calendarDeleteSuccessFlag,
        timeMetricSaveSuccessFlag: timeMetricSaveSuccessFlag
    };
};

});
parcelRegister("pasM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7ae43a37e8663c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cb7ae43a37e8663c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createCalendarSuccessTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.create-calendar-success-title",
        "defaultMessage": "Calendar created!"
    },
    editCalendarSuccessTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.edit-calendar-success-title",
        "defaultMessage": "Calendar edited!"
    },
    createCalendarSuccessDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.create-calendar-success-description",
        "defaultMessage": "Calendar \"{calendarName}\" created successfully!"
    },
    editCalendarSuccessDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.edit-calendar-success-description",
        "defaultMessage": "Calendar \"{calendarName}\" edited successfully!"
    },
    calendarSaveFailedTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-save-failed-title",
        "defaultMessage": "We are unable to save the calendar"
    },
    calendarSaveFailedDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-save-failed-description",
        "defaultMessage": "Try again later"
    },
    calendarImportPartialFailureTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-partial-failure-title",
        "defaultMessage": "Some of your holidays didn\u2019t import"
    },
    calendarImportPartialFailureDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-partial-failure-description",
        "defaultMessage": "Check which holidays are missing and add them in manually."
    },
    calendarImportParserFailureTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-failure-title",
        "defaultMessage": "We can\u2019t use that file format"
    },
    calendarImportParserFailureDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-failure-description",
        "defaultMessage": "Try importing your holidays using an ICS file."
    },
    calendarImportParserServerFailureTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-server-failure-title",
        "defaultMessage": "We couldn\u2019t import your file"
    },
    calendarImportParserServerFailureDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-server-failure-description",
        "defaultMessage": "Select \u2018Import\u2019 to try uploading your file again."
    },
    calendarImportSuccessTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-success-title",
        "defaultMessage": "Success"
    },
    calendarImportSuccessDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-success-description",
        "defaultMessage": "Your holidays have been imported. "
    },
    calendarDismissWithGotIt: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.calendar-dismiss-with-got-it",
        "defaultMessage": "Got it"
    },
    deleteCalendarSuccessTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.delete-calendar-success-title",
        "defaultMessage": "Calendar deleted!"
    },
    deleteCalendarSuccessDescription: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.delete-calendar-success-description",
        "defaultMessage": "Calendar \"{calendarName}\" deleted successfully!"
    },
    timeMetricSaveSuccessTitle: {
        "id": "servicedesk-sla-settings.common.sla-config-action-flags.time-metric-save-success-title",
        "defaultMessage": "{timeMetricName} saved"
    }
});

});


parcelRegister("if6GW", function(module, exports) {

$parcel$export(module.exports, "SlaDisplayFormatTitle", () => $ff705f9cc6cb8f45$export$57e187cd732c5a4c);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $dEK85 = parcelRequire("dEK85");
const $ff705f9cc6cb8f45$var$SlaDisplayFormatTitleComponent = ({ mode: mode })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $dEK85.default).displayFormatHeader))), mode === 'edit' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.ExplanationContainer), null, formatMessage((0, $dEK85.default).displayFormatHeaderExplaination)));
};
const $ff705f9cc6cb8f45$export$57e187cd732c5a4c = $ff705f9cc6cb8f45$var$SlaDisplayFormatTitleComponent;

});
parcelRegister("dEK85", function(module, exports) {

$parcel$export(module.exports, "default", () => $8af1a6c148f5eaac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8af1a6c148f5eaac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    displayFormatHeader: {
        "id": "servicedesk-sla-settings.common.sla-display-format.sla-display-format-title.display-format-header",
        "defaultMessage": "SLA format display"
    },
    displayFormatHeaderExplaination: {
        "id": "servicedesk-sla-settings.common.sla-display-format.sla-display-format-title.display-format-header-explaination",
        "defaultMessage": "Choose a format for hover states of this SLA to display. The format is effective on both issue and queue view."
    }
});

});


parcelRegister("841u6", function(module, exports) {

$parcel$export(module.exports, "splitGoals", () => $37be934b84657a08$export$9eabe1e693261ed8);
const $37be934b84657a08$export$9eabe1e693261ed8 = (goals)=>Object.keys(goals).reduce((goalList, goalKey)=>{
        const goal = goals[goalKey];
        if (goal.defaultGoal) // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
        goalList.defaultGoals.push({
            id: goalKey,
            ...goal
        });
        else // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'never'.
        goalList.draggableGoals.push({
            id: goalKey,
            ...goal
        });
        return goalList;
    }, {
        defaultGoals: [],
        draggableGoals: []
    });

});

parcelRegister("iSEfF", function(module, exports) {

$parcel$export(module.exports, "withFormContextProvider", () => $da3e51d9369a1e94$export$12f7a0523d638fcb);
$parcel$export(module.exports, "useFormContext", () => $da3e51d9369a1e94$export$4d957a5e1be13b03);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $da3e51d9369a1e94$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)([
    {
        isFormDirty: false,
        showNavBlocker: undefined,
        getNextCalendarActionCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    {
        setFormStatusToDirty: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onRegisterBlock: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setNextCalendarActionCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }
]);
const $da3e51d9369a1e94$export$12f7a0523d638fcb = (FromComponent)=>(props)=>{
        const [isFormDirty, setIsFormDirty] = (0, $eUqFw.useState)(false);
        const [showNavBlocker, setNavBlockerCallback] = (0, $eUqFw.useState)();
        const nextCalendarActionCallback = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))); // This would store the next calendar callback
        // @ts-expect-error - TS7006 - Parameter 'eventToBeRegistered' implicitly has an 'any' type.
        const onRegisterBlock = (0, $eUqFw.useCallback)((eventToBeRegistered)=>{
            setNavBlockerCallback(()=>eventToBeRegistered);
            return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        }, []);
        const setFormStatusToDirty = (0, $eUqFw.useCallback)(()=>{
            setIsFormDirty(true);
        }, []);
        const getNextCalendarActionCallback = (0, $eUqFw.useCallback)(()=>{
            nextCalendarActionCallback.current();
        }, []);
        // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
        const setNextCalendarActionCallback = (0, $eUqFw.useCallback)((callback)=>{
            nextCalendarActionCallback.current = callback;
        }, []);
        const formStatusValue = [
            {
                isFormDirty: isFormDirty,
                showNavBlocker: showNavBlocker,
                getNextCalendarActionCallback: getNextCalendarActionCallback
            },
            {
                setFormStatusToDirty: setFormStatusToDirty,
                onRegisterBlock: onRegisterBlock,
                setNextCalendarActionCallback: setNextCalendarActionCallback
            }
        ];
        return(// @ts-expect-error - TS2322 - Type '({ isFormDirty: boolean; showNavBlocker: unknown; getNextCalendarActionCallback: () => void; setFormStatusToDirty?: undefined; onRegisterBlock?: undefined; setNextCalendarActionCallback?: undefined; } | { ...; })[]' is not assignable to type 'FormContextData'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da3e51d9369a1e94$export$c24727297075ec6a.Provider, {
            value: formStatusValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FromComponent, props)));
    };
const $da3e51d9369a1e94$export$4d957a5e1be13b03 = ()=>(0, $eUqFw.useContext)($da3e51d9369a1e94$export$c24727297075ec6a);

});

parcelRegister("3ftGR", function(module, exports) {

$parcel$export(module.exports, "jsmSLASaveExperience", () => $039cd2adf85ec4a0$export$96f9e2b1254d06ba);
$parcel$export(module.exports, "jsmSLADeleteExperience", () => $039cd2adf85ec4a0$export$81e80c7e6208c4ed);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $039cd2adf85ec4a0$export$96f9e2b1254d06ba = new (0, $kDfSL.UFOExperience)('jsm-sla-save', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $039cd2adf85ec4a0$export$81e80c7e6208c4ed = new (0, $kDfSL.UFOExperience)('jsm-sla-delete', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});

});

parcelRegister("jdYrL", function(module, exports) {

$parcel$export(module.exports, "useRecalculationCostService", () => $37150534c0036563$export$5cdfd341002f6edf);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $gbxpA = parcelRequire("gbxpA");
const $37150534c0036563$export$5cdfd341002f6edf = (baseUrl, projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [data, setData] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $fV97Z.performGetRequest)((0, $gbxpA.getUrl)(baseUrl, projectKey));
            setData(response);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaRecalculationCost fetched');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useRecalculationCostService',
                packageName: 'jiraServicedeskSlaSettings'
            });
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'RecalculationCostServiceData'.
            data
        },
        {
            fetch: fetch
        }
    ];
};

});
parcelRegister("gbxpA", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $b19cd01604d22eb3$export$94df0e59ebebf4a7);
const $b19cd01604d22eb3$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/agent/${projectKey}/sla/recalculation/cost`;

});


parcelRegister("fe54E", function(module, exports) {

$parcel$export(module.exports, "useUpdateMetricService", () => $32cf6f751c88edda$export$1d4779183c5898a);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $30A1f = parcelRequire("30A1f");
const $32cf6f751c88edda$export$1d4779183c5898a = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const update = (0, $eUqFw.useCallback)(async (metric, id)=>{
        setLoading(true);
        setError(null);
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            const metricId = parseInt(id, 10) || undefined;
            const asyncRequestAction = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(metricId) ? (0, $fV97Z.performPostRequest) : (0, $fV97Z.performPutRequest);
            const payloadMetric = metricId ? {
                id: metricId,
                ...metric
            } : metric;
            const response = await asyncRequestAction((0, $30A1f.getUrl)(baseUrl, projectKey, metricId), {
                body: JSON.stringify(payloadMetric)
            });
            const { config: { goals: newGoals, definition: { start: start, stop: stop, pause: pause } } } = response;
            setLoading(false);
            setData(response);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `slaMetric ${(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(metricId) ? 'created' : 'updated'}`, {
                statsPerSLA: {
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(metricId) ? {} : {
                        slaID: metricId
                    },
                    numberOfGoals: newGoals.length,
                    numberOfStartConditions: start.length,
                    numberOfPauseConditions: pause.length,
                    numberOfStopConditions: stop.length
                }
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useUpdateMetricService',
                packageName: 'jiraServicedeskSlaSettings',
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<TimeMetric>'.
            data
        },
        {
            update: update
        }
    ];
};

});
parcelRegister("30A1f", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $f63a6d429ddcb7c7$export$94df0e59ebebf4a7);

var $ldoFd = parcelRequire("ldoFd");
const $f63a6d429ddcb7c7$export$94df0e59ebebf4a7 = (baseUrl, projectKey, metricId)=>{
    const defaultUrl = `${baseUrl}/rest/servicedesk/1/servicedesk/agent/${projectKey}/sla/metrics`;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(metricId)) return `${defaultUrl}/${metricId}?operation=updateMetric`;
    return `${defaultUrl}?operation=createMetric`;
};

});


parcelRegister("hlk8R", function(module, exports) {

$parcel$export(module.exports, "Conditions", () => $4727ff94f6c473b9$export$363c7374d425f4ad);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $7d1RI = parcelRequire("7d1RI");

var $2Ba2b = parcelRequire("2Ba2b");

var $gDsgM = parcelRequire("gDsgM");

var $iW164 = parcelRequire("iW164");

var $26tYd = parcelRequire("26tYd");
const $4727ff94f6c473b9$export$363c7374d425f4ad = ({ conditions: conditions, useCommonPageContext: useCommonPageContext = (0, $7d1RI.useCommonPageContext) })=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = useCommonPageContext();
    const { data: conditionsList, fetch: fetch, loading: loading, error: error } = (0, $iW164.useFetchConditionsService)({
        baseUrl: // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl,
        projectKey: // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
        projectKey
    });
    const { start: start, pause: pause, stop: stop } = conditions;
    (0, $eUqFw.useEffect)(()=>{
        const fetchConditionsList = async ()=>{
            await fetch();
        };
        fetchConditionsList();
    }, [
        fetch
    ]);
    if (loading || !conditionsList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26tYd.ConditionView), {
        selectedConditions: start,
        conditionsList: conditionsList.hitConditions,
        listName: (0, $gDsgM.START_CONDITIONS_FIELD_NAME)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26tYd.ConditionView), {
        selectedConditions: pause,
        conditionsList: conditionsList.matchConditions,
        listName: (0, $gDsgM.PAUSE_CONDITIONS_FIELD_NAME)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26tYd.ConditionView), {
        selectedConditions: stop,
        conditionsList: conditionsList.hitConditions,
        listName: (0, $gDsgM.STOP_CONDITIONS_FIELD_NAME)
    }));
};

});
parcelRegister("gDsgM", function(module, exports) {

$parcel$export(module.exports, "NAME_FIELD", () => $b648a6dc4d4184c8$export$63d111be6bb99e0f);
$parcel$export(module.exports, "DEFAULT", () => $b648a6dc4d4184c8$export$e6952b12ade67489);
$parcel$export(module.exports, "GOAL_FIELD_GROUP", () => $b648a6dc4d4184c8$export$721d3161089172ab);
$parcel$export(module.exports, "READ_ONLY", () => $b648a6dc4d4184c8$export$a45819e0f9bcfea2);
$parcel$export(module.exports, "EDITABLE", () => $b648a6dc4d4184c8$export$bf9ed166e9fe660e);
$parcel$export(module.exports, "CALENDAR_FIELD_NAME", () => $b648a6dc4d4184c8$export$d8d65e94f3ba900c);
$parcel$export(module.exports, "PRIORITY_FIELD_NAME", () => $b648a6dc4d4184c8$export$535e9ee40c234f01);
$parcel$export(module.exports, "DURATION_FIELD_NAME", () => $b648a6dc4d4184c8$export$8519ac0ea22b8a1e);
$parcel$export(module.exports, "JQL_FIELD_NAME", () => $b648a6dc4d4184c8$export$872ae90a9528d505);
$parcel$export(module.exports, "ROW_INDEX_TRACKER", () => $b648a6dc4d4184c8$export$df032e2e42d6ffe2);
$parcel$export(module.exports, "DEFAULT_GOAL_ROW_INDEX_TRACKER", () => $b648a6dc4d4184c8$export$40b0b30610d47ef2);
$parcel$export(module.exports, "VALIDATE_GOAL_FIELD", () => $b648a6dc4d4184c8$export$e383771f2ee4f1da);
$parcel$export(module.exports, "EMPTY_JQL", () => $b648a6dc4d4184c8$export$bcef0833a99cbbf);
$parcel$export(module.exports, "NEW", () => $b648a6dc4d4184c8$export$591d0ec9c2f920ab);
$parcel$export(module.exports, "EXISTING", () => $b648a6dc4d4184c8$export$ebb5566b5b9c2b9a);
$parcel$export(module.exports, "NEW_AND_MODIFIED", () => $b648a6dc4d4184c8$export$99d788153a65797b);
$parcel$export(module.exports, "EXISTING_AND_MODIFIED", () => $b648a6dc4d4184c8$export$791c7732bc8e5ccb);
$parcel$export(module.exports, "RESTING", () => $b648a6dc4d4184c8$export$d41937e4a0d0fbae);
$parcel$export(module.exports, "ABOUT_TO_REACH_MAX", () => $b648a6dc4d4184c8$export$e168f5390a1e6e);
$parcel$export(module.exports, "MAX_REACHED", () => $b648a6dc4d4184c8$export$60a2b4f8fb16362f);
$parcel$export(module.exports, "SHOW_WARNING_THRESHOLD", () => $b648a6dc4d4184c8$export$50044b8ca6663ad3);
$parcel$export(module.exports, "START_CONDITIONS_FIELD_NAME", () => $b648a6dc4d4184c8$export$b066a9680f943438);
$parcel$export(module.exports, "PAUSE_CONDITIONS_FIELD_NAME", () => $b648a6dc4d4184c8$export$bb8dd5919d222dd8);
$parcel$export(module.exports, "STOP_CONDITIONS_FIELD_NAME", () => $b648a6dc4d4184c8$export$225a4ff08a167a07);
$parcel$export(module.exports, "EMPTY", () => $b648a6dc4d4184c8$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID_DATE", () => $b648a6dc4d4184c8$export$3b8cfd9c1b194028);
$parcel$export(module.exports, "EMPTY_TIME", () => $b648a6dc4d4184c8$export$83c09e11dd6d3d08);
$parcel$export(module.exports, "INVALID_TIME_RANGE", () => $b648a6dc4d4184c8$export$25cb0f804ed4ed93);
$parcel$export(module.exports, "CALENDAR_NAME", () => $b648a6dc4d4184c8$export$e07b690b7f98d97);
$parcel$export(module.exports, "TIMEZONE", () => $b648a6dc4d4184c8$export$6f5c75afcb5ad5cc);
$parcel$export(module.exports, "TIME_PICKER_FIELD_PREFIX", () => $b648a6dc4d4184c8$export$367e42dea5a43a7a);
$parcel$export(module.exports, "TIME_PICKER_FIELD_START", () => $b648a6dc4d4184c8$export$ab043337b1991c7b);
$parcel$export(module.exports, "TIME_PICKER_FIELD_END", () => $b648a6dc4d4184c8$export$e0db518e31bc28d1);
$parcel$export(module.exports, "HOLIDAY_PREFIX", () => $b648a6dc4d4184c8$export$526b6bf454f1da97);
$parcel$export(module.exports, "HOLIDAY_NAME_PREFIX", () => $b648a6dc4d4184c8$export$c61fb5ebb0bc4d20);
$parcel$export(module.exports, "HOLIDAY_DATE_PREFIX", () => $b648a6dc4d4184c8$export$9b8ff4a321971e44);
$parcel$export(module.exports, "HOLIDAY_FREQUENCY_PREFIX", () => $b648a6dc4d4184c8$export$8849db9bc87fec01);
$parcel$export(module.exports, "HOLIDAY_VALIDATION_STATE_PREFIX", () => $b648a6dc4d4184c8$export$3640566be27e41ad);
$parcel$export(module.exports, "DAYS_OF_THE_WEEK", () => $b648a6dc4d4184c8$export$212ce225292f5a0b);
$parcel$export(module.exports, "DEFAULT_TIMEZONE", () => $b648a6dc4d4184c8$export$3d6925841111ef4c);
$parcel$export(module.exports, "OnTrackOngoingSlaNewSlaFormat", () => $b648a6dc4d4184c8$export$729b065a26170297);
$parcel$export(module.exports, "OnTrackOngoingSlaOldSlaFormat", () => $b648a6dc4d4184c8$export$e36363b9d80f7adc);
$parcel$export(module.exports, "AtRiskOngoingSlaNewSlaFormat", () => $b648a6dc4d4184c8$export$26c24323bef7eb3);
$parcel$export(module.exports, "AtRiskOngoingSlaOldSlaFormat", () => $b648a6dc4d4184c8$export$233c7c06afe24e99);
$parcel$export(module.exports, "CompletedSlaNewSlaFormat", () => $b648a6dc4d4184c8$export$55329f7677a6f23f);
$parcel$export(module.exports, "CompletedSlaOldSlaFormat", () => $b648a6dc4d4184c8$export$99da56e810295b55);

const $b648a6dc4d4184c8$export$63d111be6bb99e0f = 'name';
const $b648a6dc4d4184c8$export$e6952b12ade67489 = 'default';
const $b648a6dc4d4184c8$export$721d3161089172ab = 'goal-';
const $b648a6dc4d4184c8$export$a45819e0f9bcfea2 = 'read-only-';
const $b648a6dc4d4184c8$export$bf9ed166e9fe660e = 'editable-';
const $b648a6dc4d4184c8$export$d8d65e94f3ba900c = 'calendar-';
const $b648a6dc4d4184c8$export$535e9ee40c234f01 = 'priority-';
const $b648a6dc4d4184c8$export$8519ac0ea22b8a1e = 'duration-';
const $b648a6dc4d4184c8$export$872ae90a9528d505 = 'jql-';
const $b648a6dc4d4184c8$export$df032e2e42d6ffe2 = `${$b648a6dc4d4184c8$export$721d3161089172ab}rowIndex-tracker-`;
const $b648a6dc4d4184c8$export$40b0b30610d47ef2 = `${$b648a6dc4d4184c8$export$721d3161089172ab}non-draggable-rowIndex-tracker-`;
const $b648a6dc4d4184c8$export$e383771f2ee4f1da = 'validate-goal-';
const $b648a6dc4d4184c8$export$bcef0833a99cbbf = 'Empty jql';
const $b648a6dc4d4184c8$export$87f8e09199a0bfde = 'Invalid jql';
const $b648a6dc4d4184c8$export$591d0ec9c2f920ab = 'new';
const $b648a6dc4d4184c8$export$ebb5566b5b9c2b9a = 'existing';
const $b648a6dc4d4184c8$export$99d788153a65797b = 'new-and-modified';
const $b648a6dc4d4184c8$export$791c7732bc8e5ccb = 'existing-and-modified';
const $b648a6dc4d4184c8$export$d41937e4a0d0fbae = 'resting';
const $b648a6dc4d4184c8$export$e168f5390a1e6e = 'about-to-reach-max-goals';
const $b648a6dc4d4184c8$export$60a2b4f8fb16362f = 'max-reached';
const $b648a6dc4d4184c8$export$50044b8ca6663ad3 = 5;
const $b648a6dc4d4184c8$export$b066a9680f943438 = 'start';
const $b648a6dc4d4184c8$export$bb8dd5919d222dd8 = 'pause';
const $b648a6dc4d4184c8$export$225a4ff08a167a07 = 'stop';
const $b648a6dc4d4184c8$export$ccb33e29d92c9a58 = 'Empty';
const $b648a6dc4d4184c8$export$3b8cfd9c1b194028 = 'Invalid Date';
const $b648a6dc4d4184c8$export$83c09e11dd6d3d08 = 'Empty Time';
const $b648a6dc4d4184c8$export$25cb0f804ed4ed93 = 'Invalid Time Range';
const $b648a6dc4d4184c8$export$e07b690b7f98d97 = 'calendarName';
const $b648a6dc4d4184c8$export$6f5c75afcb5ad5cc = 'timezone';
const $b648a6dc4d4184c8$export$367e42dea5a43a7a = 'connected-time-picker-';
const $b648a6dc4d4184c8$export$ab043337b1991c7b = '-start-';
const $b648a6dc4d4184c8$export$e0db518e31bc28d1 = '-end-';
const $b648a6dc4d4184c8$export$526b6bf454f1da97 = 'holiday-field-group-';
const $b648a6dc4d4184c8$export$c61fb5ebb0bc4d20 = 'holiday-name-';
const $b648a6dc4d4184c8$export$9b8ff4a321971e44 = 'holiday-date-';
const $b648a6dc4d4184c8$export$8849db9bc87fec01 = 'holiday-frequency-';
const $b648a6dc4d4184c8$export$3640566be27e41ad = 'holiday-validation-state-';
const $b648a6dc4d4184c8$export$212ce225292f5a0b = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
const $b648a6dc4d4184c8$export$3d6925841111ef4c = 'America/Toronto';
const $b648a6dc4d4184c8$export$729b065a26170297 = {
    isBreached: false,
    timeRemainingInMinutes: 37,
    status: 'ONGOING',
    timeRemainingFriendly: 'Today 04:00 PM',
    metricName: 'Time to Pending',
    goalTime: '60m',
    calendarName: '24/7 Calendar (Default)',
    stopTime: 'Today 4:00 AM',
    previousCycles: [],
    hoverContent: "37m left \u2022 Due: 2022-03-21 04:00PM GMT+0530",
    slaDisplayFormat: 'NEW_SLA_FORMAT',
    breachTime: 1647858600000,
    remainingTimeMillis: '2220000',
    goalTimeMillis: '3600000',
    goalTimeLongFriendly: '60m',
    remainingTimeFriendly: '37m',
    isClosed: false,
    date: 1647858600000
};
const $b648a6dc4d4184c8$export$e36363b9d80f7adc = {
    isBreached: false,
    timeRemainingInMinutes: 300,
    status: 'ONGOING',
    timeRemainingFriendly: '7H 59M',
    metricName: 'Time to Pending',
    goalTime: '600m',
    calendarName: '24/7 Calendar (Default)',
    stopTime: 'Today 4:00 AM',
    previousCycles: [],
    hoverContent: undefined,
    slaDisplayFormat: (0, $feae9f437bfca243$export$aad60a8e044b5914),
    breachTime: 1647858600000,
    remainingTimeMillis: '2220000',
    goalTimeMillis: '3600000',
    goalTimeLongFriendly: '60m',
    remainingTimeFriendly: '7h 59m',
    isClosed: false,
    date: 1647858600000
};
const $b648a6dc4d4184c8$export$26c24323bef7eb3 = {
    isBreached: true,
    timeRemainingInMinutes: -345,
    status: 'ONGOING',
    timeRemainingFriendly: 'Today 10:30 AM',
    metricName: 'Time to Pending',
    goalTime: '31m',
    calendarName: '24/7 Calendar (Default)',
    stopTime: 'Today 4:15 PM',
    previousCycles: [],
    hoverContent: "5h 45m past \u2022 Due: 2022-03-28 10:30AM GMT+0530",
    slaDisplayFormat: (0, $feae9f437bfca243$export$13ecaaf97b049384),
    breachTime: 1648443600000,
    remainingTimeMillis: '-20700000',
    goalTimeMillis: '1860000',
    goalTimeLongFriendly: '31m',
    remainingTimeFriendly: '-5h 45m',
    isClosed: false,
    date: 1648443600000
};
const $b648a6dc4d4184c8$export$233c7c06afe24e99 = {
    isBreached: true,
    timeRemainingInMinutes: -1246,
    status: 'ONGOING',
    timeRemainingFriendly: '-20H 46m',
    metricName: 'Time to Pending',
    goalTime: '1531m',
    calendarName: '24/7 Calendar (Default)',
    stopTime: 'Today 4:15 PM',
    previousCycles: [],
    hoverContent: undefined,
    slaDisplayFormat: 'OLD_SLA_FORMAT',
    breachTime: 1648443600000,
    remainingTimeMillis: '2220000',
    goalTimeMillis: '3600000',
    goalTimeLongFriendly: '60m',
    remainingTimeFriendly: '7h 59m',
    isClosed: false,
    date: 1648443600000
};
const $b648a6dc4d4184c8$export$55329f7677a6f23f = {
    isBreached: false,
    timeRemainingInMinutes: 300,
    status: 'COMPLETED',
    timeRemainingFriendly: '24 February',
    metricName: 'Time to Pending',
    goalTime: '5h',
    calendarName: 'Test3',
    stopTime: '24/Feb/22 6:45 AM',
    previousCycles: [],
    hoverContent: "5h met \u2022 0% of 5h \u2022 2022-02-24 09:30PM GMT+0530",
    slaDisplayFormat: (0, $feae9f437bfca243$export$13ecaaf97b049384),
    breachTime: 1645718400000,
    remainingTimeMillis: '18000000',
    goalTimeMillis: '18000000',
    goalTimeLongFriendly: '5h',
    remainingTimeFriendly: '5h',
    isClosed: true,
    date: 1648463400000
};
const $b648a6dc4d4184c8$export$99da56e810295b55 = {
    isBreached: false,
    timeRemainingInMinutes: 300,
    status: 'COMPLETED',
    timeRemainingFriendly: '400H',
    metricName: 'Time to Pending',
    goalTime: '405h',
    calendarName: 'Test3',
    stopTime: '24/Feb/22 6:45 AM',
    previousCycles: [],
    hoverContent: undefined,
    slaDisplayFormat: (0, $feae9f437bfca243$export$aad60a8e044b5914),
    breachTime: 1645718400000,
    remainingTimeMillis: '2220000',
    goalTimeMillis: '3600000',
    goalTimeLongFriendly: '60m',
    remainingTimeFriendly: '7h 59m',
    isClosed: true,
    date: 1648463400000
};

});

parcelRegister("iW164", function(module, exports) {

$parcel$export(module.exports, "useFetchConditionsService", () => $e33f21423c62b640$export$5389fe0330cf22d1);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $hcWr6 = parcelRequire("hcWr6");
const $e33f21423c62b640$export$5389fe0330cf22d1 = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $fV97Z.performGetRequest)((0, $hcWr6.getUrl)(baseUrl, projectKey));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaConditions fetched');
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            setLoading(false);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useFetchConditionsService',
                packageName: 'jiraServicedeskSlaSettings'
            });
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
        error,
        data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
        data,
        fetch: fetch
    };
};

});
parcelRegister("hcWr6", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $c01951c12b643734$export$94df0e59ebebf4a7);
const $c01951c12b643734$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/sla/conditions/available`;

});


parcelRegister("26tYd", function(module, exports) {

$parcel$export(module.exports, "ConditionView", () => $4b4b0ac0fcf0eff0$export$85174b1e3c85d444);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2siPY = parcelRequire("2siPY");

var $iSEfF = parcelRequire("iSEfF");

var $SGaLI = parcelRequire("SGaLI");

var $44UxY = parcelRequire("44UxY");

var $uLDaQ = parcelRequire("uLDaQ");
const $4b4b0ac0fcf0eff0$export$85174b1e3c85d444 = ({ conditionsList: conditionsList, selectedConditions: selectedConditions, listName: listName })=>{
    const [, { setFormStatusToDirty: setFormStatusToDirty }] = (0, $iSEfF.useFormContext)();
    const [newConditionsList, setNewConditionsList] = (0, $eUqFw.useState)(selectedConditions);
    const selectCondition = (condition)=>{
        setNewConditionsList([
            ...newConditionsList,
            condition
        ]);
        setFormStatusToDirty();
    };
    const onRemoveCondition = (conditionId)=>{
        setNewConditionsList([
            ...newConditionsList.filter((condition)=>condition.conditionId !== conditionId)
        ]);
        setFormStatusToDirty();
    };
    const filteredConditionsList = (0, $eUqFw.useMemo)(()=>(0, $uLDaQ.filterConditionsList)(conditionsList, newConditionsList), [
        conditionsList,
        newConditionsList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition-${listName}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2siPY.ConditionHeader), {
        listName: listName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b4b0ac0fcf0eff0$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SGaLI.SelectedConditions), {
        conditions: newConditionsList,
        onRemove: onRemoveCondition,
        listName: listName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44UxY.NewConditions), {
        conditionsList: filteredConditionsList,
        onConditionSelect: selectCondition,
        showLabel: Boolean(newConditionsList.length),
        listName: listName
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b4b0ac0fcf0eff0$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _2lx2vrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2siPY", function(module, exports) {

$parcel$export(module.exports, "ConditionHeader", () => $6b12f8a40ceaa287$export$c9d1afbb63751a6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5jL9Z = parcelRequire("5jL9Z");
const $6b12f8a40ceaa287$var$ConditionHeaderComponent = ({ listName: listName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b12f8a40ceaa287$var$HeaderColumn, null, formatMessage((0, $5jL9Z.default)[listName]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b12f8a40ceaa287$var$DividerLine, null));
};
const $6b12f8a40ceaa287$export$c9d1afbb63751a6f = $6b12f8a40ceaa287$var$ConditionHeaderComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b12f8a40ceaa287$var$HeaderColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc _2lx2vrvc _syaz1n3s _otyru2gc",
            __cmplp.className
        ])
    });
});
const $6b12f8a40ceaa287$var$DividerLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _1bsb1osq _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5jL9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae407d5b9643601$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ae407d5b9643601$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    start: {
        "id": "servicedesk-sla-settings.common.conditions.condition-header.start",
        "defaultMessage": "Start counting time when..."
    },
    pause: {
        "id": "servicedesk-sla-settings.common.conditions.condition-header.pause",
        "defaultMessage": "Pause counting time during..."
    },
    stop: {
        "id": "servicedesk-sla-settings.common.conditions.condition-header.stop",
        "defaultMessage": "Finish counting time when..."
    }
});

});


parcelRegister("SGaLI", function(module, exports) {

$parcel$export(module.exports, "SelectedConditions", () => $d07c609fb8d9787d$export$e39bee72bcd27a4a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $jWuk1 = parcelRequire("jWuk1");

var $giAhk = parcelRequire("giAhk");

var $JLS2U = parcelRequire("JLS2U");

var $eq09R = parcelRequire("eq09R");
const $d07c609fb8d9787d$var$SelectedConditionsView = ({ intl: { formatMessage: formatMessage }, conditions: conditions, onRemove: onRemove, listName: listName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: listName,
        defaultValue: conditions,
        validate: (value)=>(0, $eq09R.validateConditions)(value, listName)
    }, ({ fieldProps: { value: value }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $JLS2U.default).validateMessage)), value.map((condition)=>{
            const { conditionId: conditionId, name: name } = condition;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d07c609fb8d9787d$var$Column, {
                key: `${listName}-condition-${condition.conditionId}`,
                tabIndex: 0,
                "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.fields.selected-condition-${listName}-${conditionId}`
            }, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d07c609fb8d9787d$var$RemoveConditionButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: "remove-condition-button",
                appearance: "subtle",
                onClick: ()=>onRemove(conditionId),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    size: "small",
                    label: formatMessage((0, $JLS2U.default).removeCondition)
                }),
                "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.fields.selected-condition.remove-condition-button-${listName}-${conditionId}`
            }));
        })));
const $d07c609fb8d9787d$export$e39bee72bcd27a4a = (0, $giAhk.injectIntlV2)($d07c609fb8d9787d$var$SelectedConditionsView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d07c609fb8d9787d$var$RemoveConditionButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltv1cib _154i1wug _1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _106tpfqs _176ppfqs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d07c609fb8d9787d$var$Column = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1yt4h8dc _1bsb1osq _16qs1j00 _4t3i1ylp _4cvr1h6o _1bah1yb4 _1e0c1txw _otyru2gc _11q7hp5a _2rko1b66 _15oopfqs _iwmjpfqs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("JLS2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66db3c85f1e7009$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f66db3c85f1e7009$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeCondition: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.fields.selected-condition.remove-condition",
        "defaultMessage": "Remove condition"
    },
    validateMessage: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.fields.selected-condition.validate-message",
        "defaultMessage": "Please select at least one condition"
    }
});

});

parcelRegister("eq09R", function(module, exports) {

$parcel$export(module.exports, "validateConditions", () => $83c13199bd7b0145$export$be1eb00dfaa91af3);

var $gDsgM = parcelRequire("gDsgM");
const $83c13199bd7b0145$export$be1eb00dfaa91af3 = (conditions, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
listName)=>{
    if (!conditions || conditions.length === 0) {
        if (listName !== (0, $gDsgM.PAUSE_CONDITIONS_FIELD_NAME)) return true;
    }
    return undefined;
};

});


parcelRegister("44UxY", function(module, exports) {

$parcel$export(module.exports, "NewConditions", () => $c44c2d7acd5d8ed5$export$fc6b3d2baaec9963);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $gO9Xw = parcelRequire("gO9Xw");

var $giAhk = parcelRequire("giAhk");

var $k1sue = parcelRequire("k1sue");

var $dGbL5 = parcelRequire("dGbL5");
const $c44c2d7acd5d8ed5$export$c880d7901dd68830 = ({ intl: { formatMessage: formatMessage }, conditionsList: conditionsList, onConditionSelect: onConditionSelect, showLabel: showLabel, listName: listName })=>{
    const [isNewConditionAdded, setIsNewConditionAdded] = (0, $eUqFw.useState)(false); // This state makes sure that only one condition is added at a time
    const setNewConditionAdded = (value)=>{
        setIsNewConditionAdded(value);
    };
    const handleOnChange = ()=>{
        setNewConditionAdded(true);
    };
    const handleConditionSelect = (condition)=>{
        onConditionSelect(condition);
    };
    const addConditionMessage = formatMessage((0, $dGbL5.default).addCondition);
    return Boolean(conditionsList.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1sue.SelectField), {
        conditionsList: conditionsList,
        onSelect: handleConditionSelect,
        isNewConditionAdded: isNewConditionAdded,
        setNewConditionAdded: setNewConditionAdded
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.add-condition-column",
        appearance: "subtle",
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconBefore: showLabel ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "",
            size: "small"
        }),
        onClick: handleOnChange,
        shouldFitContainer: true,
        "aria-label": formatMessage((0, $dGbL5.default).addConditionAriaLabel, {
            listName: listName
        })
    }, showLabel ? addConditionMessage : ''));
};
const $c44c2d7acd5d8ed5$export$fc6b3d2baaec9963 = (0, $giAhk.injectIntlV2)($c44c2d7acd5d8ed5$export$c880d7901dd68830);

});
parcelRegister("k1sue", function(module, exports) {

$parcel$export(module.exports, "SelectField", () => $4430f0dbb890b562$export$d55b50a564d0b931);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5wCDk = parcelRequire("5wCDk");

var $giAhk = parcelRequire("giAhk");

var $8PGWt = parcelRequire("8PGWt");
const $4430f0dbb890b562$var$SelectFieldView = ({ intl: { formatMessage: formatMessage }, conditionsList: conditionsList, onSelect: onSelect, isNewConditionAdded: isNewConditionAdded, setNewConditionAdded: setNewConditionAdded })=>{
    const onChange = (option)=>{
        const selectedCondition = conditionsList.find((condition)=>condition.conditionId === option.value);
        if (selectedCondition) {
            setNewConditionAdded(false);
            onSelect(selectedCondition);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4430f0dbb890b562$var$selectBoxWrapperStyles
    }, conditionsList && isNewConditionAdded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: "Select-newCondition",
        "data-test-id": "servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.fields.select-field.ak-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        options: conditionsList.map((condition)=>({
                label: condition.name,
                value: condition.conditionId
            })),
        // @ts-expect-error - TS2322 - Type '(option: {    label: string;    value: string;}) => void' is not assignable to type '(value: { label: string; value: string; } | null, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        placeholder: formatMessage((0, $8PGWt.default).selectCondition),
        styles: $4430f0dbb890b562$var$customStyles,
        onBlur: ()=>setNewConditionAdded(false),
        autoFocus: true,
        menuIsOpen: true
    })));
};
const $4430f0dbb890b562$export$d55b50a564d0b931 = (0, $giAhk.injectIntlV2)($4430f0dbb890b562$var$SelectFieldView);
const $4430f0dbb890b562$var$selectBoxWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $4430f0dbb890b562$var$customStyles = {
    container: (styles)=>({
            ...styles,
            marginTop: "var(--ds-space-100, 8px)"
        })
};

});
parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("8PGWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab5e38d3a4ac46ee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ab5e38d3a4ac46ee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectCondition: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.fields.select-field.select-condition",
        "defaultMessage": "Select condition"
    }
});

});


parcelRegister("dGbL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7463e236633bd3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fd7463e236633bd3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addCondition: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.add-condition",
        "defaultMessage": "Add Condition"
    },
    addConditionAriaLabel: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.add-condition-aria-label",
        "defaultMessage": "Add {listName} condition"
    }
});

});


parcelRegister("uLDaQ", function(module, exports) {

$parcel$export(module.exports, "filterConditionsList", () => $95d7e076dcddc118$export$9c3405d98db7ff01);
const $95d7e076dcddc118$export$9c3405d98db7ff01 = (conditions, newConditions)=>conditions.filter((condition)=>!newConditions.find((selectedCondition)=>selectedCondition.conditionId === condition.conditionId));

});



parcelRegister("j1pOI", function(module, exports) {

$parcel$export(module.exports, "Goals", () => $59c6ee7de87c3edb$export$3c4000465299790);

var $eUqFw = parcelRequire("eUqFw");

var $966Wa = parcelRequire("966Wa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vO9v = parcelRequire("6vO9v");

var $gDsgM = parcelRequire("gDsgM");

var $lxU6z = parcelRequire("lxU6z");

var $iISbO = parcelRequire("iISbO");

var $j11KM = parcelRequire("j11KM");

var $3ASJd = parcelRequire("3ASJd");

var $iMhys = parcelRequire("iMhys");

var $8Rdy0 = parcelRequire("8Rdy0");
const $59c6ee7de87c3edb$export$3c4000465299790 = ({ defaultGoals: defaultGoals, draggableGoals: draggableGoals, maxSlaGoalsLimit: maxSlaGoalsLimit, getFormValues: getFormValues, metricId: metricId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [defaultGoalList, setDefaultGoalsList] = (0, $eUqFw.useState)(defaultGoals);
    const [draggableGoalList, setDraggableGoalsList, onDragEnd, onAppendNewGoal] = (0, $8Rdy0.useGoalsState)(draggableGoals);
    const currentGoalsCount = defaultGoalList.length + draggableGoalList.length;
    const remainingGoals = maxSlaGoalsLimit - currentGoalsCount;
    const goalLimitState = (0, $3ASJd.getLimitState)(maxSlaGoalsLimit, remainingGoals);
    (0, $eUqFw.useEffect)(()=>// ComponentWillUnmount
        ()=>{
            if (goalLimitState === (0, $gDsgM.MAX_REACHED)) // Fire an event when the max goal limit is reached
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmSlaConfiguration slaGoalsLimitReached', {
                slaGoalsLimit: maxSlaGoalsLimit
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        goalLimitState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j11KM.LimitInline), {
        goalsLimit: maxSlaGoalsLimit,
        remaining: remainingGoals
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxU6z.GoalHeader), {
        mode: (0, $6vO9v.EDIT_MODE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.DragDropContext), {
        onDragEnd: onDragEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Droppable), {
        droppableId: "editable-goals-list"
    }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: provided.innerRef,
            ...provided.droppableProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMhys.GoalListView), {
            goals: draggableGoalList,
            setGoals: setDraggableGoalsList,
            getFormValues: getFormValues,
            isDraggable: true
        }), provided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMhys.GoalListView), {
        goals: defaultGoalList,
        setGoals: setDefaultGoalsList,
        getFormValues: getFormValues
    }), goalLimitState !== (0, $gDsgM.MAX_REACHED) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iISbO.AddGoalButton), {
        onAddRequested: ()=>onAppendNewGoal(metricId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j11KM.LimitInline), {
        goalsLimit: maxSlaGoalsLimit,
        remaining: remainingGoals
    }));
};

});
parcelRegister("966Wa", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $69fa0e3037063634$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $69fa0e3037063634$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $69fa0e3037063634$export$423ec2075359570a);

var $eUqFw = parcelRequire("eUqFw");

var $fzXll = parcelRequire("fzXll");

var $bqCNv = parcelRequire("bqCNv");

var $34lu7 = parcelRequire("34lu7");

var $4QJdp = parcelRequire("4QJdp");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");
var $b02ud = parcelRequire("b02ud");

var $bn5nT = parcelRequire("bn5nT");

var $dCUwp = parcelRequire("dCUwp");

var $3YjjI = parcelRequire("3YjjI");

var $l1Zd2 = parcelRequire("l1Zd2");

var $gxvYj = parcelRequire("gxvYj");

var $5JNlj = parcelRequire("5JNlj");

var $85I24 = parcelRequire("85I24");

var $lEfVV = parcelRequire("lEfVV");

var $8kUbC = parcelRequire("8kUbC");
var $69fa0e3037063634$var$isProduction = true;
var $69fa0e3037063634$var$spacesAndTabs = /[ \t]{2,}/g;
var $69fa0e3037063634$var$lineStartWithSpaces = /^[ \t]*/gm;
var $69fa0e3037063634$var$clean = function clean(value) {
    return value.replace($69fa0e3037063634$var$spacesAndTabs, ' ').replace($69fa0e3037063634$var$lineStartWithSpaces, '').trim();
};
var $69fa0e3037063634$var$getDevMessage = function getDevMessage(message) {
    return $69fa0e3037063634$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $69fa0e3037063634$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $69fa0e3037063634$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $69fa0e3037063634$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $69fa0e3037063634$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $69fa0e3037063634$var$log(type, message) {
    var _console;
    if ($69fa0e3037063634$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$69fa0e3037063634$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $69fa0e3037063634$var$getFormattedMessage(message));
}
var $69fa0e3037063634$var$warning = $69fa0e3037063634$var$log.bind(null, 'warn');
var $69fa0e3037063634$var$error = $69fa0e3037063634$var$log.bind(null, 'error');
function $69fa0e3037063634$var$noop() {}
function $69fa0e3037063634$var$getOptions(shared, fromBinding) {
    return (0, $34lu7.default)({}, shared, fromBinding);
}
function $69fa0e3037063634$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $69fa0e3037063634$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $69fa0e3037063634$var$isProduction$1 = true;
var $69fa0e3037063634$var$prefix = 'Invariant failed';
function $69fa0e3037063634$var$RbdInvariant(message) {
    this.message = message;
}
$69fa0e3037063634$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $69fa0e3037063634$var$invariant(condition, message) {
    if (condition) return;
    if ($69fa0e3037063634$var$isProduction$1) throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix);
    else throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix + ": " + (message || ''));
}
var $69fa0e3037063634$var$ErrorBoundary = function(_React$Component) {
    (0, $bqCNv.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $69fa0e3037063634$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $69fa0e3037063634$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $69fa0e3037063634$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
var $69fa0e3037063634$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $69fa0e3037063634$var$position = function position(index) {
    return index + 1;
};
var $69fa0e3037063634$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $69fa0e3037063634$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $69fa0e3037063634$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $69fa0e3037063634$var$position(source.index);
    var endPosition = $69fa0e3037063634$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $69fa0e3037063634$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $69fa0e3037063634$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $69fa0e3037063634$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $69fa0e3037063634$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $69fa0e3037063634$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $69fa0e3037063634$var$position(source.index) + "\n";
};
var $69fa0e3037063634$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n  ";
};
var $69fa0e3037063634$var$preset = {
    liftInstruction: $69fa0e3037063634$var$liftInstruction,
    onDragStart: $69fa0e3037063634$var$onDragStart,
    onDragUpdate: $69fa0e3037063634$var$onDragUpdate,
    onDragEnd: $69fa0e3037063634$var$onDragEnd
};
var $69fa0e3037063634$var$origin = {
    x: 0,
    y: 0
};
var $69fa0e3037063634$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $69fa0e3037063634$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $69fa0e3037063634$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $69fa0e3037063634$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $69fa0e3037063634$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $69fa0e3037063634$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $69fa0e3037063634$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $69fa0e3037063634$var$distance(target, point);
    }));
};
var $69fa0e3037063634$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $69fa0e3037063634$var$executeClip = function(frame, subject) {
    var result = (0, $bn5nT.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $69fa0e3037063634$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $69fa0e3037063634$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $69fa0e3037063634$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $69fa0e3037063634$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $69fa0e3037063634$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $34lu7.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $69fa0e3037063634$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $69fa0e3037063634$var$executeClip(frame.pageMarginBox, target);
    return (0, $bn5nT.getRect)(target);
};
var $69fa0e3037063634$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $69fa0e3037063634$var$scroll(page.marginBox, frame);
    var increased = $69fa0e3037063634$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $69fa0e3037063634$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $69fa0e3037063634$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $69fa0e3037063634$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $69fa0e3037063634$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $69fa0e3037063634$var$negate(scrollDiff);
    var frame = (0, $34lu7.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $34lu7.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $69fa0e3037063634$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3YjjI)))(map);
}
function $69fa0e3037063634$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $69fa0e3037063634$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $69fa0e3037063634$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $69fa0e3037063634$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $69fa0e3037063634$var$toDroppableMap = (0, $dCUwp.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDraggableMap = (0, $dCUwp.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDroppableList = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$values(droppables);
});
var $69fa0e3037063634$var$toDraggableList = (0, $dCUwp.default)(function(draggables) {
    return $69fa0e3037063634$var$values(draggables);
});
var $69fa0e3037063634$var$getDraggablesInsideDroppable = (0, $dCUwp.default)(function(droppableId, draggables) {
    var result = $69fa0e3037063634$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $69fa0e3037063634$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $69fa0e3037063634$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $69fa0e3037063634$var$removeDraggableFromList = (0, $dCUwp.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $69fa0e3037063634$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $69fa0e3037063634$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $34lu7.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $69fa0e3037063634$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $69fa0e3037063634$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $69fa0e3037063634$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $69fa0e3037063634$var$noDisplacedBy = {
    point: $69fa0e3037063634$var$origin,
    value: 0
};
var $69fa0e3037063634$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $69fa0e3037063634$var$noImpact = {
    displaced: $69fa0e3037063634$var$emptyGroups,
    displacedBy: $69fa0e3037063634$var$noDisplacedBy,
    at: null
};
var $69fa0e3037063634$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $69fa0e3037063634$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $69fa0e3037063634$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $69fa0e3037063634$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $69fa0e3037063634$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $69fa0e3037063634$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $69fa0e3037063634$var$origin;
    return $69fa0e3037063634$var$offsetByPosition(target, displacement);
};
var $69fa0e3037063634$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $69fa0e3037063634$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $69fa0e3037063634$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $69fa0e3037063634$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $69fa0e3037063634$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $69fa0e3037063634$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $69fa0e3037063634$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isPartiallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisible = function isTotallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $69fa0e3037063634$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $69fa0e3037063634$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $bn5nT.getRect)((0, $bn5nT.expand)(marginBox, expandBy));
}
function $69fa0e3037063634$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $69fa0e3037063634$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $69fa0e3037063634$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $69fa0e3037063634$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $69fa0e3037063634$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $69fa0e3037063634$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $69fa0e3037063634$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $69fa0e3037063634$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $69fa0e3037063634$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    if (index == null) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $69fa0e3037063634$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $69fa0e3037063634$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $69fa0e3037063634$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $69fa0e3037063634$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $69fa0e3037063634$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $69fa0e3037063634$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $69fa0e3037063634$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $69fa0e3037063634$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $69fa0e3037063634$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $69fa0e3037063634$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($69fa0e3037063634$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $69fa0e3037063634$var$origin : $69fa0e3037063634$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $69fa0e3037063634$var$origin;
};
var $69fa0e3037063634$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $69fa0e3037063634$var$tryGetCombine(impact);
    !combine && $69fa0e3037063634$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $69fa0e3037063634$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $69fa0e3037063634$var$add(center, displaceBy);
};
var $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $69fa0e3037063634$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveInto.contentBox[axis.start] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $69fa0e3037063634$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $69fa0e3037063634$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($69fa0e3037063634$var$didStartAfterCritical(closestAfter, afterCritical)) return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $bn5nT.offset)(closest.page, displacedBy.point);
        return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($69fa0e3037063634$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $bn5nT.offset)(last.page, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point));
        return $69fa0e3037063634$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $69fa0e3037063634$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $69fa0e3037063634$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $69fa0e3037063634$var$add(point, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $69fa0e3037063634$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $69fa0e3037063634$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $69fa0e3037063634$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $69fa0e3037063634$var$scrollViewport = function(viewport, newScroll) {
    var diff = $69fa0e3037063634$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $69fa0e3037063634$var$negate(diff);
    var frame = (0, $bn5nT.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $69fa0e3037063634$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $69fa0e3037063634$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $69fa0e3037063634$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $69fa0e3037063634$var$scrollViewport(viewport, $69fa0e3037063634$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $69fa0e3037063634$var$scrollDroppable(destination, $69fa0e3037063634$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $69fa0e3037063634$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $34lu7.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $69fa0e3037063634$var$withViewportDisplacement = function(viewport, point) {
    return $69fa0e3037063634$var$add(viewport.scroll.diff.displacement, point);
};
var $69fa0e3037063634$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $69fa0e3037063634$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $69fa0e3037063634$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $69fa0e3037063634$var$add(draggable.client.borderBox.center, offset);
};
var $69fa0e3037063634$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $69fa0e3037063634$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $69fa0e3037063634$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $69fa0e3037063634$var$isTotallyVisibleOnAxis(args) : $69fa0e3037063634$var$isTotallyVisible(args);
};
var $69fa0e3037063634$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    var impact = $69fa0e3037063634$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $69fa0e3037063634$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $69fa0e3037063634$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $69fa0e3037063634$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $69fa0e3037063634$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $69fa0e3037063634$var$invariant(false);
    return rect;
};
var $69fa0e3037063634$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $69fa0e3037063634$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $69fa0e3037063634$var$isPartiallyVisibleThroughFrame(viewport.frame)($69fa0e3037063634$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $69fa0e3037063634$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $69fa0e3037063634$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $69fa0e3037063634$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $69fa0e3037063634$var$getKnownActive(droppable)[axis.crossAxisStart] === $69fa0e3037063634$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $69fa0e3037063634$var$isWithin($69fa0e3037063634$var$getKnownActive(droppable)[axis.start], $69fa0e3037063634$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(a)));
        var second = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
};
var $69fa0e3037063634$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $69fa0e3037063634$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$offsetByPosition(original, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point)) : original;
};
var $69fa0e3037063634$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $69fa0e3037063634$var$isTotallyVisible({
            target: $69fa0e3037063634$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $69fa0e3037063634$var$getDisplacedBy = (0, $dCUwp.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $69fa0e3037063634$var$patch(axis.line, displacement)
    };
});
var $69fa0e3037063634$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $69fa0e3037063634$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $69fa0e3037063634$var$patch(axis.line, needsToGrowBy);
};
var $69fa0e3037063634$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $34lu7.default)({}, frame, {
        scroll: (0, $34lu7.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $69fa0e3037063634$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$69fa0e3037063634$var$isHomeOf(draggable, droppable) && $69fa0e3037063634$var$invariant(false);
    !!droppable.subject.withPlaceholder && $69fa0e3037063634$var$invariant(false);
    var placeholderSize = $69fa0e3037063634$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $69fa0e3037063634$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $69fa0e3037063634$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, maxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $69fa0e3037063634$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $69fa0e3037063634$var$invariant(false);
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $69fa0e3037063634$var$emptyGroups,
            displacedBy: $69fa0e3037063634$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $69fa0e3037063634$var$isHomeOf(draggable, destination) ? destination : $69fa0e3037063634$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $69fa0e3037063634$var$emptyGroups,
        index: proposedIndex
    });
};
var $69fa0e3037063634$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $69fa0e3037063634$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $69fa0e3037063634$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $69fa0e3037063634$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $69fa0e3037063634$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $69fa0e3037063634$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $69fa0e3037063634$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $69fa0e3037063634$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $69fa0e3037063634$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $69fa0e3037063634$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $69fa0e3037063634$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $69fa0e3037063634$var$isPositionInFrame(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $69fa0e3037063634$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $69fa0e3037063634$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $69fa0e3037063634$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $69fa0e3037063634$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $69fa0e3037063634$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$69fa0e3037063634$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($69fa0e3037063634$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $69fa0e3037063634$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $69fa0e3037063634$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $69fa0e3037063634$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $bn5nT.getRect)($69fa0e3037063634$var$offsetByPosition(rect, point));
};
var $69fa0e3037063634$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $69fa0e3037063634$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $69fa0e3037063634$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $69fa0e3037063634$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $69fa0e3037063634$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $69fa0e3037063634$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $69fa0e3037063634$var$isHomeOf(draggable, destination)
    });
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$combineThresholdDivisor = 4;
var $69fa0e3037063634$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $69fa0e3037063634$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $69fa0e3037063634$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $69fa0e3037063634$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $69fa0e3037063634$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $69fa0e3037063634$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $69fa0e3037063634$var$withDroppableScroll(destination, pageBorderBox);
    return $69fa0e3037063634$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $69fa0e3037063634$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $34lu7.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $69fa0e3037063634$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $69fa0e3037063634$var$whatIsDraggedOver(previousImpact);
    var now = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $69fa0e3037063634$var$removePlaceholder(lastDroppable);
    return $69fa0e3037063634$var$patchDroppableMap(droppables, updated);
};
var $69fa0e3037063634$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $69fa0e3037063634$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($69fa0e3037063634$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $69fa0e3037063634$var$addPlaceholder(droppable, draggable, draggables);
    return $69fa0e3037063634$var$patchDroppableMap(cleaned, patched);
};
var $69fa0e3037063634$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $69fa0e3037063634$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $69fa0e3037063634$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $69fa0e3037063634$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $69fa0e3037063634$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $34lu7.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $69fa0e3037063634$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $69fa0e3037063634$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $34lu7.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $69fa0e3037063634$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $69fa0e3037063634$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $69fa0e3037063634$var$getDraggables$1(last.all, draggables);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $34lu7.default)({}, impact, {
        displaced: displaced
    });
};
var $69fa0e3037063634$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $69fa0e3037063634$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $69fa0e3037063634$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $69fa0e3037063634$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $69fa0e3037063634$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $69fa0e3037063634$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $69fa0e3037063634$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $69fa0e3037063634$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $69fa0e3037063634$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $69fa0e3037063634$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $69fa0e3037063634$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $69fa0e3037063634$var$records = {};
var $69fa0e3037063634$var$isEnabled = false;
var $69fa0e3037063634$var$isTimingsEnabled = function isTimingsEnabled() {
    return $69fa0e3037063634$var$isEnabled;
};
var $69fa0e3037063634$var$start = function start(key) {
    var now;
};
var $69fa0e3037063634$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $69fa0e3037063634$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $bn5nT.offset)(draggable.client, offset$1);
    var page = (0, $bn5nT.withScroll)(client, initialWindowScroll);
    var moved = (0, $34lu7.default)({}, draggable, {
        placeholder: (0, $34lu7.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $69fa0e3037063634$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $69fa0e3037063634$var$invariant(false);
    return frame;
};
var $69fa0e3037063634$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $69fa0e3037063634$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $69fa0e3037063634$var$add(windowScrollChange, droppableScrollChange);
        var moved = $69fa0e3037063634$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $69fa0e3037063634$var$timingsKey = 'Processing dynamic changes';
var $69fa0e3037063634$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $69fa0e3037063634$var$start($69fa0e3037063634$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $69fa0e3037063634$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $34lu7.default)({}, state.dimensions.droppables, $69fa0e3037063634$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $69fa0e3037063634$var$toDraggableMap($69fa0e3037063634$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $34lu7.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $69fa0e3037063634$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingsKey);
    var draggingState = (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $34lu7.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $69fa0e3037063634$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $69fa0e3037063634$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $69fa0e3037063634$var$patchDimensionMap(state.dimensions, updated);
    if (!$69fa0e3037063634$var$isSnapping(state) || isEnabledChanging) return $69fa0e3037063634$var$update({
        state: state,
        dimensions: dimensions
    });
    return $69fa0e3037063634$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $69fa0e3037063634$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $69fa0e3037063634$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $69fa0e3037063634$var$reducer = function(state, action) {
    if (state === void 0) state = $69fa0e3037063634$var$idle;
    if (action.type === 'FLUSH') return (0, $34lu7.default)({}, $69fa0e3037063634$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $69fa0e3037063634$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                offset: $69fa0e3037063634$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $69fa0e3037063634$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result = (0, $34lu7.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($69fa0e3037063634$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $69fa0e3037063634$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $69fa0e3037063634$var$scrollDroppable(target, newScroll);
        return $69fa0e3037063634$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $69fa0e3037063634$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $69fa0e3037063634$var$invariant(false);
        var updated = (0, $34lu7.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $69fa0e3037063634$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        var _updated = (0, $34lu7.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        !state.isWindowScrollAllowed && $69fa0e3037063634$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($69fa0e3037063634$var$isEqual(state.viewport.scroll.current, _newScroll)) return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        var _viewport = $69fa0e3037063634$var$scrollViewport(state.viewport, _newScroll);
        if ($69fa0e3037063634$var$isSnapping(state)) return $69fa0e3037063634$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $69fa0e3037063634$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$69fa0e3037063634$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($69fa0e3037063634$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $34lu7.default)({}, state.viewport, {
            scroll: (0, $34lu7.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $34lu7.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result2 = $69fa0e3037063634$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $69fa0e3037063634$var$invariant(false);
        var newState = (0, $34lu7.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $69fa0e3037063634$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $69fa0e3037063634$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $69fa0e3037063634$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $69fa0e3037063634$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $69fa0e3037063634$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $69fa0e3037063634$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $69fa0e3037063634$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $69fa0e3037063634$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $69fa0e3037063634$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $69fa0e3037063634$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $69fa0e3037063634$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $69fa0e3037063634$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $69fa0e3037063634$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $69fa0e3037063634$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $69fa0e3037063634$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $69fa0e3037063634$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $69fa0e3037063634$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $69fa0e3037063634$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $69fa0e3037063634$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($69fa0e3037063634$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
                dispatch($69fa0e3037063634$var$flush());
                dispatch($69fa0e3037063634$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $69fa0e3037063634$var$validateDimensions(critical, dimensions);
                dispatch($69fa0e3037063634$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $69fa0e3037063634$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $69fa0e3037063634$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $69fa0e3037063634$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $69fa0e3037063634$var$outOfTheWayTiming = $69fa0e3037063634$var$timings.outOfTheWay + "s " + $69fa0e3037063634$var$curves.outOfTheWay;
var $69fa0e3037063634$var$transitions = {
    fluid: "opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    snap: "transform " + $69fa0e3037063634$var$outOfTheWayTiming + ", opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $69fa0e3037063634$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $69fa0e3037063634$var$outOfTheWayTiming,
    placeholder: "height " + $69fa0e3037063634$var$outOfTheWayTiming + ", width " + $69fa0e3037063634$var$outOfTheWayTiming + ", margin " + $69fa0e3037063634$var$outOfTheWayTiming
};
var $69fa0e3037063634$var$moveTo = function moveTo(offset) {
    return $69fa0e3037063634$var$isEqual(offset, $69fa0e3037063634$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $69fa0e3037063634$var$transforms = {
    moveTo: $69fa0e3037063634$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $69fa0e3037063634$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $69fa0e3037063634$var$combine.scale.drop + ")";
    }
};
var $69fa0e3037063634$var$minDropTime = $69fa0e3037063634$var$timings.minDropTime, $69fa0e3037063634$var$maxDropTime = $69fa0e3037063634$var$timings.maxDropTime;
var $69fa0e3037063634$var$dropTimeRange = $69fa0e3037063634$var$maxDropTime - $69fa0e3037063634$var$minDropTime;
var $69fa0e3037063634$var$maxDropTimeAtDistance = 1500;
var $69fa0e3037063634$var$cancelDropModifier = 0.6;
var $69fa0e3037063634$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $69fa0e3037063634$var$distance(current, destination);
    if (distance$1 <= 0) return $69fa0e3037063634$var$minDropTime;
    if (distance$1 >= $69fa0e3037063634$var$maxDropTimeAtDistance) return $69fa0e3037063634$var$maxDropTime;
    var percentage = distance$1 / $69fa0e3037063634$var$maxDropTimeAtDistance;
    var duration = $69fa0e3037063634$var$minDropTime + $69fa0e3037063634$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $69fa0e3037063634$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $69fa0e3037063634$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $69fa0e3037063634$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $69fa0e3037063634$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $69fa0e3037063634$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $34lu7.default)({}, lastImpact, {
        displaced: $69fa0e3037063634$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $69fa0e3037063634$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($69fa0e3037063634$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $69fa0e3037063634$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $69fa0e3037063634$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $69fa0e3037063634$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$69fa0e3037063634$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($69fa0e3037063634$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $69fa0e3037063634$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($69fa0e3037063634$var$animateDrop(args));
        };
    };
};
var $69fa0e3037063634$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $69fa0e3037063634$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $69fa0e3037063634$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($69fa0e3037063634$var$getWindowScroll());
    }
    var scheduled = (0, $gxvYj.default)(updateScroll);
    var binding = $69fa0e3037063634$var$getWindowScrollBinding(scheduled);
    var unbind = $69fa0e3037063634$var$noop;
    function isActive() {
        return unbind !== $69fa0e3037063634$var$noop;
    }
    function start() {
        !!isActive() && $69fa0e3037063634$var$invariant(false);
        unbind = $69fa0e3037063634$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $69fa0e3037063634$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $69fa0e3037063634$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $69fa0e3037063634$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$scrollListener = function(store) {
    var listener = $69fa0e3037063634$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($69fa0e3037063634$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $69fa0e3037063634$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $69fa0e3037063634$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $69fa0e3037063634$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $69fa0e3037063634$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $69fa0e3037063634$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $69fa0e3037063634$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $69fa0e3037063634$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $69fa0e3037063634$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $69fa0e3037063634$var$withTimings = function withTimings(key, fn) {
    $69fa0e3037063634$var$start(key);
    fn();
    $69fa0e3037063634$var$finish(key);
};
var $69fa0e3037063634$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $69fa0e3037063634$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $69fa0e3037063634$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $69fa0e3037063634$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $69fa0e3037063634$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($69fa0e3037063634$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var data = $69fa0e3037063634$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragStart', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragStart, data, announce, $69fa0e3037063634$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $69fa0e3037063634$var$tryGetDestination(impact);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        !dragging && $69fa0e3037063634$var$invariant(false);
        var hasCriticalChanged = !$69fa0e3037063634$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$69fa0e3037063634$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$69fa0e3037063634$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragUpdate', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragUpdate, data, announce, $69fa0e3037063634$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $69fa0e3037063634$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        dragging = null;
        $69fa0e3037063634$var$withTimings('onDragEnd', function() {
            return $69fa0e3037063634$var$execute(getResponders().onDragEnd, result, announce, $69fa0e3037063634$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $69fa0e3037063634$var$responders = function(getResponders, announce) {
    var publisher = $69fa0e3037063634$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $69fa0e3037063634$var$invariant(false);
            store.dispatch($69fa0e3037063634$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($69fa0e3037063634$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $69fa0e3037063634$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $69fa0e3037063634$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $69fa0e3037063634$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($69fa0e3037063634$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $69fa0e3037063634$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($69fa0e3037063634$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $69fa0e3037063634$var$composeEnhancers = (0, $4QJdp.compose);
var $69fa0e3037063634$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $4QJdp.createStore)($69fa0e3037063634$var$reducer, $69fa0e3037063634$var$composeEnhancers((0, $4QJdp.applyMiddleware)($69fa0e3037063634$var$style(styleMarshal), $69fa0e3037063634$var$dimensionMarshalStopper(dimensionMarshal), $69fa0e3037063634$var$lift$1(dimensionMarshal), $69fa0e3037063634$var$drop$1, $69fa0e3037063634$var$dropAnimationFinish, $69fa0e3037063634$var$dropAnimationFlushOnScroll, $69fa0e3037063634$var$pendingDrop, $69fa0e3037063634$var$autoScroll(autoScroller), $69fa0e3037063634$var$scrollListener, $69fa0e3037063634$var$focus(focusMarshal), $69fa0e3037063634$var$responders(getResponders, announce))));
};
var $69fa0e3037063634$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $69fa0e3037063634$var$timingKey = 'Publish collection from DOM';
function $69fa0e3037063634$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $69fa0e3037063634$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $69fa0e3037063634$var$start($69fa0e3037063634$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($69fa0e3037063634$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(removals),
                modified: updated
            };
            staging = $69fa0e3037063634$var$clean$1();
            $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $69fa0e3037063634$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $69fa0e3037063634$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $69fa0e3037063634$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $69fa0e3037063634$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $69fa0e3037063634$var$invariant(false);
    return doc;
};
var $69fa0e3037063634$var$getMaxWindowScroll = function() {
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var maxScroll = $69fa0e3037063634$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $69fa0e3037063634$var$getViewport = function() {
    var scroll = $69fa0e3037063634$var$getWindowScroll();
    var maxScroll = $69fa0e3037063634$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $69fa0e3037063634$var$origin,
                displacement: $69fa0e3037063634$var$origin
            }
        }
    };
    return viewport;
};
var $69fa0e3037063634$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $69fa0e3037063634$var$start(timingKey);
    var viewport = $69fa0e3037063634$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $69fa0e3037063634$var$toDraggableMap(draggables),
        droppables: $69fa0e3037063634$var$toDroppableMap(droppables)
    };
    $69fa0e3037063634$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $69fa0e3037063634$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $69fa0e3037063634$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $69fa0e3037063634$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $69fa0e3037063634$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $69fa0e3037063634$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $69fa0e3037063634$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $69fa0e3037063634$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $69fa0e3037063634$var$getScrollableDroppables = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $69fa0e3037063634$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $69fa0e3037063634$var$find($69fa0e3037063634$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $69fa0e3037063634$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $69fa0e3037063634$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $69fa0e3037063634$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $69fa0e3037063634$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $69fa0e3037063634$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $69fa0e3037063634$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $69fa0e3037063634$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $69fa0e3037063634$var$minScroll = 1;
var $69fa0e3037063634$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $69fa0e3037063634$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $69fa0e3037063634$var$minScroll;
    var percentageFromMaxScrollValueAt = $69fa0e3037063634$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $69fa0e3037063634$var$config.maxPixelScroll * $69fa0e3037063634$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$accelerateAt = $69fa0e3037063634$var$config.durationDampening.accelerateAt;
var $69fa0e3037063634$var$stopAt = $69fa0e3037063634$var$config.durationDampening.stopDampeningAt;
var $69fa0e3037063634$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $69fa0e3037063634$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
    var runTime = now - startOfRange;
    if (runTime >= $69fa0e3037063634$var$stopAt) return proposedScroll;
    if (runTime < $69fa0e3037063634$var$accelerateAt) return $69fa0e3037063634$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $69fa0e3037063634$var$getPercentage({
        startOfRange: $69fa0e3037063634$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $69fa0e3037063634$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($69fa0e3037063634$var$dampenValueByTime(scroll, dragStartTime), $69fa0e3037063634$var$minScroll);
};
var $69fa0e3037063634$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $69fa0e3037063634$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $69fa0e3037063634$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $69fa0e3037063634$var$clean$2 = $69fa0e3037063634$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $69fa0e3037063634$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $69fa0e3037063634$var$clean$2({
        x: x,
        y: y
    });
    if ($69fa0e3037063634$var$isEqual(required, $69fa0e3037063634$var$origin)) return null;
    var limited = $69fa0e3037063634$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $69fa0e3037063634$var$isEqual(limited, $69fa0e3037063634$var$origin) ? null : limited;
};
var $69fa0e3037063634$var$smallestSigned = $69fa0e3037063634$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $69fa0e3037063634$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $69fa0e3037063634$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($69fa0e3037063634$var$isEqual(overlap, $69fa0e3037063634$var$origin)) return null;
        return overlap;
    };
}();
var $69fa0e3037063634$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $69fa0e3037063634$var$smallestSigned(change);
    var overlap = $69fa0e3037063634$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $69fa0e3037063634$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $69fa0e3037063634$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $69fa0e3037063634$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return null;
    return $69fa0e3037063634$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $69fa0e3037063634$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $69fa0e3037063634$var$getBestScrollableDroppable({
        center: center,
        destination: $69fa0e3037063634$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $69fa0e3037063634$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $69fa0e3037063634$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $gxvYj.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $gxvYj.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $69fa0e3037063634$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $69fa0e3037063634$var$start('starting fluid scroller');
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $69fa0e3037063634$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $69fa0e3037063634$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $69fa0e3037063634$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $69fa0e3037063634$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $69fa0e3037063634$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return change;
        var overlap = $69fa0e3037063634$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
        !destination && $69fa0e3037063634$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $69fa0e3037063634$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $69fa0e3037063634$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $69fa0e3037063634$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $69fa0e3037063634$var$prefix$1 = 'data-rbd';
var $69fa0e3037063634$var$dragHandle = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $69fa0e3037063634$var$draggable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$droppable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$scrollContainer = {
    contextId: $69fa0e3037063634$var$prefix$1 + "-scroll-container-context-id"
};
var $69fa0e3037063634$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $69fa0e3037063634$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $69fa0e3037063634$var$noPointerEvents = 'pointer-events: none;';
var $69fa0e3037063634$var$getStyles$1 = function(contextId) {
    var getSelector = $69fa0e3037063634$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $69fa0e3037063634$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $69fa0e3037063634$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($69fa0e3037063634$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $69fa0e3037063634$var$getStyles(rules, 'always'),
        resting: $69fa0e3037063634$var$getStyles(rules, 'resting'),
        dragging: $69fa0e3037063634$var$getStyles(rules, 'dragging'),
        dropAnimating: $69fa0e3037063634$var$getStyles(rules, 'dropAnimating'),
        userCancel: $69fa0e3037063634$var$getStyles(rules, 'userCancel')
    };
};
var $69fa0e3037063634$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);
var $69fa0e3037063634$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $69fa0e3037063634$var$invariant(false);
    return head;
};
var $69fa0e3037063634$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $69fa0e3037063634$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eUqFw.useRef)(null);
    var dynamicRef = (0, $eUqFw.useRef)(null);
    var setDynamicStyle = (0, $fzXll.useCallback)((0, $dCUwp.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $fzXll.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $69fa0e3037063634$var$invariant(false);
        var always = $69fa0e3037063634$var$createStyleEl(nonce);
        var dynamic = $69fa0e3037063634$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($69fa0e3037063634$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($69fa0e3037063634$var$prefix$1 + "-dynamic", contextId);
        $69fa0e3037063634$var$getHead().appendChild(always);
        $69fa0e3037063634$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $69fa0e3037063634$var$invariant(false);
                $69fa0e3037063634$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $fzXll.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $fzXll.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $fzXll.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $69fa0e3037063634$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $69fa0e3037063634$var$isHtmlElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).HTMLElement;
}
function $69fa0e3037063634$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eUqFw.useRef)({});
    var recordRef = (0, $eUqFw.useRef)(null);
    var restoreFocusFrameRef = (0, $eUqFw.useRef)(null);
    var isMountedRef = (0, $eUqFw.useRef)(false);
    var register = (0, $fzXll.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $fzXll.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $69fa0e3037063634$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $fzXll.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $fzXll.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $fzXll.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $69fa0e3037063634$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $69fa0e3037063634$var$useRegistry() {
    var registry = (0, $fzXll.useMemo)($69fa0e3037063634$var$createRegistry, []);
    (0, $eUqFw.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $69fa0e3037063634$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$getBodyElement = function() {
    var body = document.body;
    !body && $69fa0e3037063634$var$invariant(false);
    return body;
};
var $69fa0e3037063634$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $69fa0e3037063634$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $69fa0e3037063634$var$useAnnouncer(contextId) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, $69fa0e3037063634$var$visuallyHidden);
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $69fa0e3037063634$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $fzXll.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $69fa0e3037063634$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $eUqFw.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, {
            display: 'none'
        });
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function unmount() {
            $69fa0e3037063634$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $69fa0e3037063634$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $69fa0e3037063634$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $69fa0e3037063634$var$getVersion = function getVersion(value) {
    var result = $69fa0e3037063634$var$semver.exec(value);
    !(result != null) && $69fa0e3037063634$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $69fa0e3037063634$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $69fa0e3037063634$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $69fa0e3037063634$var$getVersion(peerDepValue);
    var actual = $69fa0e3037063634$var$getVersion(actualValue);
    if ($69fa0e3037063634$var$isSatisfied(peerDep, actual)) return;
};
var $69fa0e3037063634$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $69fa0e3037063634$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $69fa0e3037063634$var$useDev(useHook) {}
function $69fa0e3037063634$var$useDevSetupWarning(fn, inputs) {
    $69fa0e3037063634$var$useDev(function() {
        (0, $eUqFw.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $69fa0e3037063634$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $69fa0e3037063634$var$useStartupValidation() {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$checkReactVersion($69fa0e3037063634$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).version);
        $69fa0e3037063634$var$checkDoctype(document);
    }, []);
}
function $69fa0e3037063634$var$usePrevious(current) {
    var ref = (0, $eUqFw.useRef)(current);
    (0, $eUqFw.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $69fa0e3037063634$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $69fa0e3037063634$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $69fa0e3037063634$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $69fa0e3037063634$var$tab = 9;
var $69fa0e3037063634$var$enter = 13;
var $69fa0e3037063634$var$escape = 27;
var $69fa0e3037063634$var$space = 32;
var $69fa0e3037063634$var$pageUp = 33;
var $69fa0e3037063634$var$pageDown = 34;
var $69fa0e3037063634$var$end = 35;
var $69fa0e3037063634$var$home = 36;
var $69fa0e3037063634$var$arrowLeft = 37;
var $69fa0e3037063634$var$arrowUp = 38;
var $69fa0e3037063634$var$arrowRight = 39;
var $69fa0e3037063634$var$arrowDown = 40;
var $69fa0e3037063634$var$_preventedKeys;
var $69fa0e3037063634$var$preventedKeys = ($69fa0e3037063634$var$_preventedKeys = {}, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$enter] = true, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$tab] = true, $69fa0e3037063634$var$_preventedKeys);
var $69fa0e3037063634$var$preventStandardKeyEvents = function(event) {
    if ($69fa0e3037063634$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $69fa0e3037063634$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $69fa0e3037063634$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $69fa0e3037063634$var$primaryButton = 0;
var $69fa0e3037063634$var$sloppyClickThreshold = 5;
function $69fa0e3037063634$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $69fa0e3037063634$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $69fa0e3037063634$var$sloppyClickThreshold;
}
var $69fa0e3037063634$var$idle$1 = {
    type: 'IDLE'
};
function $69fa0e3037063634$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $69fa0e3037063634$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
                var pending = phase.point;
                if (!$69fa0e3037063634$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$1);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $69fa0e3037063634$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $69fa0e3037063634$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $69fa0e3037063634$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$_scrollJumpKeys;
function $69fa0e3037063634$var$noop$1() {}
var $69fa0e3037063634$var$scrollJumpKeys = ($69fa0e3037063634$var$_scrollJumpKeys = {}, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageDown] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageUp] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$home] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$end] = true, $69fa0e3037063634$var$_scrollJumpKeys);
function $69fa0e3037063634$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($69fa0e3037063634$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop$1);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $69fa0e3037063634$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $69fa0e3037063634$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$idle$2 = {
    type: 'IDLE'
};
var $69fa0e3037063634$var$timeForLongPress = 120;
var $69fa0e3037063634$var$forcePressThreshold = 0.15;
function $69fa0e3037063634$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $69fa0e3037063634$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor$1(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$2);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var getPhase = (0, $fzXll.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $fzXll.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($69fa0e3037063634$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getHandleBindings(args), options);
        var unbindWindow = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $fzXll.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $69fa0e3037063634$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($69fa0e3037063634$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $69fa0e3037063634$var$useValidateSensorHooks(sensorHooks) {
    $69fa0e3037063634$var$useDev(function() {
        var previousRef = $69fa0e3037063634$var$usePrevious(sensorHooks);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $69fa0e3037063634$var$invariant(false);
        });
    });
}
var $69fa0e3037063634$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $69fa0e3037063634$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($69fa0e3037063634$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(parent, current.parentElement);
}
function $69fa0e3037063634$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isHtmlElement(target)) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(draggable, target);
}
var $69fa0e3037063634$var$getBorderBoxCenterPosition = function(el) {
    return (0, $bn5nT.getRect)(el.getBoundingClientRect()).center;
};
function $69fa0e3037063634$var$isElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).Element;
}
var $69fa0e3037063634$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $69fa0e3037063634$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $69fa0e3037063634$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$69fa0e3037063634$var$supportedMatchesName](selector)) return el;
    return $69fa0e3037063634$var$closestPonyfill(el.parentElement, selector);
}
function $69fa0e3037063634$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $69fa0e3037063634$var$closestPonyfill(el, selector);
}
function $69fa0e3037063634$var$getSelector(contextId) {
    return "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isElement(target)) return null;
    var selector = $69fa0e3037063634$var$getSelector(contextId);
    var handle = $69fa0e3037063634$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($69fa0e3037063634$var$dragHandle.draggableId);
}
function $69fa0e3037063634$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $69fa0e3037063634$var$preventDefault(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $69fa0e3037063634$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$69fa0e3037063634$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $69fa0e3037063634$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $69fa0e3037063634$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $69fa0e3037063634$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $69fa0e3037063634$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $69fa0e3037063634$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($69fa0e3037063634$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $69fa0e3037063634$var$invariant(false);
        }
        store.dispatch($69fa0e3037063634$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $69fa0e3037063634$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $69fa0e3037063634$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($69fa0e3037063634$var$drop({
                reason: reason
            }));
        }
        return (0, $34lu7.default)({
            isActive: function isActive() {
                return $69fa0e3037063634$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $gxvYj.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $69fa0e3037063634$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $34lu7.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $69fa0e3037063634$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $69fa0e3037063634$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $69fa0e3037063634$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $69fa0e3037063634$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $69fa0e3037063634$var$defaultSensors = [
    $69fa0e3037063634$var$useMouseSensor,
    $69fa0e3037063634$var$useKeyboardSensor,
    $69fa0e3037063634$var$useMouseSensor$1
];
function $69fa0e3037063634$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $69fa0e3037063634$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eUqFw.useState)(function() {
        return $69fa0e3037063634$var$create();
    })[0];
    var tryAbandonLock = (0, $fzXll.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $fzXll.useCallback)(function(draggableId) {
        return $69fa0e3037063634$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $fzXll.useCallback)(function(draggableId, forceStop, options) {
        return $69fa0e3037063634$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $fzXll.useCallback)(function(event) {
        return $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $fzXll.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $fzXll.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $fzXll.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $fzXll.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $69fa0e3037063634$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $69fa0e3037063634$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $69fa0e3037063634$var$getStore(lazyRef) {
    !lazyRef.current && $69fa0e3037063634$var$invariant(false);
    return lazyRef.current;
}
function $69fa0e3037063634$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $eUqFw.useRef)(null);
    $69fa0e3037063634$var$useStartupValidation();
    var lastPropsRef = $69fa0e3037063634$var$usePrevious(props);
    var getResponders = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $69fa0e3037063634$var$useAnnouncer(contextId);
    var liftInstructionId = $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $69fa0e3037063634$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $fzXll.useCallback)(function(action) {
        $69fa0e3037063634$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $fzXll.useMemo)(function() {
        return (0, $4QJdp.bindActionCreators)({
            publishWhileDragging: $69fa0e3037063634$var$publishWhileDragging,
            updateDroppableScroll: $69fa0e3037063634$var$updateDroppableScroll,
            updateDroppableIsEnabled: $69fa0e3037063634$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $69fa0e3037063634$var$updateDroppableIsCombineEnabled,
            collectionStarting: $69fa0e3037063634$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $69fa0e3037063634$var$useRegistry();
    var dimensionMarshal = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createAutoScroller((0, $34lu7.default)({
            scrollWindow: $69fa0e3037063634$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $4QJdp.bindActionCreators)({
            move: $69fa0e3037063634$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $69fa0e3037063634$var$useFocusMarshal(contextId);
    var store = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $fzXll.useCallback)(function() {
        var current = $69fa0e3037063634$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($69fa0e3037063634$var$flush());
    }, []);
    var isDragging = (0, $fzXll.useCallback)(function() {
        var state = $69fa0e3037063634$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $fzXll.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $fzXll.useCallback)(function(id) {
        return $69fa0e3037063634$var$canStartDrag($69fa0e3037063634$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$isMovementAllowed($69fa0e3037063634$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $fzXll.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $69fa0e3037063634$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eUqFw.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b02ud.default), {
        context: $69fa0e3037063634$var$StoreContext,
        store: store
    }, props.children));
}
var $69fa0e3037063634$var$instanceCount = 0;
function $69fa0e3037063634$export$2bfe52350fc0150d() {
    $69fa0e3037063634$var$instanceCount = 0;
}
function $69fa0e3037063634$export$237bd83162c14364(props) {
    var contextId = (0, $fzXll.useMemo)(function() {
        return "" + $69fa0e3037063634$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $69fa0e3037063634$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $69fa0e3037063634$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $69fa0e3037063634$var$isScroll = $69fa0e3037063634$var$isEqual$1('scroll');
var $69fa0e3037063634$var$isAuto = $69fa0e3037063634$var$isEqual$1('auto');
var $69fa0e3037063634$var$isVisible$1 = $69fa0e3037063634$var$isEqual$1('visible');
var $69fa0e3037063634$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isScroll) || $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isAuto);
};
var $69fa0e3037063634$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $69fa0e3037063634$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $69fa0e3037063634$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$69fa0e3037063634$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $69fa0e3037063634$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $69fa0e3037063634$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $69fa0e3037063634$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $69fa0e3037063634$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $69fa0e3037063634$var$getEnv = function(start) {
    var closestScrollable = $69fa0e3037063634$var$getClosestScrollable(start);
    var isFixedOnPage = $69fa0e3037063634$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $69fa0e3037063634$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $69fa0e3037063634$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $69fa0e3037063634$var$origin,
                    displacement: $69fa0e3037063634$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $69fa0e3037063634$var$vertical : $69fa0e3037063634$var$horizontal;
    var subject = $69fa0e3037063634$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $69fa0e3037063634$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $bn5nT.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $bn5nT.expand)(paddingBox, base.border);
    var client = (0, $bn5nT.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $69fa0e3037063634$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $69fa0e3037063634$var$getClient(ref, closestScrollable);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $bn5nT.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $bn5nT.withScroll)(frameClient, windowScroll),
            scroll: $69fa0e3037063634$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $69fa0e3037063634$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $69fa0e3037063634$var$immediate = {
    passive: false
};
var $69fa0e3037063634$var$delayed = {
    passive: true
};
var $69fa0e3037063634$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $69fa0e3037063634$var$immediate : $69fa0e3037063634$var$delayed;
};
function $69fa0e3037063634$var$useRequiredContext(Context) {
    var result = (0, $eUqFw.useContext)(Context);
    !result && $69fa0e3037063634$var$invariant(false);
    return result;
}
var $69fa0e3037063634$var$count = 0;
function $69fa0e3037063634$var$useUniqueId(prefix) {
    var countRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$count++);
    return prefix + "::" + countRef.current;
}
var $69fa0e3037063634$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $69fa0e3037063634$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eUqFw.useRef)(null);
    var appContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext);
    var uniqueId = $69fa0e3037063634$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $69fa0e3037063634$var$usePrevious(args);
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eUqFw.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $fzXll.useMemo)(function() {
        return (0, $dCUwp.default)(function(x, y) {
            !whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $69fa0e3037063634$var$origin;
        return $69fa0e3037063634$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $fzXll.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $fzXll.useMemo)(function() {
        return (0, $gxvYj.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $fzXll.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $69fa0e3037063634$var$invariant(false);
        var env = $69fa0e3037063634$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $69fa0e3037063634$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($69fa0e3037063634$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($69fa0e3037063634$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $fzXll.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !closest && $69fa0e3037063634$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $fzXll.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $69fa0e3037063634$var$noop$2() {}
var $69fa0e3037063634$var$empty = {
    width: 0,
    height: 0,
    margin: $69fa0e3037063634$var$noSpacing
};
var $69fa0e3037063634$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $69fa0e3037063634$var$empty;
    if (animate === 'close') return $69fa0e3037063634$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $69fa0e3037063634$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $69fa0e3037063634$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $69fa0e3037063634$var$transitions.placeholder : null
    };
};
function $69fa0e3037063634$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eUqFw.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $fzXll.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eUqFw.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eUqFw.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $69fa0e3037063634$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $69fa0e3037063634$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $69fa0e3037063634$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $fzXll.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $69fa0e3037063634$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $69fa0e3037063634$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($69fa0e3037063634$var$Placeholder);
var $69fa0e3037063634$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $69fa0e3037063634$var$checkIsValidInnerRef(el) {
    !(el && $69fa0e3037063634$var$isHtmlElement(el)) && $69fa0e3037063634$var$invariant(false);
}
function $69fa0e3037063634$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $69fa0e3037063634$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $69fa0e3037063634$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $69fa0e3037063634$var$invariant(false);
        !(typeof props.droppableId === 'string') && $69fa0e3037063634$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$69fa0e3037063634$var$isBoolean(props.isDropDisabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.ignoreContainerClipping) && $69fa0e3037063634$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $69fa0e3037063634$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $69fa0e3037063634$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $69fa0e3037063634$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $69fa0e3037063634$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $69fa0e3037063634$var$invariant(false);
    }
];
function $69fa0e3037063634$var$useValidation(args) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$shared);
        if (args.props.mode === 'standard') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$standard);
        if (args.props.mode === 'virtual') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$virtual);
    });
}
var $69fa0e3037063634$var$AnimateInOut = function(_React$PureComponent) {
    (0, $bqCNv.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
var $69fa0e3037063634$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $69fa0e3037063634$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $69fa0e3037063634$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $69fa0e3037063634$var$transitions.snap;
    return $69fa0e3037063634$var$transitions.fluid;
};
var $69fa0e3037063634$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $69fa0e3037063634$var$combine.opacity.drop : $69fa0e3037063634$var$combine.opacity.combining;
};
var $69fa0e3037063634$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $69fa0e3037063634$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $69fa0e3037063634$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $69fa0e3037063634$var$transforms.drop(offset, isCombining) : $69fa0e3037063634$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $69fa0e3037063634$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $69fa0e3037063634$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $69fa0e3037063634$var$zIndexOptions.dropAnimating : $69fa0e3037063634$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $69fa0e3037063634$var$getSecondaryStyle(secondary) {
    return {
        transform: $69fa0e3037063634$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $69fa0e3037063634$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $69fa0e3037063634$var$getDraggingStyle(mapped) : $69fa0e3037063634$var$getSecondaryStyle(mapped);
}
function $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $69fa0e3037063634$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $bn5nT.calculateBox)(borderBox, computedStyles);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $69fa0e3037063634$var$useDraggablePublisher(args) {
    var uniqueId = $69fa0e3037063634$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $fzXll.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $fzXll.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eUqFw.useRef)(entry);
    var isFirstPublishRef = (0, $eUqFw.useRef)(true);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $69fa0e3037063634$var$useValidation$1(props, contextId, getRef) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $69fa0e3037063634$var$invariant(false);
        !(typeof id === 'string') && $69fa0e3037063634$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8kUbC)))(props.index) && $69fa0e3037063634$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $69fa0e3037063634$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$69fa0e3037063634$var$findDragHandle(contextId, id) && $69fa0e3037063634$var$invariant(false);
    });
}
function $69fa0e3037063634$var$useClonePropValidation(isClone) {
    $69fa0e3037063634$var$useDev(function() {
        var initialRef = (0, $eUqFw.useRef)(isClone);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $69fa0e3037063634$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $69fa0e3037063634$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$Draggable(props) {
    var ref = (0, $eUqFw.useRef)(null);
    var setRef = (0, $fzXll.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $fzXll.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $69fa0e3037063634$var$useValidation$1(props, contextId, getRef);
    $69fa0e3037063634$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $fzXll.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $69fa0e3037063634$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $fzXll.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $69fa0e3037063634$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $fzXll.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $fzXll.useMemo)(function() {
        var style = $69fa0e3037063634$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $fzXll.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $69fa0e3037063634$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $69fa0e3037063634$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $69fa0e3037063634$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $69fa0e3037063634$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $69fa0e3037063634$var$getDraggableSelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
            var combineWith = $69fa0e3037063634$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $69fa0e3037063634$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $69fa0e3037063634$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $69fa0e3037063634$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $69fa0e3037063634$var$combine.opacity.drop : null,
                scale: _combineWith ? $69fa0e3037063634$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $69fa0e3037063634$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $69fa0e3037063634$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $69fa0e3037063634$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $69fa0e3037063634$var$getSecondarySnapshot(null)
    }
};
function $69fa0e3037063634$var$getSecondarySelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)($69fa0e3037063634$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($69fa0e3037063634$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $69fa0e3037063634$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $69fa0e3037063634$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $69fa0e3037063634$var$getDraggableSelector();
    var secondarySelector = $69fa0e3037063634$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $69fa0e3037063634$var$atRest;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps = {
    dropAnimationFinished: $69fa0e3037063634$var$dropAnimationFinished
};
var $69fa0e3037063634$var$ConnectedDraggable = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps, $69fa0e3037063634$var$mapDispatchToProps, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Draggable);
function $69fa0e3037063634$var$PrivateDraggable(props) {
    var droppableContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ConnectedDraggable, props);
}
function $69fa0e3037063634$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, (0, $34lu7.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $69fa0e3037063634$var$Droppable(props) {
    var appContext = (0, $eUqFw.useContext)($69fa0e3037063634$var$AppContext);
    !appContext && $69fa0e3037063634$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eUqFw.useRef)(null);
    var placeholderRef = (0, $eUqFw.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $fzXll.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $fzXll.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $fzXll.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $fzXll.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $69fa0e3037063634$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $fzXll.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $69fa0e3037063634$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $69fa0e3037063634$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $fzXll.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $fzXll.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $69fa0e3037063634$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $69fa0e3037063634$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $69fa0e3037063634$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $34lu7.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $dCUwp.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $dCUwp.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$69fa0e3037063634$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $69fa0e3037063634$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $69fa0e3037063634$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $69fa0e3037063634$var$whatIsDraggedOverFromResult(completed.result) === id, $69fa0e3037063634$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $69fa0e3037063634$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $69fa0e3037063634$var$updateViewportMaxScroll
};
function $69fa0e3037063634$var$getBody() {
    !document.body && $69fa0e3037063634$var$invariant(false);
    return document.body;
}
var $69fa0e3037063634$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $69fa0e3037063634$var$getBody
};
var $69fa0e3037063634$export$423ec2075359570a = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps$1, $69fa0e3037063634$var$mapDispatchToProps$1, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Droppable);
$69fa0e3037063634$export$423ec2075359570a.defaultProps = $69fa0e3037063634$var$defaultProps;

});
parcelRegister("bqCNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $852037c688a362ca$export$2e2bcd8739ae039);

var $aqlSy = parcelRequire("aqlSy");

var $hhPJ7 = parcelRequire("hhPJ7");
function $852037c688a362ca$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($aqlSy)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hhPJ7.default)(subClass, superClass);
}

});
parcelRegister("aqlSy", function(module, exports) {

module.exports = (parcelRequire("fKlYj"));

});
parcelRegister("fKlYj", function(module, exports) {
parcelRequire("3w0kn");

var $dhx8H = parcelRequire("dhx8H");
var $b76c3205a8a74d63$require$$Object = $dhx8H.Object;
module.exports = function create(P, D) {
    return $b76c3205a8a74d63$require$$Object.create(P, D);
};

});
parcelRegister("3w0kn", function(module, exports) {

var $5wEa2 = parcelRequire("5wEa2");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$5wEa2($5wEa2.S, 'Object', {
    create: (parcelRequire("cZpQU"))
});

});
parcelRegister("5wEa2", function(module, exports) {

var $63L5I = parcelRequire("63L5I");

var $dhx8H = parcelRequire("dhx8H");

var $8fJLB = parcelRequire("8fJLB");

var $8akT7 = parcelRequire("8akT7");

var $8uIdh = parcelRequire("8uIdh");
var $405f18044f314da9$var$PROTOTYPE = 'prototype';
var $405f18044f314da9$var$$export = function(type, name, source) {
    var IS_FORCED = type & $405f18044f314da9$var$$export.F;
    var IS_GLOBAL = type & $405f18044f314da9$var$$export.G;
    var IS_STATIC = type & $405f18044f314da9$var$$export.S;
    var IS_PROTO = type & $405f18044f314da9$var$$export.P;
    var IS_BIND = type & $405f18044f314da9$var$$export.B;
    var IS_WRAP = type & $405f18044f314da9$var$$export.W;
    var exports = IS_GLOBAL ? $dhx8H : $dhx8H[name] || ($dhx8H[name] = {});
    var expProto = exports[$405f18044f314da9$var$PROTOTYPE];
    var target = IS_GLOBAL ? $63L5I : IS_STATIC ? $63L5I[name] : ($63L5I[name] || {})[$405f18044f314da9$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8uIdh(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $8fJLB(out, $63L5I) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$405f18044f314da9$var$PROTOTYPE] = C[$405f18044f314da9$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $8fJLB(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $405f18044f314da9$var$$export.R && expProto && !expProto[key]) $8akT7(expProto, key, out);
        }
    }
};
// type bitmap
$405f18044f314da9$var$$export.F = 1; // forced
$405f18044f314da9$var$$export.G = 2; // global
$405f18044f314da9$var$$export.S = 4; // static
$405f18044f314da9$var$$export.P = 8; // proto
$405f18044f314da9$var$$export.B = 16; // bind
$405f18044f314da9$var$$export.W = 32; // wrap
$405f18044f314da9$var$$export.U = 64; // safe
$405f18044f314da9$var$$export.R = 128; // real proto method for `library`
module.exports = $405f18044f314da9$var$$export;

});
parcelRegister("63L5I", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $46978d3810f5c50a$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $46978d3810f5c50a$var$global; // eslint-disable-line no-undef

});

parcelRegister("dhx8H", function(module, exports) {
var $9ab691a5895850dc$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9ab691a5895850dc$var$core; // eslint-disable-line no-undef

});

parcelRegister("8fJLB", function(module, exports) {
// optional / simple context binding

var $2vhgy = parcelRequire("2vhgy");
module.exports = function(fn, that, length) {
    $2vhgy(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2vhgy", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("8akT7", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $dhKmr = parcelRequire("dhKmr");

module.exports = (parcelRequire("kD5IQ")) ? function(object, key, value) {
    return $9jrHv.f(object, key, $dhKmr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("9jrHv", function(module, exports) {

$parcel$export(module.exports, "f", () => $6c7b6032f547fb4c$export$2d1720544b23b823, (v) => $6c7b6032f547fb4c$export$2d1720544b23b823 = v);
var $6c7b6032f547fb4c$export$2d1720544b23b823;

var $aIdHH = parcelRequire("aIdHH");

var $3Ksbk = parcelRequire("3Ksbk");

var $1zpu5 = parcelRequire("1zpu5");
var $6c7b6032f547fb4c$var$dP = Object.defineProperty;

$6c7b6032f547fb4c$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $aIdHH(O);
    P = $1zpu5(P, true);
    $aIdHH(Attributes);
    if ($3Ksbk) try {
        return $6c7b6032f547fb4c$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("aIdHH", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");
module.exports = function(it) {
    if (!$8T9YM(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("8T9YM", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3Ksbk", function(module, exports) {



module.exports = !(parcelRequire("kD5IQ")) && !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty((parcelRequire("2fnkQ"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("kD5IQ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cbAAd", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("2fnkQ", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");

var $63L5I = parcelRequire("63L5I");
var $1a2f155b99584f9f$require$document = $63L5I.document;
// typeof document.createElement is 'object' in old IE
var $1a2f155b99584f9f$var$is = $8T9YM($1a2f155b99584f9f$require$document) && $8T9YM($1a2f155b99584f9f$require$document.createElement);
module.exports = function(it) {
    return $1a2f155b99584f9f$var$is ? $1a2f155b99584f9f$require$document.createElement(it) : {};
};

});


parcelRegister("1zpu5", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $8T9YM = parcelRequire("8T9YM");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$8T9YM(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("dhKmr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8uIdh", function(module, exports) {
var $62f36be98ddb54f8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $62f36be98ddb54f8$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cZpQU", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $aIdHH = parcelRequire("aIdHH");

var $1o8G4 = parcelRequire("1o8G4");

var $c3pDW = parcelRequire("c3pDW");

var $974f3c4319e9c96a$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
var $974f3c4319e9c96a$var$Empty = function() {};
var $974f3c4319e9c96a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $974f3c4319e9c96a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("2fnkQ"))('iframe');
    var i = $c3pDW.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("5JYrt")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $974f3c4319e9c96a$var$createDict = iframeDocument.F;
    while(i--)delete $974f3c4319e9c96a$var$createDict[$974f3c4319e9c96a$var$PROTOTYPE][$c3pDW[i]];
    return $974f3c4319e9c96a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = $aIdHH(O);
        result = new $974f3c4319e9c96a$var$Empty();
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$974f3c4319e9c96a$var$IE_PROTO] = O;
    } else result = $974f3c4319e9c96a$var$createDict();
    return Properties === undefined ? result : $1o8G4(result, Properties);
};

});
parcelRegister("1o8G4", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $aIdHH = parcelRequire("aIdHH");

var $kJc9M = parcelRequire("kJc9M");

module.exports = (parcelRequire("kD5IQ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $aIdHH(O);
    var keys = $kJc9M(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$9jrHv.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("kJc9M", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $58JMR = parcelRequire("58JMR");

var $c3pDW = parcelRequire("c3pDW");
module.exports = Object.keys || function keys(O) {
    return $58JMR(O, $c3pDW);
};

});
parcelRegister("58JMR", function(module, exports) {

var $8uIdh = parcelRequire("8uIdh");

var $6WitF = parcelRequire("6WitF");

var $3be1377c0765345e$var$arrayIndexOf = (parcelRequire("hZ5wn"))(false);

var $3be1377c0765345e$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $6WitF(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3be1377c0765345e$var$IE_PROTO) $8uIdh(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8uIdh(O, key = names[i++])) ~$3be1377c0765345e$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("6WitF", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $jRK2B = parcelRequire("jRK2B");

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return $jRK2B($5XrWm(it));
};

});
parcelRegister("jRK2B", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $9A6tO = parcelRequire("9A6tO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $9A6tO(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("9A6tO", function(module, exports) {
var $6f9c80961703262c$var$toString = {}.toString;
module.exports = function(it) {
    return $6f9c80961703262c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("5XrWm", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hZ5wn", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $6WitF = parcelRequire("6WitF");

var $9sYrG = parcelRequire("9sYrG");

var $dmeMq = parcelRequire("dmeMq");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6WitF($this);
        var length = $9sYrG(O.length);
        var index = $dmeMq(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("9sYrG", function(module, exports) {
// 7.1.15 ToLength

var $cIXGZ = parcelRequire("cIXGZ");
var $6e459dd0a2f7e0ab$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $6e459dd0a2f7e0ab$var$min($cIXGZ(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("cIXGZ", function(module, exports) {
// 7.1.4 ToInteger
var $9437e5c320839147$var$ceil = Math.ceil;
var $9437e5c320839147$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $9437e5c320839147$var$floor : $9437e5c320839147$var$ceil)(it);
};

});


parcelRegister("dmeMq", function(module, exports) {

var $cIXGZ = parcelRequire("cIXGZ");
var $9b98cb76c764326c$var$max = Math.max;
var $9b98cb76c764326c$var$min = Math.min;
module.exports = function(index, length) {
    index = $cIXGZ(index);
    return index < 0 ? $9b98cb76c764326c$var$max(index + length, 0) : $9b98cb76c764326c$var$min(index, length);
};

});


parcelRegister("5PKej", function(module, exports) {

var $43f59377ae23d08e$var$shared = (parcelRequire("jmDxJ"))('keys');

var $c3eWa = parcelRequire("c3eWa");
module.exports = function(key) {
    return $43f59377ae23d08e$var$shared[key] || ($43f59377ae23d08e$var$shared[key] = $c3eWa(key));
};

});
parcelRegister("jmDxJ", function(module, exports) {

var $dhx8H = parcelRequire("dhx8H");

var $63L5I = parcelRequire("63L5I");
var $e18ebed786cb5a63$var$SHARED = '__core-js_shared__';
var $e18ebed786cb5a63$var$store = $63L5I[$e18ebed786cb5a63$var$SHARED] || ($63L5I[$e18ebed786cb5a63$var$SHARED] = {});

(module.exports = function(key, value) {
    return $e18ebed786cb5a63$var$store[key] || ($e18ebed786cb5a63$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dhx8H.version,
    mode: (parcelRequire("ijzx7")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ijzx7", function(module, exports) {
module.exports = true;

});


parcelRegister("c3eWa", function(module, exports) {
var $8c615a0c227a0f34$var$id = 0;
var $8c615a0c227a0f34$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8c615a0c227a0f34$var$id + $8c615a0c227a0f34$var$px).toString(36));
};

});



parcelRegister("c3pDW", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("5JYrt", function(module, exports) {

var $63L5I = parcelRequire("63L5I");
var $42e00a46ad7a4675$require$document = $63L5I.document;
module.exports = $42e00a46ad7a4675$require$document && $42e00a46ad7a4675$require$document.documentElement;

});





parcelRegister("hhPJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c260637bde23a$export$2e2bcd8739ae039);

var $5wQ82 = parcelRequire("5wQ82");
function $c95c260637bde23a$export$2e2bcd8739ae039(o, p) {
    $c95c260637bde23a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))) ? (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c95c260637bde23a$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("5wQ82", function(module, exports) {

module.exports = (parcelRequire("1Ra8X"));

});
parcelRegister("1Ra8X", function(module, exports) {
parcelRequire("l16ba");

module.exports = (parcelRequire("dhx8H")).Object.setPrototypeOf;

});
parcelRegister("l16ba", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Object', {
    setPrototypeOf: (parcelRequire("35fJw")).set
});

});
parcelRegister("35fJw", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $8T9YM = parcelRequire("8T9YM");

var $aIdHH = parcelRequire("aIdHH");
var $23ee0b0348ea4da9$var$check = function(O, proto) {
    $aIdHH(O);
    if (!$8T9YM(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("8fJLB"))(Function.call, (parcelRequire("2PKjW")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $23ee0b0348ea4da9$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $23ee0b0348ea4da9$var$check
};

});
parcelRegister("2PKjW", function(module, exports) {

$parcel$export(module.exports, "f", () => $2104467c0339117f$export$2d1720544b23b823, (v) => $2104467c0339117f$export$2d1720544b23b823 = v);
var $2104467c0339117f$export$2d1720544b23b823;

var $4hWyV = parcelRequire("4hWyV");

var $dhKmr = parcelRequire("dhKmr");

var $6WitF = parcelRequire("6WitF");

var $1zpu5 = parcelRequire("1zpu5");

var $8uIdh = parcelRequire("8uIdh");

var $3Ksbk = parcelRequire("3Ksbk");
var $2104467c0339117f$var$gOPD = Object.getOwnPropertyDescriptor;

$2104467c0339117f$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? $2104467c0339117f$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $6WitF(O);
    P = $1zpu5(P, true);
    if ($3Ksbk) try {
        return $2104467c0339117f$var$gOPD(O, P);
    } catch (e) {}
    if ($8uIdh(O, P)) return $dhKmr(!$4hWyV.f.call(O, P), O[P]);
};

});
parcelRegister("4hWyV", function(module, exports) {

$parcel$export(module.exports, "f", () => $31f62d36f059d1f7$export$2d1720544b23b823, (v) => $31f62d36f059d1f7$export$2d1720544b23b823 = v);
var $31f62d36f059d1f7$export$2d1720544b23b823;
$31f62d36f059d1f7$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("34lu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c2693f2e66cfe6$export$2e2bcd8739ae039);

var $85I24 = parcelRequire("85I24");
function $23c2693f2e66cfe6$export$2e2bcd8739ae039() {
    $23c2693f2e66cfe6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($85I24))) ? (0, (/*@__PURE__*/$parcel$interopDefault($85I24))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23c2693f2e66cfe6$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("85I24", function(module, exports) {

module.exports = (parcelRequire("aOK7Q"));

});
parcelRegister("aOK7Q", function(module, exports) {
parcelRequire("8ASim");

module.exports = (parcelRequire("dhx8H")).Object.assign;

});
parcelRegister("8ASim", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S + $5wEa2.F, 'Object', {
    assign: (parcelRequire("jxu2z"))
});

});
parcelRegister("jxu2z", function(module, exports) {
'use strict';

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $cAldW = parcelRequire("cAldW");

var $4hWyV = parcelRequire("4hWyV");

var $1kVaN = parcelRequire("1kVaN");

var $jRK2B = parcelRequire("jRK2B");
var $e39866c849d56a4e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$e39866c849d56a4e$var$$assign || (parcelRequire("cbAAd"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $e39866c849d56a4e$var$$assign({}, A)[S] != 7 || Object.keys($e39866c849d56a4e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1kVaN(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $cAldW.f;
    var isEnum = $4hWyV.f;
    while(aLen > index){
        var S = $jRK2B(arguments[index++]);
        var keys = getSymbols ? $kJc9M(S).concat(getSymbols(S)) : $kJc9M(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$kD5IQ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $e39866c849d56a4e$var$$assign;

});
parcelRegister("cAldW", function(module, exports) {

$parcel$export(module.exports, "f", () => $92994f6ff34f2a23$export$2d1720544b23b823, (v) => $92994f6ff34f2a23$export$2d1720544b23b823 = v);
var $92994f6ff34f2a23$export$2d1720544b23b823;
$92994f6ff34f2a23$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("1kVaN", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return Object($5XrWm(it));
};

});






parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("dCUwp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ebaaafca6cfcfc3$export$2e2bcd8739ae039);
var $9ebaaafca6cfcfc3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9ebaaafca6cfcfc3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9ebaaafca6cfcfc3$var$safeIsNaN(first) && $9ebaaafca6cfcfc3$var$safeIsNaN(second)) return true;
    return false;
}
function $9ebaaafca6cfcfc3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9ebaaafca6cfcfc3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9ebaaafca6cfcfc3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9ebaaafca6cfcfc3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $9ebaaafca6cfcfc3$export$2e2bcd8739ae039 = $9ebaaafca6cfcfc3$var$memoizeOne;

});

parcelRegister("3YjjI", function(module, exports) {

module.exports = (parcelRequire("2NZpQ"));

});
parcelRegister("2NZpQ", function(module, exports) {
parcelRequire("jDAxN");

module.exports = (parcelRequire("dhx8H")).Object.values;

});
parcelRegister("jDAxN", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $5wEa2 = parcelRequire("5wEa2");

var $e4be01bfca6fcf6b$var$$values = (parcelRequire("24HEe"))(false);
$5wEa2($5wEa2.S, 'Object', {
    values: function values(it) {
        return $e4be01bfca6fcf6b$var$$values(it);
    }
});

});
parcelRegister("24HEe", function(module, exports) {

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $6WitF = parcelRequire("6WitF");

var $4hWyV = parcelRequire("4hWyV");
var $182dd014df77b78c$require$isEnum = $4hWyV.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $6WitF(it);
        var keys = $kJc9M(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$kD5IQ || $182dd014df77b78c$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("l1Zd2", function(module, exports) {

module.exports = (parcelRequire("3eZZ2"));

});
parcelRegister("3eZZ2", function(module, exports) {
parcelRequire("cV6iX");

module.exports = (parcelRequire("dhx8H")).Object.keys;

});
parcelRegister("cV6iX", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $1kVaN = parcelRequire("1kVaN");

var $kJc9M = parcelRequire("kJc9M");

(parcelRequire("1u1Xc"))('keys', function() {
    return function keys(it) {
        return $kJc9M($1kVaN(it));
    };
});

});
parcelRegister("1u1Xc", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $5wEa2 = parcelRequire("5wEa2");

var $dhx8H = parcelRequire("dhx8H");

var $cbAAd = parcelRequire("cbAAd");
module.exports = function(KEY, exec) {
    var fn = ($dhx8H.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $5wEa2($5wEa2.S + $5wEa2.F * $cbAAd(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("gxvYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a8875644982a16$export$2e2bcd8739ae039);
var $c0a8875644982a16$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c0a8875644982a16$export$2e2bcd8739ae039 = $c0a8875644982a16$var$rafSchd;

});

parcelRegister("5JNlj", function(module, exports) {

module.exports = (parcelRequire("fpboz"));

});
parcelRegister("fpboz", function(module, exports) {
parcelRequire("1WSQk");

module.exports = (parcelRequire("dhx8H")).Date.now;

});
parcelRegister("1WSQk", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $5wEa2 = parcelRequire("5wEa2");
$5wEa2($5wEa2.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("8kUbC", function(module, exports) {

module.exports = (parcelRequire("jmbPZ"));

});
parcelRegister("jmbPZ", function(module, exports) {
parcelRequire("hSyJ0");

module.exports = (parcelRequire("dhx8H")).Number.isInteger;

});
parcelRegister("hSyJ0", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Number', {
    isInteger: (parcelRequire("cYSpV"))
});

});
parcelRegister("cYSpV", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $8T9YM = parcelRequire("8T9YM");
var $97354cb9c31bad1d$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$8T9YM(it) && isFinite(it) && $97354cb9c31bad1d$var$floor(it) === it;
};

});





parcelRegister("lxU6z", function(module, exports) {

$parcel$export(module.exports, "GoalHeader", () => $6f7ddcb91df0c265$export$38c3814217442568);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hIjKU = parcelRequire("hIjKU");

var $6vO9v = parcelRequire("6vO9v");

var $flFqI = parcelRequire("flFqI");

var $9teIT = parcelRequire("9teIT");
const $6f7ddcb91df0c265$var$GoalHeaderComponent = ({ mode: mode })=>{
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return isSLAHierarchicalGoalsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$HeaderNewWithFF, null, mode === (0, $6vO9v.EDIT_MODE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$HandleFieldNewWithFF, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$IssuesFieldNewWithFF, null, formatMessage((0, $9teIT.default).applyToIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$CalendarFieldNewWithFF, {
        id: (0, $1ybV0.ff)('fix-jsma11y-980-issue') ? 'accessible-id-for-calendar-field' : ''
    }, formatMessage((0, $9teIT.default).calendar)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$GoalFieldNewWithFF, {
        id: (0, $1ybV0.ff)('fix-jsma11y-980-issue') ? 'accessible-id-for-time-target' : ''
    }, formatMessage((0, $9teIT.default).timeTarget))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$Header, null, mode === (0, $6vO9v.EDIT_MODE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$export$f727c8930e4da614, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$GoalField, null, formatMessage((0, $9teIT.default).timeGoal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$CalendarField, null, formatMessage((0, $9teIT.default).calendar)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7ddcb91df0c265$var$IssuesField, null, formatMessage((0, $9teIT.default).jql)));
};
const $6f7ddcb91df0c265$export$38c3814217442568 = $6f7ddcb91df0c265$var$GoalHeaderComponent; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f7ddcb91df0c265$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1n3s _1wybdlk8 _vwz4gktf _4t3izwfg _18s81bpf _1yt4h8dc",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$IssuesField = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl8vuz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f7ddcb91df0c265$var$GoalField = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1fwp",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$CalendarField = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlrw9l",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$export$f727c8930e4da614 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1vi7",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$tableColumnHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invisible: invisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1bto1l2s _k48p1kw7",
            __cmplp.invisible ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$HeaderNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1n3s _1wybdlk8 _vwz4gktf _4t3izwfg _18s81bpf _1yt4h8dc",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$HandleFieldNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6f7ddcb91df0c265$var$tableColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1vi7",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$IssuesFieldNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6f7ddcb91df0c265$var$tableColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dlexct",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$GoalFieldNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6f7ddcb91df0c265$var$tableColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1vi7",
            __cmplp.className
        ])
    });
});
const $6f7ddcb91df0c265$var$CalendarFieldNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $6f7ddcb91df0c265$var$tableColumnHeader, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlu29b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9teIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c954935408436ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c954935408436ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeGoal: {
        "id": "servicedesk-sla-settings.common.goals.goal-header.time-goal",
        "defaultMessage": "Time Goal"
    },
    timeTarget: {
        "id": "servicedesk-sla-settings.common.goals.goal-header.time-target",
        "defaultMessage": "Time target"
    },
    calendar: {
        "id": "servicedesk-sla-settings.common.goals.goal-header.calendar",
        "defaultMessage": "Calendar"
    },
    jql: {
        "id": "servicedesk-sla-settings.common.goals.goal-header.jql",
        "defaultMessage": "Issues to display (in JQL)"
    },
    applyToIssues: {
        "id": "servicedesk-sla-settings.common.goals.goal-header.apply-to-issues",
        "defaultMessage": "Apply to issues"
    }
});

});


parcelRegister("iISbO", function(module, exports) {

$parcel$export(module.exports, "AddGoalButton", () => $55b12725a543970c$export$c8e8ee27625af7f2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $bkIGg = parcelRequire("bkIGg");

var $jgrQL = parcelRequire("jgrQL");

var $blejQ = parcelRequire("blejQ");


var $5JgJ2 = parcelRequire("5JgJ2");

var $hIjKU = parcelRequire("hIjKU");

var $c4rDP = parcelRequire("c4rDP");

var $2qcWR = parcelRequire("2qcWR");
const $55b12725a543970c$var$MessageContainerForWarning = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
        primaryColor: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2qcWR.default).warningLabel))));
const $55b12725a543970c$var$MessageContainerForError = ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($blejQ))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$874739ea9e379ab6)})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2qcWR.default).errorLabel))));
const $55b12725a543970c$var$AddGoalButtonView = ({ onAddRequested: onAddRequested })=>{
    const [state] = (0, $c4rDP.useGoalCounter)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    return isSLAHierarchicalGoalsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$GoalsDisplayMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "medium"
        }),
        appearance: "link",
        onClick: onAddRequested,
        testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.add-goal-button.button"
    }, formatMessage((0, $2qcWR.default).addGoal)), state.yellowFlagForGoalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$MessageContainerForWarning, {
        formatMessage: formatMessage
    })), state.redFlagForGoalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55b12725a543970c$var$MessageContainerForError, {
        formatMessage: formatMessage
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.add-goal-button.button",
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: ""
        }),
        onClick: onAddRequested,
        shouldFitContainer: true,
        "aria-label": formatMessage((0, $2qcWR.default).addNewGoal)
    });
};
const $55b12725a543970c$export$c8e8ee27625af7f2 = $55b12725a543970c$var$AddGoalButtonView; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55b12725a543970c$var$GoalsDisplayMessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55b12725a543970c$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55b12725a543970c$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _1nx94jg8 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $55b12725a543970c$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _4cvr1h6o _ca0q1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("blejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $841cc35b0ae95138$var$_react = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $841cc35b0ae95138$var$_warning = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("ewJfY")));
function $841cc35b0ae95138$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $841cc35b0ae95138$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $841cc35b0ae95138$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $841cc35b0ae95138$var$_warning.default
    }));
$841cc35b0ae95138$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $841cc35b0ae95138$var$_default = module.exports.default = $841cc35b0ae95138$var$EditorWarningIcon;

});

parcelRegister("2qcWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc2cdef5a375dc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $efc2cdef5a375dc5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addNewGoal: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.add-new-goal",
        "defaultMessage": "Add new goal"
    },
    addGoal: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.add-goal",
        "defaultMessage": "Add goal"
    },
    warningLabel: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.warning-label",
        "defaultMessage": "You\u2019ve almost reached your goal limit for this service project."
    },
    errorLabel: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.error-label",
        "defaultMessage": "You can\u2019t add any more goals because you\u2019ve reached your goal limit for this service project."
    }
});

});


parcelRegister("j11KM", function(module, exports) {

$parcel$export(module.exports, "LimitInline", () => $e7c073ed5cdfabf7$export$2f1100120433c835);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jOdsB = parcelRequire("jOdsB");

var $giAhk = parcelRequire("giAhk");

var $1H7E7 = parcelRequire("1H7E7");

var $63S56 = parcelRequire("63S56");

var $gDsgM = parcelRequire("gDsgM");

var $8KKsZ = parcelRequire("8KKsZ");

var $3ASJd = parcelRequire("3ASJd");
const $e7c073ed5cdfabf7$var$getLimitInlinePopupView = (formatMessage, goalsLimit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8KKsZ.default).totalLimit, {
        goalsLimit: goalsLimit
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1H7E7.default), {
        ...(0, $8KKsZ.default).tipForCreatingNewGoals,
        values: {
            tagStart: `<a href="${(0, $63S56.ATLASSIAN_SUPPORT_URL)}" target="_blank"/>`,
            tagEnd: '</a>'
        }
    }));
const $e7c073ed5cdfabf7$var$LimitInlineView = ({ intl: { formatMessage: formatMessage }, goalsLimit: goalsLimit, remaining: remaining })=>{
    const limitState = (0, $3ASJd.getLimitState)(goalsLimit, remaining);
    if (limitState === (0, $gDsgM.ABOUT_TO_REACH_MAX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7c073ed5cdfabf7$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
        appearance: "info",
        title: formatMessage((0, $8KKsZ.default).aboutToReachMaxLimit, {
            remaining: remaining
        })
    }, $e7c073ed5cdfabf7$var$getLimitInlinePopupView(formatMessage, goalsLimit)));
    if (limitState === (0, $gDsgM.MAX_REACHED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7c073ed5cdfabf7$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
        appearance: "warning",
        title: formatMessage((0, $8KKsZ.default).maxReached, {
            goalsLimit: goalsLimit
        })
    }, $e7c073ed5cdfabf7$var$getLimitInlinePopupView(formatMessage, goalsLimit)));
    return null;
};
const $e7c073ed5cdfabf7$export$2f1100120433c835 = (0, $giAhk.injectIntlV2)($e7c073ed5cdfabf7$var$LimitInlineView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7c073ed5cdfabf7$var$Spaced = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOdsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ceaa73c399a515a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");


var $kDL8j = parcelRequire("kDL8j");
function $2ceaa73c399a515a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceaa73c399a515a$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $2ceaa73c399a515a$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $73a5c9d720aa66e1$export$747d86715d4175de})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $73a5c9d720aa66e1$export$a7175d4e9206bc80})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $73a5c9d720aa66e1$export$5aae31392d72caaa})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$4a7404f376229999})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $2ceaa73c399a515a$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2ceaa73c399a515a$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $2ceaa73c399a515a$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDL8j.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $2ceaa73c399a515a$export$2e2bcd8739ae039 = $2ceaa73c399a515a$var$InlineMessage;

});
parcelRegister("kDL8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39338dc4e2b071$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");


var $kAPh5 = parcelRequire("kAPh5");
function $2b39338dc4e2b071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b39338dc4e2b071$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $73a5c9d720aa66e1$export$940e1f69e873f202})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $73a5c9d720aa66e1$export$b48405b95304b5a1})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $73a5c9d720aa66e1$export$c6930421db9fa514})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
    }
};
const $2b39338dc4e2b071$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b39338dc4e2b071$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b39338dc4e2b071$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kAPh5.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b39338dc4e2b071$var$iconColor(appearance)
        },
        css: [
            $2b39338dc4e2b071$var$iconWrapperStyles,
            isOpen && $2b39338dc4e2b071$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        size: "medium"
    }));
};
var $2b39338dc4e2b071$export$2e2bcd8739ae039 = $2b39338dc4e2b071$var$SelectedIcon;

});
parcelRegister("kAPh5", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $6da7ad19346443c2$export$4d111645c0b39d5d);

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");
const $6da7ad19346443c2$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("1H7E7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b24d6ddddc3bd62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");
/**
 * Helper class to safely add HTML to translation strings.
 *
 * All HTML MUST be injected via 'values' and not be included directly in the defaultMessages.
 *
 * Also note that in order to mitigate mistranslations this component will not replace any placeholders unless all placeholders
 * can be replaced.
 */ // eslint-disable-next-line jira/react/no-class-components
class $1b24d6ddddc3bd62$var$HtmlFormattedMessage extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            values: {}
        };
    }
    componentDidUpdate() {
        this.renderTranslatedMessage(this.ref);
    }
    renderTranslatedMessage(ref) {
        if (ref) {
            const { values: values } = this.props;
            const { innerHTML: innerHTML } = ref;
            const containAllKeys = Object.keys(values).every((key)=>innerHTML.indexOf(key) !== -1);
            if (containAllKeys) {
                let newHtmlContent = innerHTML;
                Object.keys(values).forEach((key)=>{
                    newHtmlContent = newHtmlContent.replace(`{${key}}`, values[key]);
                });
                // eslint-disable-next-line no-param-reassign
                ref.innerHTML = newHtmlContent;
            }
        }
    }
    render() {
        const { intl: intl, id: id, defaultMessage: defaultMessage, values: values } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const messageTags = Object.keys(values).reduce((tags, key)=>{
            // eslint-disable-next-line no-param-reassign
            tags[key] = `{${key}}`;
            return tags;
        }, {});
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            ref: this.onRef,
            key: JSON.stringify(values)
        }, intl.formatMessage({
            id: id,
            defaultMessage: defaultMessage
        }, messageTags));
    }
    constructor(...args){
        super(...args);
        this.onRef = (ref)=>{
            this.ref = ref;
            this.renderTranslatedMessage(ref);
        };
    }
}
var $1b24d6ddddc3bd62$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($1b24d6ddddc3bd62$var$HtmlFormattedMessage);

});

parcelRegister("63S56", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_SUPPORT_URL", () => $530944d744929209$export$98c2bfe563916273);
$parcel$export(module.exports, "default", () => $530944d744929209$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $53c4R = parcelRequire("53c4R");

var $horL0 = parcelRequire("horL0");
const $530944d744929209$export$98c2bfe563916273 = 'https://support.atlassian.com/contact';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$530944d744929209$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53c4R.LimitData), {
        limitProperty: props.limitProperty
    }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $horL0.default), {
            limit: limit,
            ...props
        }));

});
parcelRegister("horL0", function(module, exports) {

$parcel$export(module.exports, "BELOW_LIMIT", () => $95e170e860a1ba10$export$46cb11fbb17b3d8f);
$parcel$export(module.exports, "NEAR_LIMIT", () => $95e170e860a1ba10$export$dfb3623c12fa3475);
$parcel$export(module.exports, "AT_LIMIT", () => $95e170e860a1ba10$export$cbfa4084a297cbaf);
$parcel$export(module.exports, "OVER_LIMIT", () => $95e170e860a1ba10$export$c87128cf180ff84);
$parcel$export(module.exports, "messageTypesByLimitStatus", () => $95e170e860a1ba10$export$2f997613feeb3dd8);
$parcel$export(module.exports, "default", () => $95e170e860a1ba10$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jOdsB = parcelRequire("jOdsB");
const $95e170e860a1ba10$export$5e1ad525018df794 = 5;
const $95e170e860a1ba10$export$46cb11fbb17b3d8f = 'BELOW_LIMIT';
const $95e170e860a1ba10$export$dfb3623c12fa3475 = 'NEAR_LIMIT';
const $95e170e860a1ba10$export$cbfa4084a297cbaf = 'AT_LIMIT';
const $95e170e860a1ba10$export$c87128cf180ff84 = 'OVER_LIMIT';
const $95e170e860a1ba10$export$2f997613feeb3dd8 = {
    [$95e170e860a1ba10$export$46cb11fbb17b3d8f]: 'info',
    [$95e170e860a1ba10$export$dfb3623c12fa3475]: 'info',
    [$95e170e860a1ba10$export$cbfa4084a297cbaf]: 'warning',
    [$95e170e860a1ba10$export$c87128cf180ff84]: 'warning'
};
class $95e170e860a1ba10$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            warningThreshold: $95e170e860a1ba10$export$5e1ad525018df794
        };
    }
    componentDidMount() {
        const limitStatus = this.getLimitStatus();
        const { onMessageRendered: onMessageRendered } = this.props;
        if (limitStatus !== $95e170e860a1ba10$export$46cb11fbb17b3d8f) onMessageRendered && onMessageRendered();
    }
    getLimitStatus() {
        const { numUsed: numUsed, limit: limit, warningThreshold: warningThreshold } = this.props;
        const remaining = limit - numUsed;
        if (remaining === 0) return $95e170e860a1ba10$export$cbfa4084a297cbaf;
        if (remaining < 0) return $95e170e860a1ba10$export$c87128cf180ff84;
        return remaining <= warningThreshold ? $95e170e860a1ba10$export$dfb3623c12fa3475 : $95e170e860a1ba10$export$46cb11fbb17b3d8f;
    }
    getMessageAndDescription(limitStatus) {
        const { limit: limit } = this.props;
        if (limitStatus === $95e170e860a1ba10$export$dfb3623c12fa3475) return [
            this.props.renderNearLimitMessage(limit),
            this.props.renderNearLimitDescription(limit)
        ];
        if (limitStatus === $95e170e860a1ba10$export$cbfa4084a297cbaf) return [
            this.props.renderAtLimitMessage(limit),
            this.props.renderAtLimitDescription(limit)
        ];
        return [
            this.props.renderOverLimitMessage(limit),
            this.props.renderOverLimitDescription(limit)
        ];
    }
    render() {
        const limitStatus = this.getLimitStatus();
        if (limitStatus === $95e170e860a1ba10$export$46cb11fbb17b3d8f) return null;
        const messageType = $95e170e860a1ba10$export$2f997613feeb3dd8[limitStatus];
        const [message, description] = this.getMessageAndDescription(limitStatus);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
            appearance: messageType,
            title: message
        }, description);
    }
}

});


parcelRegister("8KKsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad597d575feba2c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ad597d575feba2c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    maxReached: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.max-reached",
        "defaultMessage": "You've reached the limit of {goalsLimit} SLA {goalsLimit, plural, one {goal} other {goals}} in this project."
    },
    aboutToReachMaxLimit: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.about-to-reach-max-limit",
        "defaultMessage": "You can create {remaining} more SLA {remaining, plural, one {goal} other {goals}} in this project."
    },
    totalLimit: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.total-limit",
        "defaultMessage": "There's a limit of {goalsLimit} SLA {goalsLimit, plural, one {goal} other {goals}} in this project."
    },
    tipForCreatingNewGoals: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.tip-for-creating-new-goals",
        "defaultMessage": "You can delete some, or {tagStart}contact Atlassian Support{tagEnd} for more."
    }
});

});

parcelRegister("3ASJd", function(module, exports) {

$parcel$export(module.exports, "getLimitState", () => $7d17a1b352d284c3$export$949a97b42f95d3b4);

var $gDsgM = parcelRequire("gDsgM");
const $7d17a1b352d284c3$export$949a97b42f95d3b4 = (maxGoals, remainingGoals)=>{
    if (remainingGoals < 1) return 0, $gDsgM.MAX_REACHED;
    if (remainingGoals <= (0, $gDsgM.SHOW_WARNING_THRESHOLD)) return 0, $gDsgM.ABOUT_TO_REACH_MAX;
    return 0, $gDsgM.RESTING;
};

});


parcelRegister("iMhys", function(module, exports) {

$parcel$export(module.exports, "GoalListView", () => $ff5bebaf3bae1422$export$2084f441c7fd63d6);

var $eUqFw = parcelRequire("eUqFw");

var $iSEfF = parcelRequire("iSEfF");

var $c4rDP = parcelRequire("c4rDP");

var $kLRSQ = parcelRequire("kLRSQ");
const $ff5bebaf3bae1422$export$2084f441c7fd63d6 = ({ goals: goals, setGoals: setGoals, isDraggable: isDraggable, getFormValues: getFormValues })=>{
    const [, { setFormStatusToDirty: setFormStatusToDirty }] = (0, $iSEfF.useFormContext)();
    const [, actions] = (0, $c4rDP.useGoalCounter)();
    const onRemoveGoal = (removedGoalIndex)=>{
        const goalsAfterRemoval = goals.filter((_, index)=>index !== removedGoalIndex);
        setGoals(goalsAfterRemoval);
        setFormStatusToDirty();
        actions.decrementGoalCounter();
    };
    // @ts-expect-error - TS7006 - Parameter 'updatedGoal' implicitly has an 'any' type.
    const onSaveGoal = (removedGoalIndex, updatedGoal)=>{
        const modifiedGoals = [
            ...goals
        ];
        const [goalToBeUpdated] = modifiedGoals.splice(removedGoalIndex, 1);
        modifiedGoals.splice(removedGoalIndex, 0, {
            ...goalToBeUpdated,
            ...updatedGoal
        });
        setGoals(modifiedGoals);
        setFormStatusToDirty();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, goals.map((goal, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kLRSQ.EditableGoalField), {
            key: goal.id,
            goal: goal,
            index: index,
            onRemoveGoal: ()=>onRemoveGoal(index),
            onSaveGoal: (modifiedGoal)=>onSaveGoal(index, modifiedGoal),
            isDraggable: isDraggable,
            getFormValues: getFormValues
        })));
};

});
parcelRegister("kLRSQ", function(module, exports) {

$parcel$export(module.exports, "EditableGoalField", () => $eaf6fe305c01e34d$export$17cad2a0219dd279);

var $eUqFw = parcelRequire("eUqFw");

var $966Wa = parcelRequire("966Wa");


var $jWbaK = parcelRequire("jWbaK");
// @ts-expect-error - TS2304 - Cannot find name 'DraggableStyle'.
const $eaf6fe305c01e34d$var$getItemStyle = (isDragging, draggableStyle)=>({
        userSelect: 'none',
        padding: "var(--ds-space-025, 2px)",
        background: isDragging ? `var(--ds-surface, ${(0, $73a5c9d720aa66e1$exports).N10})` : 'transparent',
        ...draggableStyle
    });
const $eaf6fe305c01e34d$export$17cad2a0219dd279 = ({ index: index, goal: goal, onRemoveGoal: onRemoveGoal, isDraggable: isDraggable, onSaveGoal: onSaveGoal, getFormValues: getFormValues })=>{
    if (isDraggable === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Draggable), {
        "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.draggable",
        draggableId: goal.id,
        index: index
    }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $eaf6fe305c01e34d$var$getItemStyle(snapshot.isDragging, provided.draggableProps.style)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWbaK.EditableGoal), {
            index: index,
            goal: goal,
            onSaveGoal: onSaveGoal,
            onRemoveGoal: onRemoveGoal,
            getFormValues: getFormValues
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWbaK.EditableGoal), {
        index: index,
        goal: goal,
        onSaveGoal: onSaveGoal,
        onRemoveGoal: onRemoveGoal,
        getFormValues: getFormValues
    });
};

});
parcelRegister("jWbaK", function(module, exports) {

$parcel$export(module.exports, "EditableGoal", () => $744f91008b3da433$export$4b0610de89d4f2a5);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $7d1RI = parcelRequire("7d1RI");

var $gDsgM = parcelRequire("gDsgM");

var $flFqI = parcelRequire("flFqI");

var $fK421 = parcelRequire("fK421");

var $j0wWH = parcelRequire("j0wWH");

var $hIjKU = parcelRequire("hIjKU");

var $gbOGR = parcelRequire("gbOGR");

var $f4UgR = parcelRequire("f4UgR");

var $2zs8L = parcelRequire("2zs8L");

var $lCXwi = parcelRequire("lCXwi");

var $kT9hk = parcelRequire("kT9hk");

var $b3T6Y = parcelRequire("b3T6Y");

var $9OCTG = parcelRequire("9OCTG");

var $hY53D = parcelRequire("hY53D");

var $2CEAJ = parcelRequire("2CEAJ");

var $9eLlO = parcelRequire("9eLlO");

var $fshOk = parcelRequire("fshOk");
const $744f91008b3da433$export$86edce849547d281 = ({ intl: { formatMessage: formatMessage }, onRemoveGoal: onRemoveGoal, index: index, onSaveGoal: onSaveGoal, goal: goal, getFormValues: getFormValues })=>{
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    const [{ error: jqlValidationError, loading: loading }, { onValidateJql: onValidateJql, onCancel: onSaveCancel }] = // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $gbOGR.useValidateJQLService)(baseUrl);
    const [editingState, setEditingState] = (0, $eUqFw.useState)({
        isEditing: false,
        componentTriggerEdit: undefined
    });
    const { isEditing: isEditing, componentTriggerEdit: componentTriggerEdit } = editingState;
    const onToggleEditing = (0, $eUqFw.useCallback)((componentName)=>{
        setEditingState({
            isEditing: !isEditing,
            // @ts-expect-error - TS2322 - Type 'EditComponentName | undefined' is not assignable to type 'undefined'.
            componentTriggerEdit: componentName
        });
    }, [
        isEditing
    ]);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        // cancel on new goal should remove newly added goal
        // cancel on existing goals should reset goal state
        if (goal.fieldState === (0, $gDsgM.NEW)) onRemoveGoal();
        else {
            onSaveGoal(goal);
            onToggleEditing();
        }
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        onSaveCancel();
    }, [
        goal,
        onRemoveGoal,
        onSaveCancel,
        onSaveGoal,
        onToggleEditing
    ]);
    const [subGoals, setSubGoals, onAppendNewSubGoal] = (0, $9eLlO.useSubGoalsState)(goal.subGoals, goal);
    const onInputChange = (0, $eUqFw.useCallback)((defaultGoal = false)=>{
        const { calendarId: calendarId, duration: duration, subGoals: newSubGoals = [] } = (0, $fK421.getSubGoalValuesById)(getFormValues(), goal.id, subGoals, defaultGoal);
        setSubGoals(newSubGoals);
        onSaveGoal({
            ...goal,
            calendarId: calendarId,
            duration: (0, $j0wWH.formatDurationOnSave)(duration, formatMessage),
            subGoals: newSubGoals,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'GoalFieldState | undefined'
            fieldState: (0, $fshOk.getNextGoalState)(goal.fieldState)
        });
        onToggleEditing();
    }, [
        getFormValues,
        goal,
        subGoals,
        setSubGoals,
        onSaveGoal,
        formatMessage,
        onToggleEditing
    ]);
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }, { updatePrioritiesConsumed: updatePrioritiesConsumed }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    const onSave = (0, $eUqFw.useCallback)(async ()=>{
        // fetch values from form
        if (isSLAHierarchicalGoalsEnabled) {
            const { calendarId: calendarId, jqlQuery: jqlQuery, duration: duration, subGoals: newSubGoals = [] } = (0, $fK421.getSubGoalValuesById)(getFormValues(), goal.id, subGoals);
            const response = await onValidateJql({
                jqlQuery: jqlQuery,
                defaultGoal: goal.defaultGoal
            });
            if (response) {
                setSubGoals(newSubGoals);
                onSaveGoal({
                    ...goal,
                    calendarId: calendarId,
                    jqlQuery: jqlQuery,
                    duration: (0, $j0wWH.formatDurationOnSave)(duration, formatMessage),
                    subGoals: newSubGoals,
                    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'GoalFieldState | undefined'
                    fieldState: (0, $fshOk.getNextGoalState)(goal.fieldState)
                });
                onToggleEditing();
            }
        } else {
            const { calendarId: calendarId, jqlQuery: jqlQuery, duration: duration } = (0, $fK421.getGoalValuesById)(getFormValues(), goal.id);
            const response = await onValidateJql({
                jqlQuery: jqlQuery,
                defaultGoal: goal.defaultGoal
            });
            if (response) {
                onSaveGoal({
                    ...goal,
                    calendarId: calendarId,
                    jqlQuery: jqlQuery,
                    duration: (0, $j0wWH.formatDurationOnSave)(duration, formatMessage),
                    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'GoalFieldState | undefined'.
                    fieldState: (0, $fshOk.getNextGoalState)(goal.fieldState)
                });
                onToggleEditing();
            }
        }
    }, [
        goal,
        subGoals,
        isSLAHierarchicalGoalsEnabled,
        getFormValues,
        setSubGoals,
        onValidateJql,
        onSaveGoal,
        formatMessage,
        onToggleEditing
    ]);
    const onRemoveSubGoal = (removedSubGoalIndex)=>{
        const subGoalsAfterRemoval = subGoals.filter((_, subGoalIndex)=>subGoalIndex !== removedSubGoalIndex);
        setSubGoals(subGoalsAfterRemoval);
        onSaveGoal({
            ...goal,
            subGoals: subGoalsAfterRemoval,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'GoalFieldState | undefined'
            fieldState: (0, $fshOk.getNextGoalState)(goal.fieldState)
        });
    };
    const onJqlEditRequested = (0, $eUqFw.useCallback)(()=>{
        onToggleEditing('jql');
    }, [
        onToggleEditing
    ]);
    const onDurationEditRequested = (0, $eUqFw.useCallback)(()=>{
        onToggleEditing('duration');
    }, [
        onToggleEditing
    ]);
    const onCalendarEditRequested = (0, $eUqFw.useCallback)(()=>{
        onToggleEditing('calendar');
    }, [
        onToggleEditing
    ]);
    const onPriorityEditRequested = (0, $eUqFw.useCallback)(()=>{
        onToggleEditing('priority');
    }, [
        onToggleEditing
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const prioritiesSelected = subGoals.map((subGoal)=>{
            const [_, value] = subGoal.jqlQuery.split('=');
            const trimmedValue = value?.trim().replace(/^"+|"+$/g, '');
            return trimmedValue;
        });
        updatePrioritiesConsumed(goal.metricId, goal.id, prioritiesSelected);
    }, [
        subGoals,
        goal,
        updatePrioritiesConsumed
    ]);
    return isSLAHierarchicalGoalsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalContainer, {
        "data-testid": `servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.goal-container-${goal.id}`
    }, !goal.defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldWrapper, {
        invisible: goal.defaultGoal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCXwi.DraggableField), {
        id: goal.id,
        index: index,
        label: formatMessage((0, $9OCTG.default).dragGoal),
        isDefaultGoal: goal.defaultGoal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$JqlFieldWrapperNew, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3T6Y.JqlField), {
        focusOnEdit: true,
        id: goal.id,
        metricId: goal.metricId,
        onEditRequested: onJqlEditRequested,
        isEditing: true,
        defaultGoal: goal.defaultGoal,
        jqlQuery: goal.jqlQuery,
        jqlValidationError: jqlValidationError,
        validateJQL: onSave,
        areSubGoalsPresent: !!subGoals?.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$CalendarFieldWrapperNew, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalFieldWrapperNew, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$RemoveGoalWrapper, null, !goal.defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CEAJ.RemoveGoalButton), {
        onRemove: onRemoveGoal
    }))), !goal.defaultGoal && subGoals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldWrapper, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $744f91008b3da433$var$propertyHeaderStyles
    }, formatMessage((0, $9OCTG.default).priorityHeader))), subGoals.map((subGoal, subGoalIndex)=>{
        const [key, value] = subGoal.jqlQuery.split('=');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$TableRow, {
            key: subGoal.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldPlaceholderWithFF, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$SubGoalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$PriorityFieldWrapperNewWithFF, null, (key === undefined || key.trim() === 'priority') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hY53D.default), {
            focusOnEdit: componentTriggerEdit === 'priority',
            id: subGoal.id,
            goalId: goal.id,
            metricId: goal.metricId,
            onEditRequested: onPriorityEditRequested,
            selectedPriority: value.trim(),
            onChange: ()=>onInputChange(false),
            isEditing: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$CalendarFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zs8L.CalendarSelectField), {
            focusOnEdit: componentTriggerEdit === 'calendar',
            id: subGoal.id,
            goalId: goal.id,
            calendarId: subGoal.calendarId,
            onEditRequested: onCalendarEditRequested,
            onChange: ()=>onInputChange(false),
            isEditing: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kT9hk.DurationField), {
            focusOnEdit: componentTriggerEdit === 'duration',
            id: subGoal.id,
            goalId: goal.id,
            duration: subGoal.duration,
            onEditRequested: onDurationEditRequested,
            onChange: ()=>onInputChange(false),
            isEditing: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$RemoveGoalWrapper, null, !goal.defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CEAJ.RemoveGoalButton), {
            onRemove: ()=>onRemoveSubGoal(subGoalIndex)
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$TableRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldPlaceholderWithFF, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$SubGoalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$JqlPlaceholderWithFF, null, subGoals?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $9OCTG.default).allRemainingPriorities)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $9OCTG.default).allMatchingPriorities))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$CalendarFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zs8L.CalendarSelectField), {
        focusOnEdit: componentTriggerEdit === 'calendar',
        id: goal.id,
        goalId: "goal",
        calendarId: goal.calendarId,
        onEditRequested: onCalendarEditRequested,
        onChange: ()=>onInputChange(false),
        isEditing: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kT9hk.DurationField), {
        focusOnEdit: componentTriggerEdit === 'duration',
        id: goal.id,
        goalId: "goal",
        duration: goal.duration,
        onEditRequested: onDurationEditRequested,
        onChange: ()=>onInputChange(false),
        isEditing: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$RemoveGoalWrapper, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldPlaceholder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$AddPriorityButton, {
        appearance: "subtle",
        onClick: onAppendNewSubGoal,
        testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.add-priority-button"
    }, formatMessage((0, $9OCTG.default).addPriority)))), goal.defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$TableRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldWrapper, {
        invisible: goal.defaultGoal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCXwi.DraggableField), {
        id: goal.id,
        index: index,
        label: formatMessage((0, $9OCTG.default).dragGoal),
        isDefaultGoal: goal.defaultGoal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$PriorityFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3T6Y.JqlField), {
        focusOnEdit: true,
        id: goal.id,
        onEditRequested: onJqlEditRequested,
        isEditing: true,
        defaultGoal: goal.defaultGoal,
        jqlQuery: goal.jqlQuery,
        jqlValidationError: jqlValidationError,
        validateJQL: onSave
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$CalendarFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zs8L.CalendarSelectField), {
        focusOnEdit: componentTriggerEdit === 'calendar',
        id: goal.id,
        goalId: "goal",
        calendarId: goal.calendarId,
        onEditRequested: onCalendarEditRequested,
        isEditing: true,
        onChange: ()=>onInputChange(true)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalFieldWrapperNewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kT9hk.DurationField), {
        focusOnEdit: componentTriggerEdit === 'duration',
        id: goal.id,
        goalId: "goal",
        duration: goal.duration,
        onEditRequested: onDurationEditRequested,
        onChange: ()=>onInputChange(true),
        isEditing: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$RemoveGoalWrapper, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $fK421.toGoalField)(goal.id),
        defaultValue: {
            ...goal,
            subGoals: subGoals
        }
    }, ()=>null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalContainer, {
        "data-testid": `servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.goal-container-${goal.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$HandleFieldWrapper, {
        invisible: goal.defaultGoal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCXwi.DraggableField), {
        id: goal.id,
        index: index,
        label: formatMessage((0, $9OCTG.default).dragGoal),
        isDefaultGoal: goal.defaultGoal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kT9hk.DurationField), {
        focusOnEdit: componentTriggerEdit === 'duration',
        id: goal.id,
        duration: goal.duration,
        onEditRequested: onDurationEditRequested,
        isEditing: isEditing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$CalendarFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2zs8L.CalendarSelectField), {
        focusOnEdit: componentTriggerEdit === 'calendar',
        id: goal.id,
        calendarId: goal.calendarId,
        onEditRequested: onCalendarEditRequested,
        isEditing: isEditing
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$JqlFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b3T6Y.JqlField), {
        focusOnEdit: componentTriggerEdit === 'jql',
        id: goal.id,
        onEditRequested: onJqlEditRequested,
        isEditing: isEditing,
        defaultGoal: goal.defaultGoal,
        jqlQuery: goal.jqlQuery,
        jqlValidationError: jqlValidationError
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$RemoveGoalWrapper, null, !isEditing && !goal.defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CEAJ.RemoveGoalButton), {
        onRemove: onRemoveGoal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $fK421.toGoalField)(goal.id),
        defaultValue: goal
    }, ()=>null), isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($744f91008b3da433$var$GoalActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4UgR.GoalActions), {
        id: goal.id,
        isDefaultGoal: goal.defaultGoal,
        loading: loading,
        onSaveGoal: onSave,
        onCancel: onCancel
    })));
};
const $744f91008b3da433$export$4b0610de89d4f2a5 = (0, $giAhk.injectIntlV2)($744f91008b3da433$export$86edce849547d281); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$GoalContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _2rko1l7b _16qs1j00 _11q7hp5a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$GoalActionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt46lav _19pk10v4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$JqlFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl1fwp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$GoalFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlfyhu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$CalendarFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlrw9l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$JqlFieldWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jl11wp _1o9zkb7n _i0dlu29b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$GoalFieldWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlexct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$CalendarFieldWrapperNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dlfyhu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$HandleFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66 _16jlidpf _1o9zkb7n _i0dlexct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$RemoveGoalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _16jlidpf _1o9zkb7n _i0dl1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$HandleFieldPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1vi7",
            __cmplp.className
        ])
    });
});
const $744f91008b3da433$var$propertyHeaderStyles = (0, $1ZAYh.xcss)({
    marginInlineStart: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$AddPriorityButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ahbq1y44 _1tjq1vl3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$SubGoalContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _1yt41b66 _18s81r6r _16qs1os1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$TableRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$tableColumnNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invisible: invisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1bto1l2s",
            __cmplp.invisible ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$PriorityFieldWrapperNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $744f91008b3da433$var$tableColumnNewWithFF, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$JqlPlaceholderWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $744f91008b3da433$var$PriorityFieldWrapperNewWithFF, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _uimgutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$GoalFieldWrapperNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $744f91008b3da433$var$tableColumnNewWithFF, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlexct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$CalendarFieldWrapperNewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $744f91008b3da433$var$tableColumnNewWithFF, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dlfyhu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $744f91008b3da433$var$HandleFieldPlaceholderWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $744f91008b3da433$var$tableColumnNewWithFF, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1vi7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fK421", function(module, exports) {

$parcel$export(module.exports, "toGoalField", () => $cdecf631c38014ae$export$465cfbc8efc39830);
$parcel$export(module.exports, "toGoalDurationFieldName", () => $cdecf631c38014ae$export$8439fa27f90ade1a);
$parcel$export(module.exports, "toGoalCalendarFieldName", () => $cdecf631c38014ae$export$681c9b62db43a6d2);
$parcel$export(module.exports, "toGoalJqlFieldName", () => $cdecf631c38014ae$export$bc5808758c73ac7);
$parcel$export(module.exports, "toRowIndexTrackerFieldName", () => $cdecf631c38014ae$export$d61491fd7adcb01);
$parcel$export(module.exports, "toEditableActionFieldName", () => $cdecf631c38014ae$export$29e1c44a596517f8);
$parcel$export(module.exports, "getGoalValuesById", () => $cdecf631c38014ae$export$369df8c87c9dec5b);
$parcel$export(module.exports, "toSubGoalPriorityFieldName", () => $cdecf631c38014ae$export$7eb519d51b2ee7dd);
$parcel$export(module.exports, "toSubGoalCalendarFieldName", () => $cdecf631c38014ae$export$ec4579d607832277);
$parcel$export(module.exports, "toSubGoalDurationFieldName", () => $cdecf631c38014ae$export$7be43b9a1038505a);
$parcel$export(module.exports, "getSubGoalValuesById", () => $cdecf631c38014ae$export$f6a8da164ae12c02);

var $gDsgM = parcelRequire("gDsgM");
const $cdecf631c38014ae$export$2039c067f3ba194f = (isEditing)=>`${0, $gDsgM.GOAL_FIELD_GROUP}${isEditing ? (0, $gDsgM.READ_ONLY) : (0, $gDsgM.EDITABLE)}`;
const $cdecf631c38014ae$export$465cfbc8efc39830 = (fieldId)=>`${$cdecf631c38014ae$export$2039c067f3ba194f(true)}${fieldId}`;
const $cdecf631c38014ae$export$8439fa27f90ade1a = (fieldId, isEditing)=>`${$cdecf631c38014ae$export$2039c067f3ba194f(isEditing)}${0, $gDsgM.DURATION_FIELD_NAME}${fieldId}`;
const $cdecf631c38014ae$export$681c9b62db43a6d2 = (fieldId, isEditing)=>`${$cdecf631c38014ae$export$2039c067f3ba194f(isEditing)}${0, $gDsgM.CALENDAR_FIELD_NAME}${fieldId}`;
const $cdecf631c38014ae$export$bc5808758c73ac7 = (fieldId, isEditing)=>`${$cdecf631c38014ae$export$2039c067f3ba194f(isEditing)}${0, $gDsgM.JQL_FIELD_NAME}${fieldId}`;
const $cdecf631c38014ae$export$d61491fd7adcb01 = (fieldId, isDefaultGoal)=>`${isDefaultGoal ? `${0, $gDsgM.DEFAULT_GOAL_ROW_INDEX_TRACKER}${fieldId}` : `${0, $gDsgM.ROW_INDEX_TRACKER}${fieldId}`}`;
const $cdecf631c38014ae$export$29e1c44a596517f8 = (fieldId)=>`${0, $gDsgM.GOAL_FIELD_GROUP}${0, $gDsgM.VALIDATE_GOAL_FIELD}${fieldId}`;
const $cdecf631c38014ae$export$369df8c87c9dec5b = (formValues, fieldId)=>{
    const isEditing = Boolean(formValues[$cdecf631c38014ae$export$29e1c44a596517f8(fieldId)]);
    const duration = formValues[$cdecf631c38014ae$export$8439fa27f90ade1a(fieldId, isEditing)];
    const calendarId = formValues[$cdecf631c38014ae$export$681c9b62db43a6d2(fieldId, isEditing)]?.value;
    const jqlQuery = formValues[$cdecf631c38014ae$export$bc5808758c73ac7(fieldId, isEditing)];
    return {
        jqlQuery: jqlQuery,
        duration: duration,
        calendarId: calendarId
    };
};
const $cdecf631c38014ae$export$7eb519d51b2ee7dd = (goalId, subGoalId)=>`${(0, $gDsgM.GOAL_FIELD_GROUP) + (0, $gDsgM.PRIORITY_FIELD_NAME) + goalId}-${subGoalId}`;
const $cdecf631c38014ae$export$ec4579d607832277 = (goalId = '', subGoalId)=>`${(0, $gDsgM.GOAL_FIELD_GROUP) + (0, $gDsgM.CALENDAR_FIELD_NAME) + goalId}-${subGoalId}`;
const $cdecf631c38014ae$export$7be43b9a1038505a = (goalId = '', subGoalId)=>`${(0, $gDsgM.GOAL_FIELD_GROUP) + (0, $gDsgM.DURATION_FIELD_NAME) + goalId}-${subGoalId}`;
const $cdecf631c38014ae$export$f6a8da164ae12c02 = (formValues, goalId, subGoals, defaultGoal)=>{
    const duration = formValues[$cdecf631c38014ae$export$7be43b9a1038505a('goal', goalId)];
    const { label: calendarName, value: calendarId } = formValues[$cdecf631c38014ae$export$ec4579d607832277('goal', goalId)];
    const jqlQuery = formValues[$cdecf631c38014ae$export$bc5808758c73ac7(goalId, true)];
    const newSubGoals = defaultGoal ? [] : subGoals?.map((subgoal)=>({
            ...subgoal,
            duration: formValues[$cdecf631c38014ae$export$7be43b9a1038505a(goalId, subgoal.id)],
            calendarName: formValues[$cdecf631c38014ae$export$ec4579d607832277(goalId, subgoal.id)]?.label,
            calendarId: formValues[$cdecf631c38014ae$export$ec4579d607832277(goalId, subgoal.id)]?.value,
            jqlQuery: `priority = "${formValues[$cdecf631c38014ae$export$7eb519d51b2ee7dd(goalId, subgoal.id)].value?.replace(/^"+|"+$/g, '')}"`
        }));
    return {
        jqlQuery: jqlQuery,
        duration: duration,
        calendarId: calendarId,
        calendarName: calendarName,
        subGoals: newSubGoals
    };
};

});

parcelRegister("j0wWH", function(module, exports) {

$parcel$export(module.exports, "validateDuration", () => $dd5f22e73ecdd052$export$4f5e1de10b8c6f46);
$parcel$export(module.exports, "formatDurationOnSave", () => $dd5f22e73ecdd052$export$9348f169e8c2ccfd);
$parcel$export(module.exports, "validateJql", () => $dd5f22e73ecdd052$export$63510a0ba560c50c);
$parcel$export(module.exports, "validateGoal", () => $dd5f22e73ecdd052$export$a294498f46bc0d96);

var $ldoFd = parcelRequire("ldoFd");

var $6vO9v = parcelRequire("6vO9v");

var $gDsgM = parcelRequire("gDsgM");

var $6TYc5 = parcelRequire("6TYc5");
const $dd5f22e73ecdd052$export$4f5e1de10b8c6f46 = (timeGoalValue = '', formatMessage)=>{
    const inputValue = timeGoalValue.trim();
    if (inputValue.length > 0) {
        const ms = (0, $6TYc5.durationToMilliseconds)(inputValue, formatMessage);
        if (Number.isNaN(ms) || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(ms) || ms < 0) return 0, $6vO9v.INVALID_FORMAT;
    }
    return undefined;
};
const $dd5f22e73ecdd052$export$f033fe09bfbbeb73 = (timeGoalValueInMs)=>Math.min(timeGoalValueInMs, (0, $6vO9v.MAX_GOAL_HOUR));
const $dd5f22e73ecdd052$export$9348f169e8c2ccfd = (goalDuration = '', formatMessage)=>{
    const timeGoalValueInMs = (0, $6TYc5.durationToMilliseconds)(goalDuration.trim(), formatMessage);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(timeGoalValueInMs)) return '';
    return (0, $6TYc5.durationToHumanReadable)($dd5f22e73ecdd052$export$f033fe09bfbbeb73(timeGoalValueInMs), formatMessage);
};
const $dd5f22e73ecdd052$export$63510a0ba560c50c = (jql = '', isDefaultGoal = false)=>{
    // default goal will always have empty jql
    // no validation required if goal is default
    if (isDefaultGoal) return undefined;
    const inputValue = jql.trim();
    if (inputValue.length < 1) return 0, $gDsgM.EMPTY_JQL;
    return undefined;
};
const $dd5f22e73ecdd052$export$a294498f46bc0d96 = (duration, jql, isDefaultGoal, formatMessage)=>{
    const durationFieldError = $dd5f22e73ecdd052$export$4f5e1de10b8c6f46(duration, formatMessage);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(durationFieldError)) return durationFieldError;
    return undefined;
};

});

parcelRegister("gbOGR", function(module, exports) {

$parcel$export(module.exports, "useValidateJQLService", () => $08fd4ca0e561fe7d$export$4ca76c9737c9ca24);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $j0wWH = parcelRequire("j0wWH");

var $aAFhE = parcelRequire("aAFhE");

var $9LMcR = parcelRequire("9LMcR");
const $08fd4ca0e561fe7d$var$getJQLErrorMessage = (jqlValidationError, formatMessage)=>{
    if (jqlValidationError) return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(jqlValidationError, 'errors[0].error') || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(jqlValidationError, 'message') || formatMessage((0, $aAFhE.default).genericErrorMessage);
    return null;
};
const $08fd4ca0e561fe7d$export$4ca76c9737c9ca24 = (baseUrl)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onValidateJql = (0, $eUqFw.useCallback)(async (validateJQLRequest)=>{
        setLoading(true);
        setError(null);
        const localValidationResult = (0, $j0wWH.validateJql)(validateJQLRequest.jqlQuery, validateJQLRequest.defaultGoal);
        if (localValidationResult !== undefined) {
            setError(localValidationResult);
            setLoading(false);
            return false;
        }
        try {
            await (0, $lRmyA.performPutRequest)((0, $9LMcR.getUrl)(baseUrl), {
                body: JSON.stringify(validateJQLRequest),
                method: 'PUT'
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaJQL validated');
            setLoading(false);
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const jqlErrorMessage = $08fd4ca0e561fe7d$var$getJQLErrorMessage(err, formatMessage);
            setError(jqlErrorMessage);
            setLoading(false);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useValidateJQLService',
                packageName: 'jiraServicedeskSlaSettings'
            });
            return false;
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        formatMessage
    ]);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        setError(null);
    }, [
        setError
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'JqlValidationErrors | undefined'.
            error
        },
        {
            onValidateJql: onValidateJql,
            onCancel: onCancel
        }
    ];
};

});
parcelRegister("aAFhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf14bbd0fcc931e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ccf14bbd0fcc931e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    genericErrorMessage: {
        "id": "servicedesk-sla-settings.services.jql-validation.generic-error-message",
        "defaultMessage": "Something has gone wrong. An error has occurred."
    }
});

});

parcelRegister("9LMcR", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $3a1fc76fd386e3b7$export$94df0e59ebebf4a7);
const $3a1fc76fd386e3b7$export$94df0e59ebebf4a7 = (baseUrl)=>`${baseUrl}/rest/servicedesk/1/agent/sla/metric/goal/validate?operation=validateGoalJQL`;

});


parcelRegister("f4UgR", function(module, exports) {

$parcel$export(module.exports, "GoalActions", () => $23d3db59f0df0118$export$2ef5cea62f3e66ec);

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $4LhB6 = parcelRequire("4LhB6");
var $7CD1S = parcelRequire("7CD1S");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fK421 = parcelRequire("fK421");

var $j0wWH = parcelRequire("j0wWH");

var $62Hlq = parcelRequire("62Hlq");
const $23d3db59f0df0118$var$GoalActionsView = ({ id: id, loading: loading, isDefaultGoal: isDefaultGoal, onSaveGoal: onSaveGoal, onCancel: onCancel })=>{
    const fieldName = (0, $fK421.toEditableActionFieldName)(id);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onValidate = (_, formData)=>{
        const { jqlQuery: jqlQuery, duration: duration } = (0, $fK421.getGoalValuesById)(formData, id);
        return (0, $j0wWH.validateGoal)(duration, jqlQuery, isDefaultGoal, formatMessage);
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: fieldName,
        defaultValue: true,
        validate: onValidate
    }, ({ valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
            appearance: "primary",
            isDisabled: !valid,
            onClick: onSaveGoal,
            isLoading: loading,
            testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.actions.save-button"
        }, formatMessage((0, $62Hlq.default).save)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.actions.cancel-button",
            onClick: onCancel
        }, formatMessage((0, $62Hlq.default).cancel)))));
};
const $23d3db59f0df0118$export$2ef5cea62f3e66ec = $23d3db59f0df0118$var$GoalActionsView;

});
parcelRegister("62Hlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $69be0f7c29aa8f62$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69be0f7c29aa8f62$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    save: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.actions.save",
        "defaultMessage": "Save"
    },
    cancel: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.actions.cancel",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("2zs8L", function(module, exports) {

$parcel$export(module.exports, "CalendarSelectField", () => $6b48fb1570f24b36$export$8c7af73b1673084);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $kMHOY = parcelRequire("kMHOY");

var $29yDk = parcelRequire("29yDk");

var $2yRWX = parcelRequire("2yRWX");

var $5wCDk = parcelRequire("5wCDk");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fK421 = parcelRequire("fK421");

var $hIjKU = parcelRequire("hIjKU");

var $jwvob = parcelRequire("jwvob");

var $1Fqyf = parcelRequire("1Fqyf");

var $cthm0 = parcelRequire("cthm0");
const $6b48fb1570f24b36$export$8c7af73b1673084 = ({ id: id, goalId: goalId, isEditing: isEditing, onEditRequested: onEditRequested, focusOnEdit: focusOnEdit = false, calendarId: calendarId, onChange: // eslint-disable-next-line @typescript-eslint/no-empty-function
onChange = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ data: data }] = (0, $jwvob.useMetricResource)();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    let fieldName;
    if (isSLAHierarchicalGoalsEnabled) fieldName = (0, $fK421.toSubGoalCalendarFieldName)(goalId, id);
    else fieldName = (0, $fK421.toGoalCalendarFieldName)(id, isEditing);
    const calendarOptions = (0, $eUqFw.useMemo)(()=>(0, $cthm0.formatOptions)(data?.calendarRefs ?? []), [
        data
    ]);
    const akSelectRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        isEditing && focusOnEdit && akSelectRef.current?.focus();
        // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        !isEditing && document?.activeElement?.blur();
    }, [
        focusOnEdit,
        isEditing
    ]);
    const defaultValue = (0, $eUqFw.useMemo)(()=>{
        const selectedCalendarOption = calendarOptions.find((option)=>calendarId === option.value);
        if (selectedCalendarOption) return selectedCalendarOption;
        const defaultCalendarOption = calendarOptions.find(({ isDefaultOption: isDefaultOption })=>isDefaultOption);
        return defaultCalendarOption;
    }, [
        calendarId,
        calendarOptions
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps: { value, ...rest } }: { fieldProps: FieldProps<CalendarSelectOption, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; focus: true; name: string; defaultValue: CalendarSelectOption | undefined; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<CalendarSelectOption, HTMLInputElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        focus: true,
        name: fieldName,
        defaultValue: defaultValue
    }, ({ fieldProps: { value: value, ...rest } })=>// @ts-expect-error - TS2741 - Property 'defaultValue' is missing in type '{ editView: ({ errorMessage, isInvalid }: ExtendedFieldProps<string>) => Element; readView: () => Element; isEditing: boolean; onConfirm: () => void; onEdit: () => void; hideActionButtons: true; readViewFitContainerWidth: true; }' but required in type 'InlineEditProps<string>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
            editView: ({ errorMessage: errorMessage, isInvalid: isInvalid })=>(0, $1ybV0.ff)('fix-jsma11y-980-issue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                    isOpen: isInvalid,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, errorMessage),
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "aria-labelledby": "accessible-id-for-calendar-field"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type '((string | ((instance: { components: Partial<SelectComponents<CalendarSelectOption, false, GroupTypeBase<CalendarSelectOption>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; } | null) => void) | RefObject<...>) & (((instance: any) => void)...'.
                ), {
                    ref: akSelectRef,
                    inputId: rest.id,
                    options: calendarOptions,
                    components: {
                        ValueContainer: $6b48fb1570f24b36$export$4dc9f58ad9a1a000
                    },
                    "aria-label": formatMessage((0, $1Fqyf.default).selectCalendar),
                    value: value,
                    "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.calendar.ak-select",
                    ...rest,
                    onChange: (...args)=>{
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                        rest.onChange(...args);
                        onChange();
                    },
                    appearance: isSLAHierarchicalGoalsEnabled ? 'subtle' : 'default',
                    styles: $6b48fb1570f24b36$var$customStyles
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                    isOpen: isInvalid,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, errorMessage),
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type '((string | ((instance: { components: Partial<SelectComponents<CalendarSelectOption, false, GroupTypeBase<CalendarSelectOption>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; } | null) => void) | RefObject<...>) & (((instance: any) => void)...'.
                ), {
                    ref: akSelectRef,
                    inputId: rest.id,
                    options: calendarOptions,
                    components: {
                        ValueContainer: $6b48fb1570f24b36$export$4dc9f58ad9a1a000
                    },
                    "aria-label": formatMessage((0, $1Fqyf.default).selectCalendar),
                    value: value,
                    "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.calendar.ak-select",
                    ...rest,
                    onChange: (...args)=>{
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                        rest.onChange(...args);
                        onChange();
                    },
                    appearance: isSLAHierarchicalGoalsEnabled ? 'subtle' : 'default',
                    styles: $6b48fb1570f24b36$var$customStyles
                })),
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b48fb1570f24b36$export$4dc9f58ad9a1a000, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b48fb1570f24b36$var$ReadViewContainer, {
                    "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.calendar.read-view-container",
                    isEditMode: true
                }, value?.label)),
            isEditing: isEditing,
            onConfirm: ()=>{},
            onEdit: onEditRequested,
            hideActionButtons: true,
            readViewFitContainerWidth: true
        })));
};
const $6b48fb1570f24b36$export$4dc9f58ad9a1a000 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b48fb1570f24b36$var$CalendarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
        label: ""
    }), children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b48fb1570f24b36$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditMode: isEditMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _1nmz1hna _1e0c1o8l _19bv12x7",
            __cmplp.isEditMode && "_ca0q1crf _n3td1crf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b48fb1570f24b36$var$CalendarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6b48fb1570f24b36$var$customStyles = {
    control: (styles)=>({
            ...styles,
            flexWrap: 'nowrap'
        }),
    valueContainer: (styles)=>({
            ...styles,
            display: 'flex'
        })
};

});
parcelRegister("2yRWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0664d820ae0097f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $XHGTv = parcelRequire("XHGTv");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $5wwB6 = parcelRequire("5wwB6");

var $kNcDT = parcelRequire("kNcDT");

var $8hUcM = parcelRequire("8hUcM");
function $0664d820ae0097f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0664d820ae0097f9$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $0664d820ae0097f9$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $0664d820ae0097f9$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel = (0, $5Q9wj.default), onEdit: providedOnEdit = (0, $5Q9wj.default), testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $kNcDT.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$0664d820ae0097f9$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /**
   * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /**
   * Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8hUcM.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $XHGTv.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $0664d820ae0097f9$var$fieldStyles,
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wwB6.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $0664d820ae0097f9$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $byn9U.jsx)($0664d820ae0097f9$var$InnerInlineEdit, props);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0664d820ae0097f9$export$2e2bcd8739ae039 = $0664d820ae0097f9$var$InlineEdit;

});
parcelRegister("5wwB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d378d9c54c5a6cc$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
                                                                                                                                      * @jsxRuntime classic
                                                                                                                                      * @jsx jsx
                                                                                                                                      */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");


var $8tdcZ = parcelRequire("8tdcZ");
function $6d378d9c54c5a6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d378d9c54c5a6cc$var$buttonsContainerStyles = {
    name: "ki22df",
    styles: "display:flex;position:absolute;flex-shrink:0;inset-block-start:100%;inset-inline-end:0;margin-block-start:var(--ds-space-075, 6px)"
};
const $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    fontSize: (0, $8tdcZ.fontSize),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`
    },
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`
    },
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    }
});
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Buttons__
 *
 * A buttons {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $6d378d9c54c5a6cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $6d378d9c54c5a6cc$export$2e2bcd8739ae039 = $6d378d9c54c5a6cc$var$Buttons;

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});


parcelRegister("8tdcZ", function(module, exports) {

$parcel$export(module.exports, "fontSize", () => $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "borderRadius", () => $0b3df1ecc0dc12b2$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93 = 14;
const $0b3df1ecc0dc12b2$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();

});


parcelRegister("kNcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc2637f9691157f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $acc2637f9691157f$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $acc2637f9691157f$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $acc2637f9691157f$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $acc2637f9691157f$export$2e2bcd8739ae039 = $acc2637f9691157f$var$useButtonFocusHook;

});

parcelRegister("8hUcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e4844bc5b892d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");


var $8tdcZ = parcelRequire("8tdcZ");
function $f1e4844bc5b892d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1e4844bc5b892d8$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $f1e4844bc5b892d8$var$editButtonStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $f1e4844bc5b892d8$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $8tdcZ.borderRadius),
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    }
});
const $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $f1e4844bc5b892d8$var$DRAG_THRESHOLD = 5;
const $f1e4844bc5b892d8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f1e4844bc5b892d8$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $f1e4844bc5b892d8$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f1e4844bc5b892d8$var$readViewWrapperStyles,
            readViewFitContainerWidth && $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $f1e4844bc5b892d8$export$2e2bcd8739ae039 = $f1e4844bc5b892d8$var$ReadView;

});


parcelRegister("1Fqyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d9338816cd088b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93d9338816cd088b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectCalendar: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.calendar.select-calendar",
        "defaultMessage": "Select calendar"
    }
});

});

parcelRegister("cthm0", function(module, exports) {

$parcel$export(module.exports, "formatOptions", () => $9c5697dc25509f0a$export$fb6751f88f91d177);
const $9c5697dc25509f0a$export$fb6751f88f91d177 = (calendarRefs)=>calendarRefs.map(({ name: name, id: id, ...rest })=>({
            label: name,
            value: id,
            isDefaultOption: rest.default
        }));

});


parcelRegister("lCXwi", function(module, exports) {

$parcel$export(module.exports, "DraggableField", () => $3c888bedf3d650b0$export$9da4c019583ac469);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $gDDo4 = parcelRequire("gDDo4");

var $fK421 = parcelRequire("fK421");
const $3c888bedf3d650b0$export$9da4c019583ac469 = ({ id: id, label: label, index: index, isDefaultGoal: isDefaultGoal })=>{
    const fieldName = (0, $fK421.toRowIndexTrackerFieldName)(id, isDefaultGoal);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: fieldName,
        defaultValue: index
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c888bedf3d650b0$var$DragIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDDo4))), {
            LEGACY_size: "large",
            label: label,
            color: "currentColor"
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c888bedf3d650b0$var$DragIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om15ng",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gDDo4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b639051269ef116e35808d9097e35bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1ced756fccff737$var$_react = $c1ced756fccff737$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c1ced756fccff737$var$_UNSAFE_baseNew = $c1ced756fccff737$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c1ced756fccff737$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DragHandle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1ced756fccff737$var$DragHandleIcon = (props)=>/*#__PURE__*/ $c1ced756fccff737$var$_react.default.createElement($c1ced756fccff737$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$c1ced756fccff737$var$DragHandleIcon.displayName = 'DragHandleIcon';
var $c1ced756fccff737$var$_default = module.exports.default = $c1ced756fccff737$var$DragHandleIcon;

});


parcelRegister("kT9hk", function(module, exports) {

$parcel$export(module.exports, "DurationField", () => $db8db4db78fa17b3$export$dfd08fa47052b761);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $29yDk = parcelRequire("29yDk");

var $2yRWX = parcelRequire("2yRWX");

var $cf2Y4 = parcelRequire("cf2Y4");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vO9v = parcelRequire("6vO9v");

var $PtojF = parcelRequire("PtojF");

var $fK421 = parcelRequire("fK421");

var $j0wWH = parcelRequire("j0wWH");

var $hIjKU = parcelRequire("hIjKU");

var $8IUmy = parcelRequire("8IUmy");
const $db8db4db78fa17b3$export$92d20ec4d467d98 = ({ id: id, goalId: goalId, isEditing: isEditing, focusOnEdit: focusOnEdit = false, onEditRequested: onEditRequested, duration: duration, onChange: // eslint-disable-next-line @typescript-eslint/no-empty-function
onChange = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    let fieldName;
    if (isSLAHierarchicalGoalsEnabled) fieldName = (0, $fK421.toSubGoalDurationFieldName)(goalId, id);
    else fieldName = (0, $fK421.toGoalDurationFieldName)(id, isEditing);
    const debouncedOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onChange, 1500);
    const validateDurationFn = (timeGoalValue)=>(0, $j0wWH.validateDuration)(timeGoalValue, formatMessage);
    const inputRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditing) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        focusOnEdit && inputRef.current?.focus();
    }, [
        focusOnEdit,
        isEditing
    ]);
    return(// @ts-expect-error - TS2322 - Type '(timeGoalValue: string) => string | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: fieldName,
        defaultValue: duration,
        validate: validateDurationFn
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
            isEditing: isEditing,
            editView: ({ errorMessage: errorMessage, isInvalid: isInvalid })=>(0, $1ybV0.ff)('fix-jsma11y-980-issue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                    isOpen: isInvalid,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errorMessage),
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "aria-labelledby": "accessible-id-for-time-target"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ref: inputRef,
                    "aria-label": formatMessage((0, $8IUmy.default).selectDuration),
                    ...fieldProps,
                    placeholder: isSLAHierarchicalGoalsEnabled ? formatMessage((0, $8IUmy.default).openTipForGoalDurationFormat) : '',
                    testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.duration.ak-single-line-text-input",
                    onChange: (...args)=>{
                        fieldProps.onChange(...args);
                        debouncedOnChange();
                    },
                    appearance: isSLAHierarchicalGoalsEnabled ? 'subtle' : 'standard'
                }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                    isOpen: isInvalid,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errorMessage),
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ref: inputRef,
                    "aria-label": formatMessage((0, $8IUmy.default).selectDuration),
                    ...fieldProps,
                    placeholder: isSLAHierarchicalGoalsEnabled ? formatMessage((0, $8IUmy.default).openTipForGoalDurationFormat) : '',
                    testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.duration.ak-single-line-text-input",
                    onChange: (...args)=>{
                        fieldProps.onChange(...args);
                        debouncedOnChange();
                    },
                    appearance: isSLAHierarchicalGoalsEnabled ? 'subtle' : 'standard'
                })),
            readView: ()=>// @ts-expect-error - TS2741 - Property 'placeholder' is missing in type '{ children: string; editMode: true; "data-test-id": string; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { editMode: boolean; placeholder: any; }, any>>'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.ReadViewContainer), {
                    editMode: true,
                    "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.duration.read-view"
                }, fieldProps.value || formatMessage((0, $8IUmy.default).noTarget)),
            onEdit: onEditRequested,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onConfirm: ()=>{},
            hideActionButtons: true,
            readViewFitContainerWidth: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, error === (0, $6vO9v.INVALID_FORMAT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.duration.ak-error-message"
        }, formatMessage((0, $8IUmy.default).invalidDurationFormat)) : !isSLAHierarchicalGoalsEnabled && isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $8IUmy.default).openTipForGoalDurationFormat))))));
};
const $db8db4db78fa17b3$export$dfd08fa47052b761 = $db8db4db78fa17b3$export$92d20ec4d467d98;

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("PtojF", function(module, exports) {

$parcel$export(module.exports, "Row", () => $873e54a9726e5b45$export$b59bdbef9ce70de2);
$parcel$export(module.exports, "JqlFieldWrapper", () => $873e54a9726e5b45$export$fa8df9d078fa69a);
$parcel$export(module.exports, "PriorityFieldWrapper", () => $873e54a9726e5b45$export$415d0f90dbe1859b);
$parcel$export(module.exports, "GoalFieldWrapper", () => $873e54a9726e5b45$export$98a8cf21bc5d97b9);
$parcel$export(module.exports, "CalendarFieldWrapper", () => $873e54a9726e5b45$export$92b2000c64de2a29);
$parcel$export(module.exports, "ReadViewContainer", () => $873e54a9726e5b45$export$ebb3489b83262b26);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $flFqI = parcelRequire("flFqI");
const $873e54a9726e5b45$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16qs1os1 _2rko1l7b _2lx2vrvc _1tke1ylp _otyru2gc",
            __cmplp.className
        ])
    });
});
const $873e54a9726e5b45$export$fa8df9d078fa69a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl1fwp",
            __cmplp.className
        ])
    });
});
const $873e54a9726e5b45$export$415d0f90dbe1859b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl1fwp",
            __cmplp.className
        ])
    });
});
const $873e54a9726e5b45$export$98a8cf21bc5d97b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlfyhu",
            __cmplp.className
        ])
    });
});
const $873e54a9726e5b45$export$92b2000c64de2a29 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.tableColumnNew), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlrw9l",
            __cmplp.className
        ])
    });
});
const $873e54a9726e5b45$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { editMode: editMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz410nf _1nmz1hna",
            __cmplp.editMode && "_ca0q19bv _u5f3rdoj _n3td19bv _19bvrdoj",
            __cmplp.placeholder && "_syaz1ap7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8IUmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e14940b940657c68$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e14940b940657c68$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidDurationFormat: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.invalid-duration-format",
        "defaultMessage": "Goals can be empty or defined using the format: 4h 30m"
    },
    openTipForGoalDurationFormat: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.open-tip-for-goal-duration-format",
        "defaultMessage": "E.g. 4h 30m"
    },
    noTarget: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.no-target",
        "defaultMessage": "No target"
    },
    durationInHours: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.duration-in-hours",
        "defaultMessage": "{duration}h"
    },
    durationInMinutes: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.duration-in-minutes",
        "defaultMessage": "{duration}m"
    },
    selectDuration: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.duration.select-duration",
        "defaultMessage": "Enter duration"
    }
});

});


parcelRegister("b3T6Y", function(module, exports) {

$parcel$export(module.exports, "JqlField", () => $1b13d66cd6fc1523$export$b36aa7adf1ed5907);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $2yRWX = parcelRequire("2yRWX");


var $2eG9N = parcelRequire("2eG9N");

var $giAhk = parcelRequire("giAhk");

var $PtojF = parcelRequire("PtojF");

var $flFqI = parcelRequire("flFqI");

var $fK421 = parcelRequire("fK421");

var $hIjKU = parcelRequire("hIjKU");

var $5Eq0a = parcelRequire("5Eq0a");

var $WbUNm = parcelRequire("WbUNm");
const $1b13d66cd6fc1523$var$JqlFieldView = ({ intl: { formatMessage: formatMessage }, id: id, defaultGoal: defaultGoal, isEditing: isEditing, focusOnEdit: focusOnEdit = false, jqlValidationError: jqlValidationError, jqlQuery: jqlQuery, metricId: metricId, areSubGoalsPresent: areSubGoalsPresent = false, onEditRequested: onEditRequested, validateJQL: // eslint-disable-next-line @typescript-eslint/no-empty-function
validateJQL = ()=>{} })=>{
    const fieldName = (0, $fK421.toGoalJqlFieldName)(id, isEditing);
    const [{ isPriorityNameChanged: isPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        !isEditing && document?.activeElement?.blur();
    }, [
        isEditing
    ]);
    const debouncedValidateJQL = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(validateJQL, 2000);
    if (defaultGoal) return(// @ts-expect-error - TS2739 - Type '{ children: string; }' is missing the following properties from type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { editMode: boolean; placeholder: any; }, any>>': placeholder, editMode
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b13d66cd6fc1523$export$208bc1da613d4eba, null, formatMessage((0, $WbUNm.default).allRemainingIssues)));
    const accessibleIdForJqlValidationError = 'accessible-id-for-jql-validation-error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: fieldName,
        defaultValue: jqlQuery
    }, ({ fieldProps: { value: value = '', onChange: onChange } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b13d66cd6fc1523$var$JQLContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
            isEditing: isEditing,
            editView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b13d66cd6fc1523$var$EditViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Eq0a.JqlEditor), {
                    autoFocus: focusOnEdit,
                    ariaDescribedBy: accessibleIdForJqlValidationError,
                    jql: value,
                    onJqlChanged: (...args)=>{
                        onChange(...args);
                        debouncedValidateJQL?.();
                    }
                })),
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.ReadViewContainer), {
                    "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.jql.read-view-container",
                    editMode: true,
                    placeholder: value ? 0 : 1
                }, value || formatMessage((0, $WbUNm.default).newJql)),
            onEdit: onEditRequested,
            onConfirm: ()=>{},
            hideActionButtons: true,
            readViewFitContainerWidth: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), null, // @ts-expect-error - TS7053
        isPriorityNameChanged?.[metricId]?.[id] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $WbUNm.default).errorTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
                size: "medium",
                label: formatMessage((0, $WbUNm.default).errorTooltip)
            }),
            appearance: "subtle"
        })), value.toLowerCase().includes('priority') && areSubGoalsPresent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $WbUNm.default).warningWhenPriorityIsPresentInJqlWithSubGoals),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
                size: "medium",
                label: formatMessage((0, $WbUNm.default).warningWhenPriorityIsPresentInJqlWithSubGoals)
            }),
            appearance: "subtle"
        })))), jqlValidationError !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            id: accessibleIdForJqlValidationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, jqlValidationError))));
};
const $1b13d66cd6fc1523$export$b36aa7adf1ed5907 = (0, $giAhk.injectIntlV2)($1b13d66cd6fc1523$var$JqlFieldView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $1b13d66cd6fc1523$var$EditViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbyowjs _1bsb1osq _19pkze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $1b13d66cd6fc1523$var$JQLContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.Row), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1q9y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1b13d66cd6fc1523$export$208bc1da613d4eba = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $PtojF.ReadViewContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qu2gc _vwz41ylp _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Eq0a", function(module, exports) {

$parcel$export(module.exports, "JqlEditor", () => $a40998549df895ad$export$73bd1ed96c0b814a);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $aQt6E = parcelRequire("aQt6E");
const $a40998549df895ad$var$EXCLUDED_AUTOCOMPLETE_FIELDS = [
    'project'
];
const $a40998549df895ad$export$73bd1ed96c0b814a = ({ jql: jql, autoFocus: autoFocus, onJqlChanged: onJqlChanged, ariaDescribedBy: ariaDescribedBy })=>(0, $eI5EY.fg)('fix_jsmca11y-502_issue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-describedby": ariaDescribedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQt6E.default), {
        analyticsSource: "jsm-sla-configuration",
        query: jql,
        autoFocus: autoFocus,
        onUpdate: onJqlChanged,
        excludedAutocompleteFields: $a40998549df895ad$var$EXCLUDED_AUTOCOMPLETE_FIELDS
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQt6E.default), {
        analyticsSource: "jsm-sla-configuration",
        query: jql,
        autoFocus: autoFocus,
        onUpdate: onJqlChanged,
        excludedAutocompleteFields: $a40998549df895ad$var$EXCLUDED_AUTOCOMPLETE_FIELDS
    });

});
parcelRegister("aQt6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebbe160d8f005e16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c3Y34 = parcelRequire("c3Y34");

var $CDhez = parcelRequire("CDhez");
const $ebbe160d8f005e16$var$JQLBuilderAdvancedAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $CDhez.default), {
        ...props,
        JQLEditor: (0, $c3Y34.JQLEditorAsync)
    });
var $ebbe160d8f005e16$export$2e2bcd8739ae039 = $ebbe160d8f005e16$var$JQLBuilderAdvancedAsync;

});
parcelRegister("c3Y34", function(module, exports) {

$parcel$export(module.exports, "preloadJQLEditor", () => $619f9344351c4fdb$export$d5d5e8328005e2ec);
$parcel$export(module.exports, "JQLEditorAsync", () => $619f9344351c4fdb$export$ecdc147409ce705b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $6ceU4 = parcelRequire("6ceU4");

var $1OXH6 = parcelRequire("1OXH6");

var $k6W3e = parcelRequire("k6W3e");

const $619f9344351c4fdb$var$JQLEditor = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("70Lp3")).then(({ default: JQLEditorUI })=>JQLEditorUI), {
    ssr: false,
    moduleId: "../platform/packages/jql/jql-editor/src/ui/jql-editor/index.tsx"
});
const $619f9344351c4fdb$export$d5d5e8328005e2ec = ()=>$619f9344351c4fdb$var$JQLEditor.preload();
const $619f9344351c4fdb$export$ecdc147409ce705b = (0, $1OXH6.withIntlProvider)((0, $6ceU4.withErrorBoundary)((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6W3e.JQLEditorReadOnly), {
            query: props.query,
            isSearch: !!props.onSearch,
            isCompact: props.isCompact
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($619f9344351c4fdb$var$JQLEditor, props));
}));

});
parcelRegister("6ceU4", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $800fa6346ab71130$export$f0c7a449e0cfaec7);

var $eUqFw = parcelRequire("eUqFw");

var $k6W3e = parcelRequire("k6W3e");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $800fa6346ab71130$var$ErrorBoundary extends (0, $eUqFw.Component) {
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError && this.props.onError(error);
    }
    render() {
        const { children: children, render: renderFallback } = this.props;
        const { error: error } = this.state;
        if (error === null) return children;
        return renderFallback({
            error: error
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
const $800fa6346ab71130$export$f0c7a449e0cfaec7 = (WrappedComponent)=>{
    return (props)=>{
        const { query: query, onRenderError: onRenderError, onSearch: onSearch, isCompact: isCompact } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($800fa6346ab71130$var$ErrorBoundary, {
            onError: onRenderError,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6W3e.JQLEditorReadOnly), {
                    query: query,
                    isSearch: !!onSearch,
                    isCompact: isCompact
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));
    };
};

});
parcelRegister("k6W3e", function(module, exports) {

$parcel$export(module.exports, "JQLEditorReadOnly", () => $cdb8e7c20aecb630$export$96157d0351f40cdc);
$parcel$export(module.exports, "default", () => $cdb8e7c20aecb630$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");

var $h1ezC = parcelRequire("h1ezC");

var $8vcuh = parcelRequire("8vcuh");

var $4ShqD = parcelRequire("4ShqD");

var $cSykA = parcelRequire("cSykA");
const $cdb8e7c20aecb630$var$JQLEditorLayout = (props)=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $h1ezC.useEditorThemeContext)();
    const { editorViewHasFocus: editorViewHasFocus, EditorControlsContent: EditorControlsContent, EditorFooterContent: EditorFooterContent, editorViewIsInvalid: editorViewIsInvalid, lineNumbersVisible: lineNumbersVisible, mainId: mainId, onEditorMainRef: onEditorMainRef, onEditorViewContainerRef: onEditorViewContainerRef, onEditorViewContainerScroll: onEditorViewContainerScroll, onEditorViewRef: onEditorViewRef, onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus, onEditorViewTransitionEnd: onEditorViewTransitionEnd } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorMain), {
        id: mainId,
        ref: onEditorMainRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorViewContainer), {
        editorViewHasFocus: editorViewHasFocus,
        editorViewIsInvalid: editorViewIsInvalid,
        ref: onEditorViewContainerRef,
        onScroll: onEditorViewContainerScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.LineNumberToolbar), {
        lineNumbersVisible: lineNumbersVisible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorView), {
        defaultMaxRows: defaultMaxRows,
        expandedRows: expandedRows,
        isCompact: isCompact,
        lineNumbersVisible: lineNumbersVisible,
        ref: onEditorViewRef,
        onBlur: onEditorViewBlur,
        onFocus: onEditorViewFocus,
        onTransitionEnd: onEditorViewTransitionEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorControls), {
        isSearch: isSearch,
        isCompact: isCompact,
        isVisualRefresh: (0, $XHGTv.fg)('platform-component-visual-refresh')
    }, EditorControlsContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorFooter), null, EditorFooterContent));
};
/**
 * A read only version of the JQL Editor which mimics the layout of the complete component, suitable as an intermediary
 * state when rendering the editor asynchronously.
 * In order to minimise bundle size impact on consumers, it is critical that this component (and any child component)
 * only imports the bare minimum dependencies required to replicate the editor layout.
 */ const $cdb8e7c20aecb630$var$JQLEditorReadOnlyWithoutTheme = ({ query: query })=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $h1ezC.useEditorThemeContext)();
    const blocks = (0, $8vcuh.splitTextByNewLine)(query);
    const lineNumbersVisible = blocks.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorMain), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.ReadOnlyEditorViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.LineNumberToolbar), {
        lineNumbersVisible: lineNumbersVisible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.ReadOnlyEditorView), {
        "data-testid": "jql-editor-read-only",
        role: "combobox",
        "aria-readonly": true,
        defaultMaxRows: defaultMaxRows,
        expandedRows: expandedRows,
        lineNumbersVisible: lineNumbersVisible,
        isCompact: isCompact,
        // aria-expanded and aria-controls here are placeholders only. This is to avoid a11y violations.
        // This component JQLEditorReadOnlyWithoutTheme is only a loading state
        // Therefore the autocomplete combobox is never shown to the users
        "aria-expanded": false,
        "aria-controls": "dummy-jql-editor-auto-complete-id",
        "aria-label": "JQL query"
    }, blocks.map((block, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p",
            key: index
        }, block))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorControls), {
        isSearch: isSearch,
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ShqD.ReadOnlyControlsContent), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cSykA.EditorFooter), null));
};
const $cdb8e7c20aecb630$export$96157d0351f40cdc = ({ isSearch: isSearch, isCompact: isCompact, ...props })=>{
    const editorTheme = (0, $h1ezC.useEditorTheme)({
        isSearch: isSearch,
        isCompact: isCompact
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1ezC.EditorThemeContext).Provider, {
        value: editorTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cdb8e7c20aecb630$var$JQLEditorReadOnlyWithoutTheme, props));
};
var $cdb8e7c20aecb630$export$2e2bcd8739ae039 = $cdb8e7c20aecb630$var$JQLEditorLayout;

});
parcelRegister("h1ezC", function(module, exports) {

$parcel$export(module.exports, "EditorThemeContext", () => $4ba88b0e2b260932$export$fc25b324c910bbf4);
$parcel$export(module.exports, "useEditorTheme", () => $4ba88b0e2b260932$export$c119185e316114b3);
$parcel$export(module.exports, "useEditorThemeContext", () => $4ba88b0e2b260932$export$cf804716df5ed454);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $4ba88b0e2b260932$var$defaultMaxRows = 3;
const $4ba88b0e2b260932$var$expandedRows = 15;
const $4ba88b0e2b260932$var$defaultEditorTheme = {
    defaultMaxRows: $4ba88b0e2b260932$var$defaultMaxRows,
    expanded: false,
    expandedRows: $4ba88b0e2b260932$var$expandedRows,
    toggleExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isSearch: false,
    isCompact: false
};
const $4ba88b0e2b260932$export$fc25b324c910bbf4 = (0, $eUqFw.createContext)($4ba88b0e2b260932$var$defaultEditorTheme);
const $4ba88b0e2b260932$export$c119185e316114b3 = ({ isSearch: isSearch = false, isCompact: isCompact = false })=>{
    const [expanded, setExpanded] = (0, $eUqFw.useState)(false);
    const toggleExpanded = (0, $eUqFw.useCallback)(()=>setExpanded((prevState)=>!prevState), []);
    return (0, $eUqFw.useMemo)(()=>({
            defaultMaxRows: $4ba88b0e2b260932$var$defaultMaxRows,
            expanded: expanded,
            expandedRows: $4ba88b0e2b260932$var$expandedRows,
            toggleExpanded: toggleExpanded,
            isSearch: isSearch,
            isCompact: isCompact
        }), [
        expanded,
        toggleExpanded,
        isSearch,
        isCompact
    ]);
};
const $4ba88b0e2b260932$export$cf804716df5ed454 = ()=>(0, $eUqFw.useContext)($4ba88b0e2b260932$export$fc25b324c910bbf4);

});

parcelRegister("8vcuh", function(module, exports) {

$parcel$export(module.exports, "splitTextByNewLine", () => $878315037c8be85b$export$ccd327fb940bd525);
/**
 * Splits the provided text by new line characters.
 */ const $878315037c8be85b$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);

});

parcelRegister("4ShqD", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyControlsContent", () => $27d5949cf679d985$export$26cf64f30d6cc7f3);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $h1ezC = parcelRequire("h1ezC");

var $7fIXo = parcelRequire("7fIXo");

var $l336g = parcelRequire("l336g");

var $fKpu4 = parcelRequire("fKpu4");
const $27d5949cf679d985$export$26cf64f30d6cc7f3 = ()=>{
    const { isSearch: isSearch } = (0, $h1ezC.useEditorThemeContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fIXo.BaseExpandToggle), {
        // The label here is for avoiding a11y violations only
        // This component ReadOnlyControlsContent is only used as a fallback for a loading state
        label: 'Editor',
        editorId: '',
        expanded: false,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKpu4.BaseSyntaxHelp), {
        label: '',
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isDisabled: true
    }), isSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l336g.BaseSearch), {
        // The label here is for avoiding a11y violations only
        // This component ReadOnlyControlsContent is only used as a fallback for a loading state
        label: 'Search',
        onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isDisabled: true
    }));
};

});
parcelRegister("7fIXo", function(module, exports) {

$parcel$export(module.exports, "BaseExpandToggle", () => $a67b2715e68eda13$export$651ea466a727285d);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $8TYN8 = parcelRequire("8TYN8");

var $34ons = parcelRequire("34ons");

var $22LS1 = parcelRequire("22LS1");

var $drWMe = parcelRequire("drWMe");

var $XHGTv = parcelRequire("XHGTv");


var $f8ntU = parcelRequire("f8ntU");
// Atlaskit doesn't provide a circle variation of the expand/collapse icons so we have to implement our own
const $a67b2715e68eda13$var$ExpandCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8TYN8))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($22LS1)))
    });
const $a67b2715e68eda13$var$CollapseCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34ons))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($drWMe)))
    });
const $a67b2715e68eda13$export$651ea466a727285d = ({ expanded: expanded, editorId: editorId, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    let Icon;
    if (expanded) Icon = $a67b2715e68eda13$var$CollapseCircleIcon;
    else Icon = $a67b2715e68eda13$var$ExpandCircleIcon;
    return (0, $XHGTv.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: 'subtle',
        spacing: "compact",
        "aria-expanded": expanded,
        "aria-controls": editorId,
        label: label,
        isDisabled: isDisabled,
        onClick: onClick,
        icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($34ons))) : (0, (/*@__PURE__*/$parcel$interopDefault($8TYN8)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8ntU.ExpandToggleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: 'subtle',
        "aria-expanded": expanded,
        "aria-controls": editorId,
        "aria-label": label,
        isDisabled: isDisabled,
        spacing: 'none',
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            isDisabled: isDisabled
        })
    }));
};

});
parcelRegister("8TYN8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b29db82a7ea305$var$_react = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b29db82a7ea305$var$_UNSAFE_baseNew = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b29db82a7ea305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b29db82a7ea305$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67b29db82a7ea305$var$_react.default.createElement($67b29db82a7ea305$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$67b29db82a7ea305$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67b29db82a7ea305$var$_default = module.exports.default = $67b29db82a7ea305$var$GrowDiagonalIcon;

});

parcelRegister("34ons", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::093b1e9b17ed5e0dd45627fbe3b0508b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23c4a7a9c7073b1c$var$_react = $23c4a7a9c7073b1c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23c4a7a9c7073b1c$var$_UNSAFE_baseNew = $23c4a7a9c7073b1c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $23c4a7a9c7073b1c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23c4a7a9c7073b1c$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $23c4a7a9c7073b1c$var$_react.default.createElement($23c4a7a9c7073b1c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$23c4a7a9c7073b1c$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $23c4a7a9c7073b1c$var$_default = module.exports.default = $23c4a7a9c7073b1c$var$ShrinkDiagonalIcon;

});

parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $17d0e6b497755428$var$_growDiagonal = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("8TYN8")));
function $17d0e6b497755428$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $17d0e6b497755428$var$_growDiagonal.default
    }));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = module.exports.default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;

});

parcelRegister("drWMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cab63de7a2a3a02$var$_react = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9cab63de7a2a3a02$var$_shrinkDiagonal = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("34ons")));
function $9cab63de7a2a3a02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $9cab63de7a2a3a02$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $9cab63de7a2a3a02$var$_shrinkDiagonal.default
    }));
$9cab63de7a2a3a02$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $9cab63de7a2a3a02$var$_default = module.exports.default = $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon;

});

parcelRegister("f8ntU", function(module, exports) {

$parcel$export(module.exports, "ExpandToggleContainer", () => $1d74de44dda7c63b$export$e6d67f4f78864edc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $1d74de44dda7c63b$export$e6d67f4f78864edc = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1cnrddf0"
})({
    /* Override background styles for our button to match designs */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> button': {
        borderRadius: '100%',
        /* Fill the remaining vertical space for a single line in our editor and space between buttons */ margin: `${"var(--ds-space-050, 4px)"} 0`,
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`
        }
    }
});

});


parcelRegister("l336g", function(module, exports) {

$parcel$export(module.exports, "BaseSearch", () => $8c7240c76c9dd40e$export$c3a2772f8bfd85f4);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $j9fWg = parcelRequire("j9fWg");

var $hcvt0 = parcelRequire("hcvt0");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $8c7240c76c9dd40e$var$style = {
    // Fixes an issue where loading button makes the editor flicker with a scrollbar
    overflow: 'hidden'
};
// Fixes icon margin issus after new icon migration
const $8c7240c76c9dd40e$var$iconStyle = (0, $1ZAYh.xcss)({
    margin: 'space.050',
    display: 'flex'
});
// Fixes an issue where loading button makes the editor flicker with a scrollbar
const $8c7240c76c9dd40e$var$buttonContainerStyle = (0, $1ZAYh.xcss)({
    overflow: 'hidden'
});
const $8c7240c76c9dd40e$export$c3a2772f8bfd85f4 = ({ isDisabled: isDisabled, isSearching: isSearching, label: label, onSearch: onSearch })=>{
    // Prevent click events being repeatedly fired if the Enter key is held down.
    const preventRepeatClick = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter' && e.repeat) e.preventDefault();
    }, []);
    return (0, $XHGTv.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8c7240c76c9dd40e$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: label,
        isDisabled: isDisabled,
        testId: "jql-editor-search",
        appearance: 'primary',
        spacing: "compact",
        onClick: onSearch,
        onKeyDown: preventRepeatClick,
        isLoading: isSearching,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hcvt0)))
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        "aria-label": label,
        isDisabled: isDisabled,
        testId: "jql-editor-search",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $8c7240c76c9dd40e$var$style,
        appearance: 'primary',
        spacing: 'none',
        onClick: onSearch,
        onKeyDown: preventRepeatClick,
        isLoading: isSearching,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $8c7240c76c9dd40e$var$iconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hcvt0))), {
            color: "currentColor",
            label: '',
            LEGACY_size: 'medium',
            LEGACY_margin: "-4px"
        }))
    });
};

});
parcelRegister("hcvt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85bf750af932d50$var$_react = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c85bf750af932d50$var$_search = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("9IsWp")));

var $c85bf750af932d50$var$_search2 = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("bPZtE")));
function $c85bf750af932d50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c85bf750af932d50$var$SearchIcon = (props)=>/*#__PURE__*/ $c85bf750af932d50$var$_react.default.createElement($c85bf750af932d50$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c85bf750af932d50$var$_search2.default
    }, props));
$c85bf750af932d50$var$SearchIcon.Name = 'SearchIconMigration';
var $c85bf750af932d50$var$_default = module.exports.default = $c85bf750af932d50$var$SearchIcon;

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});



parcelRegister("fKpu4", function(module, exports) {

$parcel$export(module.exports, "BaseSyntaxHelp", () => $df71f29559699f6e$export$7267128805e130a);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8GeQ6 = parcelRequire("8GeQ6");

var $8MkOl = parcelRequire("8MkOl");

var $eQuyQ = parcelRequire("eQuyQ");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $eQwlx = parcelRequire("eQwlx");
// Fixes icon margin issus after new icon migration
const $df71f29559699f6e$var$iconStyle = (0, $1ZAYh.xcss)({
    margin: 'space.025',
    display: 'inline-flex'
});
const $df71f29559699f6e$export$7267128805e130a = ({ describedby: describedby, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    return (0, $XHGTv.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GeQ6.default), {
        "aria-describedby": describedby,
        label: label,
        isDisabled: isDisabled,
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        target: "blank",
        href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MkOl))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)"
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQwlx.SyntaxHelpContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-describedby": describedby,
        "aria-label": label,
        isDisabled: isDisabled,
        appearance: 'subtle',
        spacing: 'none',
        target: 'blank',
        href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $df71f29559699f6e$var$iconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MkOl))), {
            label: '',
            color: isDisabled ? `var(--ds-icon-disabled, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            LEGACY_size: 'small',
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eQuyQ))),
            LEGACY_margin: "-2px"
        })),
        onClick: onClick
    }));
};

});
parcelRegister("eQuyQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aceda0cfde73f17b$var$_react = $aceda0cfde73f17b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $aceda0cfde73f17b$var$_questionCircle = $aceda0cfde73f17b$var$_interopRequireDefault((parcelRequire("8MkOl")));
function $aceda0cfde73f17b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aceda0cfde73f17b$var$QuestionIcon = (props)=>/*#__PURE__*/ $aceda0cfde73f17b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $aceda0cfde73f17b$var$_questionCircle.default
    }));
$aceda0cfde73f17b$var$QuestionIcon.displayName = 'QuestionIcon';
var $aceda0cfde73f17b$var$_default = module.exports.default = $aceda0cfde73f17b$var$QuestionIcon;

});

parcelRegister("eQwlx", function(module, exports) {

$parcel$export(module.exports, "SyntaxHelpContainer", () => $e12e848194a80925$export$4e1b8f789d662a1c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $e12e848194a80925$export$4e1b8f789d662a1c = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1rcevfp0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> a': {
        background: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
        borderRadius: '100%',
        margin: "var(--ds-space-050, 4px)",
        '&:hover': {
            background: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:focus': {
            background: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-bold-pressed, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[disabled]': {
            background: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`
        }
    }
});

});



parcelRegister("cSykA", function(module, exports) {

$parcel$export(module.exports, "EditorMain", () => $7b10abb45a5efabd$export$4a1fe064357e4803);
$parcel$export(module.exports, "EditorFooter", () => $7b10abb45a5efabd$export$6b199f86fb39c56e);
$parcel$export(module.exports, "EditorViewContainer", () => $7b10abb45a5efabd$export$e1a59ec983b6e626);
$parcel$export(module.exports, "ReadOnlyEditorViewContainer", () => $7b10abb45a5efabd$export$92dc95fac89d1410);
$parcel$export(module.exports, "LineNumberToolbar", () => $7b10abb45a5efabd$export$c7f458a6447d7077);
$parcel$export(module.exports, "EditorView", () => $7b10abb45a5efabd$export$eece2fccabbb77c5);
$parcel$export(module.exports, "ReadOnlyEditorView", () => $7b10abb45a5efabd$export$1eeaf339fa9196a5);
$parcel$export(module.exports, "EditorControls", () => $7b10abb45a5efabd$export$3ebfd5942f1290ac);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $lcnyw = parcelRequire("lcnyw");

var $CYd0c = parcelRequire("CYd0c");

var $joBf7 = parcelRequire("joBf7");
function $7b10abb45a5efabd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b10abb45a5efabd$var$fadeIn = (0, $byn9U.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $7b10abb45a5efabd$var$fadeOut = (0, $byn9U.keyframes)({
    from: {
        visibility: 'visible',
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
const $7b10abb45a5efabd$export$4a1fe064357e4803 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j67"
})("font-family:", (0, $lcnyw.fontFamily)(), ";font-size:", (0, $lcnyw.fontSize)(), "px;flex-grow:1;/* These styles and animations are derived from @atlaskit/tooltip */.", (0, $CYd0c.TOOLTIP_CLASSNAME), "{background-color:", `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`, ";color:", `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`, ";border-radius:var(--ds-border-radius-100, 3px);box-sizing:border-box;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);line-height:1.3;max-width:240px;padding:var(--ds-space-025, 2px) var(--ds-space-075, 6px);word-wrap:break-word;overflow-wrap:break-word;z-index:", (0, $lcnyw.layers).tooltip(), ";pointer-events:none;position:absolute;visibility:hidden;transform:translate(-50%, calc(-100% - var(--ds-space-200, 16px)));&.", (0, $CYd0c.TOOLTIP_ENTER_CLASSNAME), "{animation:", $7b10abb45a5efabd$var$fadeIn, " 350ms cubic-bezier(0.15, 1, 0.3, 1);visibility:visible;}&.", (0, $CYd0c.TOOLTIP_EXIT_CLASSNAME), "{animation:", $7b10abb45a5efabd$var$fadeOut, " 350ms cubic-bezier(0.15, 1, 0.3, 1);}}");
const $7b10abb45a5efabd$export$6b199f86fb39c56e = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j66"
})({
    name: "y524xc",
    styles: "display:flex;justify-content:space-between;min-height:20px"
});
// Height (in px) for a single row in the editor
const $7b10abb45a5efabd$var$rowHeight = (0, $lcnyw.gridSize)() * 2.75;
// Vertical padding for the editor input
const $7b10abb45a5efabd$var$getEditorInputVerticalPadding = (isCompact)=>isCompact ? 3 : 7;
const $7b10abb45a5efabd$var$editorInputHorizontalPadding = 6;
const $7b10abb45a5efabd$export$e1a59ec983b6e626 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j65"
})({
    backgroundColor: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    borderColor: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    padding: "var(--ds-border-width, 1px)",
    boxSizing: 'border-box',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    display: 'flex',
    overflow: 'auto',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewIsInvalid && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)({
        borderColor: `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`}`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewHasFocus ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)({
        backgroundColor: `var(--ds-surface, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`
    }) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        }
    }));
const $7b10abb45a5efabd$export$92dc95fac89d1410 = /*#__PURE__*/ (0, $joBf7.default)($7b10abb45a5efabd$export$e1a59ec983b6e626, {
    target: "ezls2j64"
})({
    backgroundColor: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    pointerEvents: 'none'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $7b10abb45a5efabd$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $7b10abb45a5efabd$export$c7f458a6447d7077 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j63"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    flexShrink: 0,
    width: '30px',
    position: 'sticky',
    top: 0
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $7b10abb45a5efabd$var$_ref2);
/**
 * The main div which the Prosemirror editor will be rendered into.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $7b10abb45a5efabd$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $7b10abb45a5efabd$export$eece2fccabbb77c5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j62"
})("counter-reset:lineNumber;flex-grow:1;transition:height 250ms cubic-bezier(0.15, 1, 0.3, 1),max-height 250ms cubic-bezier(0.15, 1, 0.3, 1);max-height:", (props)=>$7b10abb45a5efabd$var$rowHeight * props.defaultMaxRows + $7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;line-height:", $7b10abb45a5efabd$var$rowHeight / (0, $lcnyw.fontSize)(), ";font-family:", (0, $lcnyw.codeFontFamily)(), ";word-break:break-word;overflow-wrap:anywhere;white-space:pre-wrap;&[data-expanded]{height:", (props)=>$7b10abb45a5efabd$var$rowHeight * props.expandedRows + $7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;max-height:", (props)=>$7b10abb45a5efabd$var$rowHeight * props.expandedRows + $7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;}.ProseMirror{color:", `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$ad0bacf983b7ddaa)})`, ";padding:", (props)=>$7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact), "px ", $7b10abb45a5efabd$var$editorInputHorizontalPadding, "px;&:focus{outline:none;}.mark-token-keyword{color:", `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$export$c71e4279dd54a18d)})`, ";}.mark-token-field{color:", `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`, ";}.mark-token-operator{color:", `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`, ";}.mark-token-error{color:", `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`, ";text-decoration:wavy underline;text-decoration-thickness:1px;text-decoration-skip-ink:none;}}p{margin:0;counter-increment:lineNumber;position:relative;&::before{content:counter(lineNumber);color:", `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`, ";font-size:10px;line-height:", $7b10abb45a5efabd$var$rowHeight / 10, ";padding:0 var(--ds-space-100, 8px) 0 var(--ds-space-025, 2px);position:absolute;box-sizing:border-box;transform:translateX(calc(-100% - var(--ds-space-100, 8px)));max-width:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;", (props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    $7b10abb45a5efabd$var$_ref, ";}}");
const $7b10abb45a5efabd$export$1eeaf339fa9196a5 = /*#__PURE__*/ (0, $joBf7.default)($7b10abb45a5efabd$export$eece2fccabbb77c5, {
    target: "ezls2j61"
})("padding:", (props)=>$7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact), "px ", $7b10abb45a5efabd$var$editorInputHorizontalPadding, "px;max-height:", (props)=>$7b10abb45a5efabd$var$rowHeight * props.defaultMaxRows, "px;>p{min-height:", $7b10abb45a5efabd$var$rowHeight, "px;}");
const $7b10abb45a5efabd$export$3ebfd5942f1290ac = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ezls2j60"
})((props)=>({
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        marginLeft: 'auto',
        marginRight: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isSearch ? $7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact) - 1 // the search button needs the same vertical & horizontal spacing
         : $7b10abb45a5efabd$var$editorInputHorizontalPadding - 3}px`,
        lineHeight: 'normal',
        position: 'sticky',
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$7b10abb45a5efabd$var$rowHeight + 2 * $7b10abb45a5efabd$var$getEditorInputVerticalPadding(props.isCompact)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: props.isVisualRefresh ? "var(--ds-space-025, 2px)" : 'unset'
    }));

});
parcelRegister("CYd0c", function(module, exports) {

$parcel$export(module.exports, "JQLValidationTooltipPluginKey", () => $259f6808bb77bd53$export$9c08c6e09c037890);
$parcel$export(module.exports, "TOOLTIP_CLASSNAME", () => $259f6808bb77bd53$export$a6e3ebd2348b0a1);
$parcel$export(module.exports, "TOOLTIP_ENTER_CLASSNAME", () => $259f6808bb77bd53$export$c58b4cecb88a4d51);
$parcel$export(module.exports, "TOOLTIP_EXIT_CLASSNAME", () => $259f6808bb77bd53$export$22dac80660f4fba2);

var $kpTIW = parcelRequire("kpTIW");
const $259f6808bb77bd53$export$9c08c6e09c037890 = new (0, $kpTIW.PluginKey)('jql-validation-tooltip-plugin');
const $259f6808bb77bd53$export$a6e3ebd2348b0a1 = 'jql-validation-tooltip';
const $259f6808bb77bd53$export$c58b4cecb88a4d51 = 'jql-validation-tooltip-enter';
const $259f6808bb77bd53$export$22dac80660f4fba2 = 'jql-validation-tooltip-exit';

});
parcelRegister("kpTIW", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $edd15e116d766874$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $edd15e116d766874$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $edd15e116d766874$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $edd15e116d766874$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $edd15e116d766874$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $edd15e116d766874$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $edd15e116d766874$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $edd15e116d766874$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $edd15e116d766874$export$1692d8b0e89cecc3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $edd15e116d766874$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $edd15e116d766874$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $edd15e116d766874$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7dkLM.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
            if (i == 0) $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $edd15e116d766874$export$c2b25f346d19bcbb($pos) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $edd15e116d766874$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, 0, 0, 1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $edd15e116d766874$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $edd15e116d766874$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $edd15e116d766874$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$edd15e116d766874$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $edd15e116d766874$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $edd15e116d766874$var$warnedAboutTextSelection = false;
function $edd15e116d766874$var$checkTextSelection($pos) {
    if (!$edd15e116d766874$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $edd15e116d766874$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $edd15e116d766874$export$c2b25f346d19bcbb extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $edd15e116d766874$var$checkTextSelection($anchor);
        $edd15e116d766874$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $edd15e116d766874$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7dkLM.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $edd15e116d766874$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $edd15e116d766874$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $edd15e116d766874$export$52baac22726c72bf.findFrom($head, bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $edd15e116d766874$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("text", $edd15e116d766874$export$c2b25f346d19bcbb);
class $edd15e116d766874$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $edd15e116d766874$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $edd15e116d766874$export$e2940151ac854c0b extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $edd15e116d766874$export$52baac22726c72bf.near($pos);
        return new $edd15e116d766874$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $edd15e116d766874$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$edd15e116d766874$export$e2940151ac854c0b.prototype.visible = false;
$edd15e116d766874$export$52baac22726c72bf.jsonID("node", $edd15e116d766874$export$e2940151ac854c0b);
class $edd15e116d766874$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $edd15e116d766874$var$TextBookmark(pos, pos) : new $edd15e116d766874$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(node)) return new $edd15e116d766874$export$e2940151ac854c0b($pos);
        return $edd15e116d766874$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $edd15e116d766874$export$c15d9ba76bdbcd95 extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        if (content == (0, $7dkLM.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $edd15e116d766874$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $edd15e116d766874$var$AllBookmark;
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("all", $edd15e116d766874$export$c15d9ba76bdbcd95);
const $edd15e116d766874$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $edd15e116d766874$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $edd15e116d766874$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $edd15e116d766874$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(child)) return $edd15e116d766874$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $edd15e116d766874$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($edd15e116d766874$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $edd15e116d766874$var$UPDATED_SEL = 1, $edd15e116d766874$var$UPDATED_MARKS = 2, $edd15e116d766874$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $edd15e116d766874$export$febc5573c75cefb0 extends (0, $d6JJW.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $edd15e116d766874$var$UPDATED_SEL) & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $edd15e116d766874$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7dkLM.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7dkLM.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($edd15e116d766874$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $edd15e116d766874$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SCROLL) > 0;
    }
}
function $edd15e116d766874$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $edd15e116d766874$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $edd15e116d766874$var$bind(desc.init, self);
        this.apply = $edd15e116d766874$var$bind(desc.apply, self);
    }
}
const $edd15e116d766874$var$baseFields = [
    new $edd15e116d766874$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $edd15e116d766874$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $edd15e116d766874$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $edd15e116d766874$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $edd15e116d766874$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $edd15e116d766874$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $edd15e116d766874$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $edd15e116d766874$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $edd15e116d766874$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $edd15e116d766874$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $edd15e116d766874$var$Configuration(config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7dkLM.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $edd15e116d766874$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $edd15e116d766874$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $edd15e116d766874$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $edd15e116d766874$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $edd15e116d766874$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $edd15e116d766874$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $edd15e116d766874$var$keys = Object.create(null);
function $edd15e116d766874$var$createKey(name) {
    if (name in $edd15e116d766874$var$keys) return name + "$" + ++$edd15e116d766874$var$keys[name];
    $edd15e116d766874$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $edd15e116d766874$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $edd15e116d766874$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("7dkLM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5409dbb98ebf29ba$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $5409dbb98ebf29ba$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $5409dbb98ebf29ba$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $5409dbb98ebf29ba$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $5409dbb98ebf29ba$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $5409dbb98ebf29ba$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $5409dbb98ebf29ba$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $5409dbb98ebf29ba$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $5409dbb98ebf29ba$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $5409dbb98ebf29ba$export$3476b78f8f5a8b72);

var $cPnfS = parcelRequire("cPnfS");
function $5409dbb98ebf29ba$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $5409dbb98ebf29ba$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $5409dbb98ebf29ba$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $5409dbb98ebf29ba$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $5409dbb98ebf29ba$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $5409dbb98ebf29ba$var$retIndex(0, pos);
        if (pos == this.size) return $5409dbb98ebf29ba$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $5409dbb98ebf29ba$var$retIndex(i + 1, end);
                return $5409dbb98ebf29ba$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (nodes instanceof $5409dbb98ebf29ba$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $5409dbb98ebf29ba$export$ffb0004e005737fa.empty = new $5409dbb98ebf29ba$export$ffb0004e005737fa([], 0);
const $5409dbb98ebf29ba$var$found = {
    index: 0,
    offset: 0
};
function $5409dbb98ebf29ba$var$retIndex(index, offset) {
    $5409dbb98ebf29ba$var$found.index = index;
    $5409dbb98ebf29ba$var$found.offset = offset;
    return $5409dbb98ebf29ba$var$found;
}
function $5409dbb98ebf29ba$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$5409dbb98ebf29ba$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$5409dbb98ebf29ba$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $5409dbb98ebf29ba$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        if (marks instanceof $5409dbb98ebf29ba$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $5409dbb98ebf29ba$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $5409dbb98ebf29ba$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty = new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, 0, 0);
function $5409dbb98ebf29ba$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($5409dbb98ebf29ba$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $5409dbb98ebf29ba$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $5409dbb98ebf29ba$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $5409dbb98ebf29ba$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inconsistent open depths");
    return $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, 0);
}
function $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $5409dbb98ebf29ba$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $from);
        return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $5409dbb98ebf29ba$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $5409dbb98ebf29ba$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $5409dbb98ebf29ba$var$checkJoin(node, $after.node(depth));
    return node;
}
function $5409dbb98ebf29ba$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $5409dbb98ebf29ba$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $5409dbb98ebf29ba$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$5409dbb98ebf29ba$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $5409dbb98ebf29ba$var$addNode($end.nodeBefore, target);
}
function $5409dbb98ebf29ba$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $5409dbb98ebf29ba$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $5409dbb98ebf29ba$var$joinable($end, $to, depth + 1);
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $5409dbb98ebf29ba$var$checkJoin(openStart, openEnd);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceTwoWay($from, $start, depth + 1)), content);
        $5409dbb98ebf29ba$var$addRange($start, $end, depth, content);
        if (openEnd) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openEnd, $5409dbb98ebf29ba$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $5409dbb98ebf29ba$var$joinable($from, $to, depth + 1);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(type, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $5409dbb98ebf29ba$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $5409dbb98ebf29ba$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $5409dbb98ebf29ba$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $5409dbb98ebf29ba$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $5409dbb98ebf29ba$var$resolveCache.set(doc, cache = new $5409dbb98ebf29ba$var$ResolveCache);
        let result = cache.elts[cache.i] = $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $5409dbb98ebf29ba$var$resolveCacheSize;
        return result;
    }
}
class $5409dbb98ebf29ba$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $5409dbb98ebf29ba$var$resolveCacheSize = 12, $5409dbb98ebf29ba$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $5409dbb98ebf29ba$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $5409dbb98ebf29ba$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $5409dbb98ebf29ba$var$emptyAttrs) && $5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $5409dbb98ebf29ba$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $5409dbb98ebf29ba$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$5409dbb98ebf29ba$export$85c928794f8d04d4.prototype.text = undefined;
class $5409dbb98ebf29ba$var$TextNode extends $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $5409dbb98ebf29ba$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $5409dbb98ebf29ba$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $5409dbb98ebf29ba$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $5409dbb98ebf29ba$var$dfa($5409dbb98ebf29ba$var$nfa(expr));
        $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $5409dbb98ebf29ba$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $5409dbb98ebf29ba$export$364ed450558d7ec4.empty = new $5409dbb98ebf29ba$export$364ed450558d7ec4(true);
class $5409dbb98ebf29ba$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $5409dbb98ebf29ba$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSubscript(stream) {
    let expr = $5409dbb98ebf29ba$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $5409dbb98ebf29ba$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $5409dbb98ebf29ba$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $5409dbb98ebf29ba$var$parseExprRange(stream, expr) {
    let min = $5409dbb98ebf29ba$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $5409dbb98ebf29ba$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $5409dbb98ebf29ba$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $5409dbb98ebf29ba$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $5409dbb98ebf29ba$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $5409dbb98ebf29ba$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $5409dbb98ebf29ba$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $5409dbb98ebf29ba$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($5409dbb98ebf29ba$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $5409dbb98ebf29ba$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($5409dbb98ebf29ba$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $5409dbb98ebf29ba$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $5409dbb98ebf29ba$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($5409dbb98ebf29ba$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $5409dbb98ebf29ba$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $5409dbb98ebf29ba$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $5409dbb98ebf29ba$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $5409dbb98ebf29ba$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $5409dbb98ebf29ba$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $5409dbb98ebf29ba$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, attrs, content.append(after), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $5409dbb98ebf29ba$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $5409dbb98ebf29ba$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $5409dbb98ebf29ba$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $5409dbb98ebf29ba$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $5409dbb98ebf29ba$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $5409dbb98ebf29ba$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cPnfS.default).from(spec.nodes), instanceSpec.marks = (0, $cPnfS.default).from(spec.marks || {}), this.nodes = $5409dbb98ebf29ba$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $5409dbb98ebf29ba$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $5409dbb98ebf29ba$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $5409dbb98ebf29ba$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $5409dbb98ebf29ba$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $5409dbb98ebf29ba$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $5409dbb98ebf29ba$var$TextNode(type, type.defaultAttrs, text, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $5409dbb98ebf29ba$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $5409dbb98ebf29ba$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $5409dbb98ebf29ba$var$isTagRule(rule) {
    return rule.tag != null;
}
function $5409dbb98ebf29ba$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $5409dbb98ebf29ba$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($5409dbb98ebf29ba$var$isTagRule(rule)) this.tags.push(rule);
            else if ($5409dbb98ebf29ba$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, false);
        context.addAll(dom, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, true);
        context.addAll(dom, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($5409dbb98ebf29ba$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $5409dbb98ebf29ba$export$1059c6e7d2ce5669(schema, $5409dbb98ebf29ba$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $5409dbb98ebf29ba$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $5409dbb98ebf29ba$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $5409dbb98ebf29ba$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $5409dbb98ebf29ba$var$OPT_PRESERVE_WS = 1, $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL = 2, $5409dbb98ebf29ba$var$OPT_OPEN_LEFT = 4;
function $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS | $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : base & ~$5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
}
class $5409dbb98ebf29ba$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$5409dbb98ebf29ba$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $5409dbb98ebf29ba$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $5409dbb98ebf29ba$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $5409dbb98ebf29ba$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $5409dbb98ebf29ba$var$NodeContext(topNode.type, topNode.attrs, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $5409dbb98ebf29ba$var$NodeContext(null, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $5409dbb98ebf29ba$var$NodeContext(parser.schema.topNodeType, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $5409dbb98ebf29ba$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $5409dbb98ebf29ba$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($5409dbb98ebf29ba$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                return;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $5409dbb98ebf29ba$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
        let applyMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $5409dbb98ebf29ba$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $5409dbb98ebf29ba$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $5409dbb98ebf29ba$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $5409dbb98ebf29ba$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $5409dbb98ebf29ba$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $5409dbb98ebf29ba$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $5409dbb98ebf29ba$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $5409dbb98ebf29ba$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $5409dbb98ebf29ba$var$renderSpec($5409dbb98ebf29ba$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $5409dbb98ebf29ba$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $5409dbb98ebf29ba$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $5409dbb98ebf29ba$var$gatherToDOM(schema.marks);
    }
}
function $5409dbb98ebf29ba$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $5409dbb98ebf29ba$var$doc(options) {
    return options.document || window.document;
}
const $5409dbb98ebf29ba$var$suspiciousAttributeCache = new WeakMap();
function $5409dbb98ebf29ba$var$suspiciousAttributes(attrs) {
    let value = $5409dbb98ebf29ba$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $5409dbb98ebf29ba$var$suspiciousAttributeCache.set(attrs, value = $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs));
    return value;
}
function $5409dbb98ebf29ba$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $5409dbb98ebf29ba$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $5409dbb98ebf29ba$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $5409dbb98ebf29ba$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("cPnfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c496b6231a8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $956c496b6231a8e7$var$OrderedMap(content) {
    this.content = content;
}
$956c496b6231a8e7$var$OrderedMap.prototype = {
    constructor: $956c496b6231a8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $956c496b6231a8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$956c496b6231a8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $956c496b6231a8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $956c496b6231a8e7$var$OrderedMap(content);
};
var $956c496b6231a8e7$export$2e2bcd8739ae039 = $956c496b6231a8e7$var$OrderedMap;

});


parcelRegister("d6JJW", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $98af50e5743169ae$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $98af50e5743169ae$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $98af50e5743169ae$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $98af50e5743169ae$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $98af50e5743169ae$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $98af50e5743169ae$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $98af50e5743169ae$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $98af50e5743169ae$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $98af50e5743169ae$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $98af50e5743169ae$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $98af50e5743169ae$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $98af50e5743169ae$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $98af50e5743169ae$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $98af50e5743169ae$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $98af50e5743169ae$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $98af50e5743169ae$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $98af50e5743169ae$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $98af50e5743169ae$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $98af50e5743169ae$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $98af50e5743169ae$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $98af50e5743169ae$export$563a914cafbdc389);

var $7dkLM = parcelRequire("7dkLM");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $98af50e5743169ae$var$lower16 = 0xffff;
const $98af50e5743169ae$var$factor16 = Math.pow(2, 16);
function $98af50e5743169ae$var$makeRecover(index, offset) {
    return index + offset * $98af50e5743169ae$var$factor16;
}
function $98af50e5743169ae$var$recoverIndex(value) {
    return value & $98af50e5743169ae$var$lower16;
}
function $98af50e5743169ae$var$recoverOffset(value) {
    return (value - (value & $98af50e5743169ae$var$lower16)) / $98af50e5743169ae$var$factor16;
}
const $98af50e5743169ae$var$DEL_BEFORE = 1, $98af50e5743169ae$var$DEL_AFTER = 2, $98af50e5743169ae$var$DEL_ACROSS = 4, $98af50e5743169ae$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $98af50e5743169ae$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_BEFORE | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_AFTER | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $98af50e5743169ae$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $98af50e5743169ae$export$c53d01c3ab9721b3.empty) return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $98af50e5743169ae$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $98af50e5743169ae$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $98af50e5743169ae$var$DEL_AFTER : pos == end ? $98af50e5743169ae$var$DEL_BEFORE : $98af50e5743169ae$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $98af50e5743169ae$var$DEL_SIDE;
                return new $98af50e5743169ae$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $98af50e5743169ae$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $98af50e5743169ae$export$c53d01c3ab9721b3.empty : new $98af50e5743169ae$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $98af50e5743169ae$export$c53d01c3ab9721b3.empty = new $98af50e5743169ae$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $98af50e5743169ae$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $98af50e5743169ae$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $98af50e5743169ae$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $98af50e5743169ae$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $98af50e5743169ae$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $98af50e5743169ae$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $98af50e5743169ae$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $98af50e5743169ae$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $98af50e5743169ae$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7dkLM.ReplaceError)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $98af50e5743169ae$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($98af50e5743169ae$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $98af50e5743169ae$export$d24ba56b0e3464a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addMark", $98af50e5743169ae$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $98af50e5743169ae$export$94150db1311f67a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $98af50e5743169ae$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeMark", $98af50e5743169ae$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $98af50e5743169ae$export$adefd16c402fee4e extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addNodeMark", $98af50e5743169ae$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $98af50e5743169ae$export$fdf7d1dc10724da2 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeNodeMark", $98af50e5743169ae$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $98af50e5743169ae$export$5c860b2e74034756 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $98af50e5743169ae$var$contentBetween(doc, this.from, this.to)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $98af50e5743169ae$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $98af50e5743169ae$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $98af50e5743169ae$export$5c860b2e74034756(json.from, json.to, (0, $7dkLM.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replace", $98af50e5743169ae$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $98af50e5743169ae$export$444ba800d6024a98 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($98af50e5743169ae$var$contentBetween(doc, this.from, this.gapFrom) || $98af50e5743169ae$var$contentBetween(doc, this.gapTo, this.to))) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $98af50e5743169ae$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $98af50e5743169ae$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $98af50e5743169ae$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7dkLM.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replaceAround", $98af50e5743169ae$export$444ba800d6024a98);
function $98af50e5743169ae$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $98af50e5743169ae$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $98af50e5743169ae$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $98af50e5743169ae$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $98af50e5743169ae$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7dkLM.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $98af50e5743169ae$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $98af50e5743169ae$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur, end, (0, $7dkLM.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $98af50e5743169ae$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7dkLM.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7dkLM.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $98af50e5743169ae$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $98af50e5743169ae$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$98af50e5743169ae$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $98af50e5743169ae$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7dkLM.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7dkLM.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7dkLM.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7dkLM.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7dkLM.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $98af50e5743169ae$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $98af50e5743169ae$var$findWrappingOutside(range, nodeType);
    let inner = around && $98af50e5743169ae$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($98af50e5743169ae$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($98af50e5743169ae$var$withAttrs));
}
function $98af50e5743169ae$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $98af50e5743169ae$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $98af50e5743169ae$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $98af50e5743169ae$var$wrap(tr, range, wrappers) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, start, end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
}
function $98af50e5743169ae$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $98af50e5743169ae$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $98af50e5743169ae$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $98af50e5743169ae$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $98af50e5743169ae$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $98af50e5743169ae$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $98af50e5743169ae$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $98af50e5743169ae$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $98af50e5743169ae$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $98af50e5743169ae$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7dkLM.Fragment).empty, after = (0, $7dkLM.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7dkLM.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7dkLM.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $98af50e5743169ae$export$5c860b2e74034756(pos, pos, new (0, $7dkLM.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $98af50e5743169ae$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $98af50e5743169ae$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $98af50e5743169ae$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $98af50e5743169ae$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $98af50e5743169ae$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $98af50e5743169ae$var$join(tr, pos, depth) {
    let step = new $98af50e5743169ae$export$5c860b2e74034756(pos - depth, pos + depth, (0, $7dkLM.Slice).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $98af50e5743169ae$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $98af50e5743169ae$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $98af50e5743169ae$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7dkLM.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice);
    return new $98af50e5743169ae$var$Fitter($from, $to, slice).fit();
}
function $98af50e5743169ae$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $98af50e5743169ae$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7dkLM.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7dkLM.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7dkLM.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $98af50e5743169ae$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $98af50e5743169ae$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $98af50e5743169ae$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7dkLM.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7dkLM.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($98af50e5743169ae$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, frontierDepth, (0, $7dkLM.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$98af50e5743169ae$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $98af50e5743169ae$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $98af50e5743169ae$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.depth, (0, $7dkLM.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7dkLM.Fragment).empty, true);
        if (add.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $98af50e5743169ae$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($98af50e5743169ae$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $98af50e5743169ae$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($98af50e5743169ae$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $98af50e5743169ae$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $98af50e5743169ae$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $98af50e5743169ae$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $98af50e5743169ae$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$98af50e5743169ae$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $98af50e5743169ae$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $98af50e5743169ae$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $98af50e5743169ae$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return tr.step(new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $98af50e5743169ae$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $98af50e5743169ae$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7dkLM.Slice)($98af50e5743169ae$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $98af50e5743169ae$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($98af50e5743169ae$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return fragment;
}
function $98af50e5743169ae$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $98af50e5743169ae$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
}
function $98af50e5743169ae$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $98af50e5743169ae$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $98af50e5743169ae$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $98af50e5743169ae$export$626399c38172f669 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $98af50e5743169ae$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("attr", $98af50e5743169ae$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $98af50e5743169ae$export$f50707b396300ac9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $98af50e5743169ae$export$f50707b396300ac9(json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("docAttr", $98af50e5743169ae$export$f50707b396300ac9);
/**
@internal
*/ let $98af50e5743169ae$export$88cc3a1dfce48dd3 = class extends Error {
};
$98af50e5743169ae$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.constructor = $98af50e5743169ae$export$88cc3a1dfce48dd3;
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $98af50e5743169ae$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $98af50e5743169ae$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $98af50e5743169ae$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7dkLM.Slice).empty) {
        let step = $98af50e5743169ae$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7dkLM.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $98af50e5743169ae$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $98af50e5743169ae$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $98af50e5743169ae$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $98af50e5743169ae$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $98af50e5743169ae$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $98af50e5743169ae$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $98af50e5743169ae$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $98af50e5743169ae$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $98af50e5743169ae$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $98af50e5743169ae$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $98af50e5743169ae$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7dkLM.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $98af50e5743169ae$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $98af50e5743169ae$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $98af50e5743169ae$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $98af50e5743169ae$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $98af50e5743169ae$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});






parcelRegister("1OXH6", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $f3722f3047af5288$export$a5d940130f33be3f);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $f3722f3047af5288$export$a5d940130f33be3f = (WrappedComponent)=>{
    return (props)=>{
        const { locale: locale, ...rest } = props;
        if (locale) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, rest));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, rest);
    };
};

});

parcelRegister("70Lp3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jMmI5")
]).then(()=>parcelRequire('hbnDW'));

});


parcelRegister("CDhez", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bc4b085965050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $8CfG4 = parcelRequire("8CfG4");

var $2njBd = parcelRequire("2njBd");

var $9sehj = parcelRequire("9sehj");

var $9zALC = parcelRequire("9zALC");

var $jmejm = parcelRequire("jmejm");

var $gfXKy = parcelRequire("gfXKy");

var $axKFq = parcelRequire("axKFq");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2b5us = parcelRequire("2b5us");

var $6oH5O = parcelRequire("6oH5O");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3DOEL = parcelRequire("3DOEL");


var $idLJG = parcelRequire("idLJG");

var $5l4v4 = parcelRequire("5l4v4");

var $43qBf = parcelRequire("43qBf");

var $5ukwI = parcelRequire("5ukwI");
const $b60bc4b085965050$var$JQLBuilderAdvancedUI = (props)=>{
    (0, $asu8X.di)(requestAnimationFrame);
    const { analyticsSource: analyticsSource, JQLEditor: JQLEditor, query: query, jqlMessages: jqlMessages, isCompact: isCompact, isSearching: isSearching, onUpdate: onUpdate, onReady: onReady, onSearch: onSearch, excludedAutocompleteFields: excludedAutocompleteFields, onJourneyStart: onJourneyStart, autoFocus: autoFocus, viewContext: viewContext = null } = props;
    const onPerformanceMark = (0, $2b5us.usePerformanceContext)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $6oH5O.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onHydrate = (0, $5ukwI.useOnHydrate)(viewContext);
    const getInitialData = (0, $5l4v4.useAutocompleteInitialData)(excludedAutocompleteFields);
    const getSuggestions = (0, $43qBf.useAutocompleteSuggestions)();
    const autocompleteProvider = (0, $9sehj.useAutocompleteProvider)(analyticsSource, getInitialData, getSuggestions);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const onExperienceStart = (0, $bDhRl.useExperienceStart)({
        experienceId: undefined,
        experience: (0, $86744a571d2f9364$export$abc61f74b6bec12c),
        analyticsSource: analyticsSource
    });
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $86744a571d2f9364$export$abc61f74b6bec12c)
    });
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $86744a571d2f9364$export$abc61f74b6bec12c)
    });
    const onError = (0, $eUqFw.useCallback)((error)=>{
        showFlag({
            type: 'error',
            title: (0, $idLJG.default).errorFlagTitle,
            description: (0, $idLJG.default).errorFlagDescription
        });
        // A success event may have already been fired on initial render. We need to start a new experience so we
        // can mark it as failed.
        onExperienceStart();
        onExperienceFail(analyticsSource, error);
        (0, $guiFP.default)({
            meta: {
                id: (0, $86744a571d2f9364$export$abc61f74b6bec12c),
                packageName: (0, $86744a571d2f9364$export$b8b9d90f9e5bd72b),
                teamName: (0, $86744a571d2f9364$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag,
        onExperienceStart,
        onExperienceFail,
        analyticsSource
    ]);
    // Additional logging to debug unexpected (non-fatal) behaviour in the editor.
    const onDebugUnsafeMessage = (0, $eUqFw.useCallback)((message, event)=>{
        (0, $gUUjF.default).unsafeErrorWithCustomerData('jiraJqlBuilderAdvanced.onDebugUnsafeMessage', message, event);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // Start the view experience on mount. This experience will be marked as successful by the JQLBuilderAdvancedUI
        // component upon render.
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const focusSearchInput = (0, $eUqFw.useCallback)(()=>{
        // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef?.current?.focus();
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'jqlEditorAdvancedSearchInputKeyboardShortcut', {
            keyPressed: 'f',
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const onEditorMounted = (0, $eUqFw.useCallback)(()=>{
        onExperienceSuccess();
        if (autoFocus) focusSearchInput();
        onReady && onReady();
    }, [
        onExperienceSuccess,
        onReady,
        autoFocus,
        focusSearchInput
    ]);
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'jqlEditorAdvancedSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axKFq.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-advanced-focus-search-input',
                    name: formatMessage((0, $idLJG.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                                label: formatMessage((0, $idLJG.default).searchCurrentPage)
                            })
                    },
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JQLEditor, {
        inputRef: searchInputRef,
        analyticsSource: analyticsSource,
        query: query,
        messages: jqlMessages,
        isCompact: isCompact,
        isSearching: isSearching,
        onEditorMounted: onEditorMounted,
        onUpdate: onUpdate,
        onSearch: onSearch,
        onHydrate: onHydrate,
        onFocus: onJourneyStart ? onFocus : undefined,
        autocompleteProvider: autocompleteProvider,
        onRenderError: onError,
        onDebugUnsafeMessage: onDebugUnsafeMessage,
        enableRichInlineNodes: true
    }));
};
const $b60bc4b085965050$var$JQLBuilderAdvancedUIWithAnalytics = (props)=>{
    const clientWrapper = (0, $eUqFw.useRef)((0, $3DOEL.getAnalyticsWebClient)());
    return /* @ts-expect-error - Property 'analyticsClient' does not exist on type 'AnalyticsWebClient'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2njBd.default), {
        client: clientWrapper.current?.analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "jqlBuilderAdvanced",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b60bc4b085965050$var$JQLBuilderAdvancedUI, props)));
};
var $b60bc4b085965050$export$2e2bcd8739ae039 = $b60bc4b085965050$var$JQLBuilderAdvancedUIWithAnalytics;

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("2njBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab5fdf6549b1dbec$export$2e2bcd8739ae039);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/FabricEditorListener.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $1nSuw = parcelRequire("1nSuw");

var $gl8n6 = parcelRequire("gl8n6");

var $clvJR = parcelRequire("clvJR");
class $ab5fdf6549b1dbec$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.handleEventWrapper = (event)=>{
            (0, $gl8n6.handleEvent)(event, this.logger, this.props.client);
        };
        this.logger = new (0, $clvJR.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $1nSuw.ANALYTICS_CHANNEL)
        }, this.props.children);
    }
}

});
parcelRegister("1nSuw", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $16d6105d9ce42418$export$85183a312807388d);
$parcel$export(module.exports, "EventType", () => $16d6105d9ce42418$export$3d7865934588d77e);
const $16d6105d9ce42418$export$85183a312807388d = 'jql-editor';
var $16d6105d9ce42418$export$3d7865934588d77e;
(function(EventType) {
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
})($16d6105d9ce42418$export$3d7865934588d77e || ($16d6105d9ce42418$export$3d7865934588d77e = {}));

});

parcelRegister("gl8n6", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $29a37a14ea070165$export$d6e5ca10785815df);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/handle-event.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $982pK = parcelRequire("982pK");

var $iSqjs = parcelRequire("iSqjs");
const $29a37a14ea070165$export$d6e5ca10785815df = (event, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $iSqjs.processEventPayload)(event);
    (0, $982pK.sendEvent)(logger, client)(payload);
};

});
parcelRegister("982pK", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $a8cf89f0809174f8$export$7329bcdc3edcd90e);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/analytics-web-client-wrapper.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $a8cf89f0809174f8$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $a8cf89f0809174f8$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const gasEvent = {
                ...event
            };
            /*
      Merging this ts-ignore is not going to affect the type definitions of the package
      there's a whole lot more wrong going on here than just this delete.
      All the send methods on the client take a GasPurePayload object which requires actionSubject
      actionSubject is missing on GasPayload | GasScreenEventPayload
    */ // @ts-ignore mergeable @fixme TypeScript 4.2.4 upgrade
            delete gasEvent.eventType;
            const withClient = (cb)=>{
                if ($a8cf89f0809174f8$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("iSqjs", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $93573902655d0757$export$c37d638b7f2ca192);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/process-event-payload.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $2vzCR = parcelRequire("2vzCR");

const $93573902655d0757$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, item), {});
const $93573902655d0757$var$fieldExtractor = ()=>$93573902655d0757$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId'
    ]);
const $93573902655d0757$var$updatePayloadWithContext = (event)=>{
    if (event.context.length === 0) return {
        source: (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        ...event.payload
    };
    const fields = $93573902655d0757$var$fieldExtractor()(event.context);
    return {
        source: (0, $662e33bb7444ae33$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $93573902655d0757$export$c37d638b7f2ca192 = (event)=>{
    return $93573902655d0757$var$updatePayloadWithContext(event);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';



parcelRegister("clvJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f0e7059338dd99$export$2e2bcd8739ae039);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/helpers/logger.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $a9f0e7059338dd99$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $a9f0e7059338dd99$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $a9f0e7059338dd99$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $a9f0e7059338dd99$export$ffe0c436e29512cf.DEBUG && logLevel <= $a9f0e7059338dd99$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $a9f0e7059338dd99$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) // eslint-disable-next-line no-console
        console[type](...args);
    }
    debug(...args) {
        this.logMessage($a9f0e7059338dd99$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($a9f0e7059338dd99$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($a9f0e7059338dd99$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($a9f0e7059338dd99$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});


parcelRegister("9sehj", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteProvider", () => $d4bff8c4a51616d4$export$2ae605545144a62d);

var $eUqFw = parcelRequire("eUqFw");

var $gHajm = parcelRequire("gHajm");

var $dM6Yo = parcelRequire("dM6Yo");

var $aCGRI = parcelRequire("aCGRI");

var $5mlxZ = parcelRequire("5mlxZ");

var $6BvAr = parcelRequire("6BvAr");

var $kgWet = parcelRequire("kgWet");
const $d4bff8c4a51616d4$export$2ae605545144a62d = (/**
	 * Page/experience where the hook is being rendered. Used to correlate JQL analytics events to a given consumer.
	 */ analyticsSource, /**
	 * Fetch initial autocomplete data for fields and functions using the [Get field reference data API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-post).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getInitialData, /**
	 * Fetch autocomplete suggestions for field values using the [Get field autocomplete suggestions API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-suggestions-get).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getSuggestions)=>{
    const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, $gHajm.useJqlEditorAutocompleteAnalytics)(analyticsSource);
    const [, { load: load }] = (0, $dM6Yo.useJqlAutocompleteActions)();
    const [jqlSearchableFields$] = (0, $dM6Yo.useJqlSearchableFieldsObservable)();
    const [jqlOrderableFields$] = (0, $dM6Yo.useJqlOrderableFieldsObservable)();
    const [jqlFunctions$] = (0, $dM6Yo.useJqlFunctionsObservable)();
    const onFields = (0, $aCGRI.default)(jqlSearchableFields$, jqlOrderableFields$);
    const onOperators = (0, $6BvAr.default)(jqlSearchableFields$);
    const onFunctions = (0, $5mlxZ.default)(jqlSearchableFields$, jqlFunctions$);
    const onValues = (0, $kgWet.default)(jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent);
    (0, $eUqFw.useEffect)(()=>{
        // Load autocomplete data on mount
        load(getInitialData, createAndFireAnalyticsEvent);
    }, [
        createAndFireAnalyticsEvent,
        getInitialData,
        load
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            onFields: onFields,
            onOperators: onOperators,
            onFunctions: onFunctions,
            onValues: onValues
        }), [
        onFields,
        onOperators,
        onFunctions,
        onValues
    ]);
};

});
parcelRegister("gHajm", function(module, exports) {

$parcel$export(module.exports, "useJqlEditorAutocompleteAnalytics", () => $9b1c4702f3d5e6d5$export$67ceee19d6563eac);

var $1nSuw = parcelRequire("1nSuw");
var $16rlz = parcelRequire("16rlz");

var $7QK5f = parcelRequire("7QK5f");
const $9b1c4702f3d5e6d5$export$67ceee19d6563eac = (analyticsSource)=>{
    return (0, $16rlz.useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, $1nSuw.ANALYTICS_CHANNEL));
};

});
parcelRegister("16rlz", function(module, exports) {

$parcel$export(module.exports, "useJqlPackageAnalytics", () => $fd1a70eb75437dcc$export$62edc016e6670a97);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");
const $fd1a70eb75437dcc$export$62edc016e6670a97 = (analyticsSource, packageName, packageVersion, analyticsChannel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const createAndFireAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
        const event = createAnalyticsEvent({
            ...payload,
            attributes: {
                ...payload.attributes,
                analyticsSource: analyticsSource,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        event.fire(analyticsChannel);
    }, [
        createAnalyticsEvent,
        analyticsSource,
        packageName,
        packageVersion,
        analyticsChannel
    ]);
    return {
        createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
    };
};

});

parcelRegister("7QK5f", function(module, exports) {

$parcel$export(module.exports, "Action", () => $2f0e5bedda3f1c5a$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $2f0e5bedda3f1c5a$export$7f97440769de1377);
var $2f0e5bedda3f1c5a$export$e19cd5f9376f8cee;
(function(Action) {
    Action["FAILED"] = "failed";
    Action["SUCCESS"] = "success";
})($2f0e5bedda3f1c5a$export$e19cd5f9376f8cee || ($2f0e5bedda3f1c5a$export$e19cd5f9376f8cee = {}));
var $2f0e5bedda3f1c5a$export$7f97440769de1377;
(function(ActionSubject) {
    ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
    ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
})($2f0e5bedda3f1c5a$export$7f97440769de1377 || ($2f0e5bedda3f1c5a$export$7f97440769de1377 = {}));
var $2f0e5bedda3f1c5a$export$cb7d54f314e067cb;
$2f0e5bedda3f1c5a$export$cb7d54f314e067cb || ($2f0e5bedda3f1c5a$export$cb7d54f314e067cb = {});

});


parcelRegister("dM6Yo", function(module, exports) {

$parcel$export(module.exports, "useJqlAutocompleteActions", () => $07672df157f5bd16$export$dfe74b189a0a3dd);
$parcel$export(module.exports, "useJqlSearchableFieldsObservable", () => $07672df157f5bd16$export$e00ad85496518b08);
$parcel$export(module.exports, "useJqlOrderableFieldsObservable", () => $07672df157f5bd16$export$ddac70d4fccb6121);
$parcel$export(module.exports, "useJqlFunctionsObservable", () => $07672df157f5bd16$export$20ce426c77c6c794);

var $WBLbN = parcelRequire("WBLbN");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $1nSuw = parcelRequire("1nSuw");

var $7QK5f = parcelRequire("7QK5f");
const $07672df157f5bd16$var$initialData = {
    jqlSearchableFields: [],
    jqlOrderableFields: [],
    jqlFunctions: []
};
const $07672df157f5bd16$var$initialState = {
    initialDataFetched: false,
    jqlSearchableFields$: (0, $jpkPA.from)($07672df157f5bd16$var$initialData.jqlSearchableFields),
    jqlOrderableFields$: (0, $jpkPA.from)($07672df157f5bd16$var$initialData.jqlOrderableFields),
    jqlFunctions$: (0, $jpkPA.from)($07672df157f5bd16$var$initialData.jqlFunctions)
};
const $07672df157f5bd16$export$e324594224ef24da = {
    load: (getInitialData, createAndFireAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
            const { initialDataFetched: initialDataFetched } = getState();
            if (initialDataFetched) return;
            const promise = getInitialData(`/rest/api/latest/jql/autocompletedata`).then((res)=>{
                const initialValue = {
                    jqlSearchableFields: [],
                    jqlOrderableFields: [],
                    jqlFunctions: res.jqlFunctions
                };
                const data = res.jqlFields.reduce((result, field)=>{
                    if (field.searchable === 'true') result.jqlSearchableFields.push(field);
                    if (field.orderable === 'true') result.jqlOrderableFields.push(field);
                    return result;
                }, initialValue);
                // Minor optimisation so consumers don't have to wait for the promise `then` function to be called
                // whenever we subscribe to the observable. (`then` runs async in the current thread loop)
                setState({
                    jqlSearchableFields$: (0, $jpkPA.from)(data.jqlSearchableFields),
                    jqlOrderableFields$: (0, $jpkPA.from)(data.jqlOrderableFields),
                    jqlFunctions$: (0, $jpkPA.from)(data.jqlFunctions)
                });
                createAndFireAnalyticsEvent({
                    action: (0, $7QK5f.Action).SUCCESS,
                    actionSubject: (0, $7QK5f.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $1nSuw.EventType).OPERATIONAL
                });
                return data;
            }).catch(()=>{
                setState({
                    jqlSearchableFields$: $07672df157f5bd16$var$initialState.jqlSearchableFields$,
                    jqlOrderableFields$: $07672df157f5bd16$var$initialState.jqlOrderableFields$,
                    jqlFunctions$: $07672df157f5bd16$var$initialState.jqlFunctions$
                });
                createAndFireAnalyticsEvent({
                    action: (0, $7QK5f.Action).FAILED,
                    actionSubject: (0, $7QK5f.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $1nSuw.EventType).OPERATIONAL
                });
                return $07672df157f5bd16$var$initialData;
            });
            // Set the in-flight promise in state as an observable. This allows consumers to subscribe to our initial data
            // without worrying about race conditions with the API call.
            setState({
                initialDataFetched: true,
                jqlSearchableFields$: (0, $jpkPA.from)(promise).pipe((0, $eGPtZ.concatMap)(({ jqlSearchableFields: jqlSearchableFields })=>jqlSearchableFields)),
                jqlOrderableFields$: (0, $jpkPA.from)(promise).pipe((0, $eGPtZ.concatMap)(({ jqlOrderableFields: jqlOrderableFields })=>jqlOrderableFields)),
                jqlFunctions$: (0, $jpkPA.from)(promise).pipe((0, $eGPtZ.concatMap)(({ jqlFunctions: jqlFunctions })=>jqlFunctions))
            });
        }
};
const $07672df157f5bd16$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    initialState: $07672df157f5bd16$var$initialState,
    actions: $07672df157f5bd16$export$e324594224ef24da
});
const $07672df157f5bd16$export$96c8f4ecc88d96a5 = (0, $WBLbN.createContainer)($07672df157f5bd16$export$6f57813fe9f31bf9);
const $07672df157f5bd16$export$dfe74b189a0a3dd = (0, $WBLbN.createHook)($07672df157f5bd16$export$6f57813fe9f31bf9, {
    selector: null
});
const $07672df157f5bd16$export$e00ad85496518b08 = (0, $WBLbN.createHook)($07672df157f5bd16$export$6f57813fe9f31bf9, {
    selector: ({ jqlSearchableFields$: jqlSearchableFields$ })=>jqlSearchableFields$
});
const $07672df157f5bd16$export$ddac70d4fccb6121 = (0, $WBLbN.createHook)($07672df157f5bd16$export$6f57813fe9f31bf9, {
    selector: ({ jqlOrderableFields$: jqlOrderableFields$ })=>jqlOrderableFields$
});
const $07672df157f5bd16$export$20ce426c77c6c794 = (0, $WBLbN.createHook)($07672df157f5bd16$export$6f57813fe9f31bf9, {
    selector: ({ jqlFunctions$: jqlFunctions$ })=>jqlFunctions$
});

});

parcelRegister("aCGRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $772466329257395c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hfK6B = parcelRequire("hfK6B");

var $bKhOq = parcelRequire("bKhOq");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $8TnD2 = parcelRequire("8TnD2");

var $2arAN = parcelRequire("2arAN");

var $5gUCw = parcelRequire("5gUCw");

var $liYmF = parcelRequire("liYmF");
const $772466329257395c$export$df27029b4333540b = 20;
const $772466329257395c$var$CF_ID_PATTERN = /^"?cf\[\d+]"?$/;
const $772466329257395c$var$COLLAPSED_FIELD_PATTERN = /^"?.+\[(.+)]"?$/;
const $772466329257395c$var$isCollapsedField = ({ value: value })=>$772466329257395c$var$COLLAPSED_FIELD_PATTERN.test(value) && !$772466329257395c$var$CF_ID_PATTERN.test(value);
const $772466329257395c$export$b9089a6e41ed43aa = (field)=>{
    if (!$772466329257395c$var$isCollapsedField(field)) return null;
    const matches = $772466329257395c$var$COLLAPSED_FIELD_PATTERN.exec(field.value);
    if (!matches || matches.length < 2) return null;
    return matches[1];
};
const $772466329257395c$var$useOnFields = (jqlSearchableFields$, jqlOrderableFields$)=>{
    // Returns an Observable of the fields to render for the provided query string
    return (0, $eUqFw.useCallback)((query, clause)=>{
        if (clause === undefined) return (0, $bKhOq.empty)();
        const jqlFields$ = clause === 'orderBy' ? jqlOrderableFields$ : jqlSearchableFields$;
        return jqlFields$.pipe((0, $dXapj.filter)((field)=>(0, $5gUCw.filterJqlValue)(field, query)), // Limit the result to MAX_VISIBLE_OPTIONS
        (0, $8TnD2.take)($772466329257395c$export$df27029b4333540b), (0, $aynDk.map)((field)=>{
            const fieldType = $772466329257395c$export$b9089a6e41ed43aa(field);
            if (fieldType !== null) {
                const name = (0, (/*@__PURE__*/$parcel$interopDefault($hfK6B)))(field.displayName).replace(` - ${(0, $liYmF.normalize)(field.value)}`, '');
                return {
                    name: name,
                    value: field.value,
                    fieldType: fieldType,
                    isDeprecated: field.deprecated === 'true',
                    deprecatedSearcherKey: field.deprecatedSearcherKey
                };
            }
            return {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($hfK6B)))(field.displayName),
                value: field.value,
                isDeprecated: field.deprecated === 'true',
                deprecatedSearcherKey: field.deprecatedSearcherKey
            };
        }), (0, $2arAN.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $dXapj.filter)((fields)=>fields.length > 0));
    }, [
        jqlSearchableFields$,
        jqlOrderableFields$
    ]);
};
var $772466329257395c$export$2e2bcd8739ae039 = $772466329257395c$var$useOnFields;

});
parcelRegister("hfK6B", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");

var $cIdd3 = parcelRequire("cIdd3");
/** Used to match HTML entities and HTML characters. */ var $c8f799fa296abe36$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $c8f799fa296abe36$var$reHasEscapedHtml = RegExp($c8f799fa296abe36$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $c8f799fa296abe36$var$unescape(string) {
    string = $1uqnh(string);
    return string && $c8f799fa296abe36$var$reHasEscapedHtml.test(string) ? string.replace($c8f799fa296abe36$var$reEscapedHtml, $cIdd3) : string;
}
module.exports = $c8f799fa296abe36$var$unescape;

});
parcelRegister("cIdd3", function(module, exports) {

var $aJZyN = parcelRequire("aJZyN");
/** Used to map HTML entities to characters. */ var $02636ab28c8f8499$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $02636ab28c8f8499$var$unescapeHtmlChar = $aJZyN($02636ab28c8f8499$var$htmlUnescapes);
module.exports = $02636ab28c8f8499$var$unescapeHtmlChar;

});


parcelRegister("5gUCw", function(module, exports) {

$parcel$export(module.exports, "filterJqlValue", () => $1fea0e631955e0f5$export$7a9ba8200d77b3fe);

var $liYmF = parcelRequire("liYmF");
const $1fea0e631955e0f5$export$7a9ba8200d77b3fe = ({ displayName: displayName, value: value }, query)=>{
    if (typeof query !== 'string' || query === '') return true;
    const normalizedQuery = (0, $liYmF.normalize)(query);
    const normalizedDisplayName = (0, $liYmF.normalize)(displayName);
    const normalizedValue = (0, $liYmF.normalize)(value);
    // If query is quoted, then we only return exact matches with the JQL value
    if ((0, $liYmF.isQuoted)(query)) return (0, $liYmF.areStringsEquivalent)(normalizedQuery, normalizedValue);
    return (0, $liYmF.areStringsEquivalent)(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || (0, $liYmF.areStringsEquivalent)(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
};

});
parcelRegister("liYmF", function(module, exports) {

$parcel$export(module.exports, "isQuoted", () => $5c30bc97ae4c432f$export$b86601123607fee5);
$parcel$export(module.exports, "normalize", () => $5c30bc97ae4c432f$export$a3295358bff77e);
$parcel$export(module.exports, "areStringsEquivalent", () => $5c30bc97ae4c432f$export$cef6d95c2df8ec7f);
const $5c30bc97ae4c432f$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $5c30bc97ae4c432f$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $5c30bc97ae4c432f$export$b86601123607fee5 = (maybeQuotedString)=>$5c30bc97ae4c432f$export$7a0b99b892e0dda8(maybeQuotedString) || $5c30bc97ae4c432f$export$d5efd6512db694fd(maybeQuotedString);
const $5c30bc97ae4c432f$export$a3295358bff77e = (maybeQuotedString)=>{
    if ($5c30bc97ae4c432f$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
const $5c30bc97ae4c432f$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base'
});
const $5c30bc97ae4c432f$export$cef6d95c2df8ec7f = (a, b)=>$5c30bc97ae4c432f$var$collator.compare(a, b) === 0;

});



parcelRegister("5mlxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d20f92e8bee17b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $e1vfz = parcelRequire("e1vfz");

var $bKhOq = parcelRequire("bKhOq");

var $eGPtZ = parcelRequire("eGPtZ");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $2arAN = parcelRequire("2arAN");

var $6lq5N = parcelRequire("6lq5N");
const $22d20f92e8bee17b$var$useOnFunctions = (jqlSearchableFields$, jqlFunctions$)=>{
    return (0, $eUqFw.useCallback)((query, field, isListOperator)=>{
        if (typeof field !== 'string' || field === '') return (0, $bKhOq.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(query)}[^$]`, 'i') : undefined;
        const field$ = (0, $6lq5N.default)(jqlSearchableFields$, field);
        // Find all functions that match our query with a type that intersects our field types
        return field$.pipe((0, $eGPtZ.concatMap)((matchingField)=>jqlFunctions$.pipe((0, $dXapj.filter)((func)=>!filterRegex || func.displayName.match(filterRegex) !== null), (0, $dXapj.filter)((func)=>// Do not include functions that return a list unless we are using a list operator
                !!isListOperator || func.isList !== 'true'), (0, $dXapj.filter)((func)=>// Include functions with a type that intersects our field types
                func.types.filter((type)=>matchingField.types.includes(type)).length > 0), (0, $aynDk.map)((func)=>({
                    name: func.displayName,
                    value: func.value,
                    isListFunction: func.isList === 'true' || func.supportsListAndSingleValueOperators === 'true'
                })), (0, $2arAN.toArray)())), // We can filter out empty arrays as there is nothing to consume
        (0, $dXapj.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        jqlFunctions$
    ]);
};
var $22d20f92e8bee17b$export$2e2bcd8739ae039 = $22d20f92e8bee17b$var$useOnFunctions;

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});

parcelRegister("6lq5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $105d630895c20e84$export$2e2bcd8739ae039);

var $dXapj = parcelRequire("dXapj");

var $8TnD2 = parcelRequire("8TnD2");

var $liYmF = parcelRequire("liYmF");
/**
 * Returns an Observable of the first field matching the provided string, or an empty Observable if no matching field
 * could be found.
 */ const $105d630895c20e84$var$findField$ = (jqlFields$, field)=>{
    return jqlFields$.pipe((0, $dXapj.filter)(({ value: value })=>{
        const normalizedField = (0, $liYmF.normalize)(field);
        const normalizedValue = (0, $liYmF.normalize)(value);
        return (0, $liYmF.areStringsEquivalent)(normalizedField, normalizedValue);
    }), (0, $8TnD2.take)(1));
};
var $105d630895c20e84$export$2e2bcd8739ae039 = $105d630895c20e84$var$findField$;

});


parcelRegister("6BvAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5307fbe35e6cb8c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $e1vfz = parcelRequire("e1vfz");

var $bKhOq = parcelRequire("bKhOq");

var $eGPtZ = parcelRequire("eGPtZ");

var $dXapj = parcelRequire("dXapj");

var $aynDk = parcelRequire("aynDk");

var $2arAN = parcelRequire("2arAN");

var $6lq5N = parcelRequire("6lq5N");
const $c5307fbe35e6cb8c$var$useOnOperators = (jqlSearchableFields$)=>{
    return (0, $eUqFw.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $bKhOq.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(query)}[^$]`, 'i') : undefined;
        // Find operators for matching field
        return (0, $6lq5N.default)(jqlSearchableFields$, field).pipe((0, $eGPtZ.concatMap)(({ operators: operators })=>operators), // Filter operators that match query
        (0, $dXapj.filter)((operator)=>!filterRegex || operator.match(filterRegex) !== null), (0, $aynDk.map)((operator)=>{
            const value = operator.toUpperCase();
            return {
                name: value,
                value: value
            };
        }), (0, $2arAN.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $dXapj.filter)((operators)=>operators.length > 0));
    }, [
        jqlSearchableFields$
    ]);
};
var $c5307fbe35e6cb8c$export$2e2bcd8739ae039 = $c5307fbe35e6cb8c$var$useOnOperators;

});

parcelRegister("kgWet", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd3461dd2081b41$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $bKhOq = parcelRequire("bKhOq");

var $cwK3t = parcelRequire("cwK3t");

var $eGPtZ = parcelRequire("eGPtZ");

var $kW6gr = parcelRequire("kW6gr");

var $dXapj = parcelRequire("dXapj");

var $6lq5N = parcelRequire("6lq5N");

var $liYmF = parcelRequire("liYmF");


var $dfwxG = parcelRequire("dfwxG");
const $fcd3461dd2081b41$var$getValueType = (field)=>{
    if (field.types.includes((0, $191dad2516e3f528$export$7cba791a20c35c0c))) return 'user';
    return undefined;
};
const $fcd3461dd2081b41$var$fieldValuesReducer = (state, action)=>{
    const { cacheKey: cacheKey, values: values } = action.payload;
    return {
        ...state,
        [cacheKey]: values
    };
};
const $fcd3461dd2081b41$var$initialState = {};
// Hard coded delay before making a fetch call for operands.
const $fcd3461dd2081b41$var$OPERANDS_DELAY_MS = 650;
// Used to remove emails from user display names in autocomplete values, which come in format: "Name - email".
// Pattern below is specific enough for this purpose and we should avoid writing a more complex email matcher.
const $fcd3461dd2081b41$var$BASIC_REMOVE_EMAIL_REGEX = /\s-\s\S+@\S+\.\S+$/;
const $fcd3461dd2081b41$var$useOnValues = (jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent)=>{
    (0, $asu8X.di)((0, $eUqFw.useReducer));
    const fetchFieldValues = (0, $dfwxG.useFetchFieldValues)(getSuggestions, createAndFireAnalyticsEvent);
    const [fieldValuesCache, dispatch] = (0, $eUqFw.useReducer)($fcd3461dd2081b41$var$fieldValuesReducer, $fcd3461dd2081b41$var$initialState);
    return (0, $eUqFw.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $bKhOq.empty)();
        const field$ = (0, $6lq5N.default)(jqlSearchableFields$, field);
        // API expects unquoted and unescaped values
        const normalizedField = (0, $liYmF.normalize)(field);
        const normalizedQuery = query !== undefined ? (0, $liYmF.normalize)(query) : '';
        // Cache values by field + query
        const cacheKey = `${normalizedField}:${normalizedQuery}`;
        const isCacheHit = Object.prototype.hasOwnProperty.call(fieldValuesCache, cacheKey);
        return field$.pipe((0, $dXapj.filter)((matchingField)=>matchingField.auto === 'true'), (0, $eGPtZ.concatMap)((matchingField)=>{
            if (isCacheHit) return (0, $cwK3t.of)(fieldValuesCache[cacheKey]);
            // If we have a cfid then use it to fetch autocomplete suggestions as results will always be unique.
            // Otherwise it's possible `normalizedField` will match against multiple fields in the API and thus
            // return no data.
            const fieldNameForFetch = matchingField.cfid ?? normalizedField;
            // We emit a single value using Observable.of(null) and delay that event before fetching field values so we
            // can mimic debounce behaviour.
            return (0, $cwK3t.of)(null).pipe((0, $kW6gr.delay)($fcd3461dd2081b41$var$OPERANDS_DELAY_MS), (0, $eGPtZ.concatMap)(()=>fetchFieldValues(fieldNameForFetch, normalizedQuery).then((values)=>{
                    const valueType = $fcd3461dd2081b41$var$getValueType(matchingField);
                    if (valueType === 'user') values.forEach((value)=>{
                        value.valueType = valueType;
                        // REST autocomplete API returns user display names with this format: "Name - email". To be
                        // consistent with hydration API, we want to remove email from this name for rich inline nodes.
                        value.nameOnRichInlineNode = value.name.replace($fcd3461dd2081b41$var$BASIC_REMOVE_EMAIL_REGEX, '');
                    });
                    // Save response to in-memory cache
                    dispatch({
                        type: 'update-cache',
                        payload: {
                            cacheKey: cacheKey,
                            values: values
                        }
                    });
                    return values;
                }).catch(()=>[])));
        }), // We can filter out empty arrays as there is nothing to consume
        (0, $dXapj.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        fieldValuesCache,
        fetchFieldValues
    ]);
};
var $fcd3461dd2081b41$export$2e2bcd8739ae039 = $fcd3461dd2081b41$var$useOnValues;

});
const $191dad2516e3f528$export$7cba791a20c35c0c = 'com.atlassian.jira.user.ApplicationUser';

parcelRegister("dfwxG", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $552015ba16c14928$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $1nSuw = parcelRequire("1nSuw");

var $7QK5f = parcelRequire("7QK5f");
const $552015ba16c14928$export$7bf3f44bca0a7a65 = (field, query)=>`/rest/api/latest/jql/autocompletedata/suggestions?fieldName=${field}&fieldValue=${query ?? ''}`;
const $552015ba16c14928$export$6cb851ed13e3949e = (getSuggestions, createAndFireAnalyticsEvent)=>{
    return (0, $eUqFw.useCallback)(async (field, query)=>{
        try {
            const data = await getSuggestions($552015ba16c14928$export$7bf3f44bca0a7a65(field, query));
            const div = document.createElement('div');
            const results = data.results.map((operand)=>{
                // The displayName from the API includes HTML tags to bold matching text e.g. `<b>o</b>pen`
                // We set this as innerHTML so we can get the raw textContent
                div.innerHTML = operand.displayName;
                return {
                    name: div.textContent ?? '',
                    value: operand.value
                };
            });
            createAndFireAnalyticsEvent({
                action: (0, $7QK5f.Action).SUCCESS,
                actionSubject: (0, $7QK5f.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $1nSuw.EventType).OPERATIONAL
            });
            return results;
        } catch (error) {
            createAndFireAnalyticsEvent({
                action: (0, $7QK5f.Action).FAILED,
                actionSubject: (0, $7QK5f.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $1nSuw.EventType).OPERATIONAL
            });
            throw error;
        }
    }, [
        createAndFireAnalyticsEvent,
        getSuggestions
    ]);
};

});



parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $fmmnJ = parcelRequire("fmmnJ");

var $awzwr = parcelRequire("awzwr");

var $6jiFZ = parcelRequire("6jiFZ");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $WBLbN.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $WBLbN.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $WBLbN.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $WBLbN.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $48b165edb54974f4$export$894e19fc96687503);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));
const $48b165edb54974f4$export$894e19fc96687503 = 250;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $8PVSz = parcelRequire("8PVSz");

var $75e8i = parcelRequire("75e8i");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $75e8i.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $8PVSz.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $75e8i.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $75e8i.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $8PVSz.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});







parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});

parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("2b5us", function(module, exports) {

$parcel$export(module.exports, "PerformanceContext", () => $50e3510a76f434bc$export$39bcde15aa963086);
$parcel$export(module.exports, "usePerformanceContext", () => $50e3510a76f434bc$export$851a2d8ae957dc96);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

const $50e3510a76f434bc$export$39bcde15aa963086 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
const $50e3510a76f434bc$export$851a2d8ae957dc96 = ()=>(0, $eUqFw.useContext)($50e3510a76f434bc$export$39bcde15aa963086);

});

parcelRegister("6oH5O", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $40075442b615ad27$export$5fd6d8ece357700d);
// Performance marks
const $40075442b615ad27$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $40075442b615ad27$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $40075442b615ad27$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $40075442b615ad27$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END
};

});

const $86744a571d2f9364$export$abc61f74b6bec12c = 'viewJqlBuilderAdvanced';
const $86744a571d2f9364$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderAdvanced';
const $86744a571d2f9364$export$d57b6b390e78d90f = 'empanada';

parcelRegister("idLJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91c8531bd3c3837$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a91c8531bd3c3837$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "jql-builder-advanced.error-flag-title",
        "defaultMessage": "We couldn't edit the query"
    },
    errorFlagDescription: {
        "id": "jql-builder-advanced.error-flag-description",
        "defaultMessage": "The JQL builder is unresponsive. Refresh the page to try again."
    },
    searchCurrentPage: {
        "id": "jql-builder-advanced.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});

parcelRegister("5l4v4", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteInitialData", () => $76378629886e9b79$export$21e39afbf909ee71);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $cgDGY = parcelRequire("cgDGY");
const $76378629886e9b79$export$21e39afbf909ee71 = (excludedAutocompleteFields = [])=>(0, $eUqFw.useCallback)((url)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                includeCollapsedFields: true
            })
        };
        return (0, $cgDGY.fetchWithRetry)(()=>(0, $2OdyW.default)(url, options), 1).then((res)=>({
                jqlFields: excludedAutocompleteFields.length === 0 ? res.visibleFieldNames : res.visibleFieldNames.filter((field)=>!excludedAutocompleteFields.includes(field.value)),
                jqlFunctions: res.visibleFunctionNames
            })).catch((error)=>{
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteInitialData',
                    packageName: (0, $86744a571d2f9364$export$b8b9d90f9e5bd72b),
                    teamName: (0, $86744a571d2f9364$export$d57b6b390e78d90f)
                }
            });
            throw error;
        });
    }, [
        excludedAutocompleteFields
    ]);

});
parcelRegister("cgDGY", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $a654ece021eeee0b$export$cffaac380b94df26);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a654ece021eeee0b$export$cffaac380b94df26 = async (fetchCall, retryAttempts)=>{
    try {
        return await fetchCall();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (retryAttempts > 0) return $a654ece021eeee0b$export$cffaac380b94df26(fetchCall, retryAttempts - 1);
        throw error;
    }
};

});


parcelRegister("43qBf", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteSuggestions", () => $3acc2146efaf761e$export$b39a9f86c7843060);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

const $3acc2146efaf761e$export$b39a9f86c7843060 = ()=>{
    const baseUrl = '';
    return (0, $eUqFw.useCallback)((url)=>(0, $2OdyW.default)(baseUrl + url).catch((error)=>{
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteSuggestions',
                    packageName: (0, $86744a571d2f9364$export$b8b9d90f9e5bd72b),
                    teamName: (0, $86744a571d2f9364$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }), [
        baseUrl
    ]);
};

});

parcelRegister("5ukwI", function(module, exports) {

$parcel$export(module.exports, "useOnHydrate", () => $30576039bfd91c46$export$6d016355519acd77);

var $5QhTQ = parcelRequire("5QhTQ");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $gd0Sp = parcelRequire("gd0Sp");


const $30576039bfd91c46$export$f2e498f301ac7cdf = (response)=>{
    if (!response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) return {};
    const hydratedValues = {};
    response.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
        if (field.values) {
            const fieldValues = [];
            field.values.forEach((valueResult)=>{
                if (valueResult?.values) valueResult.values.forEach((value)=>{
                    if (value?.__typename === 'JiraJqlUserFieldValue') fieldValues.push({
                        type: 'user',
                        id: value.jqlTerm,
                        name: value.displayName,
                        avatarUrl: value.user?.picture ?? ''
                    });
                });
            });
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $8a1436951830c290$export$3df7f6b39477220a) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $8a1436951830c290$export$f8cba5bda41a61a0) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (fieldValues.length > 0 && field.field) {
                const fieldName = field.field.jqlTerm;
                hydratedValues[fieldName] = fieldValues;
            }
        }
    });
    return hydratedValues;
};
const $30576039bfd91c46$export$6d016355519acd77 = (viewContext)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useCallback)(async (jql)=>{
        try {
            const data = await (0, $iWLL0.fetchQuery)(environment, (0, $5QhTQ.default), {
                jql: jql,
                cloudId: cloudId,
                viewContext: viewContext
            }, {
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).toPromise();
            return $30576039bfd91c46$export$f2e498f301ac7cdf(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'useOnHydrateRelay',
                    packageName: (0, $86744a571d2f9364$export$b8b9d90f9e5bd72b),
                    teamName: (0, $86744a571d2f9364$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }
    }, [
        cloudId,
        environment,
        viewContext
    ]);
};

});
parcelRegister("5QhTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22270eb2439b4e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a2fbec60e53686cc15936be193c6419>>
 * @relayHash 3135d365d88950050d150a9e9c118a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba4fcfcd09e227177aa23416dd3fdedaf9a469a4454cbd34e0ea60cb63a5bf4e
const $d22270eb2439b4e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "JiraJqlSearchTemplate",
                "kind": "LinkedField",
                "name": "searchTemplate",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "id"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ba4fcfcd09e227177aa23416dd3fdedaf9a469a4454cbd34e0ea60cb63a5bf4e",
            "metadata": {},
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d22270eb2439b4e2$var$node.hash = "b26239c922b8627fea8a8e88766856e6";
var $d22270eb2439b4e2$export$2e2bcd8739ae039 = $d22270eb2439b4e2$var$node;

});

const $8a1436951830c290$export$3df7f6b39477220a = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
const $8a1436951830c290$export$f8cba5bda41a61a0 = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';





parcelRegister("WbUNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd2d78cb0ecf454$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1dd2d78cb0ecf454$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyJql: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.jql.empty-jql",
        "defaultMessage": "JQL query must not be empty"
    },
    allRemainingIssues: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.jql.all-remaining-issues",
        "defaultMessage": "All remaining issues"
    },
    newJql: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.jql.new-jql",
        "defaultMessage": "Enter JQL"
    },
    warningWhenPriorityIsPresentInJqlWithSubGoals: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.jql.warning-when-priority-is-present-in-jql-with-sub-goals",
        "defaultMessage": "This goal\u2019s priority field creates a conflict with one of its priority time targets."
    },
    errorTooltip: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.jql.error-tooltip",
        "defaultMessage": "This goal has one or more errors."
    }
});

});


parcelRegister("9OCTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3852aa3764376268$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3852aa3764376268$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dragGoal: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.drag-goal",
        "defaultMessage": "drag metric goal"
    },
    priorityHeader: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.priority-header",
        "defaultMessage": "And priority is:"
    },
    allMatchingPriorities: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.all-matching-priorities",
        "defaultMessage": "All matching priorities"
    },
    allRemainingPriorities: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.all-remaining-priorities",
        "defaultMessage": "All remaining priorities"
    },
    addPriority: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.add-priority",
        "defaultMessage": "+ Add priority"
    }
});

});

parcelRegister("hY53D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0a8b56c5bcc486$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $h28Y9 = parcelRequire("h28Y9");

var $96IgR = parcelRequire("96IgR");

var $29yDk = parcelRequire("29yDk");

var $2yRWX = parcelRequire("2yRWX");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $fK421 = parcelRequire("fK421");

var $hIjKU = parcelRequire("hIjKU");

var $7sqns = parcelRequire("7sqns");

var $6mytm = parcelRequire("6mytm");
const $6d0a8b56c5bcc486$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, props.data.value === 'EMPTY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d0a8b56c5bcc486$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h28Y9))), {
        label: "",
        LEGACY_size: "small",
        color: "currentColor"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d0a8b56c5bcc486$var$ImageIcon, {
        src: props.data.icon,
        alt: props.data.label
    }), props.data.label);
const $6d0a8b56c5bcc486$var$PrioritiesSelect = ({ id: id, goalId: goalId, metricId: metricId, isEditing: isEditing, onEditRequested: onEditRequested, focusOnEdit: focusOnEdit = false, selectedPriority: selectedPriority, onChange: // eslint-disable-next-line @typescript-eslint/no-empty-function
onChange = ()=>{} })=>{
    const [{ values: prioritiesOptions, loading: loading }] = (0, $7sqns.useFetchPrioritiesService)();
    const fieldName = (0, $fK421.toSubGoalPriorityFieldName)(goalId, id);
    const akSelectRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        isEditing && focusOnEdit && akSelectRef.current?.focus(); // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'Element'.
        !isEditing && document?.activeElement?.blur();
    }, [
        focusOnEdit,
        isEditing
    ]); // Priority name having multiple words is always saved in double quotes.
    // Eg: `priority = "High/Medium"
    // And then the selected priority becomes '"High/Medium"' and matching it with the priority options doesnt give us anything
    // since the option is 'High/Medium', with no double quotes wrapped.
    // So, to avoid this, we need to trim those extra double quotes around
    const selectedPriorityTrimmed = selectedPriority?.replace(/^"+|"+$/g, '');
    const defaultValue = (0, $eUqFw.useMemo)(()=>{
        const selectedPriorityOption = prioritiesOptions.find(// If the project has `high`, medium` and `low` priorities
        // and `high` is selected. Later on, `high` is renamed to `highest` in priorities list, it breaks the UI
        // To handle this scenario, below code is added.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (option)=>option.value === selectedPriorityTrimmed);
        if (selectedPriorityOption) return selectedPriorityOption;
        const isPriorityChanged = !selectedPriorityOption && selectedPriorityTrimmed.length > 0;
        if (isPriorityChanged) return {
            label: selectedPriorityTrimmed,
            value: selectedPriority,
            icon: ''
        };
         // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const defaultOption = prioritiesOptions.find((option)=>option.value === 'EMPTY');
        return defaultOption;
    }, [
        prioritiesOptions,
        selectedPriorityTrimmed,
        selectedPriority
    ]);
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled, isPriorityNameChanged: isPriorityNameChanged, prioritiesSelected: prioritiesSelected }, { updateIsPriorityNameChanged: updateIsPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    const selectedOption = prioritiesOptions.filter((option)=>option.value === selectedPriorityTrimmed); // If the project has `high`, medium` and `low` priorities
    // and `high` is selected. Later on, `high` is renamed to `highest` in priorities list, it breaks the UI
    // To handle this scenario, below code is added.
    const isPriorityChanged = selectedOption.length === 0 && selectedPriorityTrimmed.length > 0;
    if (prioritiesOptions.length > 0 && isPriorityNameChanged !== isPriorityChanged) updateIsPriorityNameChanged(metricId, goalId, isPriorityChanged); // eslint-disable-next-line react/no-unstable-nested-components
    const SingleValue = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.data.value === 'EMPTY' || isPriorityChanged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d0a8b56c5bcc486$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h28Y9))), {
            LEGACY_size: "small",
            label: "",
            color: "currentColor"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d0a8b56c5bcc486$var$ImageIcon, {
            src: props.data.icon,
            alt: ""
        }), children));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let filteredPriorityOptions = prioritiesOptions; // @ts-expect-error - TS2538
    if (prioritiesSelected?.[metricId]?.[goalId]?.length) filteredPriorityOptions = prioritiesOptions.filter(// @ts-expect-error - TS2538
    (option)=>!prioritiesSelected[metricId][goalId].includes(option.value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: fieldName,
        defaultValue: defaultValue
    }, ({ fieldProps: { value: value, ...rest } })=>// @ts-expect-error - TS2741 - Property 'defaultValue' is missing in type '{ editView: ({ errorMessage, isInvalid }: ExtendedFieldProps<string>) => Element; readView: () => Element; isEditing: boolean; onConfirm: () => void; onEdit: () => void; hideActionButtons: true; readViewFitContainerWidth: true; }' but required in type 'InlineEditProps<string>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), {
            editView: ({ errorMessage: errorMessage, isInvalid: isInvalid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
                    isOpen: isInvalid,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, errorMessage),
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default // @ts-expect-error - TS2322
                ), {
                    ref: akSelectRef,
                    options: filteredPriorityOptions,
                    isLoading: loading,
                    value: value,
                    "aria-label": formatMessage((0, $6mytm.default).selectPriority),
                    appearance: isSLAHierarchicalGoalsEnabled ? 'subtle' : 'default',
                    styles: {
                        singleValue: (base)=>({
                                ...base,
                                display: 'flex',
                                flexGrow: 1
                            }),
                        option: (base)=>({
                                ...base,
                                display: 'flex',
                                flexGrow: 1
                            }),
                        container: (base)=>({
                                ...base,
                                flexGrow: 1
                            })
                    },
                    components: {
                        Option: $6d0a8b56c5bcc486$var$Option,
                        SingleValue: SingleValue
                    },
                    ...rest,
                    onChange: (...args)=>{
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                        rest.onChange(...args);
                        onChange();
                    },
                    testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.priorities.ak-select"
                }), isPriorityChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                    content: formatMessage((0, $6mytm.default).invalidPriority),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
                        size: "medium",
                        label: ""
                    }),
                    appearance: "subtle",
                    "aria-label": formatMessage((0, $6mytm.default).invalidPriority)
                })))),
            isEditing: true // eslint-disable-next-line @typescript-eslint/no-empty-function
            ,
            onConfirm: ()=>{},
            onEdit: onEditRequested,
            hideActionButtons: true,
            readViewFitContainerWidth: true
        }));
};
var $6d0a8b56c5bcc486$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6d0a8b56c5bcc486$var$PrioritiesSelect;
const $6d0a8b56c5bcc486$var$ImageIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _12l2u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d0a8b56c5bcc486$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _12l2u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h28Y9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3adde9ee9d42d90381bd37327edadba1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c66994a967dfab5a$var$_react = $c66994a967dfab5a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c66994a967dfab5a$var$_UNSAFE_baseNew = $c66994a967dfab5a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c66994a967dfab5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PriorityTrivial".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for trivial issue priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c66994a967dfab5a$var$PriorityTrivialIcon = (props)=>/*#__PURE__*/ $c66994a967dfab5a$var$_react.default.createElement($c66994a967dfab5a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<circle cx="8" cy="8" r="7.25" stroke="currentcolor" stroke-width="1.5"/>`
    }, props));
$c66994a967dfab5a$var$PriorityTrivialIcon.displayName = 'PriorityTrivialIcon';
var $c66994a967dfab5a$var$_default = module.exports.default = $c66994a967dfab5a$var$PriorityTrivialIcon;

});

parcelRegister("6mytm", function(module, exports) {

$parcel$export(module.exports, "default", () => $829c1cc64d9513f0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $829c1cc64d9513f0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidPriority: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.priorities.invalid-priority",
        "defaultMessage": "This priority no longer exists. Check your Jira priorities or remove this time target."
    },
    selectPriority: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.priorities.select-priority",
        "defaultMessage": "Select priority"
    }
});

});


parcelRegister("2CEAJ", function(module, exports) {

$parcel$export(module.exports, "RemoveGoalButton", () => $00e1291b7d91956b$export$4b0ce87b563d7a07);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $je5kZ = parcelRequire("je5kZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kVxmZ = parcelRequire("kVxmZ");
const $00e1291b7d91956b$var$RemoveGoalButtonView = ({ onRemove: onRemove })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.remove-goal-button.button",
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: ""
        }),
        onClick: onRemove,
        "aria-label": formatMessage((0, $kVxmZ.default).removeGoal)
    });
};
const $00e1291b7d91956b$export$4b0ce87b563d7a07 = $00e1291b7d91956b$var$RemoveGoalButtonView;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});

parcelRegister("kVxmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f3225a790cdb95$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69f3225a790cdb95$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeGoal: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.remove-goal-button.remove-goal",
        "defaultMessage": "Remove goal"
    }
});

});


parcelRegister("9eLlO", function(module, exports) {

$parcel$export(module.exports, "useSubGoalsState", () => $867c331a4602976f$export$e28327429c55745e);

var $eUqFw = parcelRequire("eUqFw");

var $gDsgM = parcelRequire("gDsgM");

var $jwvob = parcelRequire("jwvob");

var $7sqns = parcelRequire("7sqns");

var $gQ1Wg = parcelRequire("gQ1Wg");
const $867c331a4602976f$export$e28327429c55745e = (intialSubGoals = [], goal)=>{
    const newSubGoalReference = (0, $eUqFw.useRef)(0);
    const [subGoals, setSubGoals] = (0, $eUqFw.useState)(intialSubGoals);
    const [{ data: data }] = (0, $jwvob.useMetricResource)();
    const calendarOptions = (0, $eUqFw.useMemo)(()=>(0, $gQ1Wg.formatOptions)(data?.calendarRefs ?? []), [
        data
    ]);
    const defaultCalendarOption = calendarOptions.find(({ isDefaultOption: isDefaultOption })=>isDefaultOption);
    const [{ values: prioritiesOptions }] = (0, $7sqns.useFetchPrioritiesService)();
    const defaultPriorityOption = prioritiesOptions[prioritiesOptions.length - 1];
    const onAppendNewSubGoal = (0, $eUqFw.useCallback)(()=>{
        newSubGoalReference.current += 1;
        const newList = (0, $gQ1Wg.appendNewSubGoal)(subGoals, {
            id: `new-subgoal-with-id-${newSubGoalReference.current}`,
            jqlQuery: `priority=${defaultPriorityOption?.value}`,
            duration: '',
            calendarId: defaultCalendarOption?.value,
            calendarName: defaultCalendarOption?.label,
            defaultGoal: false,
            // For new Goal, if we add subGoals, the subGoal should not have goalId
            // since these are new subGoals
            ...goal.fieldState === (0, $gDsgM.NEW) || goal.fieldState === (0, $gDsgM.NEW_AND_MODIFIED) ? {} : {
                goalId: goal.id
            },
            // @ts-expect-error - TS2345 - 'fieldState' does not exist in type 'SubGoal'
            fieldState: 'NEW'
        });
        // @ts-expect-error - TS2345 - Argument of type 'readonly [...GoalWithId[], GoalWithId]' is not assignable to parameter of type 'SetStateAction<GoalWithIds>'.
        setSubGoals(newList);
    }, [
        goal,
        subGoals,
        defaultCalendarOption,
        defaultPriorityOption
    ]);
    return [
        subGoals,
        setSubGoals,
        onAppendNewSubGoal
    ];
};

});
parcelRegister("gQ1Wg", function(module, exports) {

$parcel$export(module.exports, "appendNewSubGoal", () => $7c1c16f7baed7bc2$export$8a27619d5e73b5ac);
$parcel$export(module.exports, "formatOptions", () => $7c1c16f7baed7bc2$export$fb6751f88f91d177);
const $7c1c16f7baed7bc2$export$8a27619d5e73b5ac = (list = [], newGoal)=>{
    const result = Array.from(list);
    return [
        ...result,
        newGoal
    ];
};
const $7c1c16f7baed7bc2$export$fb6751f88f91d177 = (calendarRefs)=>calendarRefs.map(({ name: name, id: id, ...rest })=>({
            label: name,
            value: id,
            isDefaultOption: rest.default
        }));

});


parcelRegister("fshOk", function(module, exports) {

$parcel$export(module.exports, "getNextGoalState", () => $c6183e400803b1a3$export$b6d9c47e94d089bb);

var $gDsgM = parcelRequire("gDsgM");
const $c6183e400803b1a3$export$b6d9c47e94d089bb = (previousGoalState)=>{
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    if ([
        (0, $gDsgM.NEW),
        (0, $gDsgM.NEW_AND_MODIFIED)
    ].includes(previousGoalState)) return 0, $gDsgM.NEW_AND_MODIFIED;
    return 0, $gDsgM.EXISTING_AND_MODIFIED;
};

});




parcelRegister("8Rdy0", function(module, exports) {

$parcel$export(module.exports, "useGoalsState", () => $0bff97790edfa41d$export$e35d70bfd59b7584);

var $eUqFw = parcelRequire("eUqFw");

var $gDsgM = parcelRequire("gDsgM");

var $c4rDP = parcelRequire("c4rDP");

var $7lQGO = parcelRequire("7lQGO");
const $0bff97790edfa41d$export$e35d70bfd59b7584 = (initialGoals)=>{
    const newGoalReference = (0, $eUqFw.useRef)(0);
    const [goals, setGoals] = (0, $eUqFw.useState)(initialGoals);
    const [, actions] = (0, $c4rDP.useGoalCounter)();
    const onDragEnd = (0, $eUqFw.useCallback)(({ source: source, destination: destination })=>{
        if (!destination) return;
        if (destination.index === source.index) return;
        const reorderedList = (0, $7lQGO.reorderList)(goals, source.index, destination.index);
        setGoals(reorderedList);
    }, [
        goals
    ]);
    const onAppendNewGoal = (0, $eUqFw.useCallback)((metricId)=>{
        newGoalReference.current += 1;
        const newList = (0, $7lQGO.appendNewGoal)(goals, {
            id: `new-with-id-${newGoalReference.current}`,
            jqlQuery: '',
            duration: '',
            calendarId: undefined,
            defaultGoal: false,
            timeMetricId: 0,
            subGoals: [],
            fieldState: (0, $gDsgM.NEW),
            metricId: metricId
        });
        actions.incrementGoalCounter(1);
        // @ts-expect-error - TS2345 - Argument of type 'readonly [...GoalWithId[], GoalWithId]' is not assignable to parameter of type 'SetStateAction<GoalWithIds>'.
        setGoals(newList);
    }, [
        goals,
        actions
    ]);
    return [
        goals,
        setGoals,
        onDragEnd,
        onAppendNewGoal
    ];
};

});
parcelRegister("7lQGO", function(module, exports) {

$parcel$export(module.exports, "reorderList", () => $d275f19131017d3d$export$1c97eb4883130bfd);
$parcel$export(module.exports, "appendNewGoal", () => $d275f19131017d3d$export$1d9e3810020a1b5b);
const $d275f19131017d3d$export$1c97eb4883130bfd = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $d275f19131017d3d$export$1d9e3810020a1b5b = (list, newGoal)=>{
    const result = Array.from(list);
    return [
        ...result,
        newGoal
    ];
};

});



parcelRegister("04OGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3531a9c69e2b280d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3531a9c69e2b280d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.error-message",
        "defaultMessage": "Something has gone wrong. An error has occurred."
    },
    errorTooltip: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.error-tooltip",
        "defaultMessage": "This SLA has one or more errors."
    }
});

});

parcelRegister("kzSsu", function(module, exports) {

$parcel$export(module.exports, "Name", () => $cf15d45965be910f$export$c7bd411105e2dec3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $eSHsi = parcelRequire("eSHsi");

var $1ZpeU = parcelRequire("1ZpeU");


var $5JgJ2 = parcelRequire("5JgJ2");

var $7d1RI = parcelRequire("7d1RI");

var $gDsgM = parcelRequire("gDsgM");

var $ebD7Y = parcelRequire("ebD7Y");

var $52BdI = parcelRequire("52BdI");


var $6BSYq = parcelRequire("6BSYq");

var $8kC0R = parcelRequire("8kC0R");
const $cf15d45965be910f$var$fetchWithDebounce = (0, $8kC0R.debounce)(async (fetch, query, resolve)=>{
    const options = await fetch(query);
    const filteredOption = (options || []).filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
    resolve(filteredOption);
});
const $cf15d45965be910f$var$NameField = ({ name: name, canManageFields: canManageFields })=>{
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const [, { fetch: fetch }] = (0, $52BdI.useSlaFieldsService)(baseUrl);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchOnInputChange = (0, $eUqFw.useCallback)((query, resolve)=>{
        $cf15d45965be910f$var$fetchWithDebounce(fetch, query, resolve);
    }, [
        fetch
    ]);
    const defaultValue = {
        value: name,
        label: name
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf15d45965be910f$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf15d45965be910f$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eSHsi))), {
        LEGACY_size: "large",
        LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf15d45965be910f$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $gDsgM.NAME_FIELD),
        validate: (0, $8kC0R.validateName),
        isRequired: true // @ts-expect-error - TS2322 - Type '{ value: string | undefined; label: string | undefined; }' is not assignable to type 'Field | ((currentDefaultValue?: Field | null | undefined) => Field | null) | null | undefined'.
        ,
        defaultValue: defaultValue
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "servicedesk-sla-settings.ui.metrics.metric.editable.form.name.name-dropdown"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZpeU.default), {
            autoFocus: true,
            formatCreateLabel: (newName)=>`${formatMessage((0, $6BSYq.default).createNew, {
                    newName: newName
                })}`,
            "aria-label": formatMessage((0, $6BSYq.default).newName),
            placeholder: formatMessage((0, $6BSYq.default).placeHolder),
            loadOptions: fetchOnInputChange,
            ...fieldProps,
            defaultOptions: true // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number | undefined' and 'string' have no overlap.
            ,
            isClearable: fieldProps.value?.value !== ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
            hasPermission: !canManageFields
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $6BSYq.default).chooseMetricName))), error === (0, $f8250499268a821d$export$e420739a557ec378) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $6BSYq.default).emptyMetricName))))));
};
const $cf15d45965be910f$export$c7bd411105e2dec3 = $cf15d45965be910f$var$NameField; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf15d45965be910f$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1tkevbgk _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf15d45965be910f$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8q9o2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf15d45965be910f$var$FieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18s810ua",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ZpeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $724bfa4358c46735$export$2e2bcd8739ae039);

var $03F4S = parcelRequire("03F4S");

var $5FjBr = parcelRequire("5FjBr");
const $724bfa4358c46735$var$AsyncCreatableSelect = (0, $5FjBr.default)((0, $03F4S.default));
var $724bfa4358c46735$export$2e2bcd8739ae039 = $724bfa4358c46735$var$AsyncCreatableSelect;

});
parcelRegister("03F4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b02518902b6778$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $3IL7Z = parcelRequire("3IL7Z");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $00b02518902b6778$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $3IL7Z.u)(props);
    var creatableProps = (0, $7IqRg.u)(stateManagerProps);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $00b02518902b6778$export$2e2bcd8739ae039 = $00b02518902b6778$var$AsyncCreatableSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("ebD7Y", function(module, exports) {

$parcel$export(module.exports, "HasPermission", () => $974008cab89d6f6a$export$be0f00fd86c746c2);

var $eUqFw = parcelRequire("eUqFw");
const $974008cab89d6f6a$export$be0f00fd86c746c2 = ({ hasPermission: hasPermission, children: children })=>{
    if (hasPermission === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return null;
};

});

parcelRegister("52BdI", function(module, exports) {

$parcel$export(module.exports, "useSlaFieldsService", () => $81d6b1222073db90$export$17822d393cec9c01);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $bFN7g = parcelRequire("bFN7g");
const $81d6b1222073db90$export$17822d393cec9c01 = (baseUrl)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [error, setError] = (0, $eUqFw.useState)();
    const abortController = (0, $eUqFw.useRef)(null);
    const fetch = (0, $eUqFw.useCallback)(async (searchQuery)=>{
        setError(null);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (abortController.current && abortController.current.abort) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        abortController.current.abort();
        try {
            abortController.current = new AbortController();
            // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
            const { signal: signal } = abortController.current;
            const response = await (0, $fV97Z.performGetRequest)((0, $bFN7g.getUrl)(baseUrl, searchQuery), {
                method: 'GET',
                signal: signal
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaFields fetched');
            return (0, $bFN7g.transformRestResponse)(response);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (err && err.name === 'AbortError') return undefined;
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useSlaFieldsService',
                packageName: 'jiraServicedeskSlaSettings'
            });
            setError(err);
        }
        return undefined;
    }, [
        baseUrl,
        createAnalyticsEvent
    ]);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
    return [
        {
            error: error
        },
        {
            fetch: fetch
        }
    ];
};

});
parcelRegister("bFN7g", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $753c2ca3301f7358$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformRestResponse", () => $753c2ca3301f7358$export$73ba76a6408c630a);
const $753c2ca3301f7358$export$94df0e59ebebf4a7 = (baseUrl, searchQuery)=>`${baseUrl}/rest/servicedesk/1/sla/field/all?query=${searchQuery || ''}`;
const $753c2ca3301f7358$export$73ba76a6408c630a = (response)=>response.fields.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));

});


const $f8250499268a821d$export$e420739a557ec378 = 'EMPTY_NAME';

parcelRegister("6BSYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af87030e1c87529$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4af87030e1c87529$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeHolder: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.name.place-holder",
        "defaultMessage": "Enter the SLA name..."
    },
    emptyMetricName: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.name.empty-metric-name",
        "defaultMessage": "Metric name is required"
    },
    chooseMetricName: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.name.choose-metric-name",
        "defaultMessage": "You can only choose from suggested metric names. If you want to create new ones, please contact your Jira administrator."
    },
    createNew: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.name.create-new",
        "defaultMessage": "{newName} (New SLA)"
    },
    newName: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.name.new-name",
        "defaultMessage": "Select metric name"
    }
});

});

parcelRegister("8kC0R", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $e7906c7885bec156$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "validateName", () => $e7906c7885bec156$export$b135c3f9b9f02308);

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

const $e7906c7885bec156$export$e39301eefbc90236 = 300;
const $e7906c7885bec156$export$61fc7d43ac8f84b0 = (callBack)=>// @ts-expect-error - TS2322 - Type 'DebouncedFunc<F>' is not assignable to type 'F'.
    (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(callBack, $e7906c7885bec156$export$e39301eefbc90236);
const $e7906c7885bec156$export$b135c3f9b9f02308 = (fieldValue)=>{
    const inputValue = fieldValue?.label.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(inputValue) || inputValue.length < 1) return 0, $f8250499268a821d$export$e420739a557ec378;
    return undefined;
};

});


parcelRegister("6VPPR", function(module, exports) {

$parcel$export(module.exports, "SlaDisplayFormat", () => $dd2b5dab497005e4$export$c275d9413371babf);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $hiIej = parcelRequire("hiIej");

var $giAhk = parcelRequire("giAhk");


var $9dHVy = parcelRequire("9dHVy");

var $gDsgM = parcelRequire("gDsgM");

var $jo49X = parcelRequire("jo49X");

var $iejLh = parcelRequire("iejLh");
const $dd2b5dab497005e4$export$4cca27b0fd03c99c = ({ slaDisplayFormat: slaDisplayFormat })=>{
    let OnTrackOngoingSLA;
    let AtRiskOngoingSLA;
    let CompletedSLA;
    switch(slaDisplayFormat){
        case 0, $feae9f437bfca243$export$13ecaaf97b049384:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.AtRiskOngoingSlaNewSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaNewSlaFormat);
            break;
        case 0, $feae9f437bfca243$export$aad60a8e044b5914:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaOldSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.AtRiskOngoingSlaOldSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaOldSlaFormat);
            break;
        default:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaNewSlaFormat);
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$SlaCapsuleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 37; readonly status: "ONGOING"; readonly timeRemainingFriendly: "Today 04:00 PM"; readonly metricName: "Time to Pending"; ... 12 more ...; readonly date: 1647858600000; } | { ...; } | TransformedGoalView' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(OnTrackOngoingSLA)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 37; readonly status: "ONGOING"; readonly timeRemainingFriendly: "Today 04:00 PM"; readonly metricName: "Time to Pending"; ... 12 more ...; readonly date: 1647858600000; } | { ...; } | { ...; } | TransformedGoalView' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(AtRiskOngoingSLA)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 300; readonly status: "COMPLETED"; readonly timeRemainingFriendly: "24 February"; readonly metricName: "Time to Pending"; ... 5 more ...; readonly slaDisplayFormat: "NEW_SLA_FORMAT"; } | { ...; }' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(CompletedSLA)
    })));
};
const $dd2b5dab497005e4$var$SlaDisplayFormatOption = ({ slaDisplayFormat: slaDisplayFormat, intl: { formatMessage: formatMessage } })=>{
    const formattedSLADisplay = slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? formatMessage((0, $iejLh.default).dueDateCentric) : formatMessage((0, $iejLh.default).timeCentric);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$DisplayOptionRowView, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$DisplayFormatTextConatiner, null, formattedSLADisplay), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$export$4cca27b0fd03c99c, {
        slaDisplayFormat: slaDisplayFormat
    }));
};
const $dd2b5dab497005e4$var$SlaDisplayFormatLabel = (0, $giAhk.injectIntlV2)($dd2b5dab497005e4$var$SlaDisplayFormatOption);
const $dd2b5dab497005e4$var$options = [
    {
        name: 'slaDisplayFormat',
        value: (0, $feae9f437bfca243$export$13ecaaf97b049384),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$SlaDisplayFormatLabel, {
            slaDisplayFormat: (0, $feae9f437bfca243$export$13ecaaf97b049384)
        }),
        testId: 'servicedesk-sla-settings.ui.metrics.metric.editable.form.sla-display-format.new-sla-format'
    },
    {
        name: 'slaDisplayFormat',
        value: (0, $feae9f437bfca243$export$aad60a8e044b5914),
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$SlaDisplayFormatLabel, {
            slaDisplayFormat: (0, $feae9f437bfca243$export$aad60a8e044b5914)
        }),
        testId: 'servicedesk-sla-settings.ui.metrics.metric.editable.form.sla-display-format.old-sla-format'
    }
];
const $dd2b5dab497005e4$export$c275d9413371babf = ({ slaDisplayFormat: slaDisplayFormat })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "slaDisplayFormat",
        defaultValue: slaDisplayFormat
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd2b5dab497005e4$var$SlaDisplaySettingsContainer, {
            "data-test-id": "servicedesk-sla-settings.ui.metrics.metric.editable.form.sla-display-format"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
            onChange: fieldProps.onChange,
            options: $dd2b5dab497005e4$var$options,
            defaultValue: slaDisplayFormat
        }))); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $dd2b5dab497005e4$var$SlaDisplaySettingsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _ca0q1b66 _n3tdv77o _2rko1l7b _16qs1os1 _11q7hp5a _5h1ku2gc _jgkou2gc _gys3r5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $dd2b5dab497005e4$var$DisplayOptionRowView = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx2vrvc _1bah1yb4 _19pk1b66 _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $dd2b5dab497005e4$var$DisplayFormatTextConatiner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb11ux _2hwx1b66 _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $dd2b5dab497005e4$var$SlaCapsuleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $dd2b5dab497005e4$export$96d7abc8e13adb8f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb119p _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hiIej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2025a66c6553d911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $hnuwz = parcelRequire("hnuwz");
const $2025a66c6553d911$var$noOptions = [];
function $2025a66c6553d911$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $2025a66c6553d911$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $5Q9wj.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $eUqFw.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

const $306a59ce4e6b6146$var$packageName = "platform-pkg";
const $306a59ce4e6b6146$var$packageVersion = "0.0.0-use.local";
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});


parcelRegister("9dHVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7ef6bb70a7c525$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eSHsi = parcelRequire("eSHsi");

var $3eRLD = parcelRequire("3eRLD");

var $7RK9I = parcelRequire("7RK9I");

var $adUQx = parcelRequire("adUQx");


var $2eG9N = parcelRequire("2eG9N");

var $jMP2a = parcelRequire("jMP2a");


const $ac7ef6bb70a7c525$var$SEMIBOLD = 600;
const $ac7ef6bb70a7c525$var$SUCCESS_STYLE = {
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20})`,
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    iconColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`,
    fontWeight: 'bold',
    backgroundIconColor: "var(--ds-background-neutral-subtle, transparent)"
};
const $ac7ef6bb70a7c525$var$FAILURE_STYLE = {
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20})`,
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    iconColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R300})`,
    fontWeight: 'bold',
    backgroundIconColor: "var(--ds-background-neutral-subtle, transparent)"
};
const $ac7ef6bb70a7c525$var$PAUSED_STYLE = {
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    iconColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    fontWeight: $ac7ef6bb70a7c525$var$SEMIBOLD,
    backgroundIconColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$exports).N20})`
};
const $ac7ef6bb70a7c525$var$PAUSED_BREACHED_STYLE = {
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    fontWeight: $ac7ef6bb70a7c525$var$SEMIBOLD,
    iconColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    backgroundIconColor: `var(--ds-background-danger-bold, ${(0, $73a5c9d720aa66e1$exports).R300})`
};
const $ac7ef6bb70a7c525$var$PAUSED_UNDER_THIRTY_REMAINING_STYLE = {
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    fontWeight: $ac7ef6bb70a7c525$var$SEMIBOLD,
    iconColor: `var(--ds-icon-warning-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    backgroundIconColor: `var(--ds-background-warning-bold, ${(0, $73a5c9d720aa66e1$exports).Y400})`
};
const $ac7ef6bb70a7c525$var$ONGOING_STYLE = {
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    textColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
    iconColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N70})`,
    fontWeight: $ac7ef6bb70a7c525$var$SEMIBOLD,
    backgroundIconColor: "var(--ds-background-neutral-subtle, transparent)"
};
const $ac7ef6bb70a7c525$var$ONGOING_BREACHED_STYLE = {
    backgroundColor: `var(--ds-background-danger-bold, ${(0, $73a5c9d720aa66e1$exports).R300})`,
    textColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    iconColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    fontWeight: 'bold',
    backgroundIconColor: "var(--ds-background-neutral-subtle, transparent)"
};
const $ac7ef6bb70a7c525$var$ONGOING_UNDER_THIRTY_REMAINING_STYLE = {
    backgroundColor: `var(--ds-background-warning-bold, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    textColor: `var(--ds-text-warning-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    iconColor: `var(--ds-icon-warning-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
    fontWeight: 'bold',
    backgroundIconColor: "var(--ds-background-neutral-subtle, transparent)"
};
const $ac7ef6bb70a7c525$var$getStyles = (isBreached, status, timeRemainingInMinutes)=>{
    if (status === (0, $8f398e8176e5defb$export$fc332a617fd34192) && !isBreached) return $ac7ef6bb70a7c525$var$SUCCESS_STYLE;
    if (status === (0, $8f398e8176e5defb$export$fc332a617fd34192) && isBreached) return $ac7ef6bb70a7c525$var$FAILURE_STYLE;
    if (status === (0, $8f398e8176e5defb$export$3ad39751a33c16b8)) {
        if (timeRemainingInMinutes < 0) return $ac7ef6bb70a7c525$var$PAUSED_BREACHED_STYLE;
        if (timeRemainingInMinutes < 30) return $ac7ef6bb70a7c525$var$PAUSED_UNDER_THIRTY_REMAINING_STYLE;
        return $ac7ef6bb70a7c525$var$PAUSED_STYLE;
    }
    if (timeRemainingInMinutes < 0) return $ac7ef6bb70a7c525$var$ONGOING_BREACHED_STYLE;
    if (timeRemainingInMinutes < 30) return $ac7ef6bb70a7c525$var$ONGOING_UNDER_THIRTY_REMAINING_STYLE;
    return $ac7ef6bb70a7c525$var$ONGOING_STYLE;
};
const $ac7ef6bb70a7c525$var$getIcon = (isBreached, status, iconColor, backgroundIconColor)=>{
    switch(status){
        case 0, $8f398e8176e5defb$export$fc332a617fd34192:
            {
                const TickOrCrossIcon = isBreached ? (0, (/*@__PURE__*/$parcel$interopDefault($adUQx))) : (0, (/*@__PURE__*/$parcel$interopDefault($7RK9I)));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac7ef6bb70a7c525$var$IconContainer, {
                    iconColor: iconColor
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TickOrCrossIcon, {
                    size: "large"
                }));
            }
        case 0, $8f398e8176e5defb$export$3ad39751a33c16b8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac7ef6bb70a7c525$var$PauseIconContainer, {
                iconColor: iconColor,
                backgroundIconColor: backgroundIconColor
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3eRLD))), {
                label: "pauseIcon",
                size: "small"
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac7ef6bb70a7c525$var$IconContainer, {
                iconColor: iconColor
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eSHsi))), {
                label: "",
                LEGACY_size: "large",
                color: "currentColor"
            }));
    }
};
const $ac7ef6bb70a7c525$export$5e53520e517ec9ab = (analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'slaWidgetHovered');
const $ac7ef6bb70a7c525$var$Sla = ({ value: { isBreached: isBreached, timeRemainingFriendly: timeRemainingFriendly, status: status, timeRemainingInMinutes: timeRemainingInMinutes, hoverContent: hoverContent, slaDisplayFormat: slaDisplayFormat } })=>{
    if (timeRemainingFriendly === null) return null;
    const styles = $ac7ef6bb70a7c525$var$getStyles(isBreached, status, timeRemainingInMinutes);
    const sla = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac7ef6bb70a7c525$var$LozengeContainer, {
        backgroundColor: styles.backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac7ef6bb70a7c525$var$TextContainer, {
        textColor: styles.textColor,
        fontWeight: styles.fontWeight
    }, timeRemainingFriendly), $ac7ef6bb70a7c525$var$getIcon(isBreached, status, styles.iconColor, styles.backgroundIconColor));
    return slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: hoverContent || '',
        truncate: true,
        onShow: $ac7ef6bb70a7c525$export$5e53520e517ec9ab
    }, sla) : sla;
};
var $ac7ef6bb70a7c525$export$2e2bcd8739ae039 = $ac7ef6bb70a7c525$var$Sla;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ac7ef6bb70a7c525$var$LozengeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2rkopxbi _bfhk3qkl _4t3ixy5q _4cvr1h6o _135a1yb4",
            __cmplp.className
        ])
    });
});
const $ac7ef6bb70a7c525$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_k7dk7i": (0, $9t7rW.default)(__cmplp.fontWeight),
            "--_1qrlcdp": (0, $9t7rW.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1wybutpp _k48pc8id _syazijt0 _y3gnusic _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $ac7ef6bb70a7c525$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $9t7rW.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kah _1bsbxy5q _4t3i1ejb _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ac7ef6bb70a7c525$var$PauseIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, backgroundIconColor: backgroundIconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $9t7rW.default)(__cmplp.iconColor),
            "--_9kl46p": (0, $9t7rW.default)(__cmplp.backgroundIconColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kah _bfhkt95u _2rkov77o _4t3i1ejb _1bsb1ejb _18s81l3d _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3eRLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25bc62fa91a495ac$var$_react = $25bc62fa91a495ac$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $25bc62fa91a495ac$var$_videoPause = $25bc62fa91a495ac$var$_interopRequireDefault((parcelRequire("hTFHh")));
function $25bc62fa91a495ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25bc62fa91a495ac$var$VidPauseIcon = (props)=>/*#__PURE__*/ $25bc62fa91a495ac$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 4h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m10 0h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $25bc62fa91a495ac$var$_videoPause.default
    }));
$25bc62fa91a495ac$var$VidPauseIcon.displayName = 'VidPauseIcon';
var $25bc62fa91a495ac$var$_default = module.exports.default = $25bc62fa91a495ac$var$VidPauseIcon;

});
parcelRegister("hTFHh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2374c848a4232f0c748ea013a33fd06b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d077eae4e09c9f54$var$_react = $d077eae4e09c9f54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d077eae4e09c9f54$var$_UNSAFE_baseNew = $d077eae4e09c9f54$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d077eae4e09c9f54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d077eae4e09c9f54$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $d077eae4e09c9f54$var$_react.default.createElement($d077eae4e09c9f54$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2.75 3c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25zm7 0c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$d077eae4e09c9f54$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $d077eae4e09c9f54$var$_default = module.exports.default = $d077eae4e09c9f54$var$VideoPauseIcon;

});


parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

const $8f398e8176e5defb$export$d1917132a74c7b93 = 'ONGOING';
const $8f398e8176e5defb$export$fc332a617fd34192 = 'COMPLETED';
const $8f398e8176e5defb$export$3ad39751a33c16b8 = 'PAUSED';


parcelRegister("jo49X", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $85ae5d9a5ca59b85$export$631ca5fe503ed873);

var $6wqPF = parcelRequire("6wqPF");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jwKk8 = parcelRequire("jwKk8");

var $4xHig = parcelRequire("4xHig");

var $lGLse = parcelRequire("lGLse");
const $85ae5d9a5ca59b85$export$631ca5fe503ed873 = (sla)=>{
    const { remainingTimeMillis: remainingTimeMillis, breachTime: breachTime, goalTimeMillis: goalTimeMillis, goalTimeLongFriendly: goalTimeLongFriendly, remainingTimeFriendly: remainingTimeFriendly, date: date, isClosed: isClosed, slaDisplayFormat: slaDisplayFormat } = sla;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $5JgJ2.default)();
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const userTimezone = loggedInUser?.timeZone || 'America/Toronto';
    let locale = (0, $4xHig.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getDays = ()=>{
        const calDate = new Date(date);
        return [
            (0, $3jYzf.default)(calDate),
            (0, $3jYzf.default)((0, $6wqPF.default)(calDate, 1)),
            (0, $3jYzf.default)((0, $9FEvp.default)(calDate, 1))
        ];
    };
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const getMatchingDay = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = getDays();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $jwKk8.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $jwKk8.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $jwKk8.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForSLAConfig = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $bbmZl.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDay(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        percentage = Math.round(percentage * 100);
        return percentage.toString();
    };
    const getBreachTimeInLocalString = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $bbmZl.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $4p54N.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $jwKk8.default).notApplicable)}`;
    };
    const getHoverContentForSLAConfig = (isClosedSlaConfig, timeRemainingMillis, breachTimeMillisFormat, goalTimeMillisFormat, goalTimeLongFriendlyFormat, remainingTimeFriendlyFormat)=>{
        const isTimeInMinus = remainingTimeFriendlyFormat.startsWith('-');
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendlyFormat.substring(1);
            timeStatus = formatMessage((0, $jwKk8.default).past);
        } else {
            remainingTimeString = remainingTimeFriendlyFormat;
            timeStatus = formatMessage((0, $jwKk8.default).left);
        }
        if (isClosedSlaConfig) {
            timeStatus = isTimeInMinus ? formatMessage((0, $jwKk8.default).breached) : formatMessage((0, $jwKk8.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillisFormat, timeRemainingMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendlyFormat} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalString(breachTimeMillisFormat)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $jwKk8.default).due)}: ${getBreachTimeInLocalString(breachTimeMillisFormat)}`;
        return hoverContent;
    };
    const timeFriendly = getTimeInSlaFriendlierFormatForSLAConfig(breachTime);
    const hoverFriendly = getHoverContentForSLAConfig(isClosed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly);
    if (slaDisplayFormat === 'OLD_SLA_FORMAT') return sla;
    return {
        ...sla,
        timeRemainingFriendly: timeFriendly,
        hoverContent: hoverFriendly
    };
};

});
parcelRegister("jwKk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0d7cb80c20df77$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1d0d7cb80c20df77$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    past: {
        "id": "sla-panel.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "sla-panel.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "sla-panel.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "sla-panel.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "sla-panel.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "sla-panel.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "sla-panel.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "sla-panel.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "sla-panel.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});


parcelRegister("iejLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea64a09080cdea1b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea64a09080cdea1b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeCentric: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.sla-display-format.time-centric",
        "defaultMessage": "Time centric e.g."
    },
    dueDateCentric: {
        "id": "servicedesk-sla-settings.metrics.metric.editable.form.sla-display-format.due-date-centric",
        "defaultMessage": "Due date centric e.g."
    }
});

});


parcelRegister("58B99", function(module, exports) {

$parcel$export(module.exports, "useUpdateMetricResource", () => $709b3abb2352a4ab$export$afaf0a2aa7bb386f);

var $kd0cS = parcelRequire("kd0cS");

var $jwvob = parcelRequire("jwvob");
const $709b3abb2352a4ab$export$c18f47c6352836b9 = (updatedMetric)=>(previous)=>{
        if (!previous) return previous;
        const previousSla = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(previous);
        const { timeMetrics: timeMetrics } = previousSla;
        const findMetricIndex = timeMetrics.findIndex((metric)=>metric.id === updatedMetric.id);
        // it's a new metric
        if (findMetricIndex === -1) timeMetrics.push(updatedMetric);
        else // existed metric
        timeMetrics.splice(findMetricIndex, 1, updatedMetric);
        return {
            ...previousSla,
            timeMetrics: timeMetrics
        };
    };
const $709b3abb2352a4ab$export$afaf0a2aa7bb386f = ()=>{
    const [, { update: update }] = (0, $jwvob.useMetricResource)();
    const updateResourceMetric = (updatedMetric)=>update($709b3abb2352a4ab$export$c18f47c6352836b9(updatedMetric));
    return [
        {
            updateResourceMetric: updateResourceMetric
        }
    ];
};

});

parcelRegister("4KIV6", function(module, exports) {

$parcel$export(module.exports, "getPayload", () => $83f76ccbca77f4c5$export$ccab2b64c5d440);

var $ldoFd = parcelRequire("ldoFd");

var $gDsgM = parcelRequire("gDsgM");

var $6TYc5 = parcelRequire("6TYc5");

var $fK421 = parcelRequire("fK421");
const $83f76ccbca77f4c5$export$78c40473e313bd89 = (formFields, formFiledEntities, formatMessage, isSLAHierarchicalGoalsEnabled = false)=>{
    // @ts-expect-error - TS2769 - No overload matches this call.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultGoal = formFiledEntities.find(([key])=>RegExp((0, $gDsgM.DEFAULT_GOAL_ROW_INDEX_TRACKER)).test(key));
    const [defaultGoalKey] = defaultGoal || [];
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const defaultGoalId = defaultGoalKey.slice((0, $gDsgM.DEFAULT_GOAL_ROW_INDEX_TRACKER).length);
    const goal = formFields[(0, $fK421.toGoalField)(defaultGoalId)];
    const { fieldState: fieldState, calendarName: calendarName, duration: durationHumanReadable, subGoals: subGoals = [], ...restGoal } = goal;
    const duration = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(durationHumanReadable) ? '' : (0, $6TYc5.durationToMilliseconds)(durationHumanReadable, formatMessage);
    // it's new metric with default goal
    // remove some of the properties which are EMPTY
    if (defaultGoalId === (0, $gDsgM.DEFAULT)) {
        const filteredEntities = Object.entries({
            duration: duration,
            ...restGoal
        }).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>[
                'calendarId',
                'duration',
                'defaultGoal'
            ].includes(key) && value !== undefined && value !== '' || key === 'jqlQuery');
        const newDefaultGoal = Object.fromEntries(filteredEntities);
        return newDefaultGoal;
    }
    if (isSLAHierarchicalGoalsEnabled) return {
        ...restGoal,
        duration: duration,
        subGoals: subGoals
    };
    return {
        ...restGoal,
        duration: duration
    };
};
const $83f76ccbca77f4c5$export$f1a56e8a2821e685 = (subGoals, formatMessage)=>// @ts-expect-error - TS2322
    subGoals.map((subGoal)=>{
        // @ts-expect-error - TS2339 - fieldState is not defined on SubGoal type
        const { id: id, fieldState: fieldState, duration: durationHumanReadable, ...rest } = subGoal;
        const duration = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(durationHumanReadable) ? '' : (0, $6TYc5.durationToMilliseconds)(durationHumanReadable, formatMessage);
        if (fieldState === 'NEW') return {
            ...rest,
            duration: duration
        };
        return {
            id: id,
            ...rest,
            duration: duration
        };
    });
const $83f76ccbca77f4c5$export$b6c1470d525124ce = (goalList, goal, formatMessage, isSLAHierarchicalGoalsEnabled = false, formValues)=>{
    const { id: id, fieldState: fieldState, duration: durationHumanReadable, timeMetricId: timeMetricId, subGoals: subGoals = [], ...restGoalFields } = goal;
    const duration = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(durationHumanReadable) ? '' : (0, $6TYc5.durationToMilliseconds)(durationHumanReadable, formatMessage);
    if (isSLAHierarchicalGoalsEnabled) {
        const newSubGoals = $83f76ccbca77f4c5$export$f1a56e8a2821e685(subGoals, formatMessage);
        // @ts-expect-error - TS2345 - Argument of type 'string | number' is not assignable to parameter of type 'string'
        const jqlQuery = formValues[(0, $fK421.toGoalJqlFieldName)(id, true)];
        if (fieldState && (fieldState === (0, $gDsgM.NEW) || fieldState === (0, $gDsgM.NEW_AND_MODIFIED))) goalList.push({
            ...restGoalFields,
            duration: duration,
            jqlQuery: jqlQuery,
            subGoals: newSubGoals
        });
        if (fieldState === undefined || fieldState && fieldState === (0, $gDsgM.EXISTING_AND_MODIFIED)) goalList.push({
            id: id,
            ...restGoalFields,
            timeMetricId: timeMetricId,
            duration: duration,
            jqlQuery: jqlQuery,
            subGoals: newSubGoals
        });
    } else {
        if (fieldState && fieldState === (0, $gDsgM.NEW_AND_MODIFIED)) goalList.push({
            ...restGoalFields,
            duration: duration
        });
        if (fieldState === undefined || fieldState && fieldState === (0, $gDsgM.EXISTING_AND_MODIFIED)) goalList.push({
            id: id,
            ...restGoalFields,
            timeMetricId: timeMetricId,
            duration: duration
        });
    }
    return goalList;
};
const $83f76ccbca77f4c5$export$da2944c52ff0de62 = (formFields, formatMessage, isSLAHierarchicalGoalsEnabled = false)=>{
    const formFiledEntities = Object.entries(formFields);
    const goalKeys = formFiledEntities// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>RegExp((0, $gDsgM.ROW_INDEX_TRACKER)).test(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .sort(([, orderA], [, orderB])=>Number(orderA) - Number(orderB)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // @ts-expect-error - TS2345 - Argument of type '([key]: [any]) => any' is not assignable to parameter of type '(value: [string, any], index: number, array: [string, any][]) => any'.
    .map(([key])=>key); // eslint-disable-line @typescript-eslint/no-explicit-any
    const goalIds = goalKeys.map((goalKey)=>goalKey.slice((0, $gDsgM.ROW_INDEX_TRACKER).length));
    const allGoals = goalIds.map((id)=>formFields[(0, $fK421.toGoalField)(id)]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const goals = allGoals.reduce((goalList, goal)=>$83f76ccbca77f4c5$export$b6c1470d525124ce(goalList, goal, formatMessage, isSLAHierarchicalGoalsEnabled, formFields), []);
    const defaultGoal = $83f76ccbca77f4c5$export$78c40473e313bd89(formFields, formFiledEntities, formatMessage, isSLAHierarchicalGoalsEnabled);
    return [
        ...goals,
        defaultGoal
    ];
};
const $83f76ccbca77f4c5$export$6dac8c184f86ad18 = (formFields)=>{
    const { start: start, pause: pause, stop: stop } = formFields;
    return {
        start: start,
        pause: pause,
        stop: stop,
        inconsistent: false
    };
};
const $83f76ccbca77f4c5$export$7d9f7e9c1c02b41e = (formFields)=>formFields?.name?.label;
const $83f76ccbca77f4c5$export$a7deb43d284261c2 = (formFields)=>{
    const { slaDisplayFormat: slaDisplayFormat } = formFields;
    return slaDisplayFormat;
};
const $83f76ccbca77f4c5$export$ccab2b64c5d440 = (formFields, formatMessage, isSLAHierarchicalGoalsEnabled = false)=>({
        name: $83f76ccbca77f4c5$export$7d9f7e9c1c02b41e(formFields),
        config: {
            definition: $83f76ccbca77f4c5$export$6dac8c184f86ad18(formFields),
            goals: $83f76ccbca77f4c5$export$da2944c52ff0de62(formFields, formatMessage, isSLAHierarchicalGoalsEnabled),
            slaDisplayFormat: $83f76ccbca77f4c5$export$a7deb43d284261c2(formFields)
        }
    });

});


parcelRegister("ffPFL", function(module, exports) {

$parcel$export(module.exports, "MetricView", () => $758c8b1944a48a73$export$e23a5c017808d4a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $6vO9v = parcelRequire("6vO9v");

var $cIHvJ = parcelRequire("cIHvJ");

var $lxU6z = parcelRequire("lxU6z");

var $aqGE9 = parcelRequire("aqGE9");

var $9C2IH = parcelRequire("9C2IH");

var $if6GW = parcelRequire("if6GW");

var $a608b = parcelRequire("a608b");

var $2KyL3 = parcelRequire("2KyL3");
const $758c8b1944a48a73$export$e23a5c017808d4a0 = ({ metric: metric })=>{
    const { config: { goals: goals, definition: selectedConditions, slaDisplayFormat: slaDisplayFormat } } = metric;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($758c8b1944a48a73$var$MetricViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqGE9.GoalTitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxU6z.GoalHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2KyL3.GoalListView), {
        goals: goals
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $758c8b1944a48a73$var$conditionContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIHvJ.ConditionTitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a608b.ConditionListView), {
        conditions: selectedConditions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $if6GW.SlaDisplayFormatTitle), {
        mode: (0, $6vO9v.VIEW_MODE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9C2IH.SLADisplayFormatHeader), {
        slaDisplayFormat: slaDisplayFormat
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $758c8b1944a48a73$var$MetricViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4174b",
            __cmplp.className
        ])
    });
});
const $758c8b1944a48a73$var$conditionContainerStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("9C2IH", function(module, exports) {

$parcel$export(module.exports, "SLADisplayFormatHeader", () => $cd21b66794717db8$export$558c854793ef821);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");


var $9dHVy = parcelRequire("9dHVy");

var $gDsgM = parcelRequire("gDsgM");

var $jo49X = parcelRequire("jo49X");

var $ei6X8 = parcelRequire("ei6X8");
const $cd21b66794717db8$export$4cca27b0fd03c99c = ({ slaDisplayFormat: slaDisplayFormat })=>{
    let OnTrackOngoingSLA;
    let AtRiskOngoingSLA;
    let CompletedSLA;
    switch(slaDisplayFormat){
        case 0, $feae9f437bfca243$export$13ecaaf97b049384:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.AtRiskOngoingSlaNewSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaNewSlaFormat);
            break;
        case 0, $feae9f437bfca243$export$aad60a8e044b5914:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaOldSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.AtRiskOngoingSlaOldSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaOldSlaFormat);
            break;
        default:
            OnTrackOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            AtRiskOngoingSLA = (0, $gDsgM.OnTrackOngoingSlaNewSlaFormat);
            CompletedSLA = (0, $gDsgM.CompletedSlaNewSlaFormat);
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd21b66794717db8$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 37; readonly status: "ONGOING"; readonly timeRemainingFriendly: "Today 04:00 PM"; readonly metricName: "Time to Pending"; ... 12 more ...; readonly date: 1647858600000; } | { ...; } | TransformedGoalView' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(OnTrackOngoingSLA)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd21b66794717db8$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 37; readonly status: "ONGOING"; readonly timeRemainingFriendly: "Today 04:00 PM"; readonly metricName: "Time to Pending"; ... 5 more ...; readonly slaDisplayFormat: "NEW_SLA_FORMAT"; } | { ...; } | { ...; }' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(AtRiskOngoingSLA)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd21b66794717db8$export$96d7abc8e13adb8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dHVy.default), {
        value: // @ts-expect-error - TS2322 - Type '{ readonly isBreached: false; readonly timeRemainingInMinutes: 300; readonly status: "COMPLETED"; readonly timeRemainingFriendly: "24 February"; readonly metricName: "Time to Pending"; ... 5 more ...; readonly slaDisplayFormat: "NEW_SLA_FORMAT"; } | { ...; }' is not assignable to type 'TransformedGoalView'.
        (0, $jo49X.SlaFieldTransformer)(CompletedSLA)
    })));
};
const $cd21b66794717db8$var$SLADisplayFormatHeaderComponent = ({ slaDisplayFormat: slaDisplayFormat, intl: { formatMessage: formatMessage } })=>{
    const formattedSLADisplay = slaDisplayFormat === (0, $feae9f437bfca243$export$13ecaaf97b049384) ? formatMessage((0, $ei6X8.default).dueDateCentric) : formatMessage((0, $ei6X8.default).timeCentric);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cd21b66794717db8$var$sLADisplayFormatContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd21b66794717db8$var$SLADisplayFormatRowView, {
        key: "sla-display-format",
        "data-test-id": "servicedesk-sla-settings.common.ui.sla-display-format.sla-display-format-header"
    }, formattedSLADisplay, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd21b66794717db8$export$4cca27b0fd03c99c, {
        slaDisplayFormat: slaDisplayFormat
    })));
};
const $cd21b66794717db8$export$558c854793ef821 = (0, $giAhk.injectIntlV2)($cd21b66794717db8$var$SLADisplayFormatHeaderComponent);
const $cd21b66794717db8$var$sLADisplayFormatContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300',
    marginTop: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd21b66794717db8$var$SLADisplayFormatRowView = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16qs1os1 _2rko1l7b _2lx2vrvc _4t3i1ylp _otyr1b66 _19bvutpp _11q7hp5a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $cd21b66794717db8$export$96d7abc8e13adb8f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s8u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ei6X8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1cdd5e81b64567$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f1cdd5e81b64567$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    slaDisplayFormat: {
        "id": "servicedesk-sla-settings.common.sla-display-format.sla-display-format-header.sla-display-format",
        "defaultMessage": "Time Goal"
    },
    timeCentric: {
        "id": "servicedesk-sla-settings.common.sla-display-format.sla-display-format-header.time-centric",
        "defaultMessage": "Time centric e.g."
    },
    dueDateCentric: {
        "id": "servicedesk-sla-settings.common.sla-display-format.sla-display-format-header.due-date-centric",
        "defaultMessage": "Due date centric e.g."
    }
});

});


parcelRegister("a608b", function(module, exports) {

$parcel$export(module.exports, "ConditionListView", () => $dbd168bc3df999ad$export$7acedb896ada846b);

var $eUqFw = parcelRequire("eUqFw");

var $gDsgM = parcelRequire("gDsgM");

var $kNVAx = parcelRequire("kNVAx");
const $dbd168bc3df999ad$export$7acedb896ada846b = ({ conditions: conditions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNVAx.ConditionView), {
        selectedConditions: conditions.start,
        listName: (0, $gDsgM.START_CONDITIONS_FIELD_NAME)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNVAx.ConditionView), {
        selectedConditions: conditions.pause,
        listName: (0, $gDsgM.PAUSE_CONDITIONS_FIELD_NAME)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNVAx.ConditionView), {
        selectedConditions: conditions.stop,
        listName: (0, $gDsgM.STOP_CONDITIONS_FIELD_NAME)
    }));

});
parcelRegister("kNVAx", function(module, exports) {

$parcel$export(module.exports, "ConditionView", () => $fa4e48e51bd82d79$export$85174b1e3c85d444);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2siPY = parcelRequire("2siPY");

var $g9sh6 = parcelRequire("g9sh6");

var $axbjt = parcelRequire("axbjt");
const $fa4e48e51bd82d79$export$30fa3a57419c2dba = ({ listName: listName, selectedConditions: selectedConditions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2siPY.ConditionHeader), {
        listName: listName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $fa4e48e51bd82d79$var$conditionListContainerStyles
    }, selectedConditions.length ? selectedConditions.map((condition)=>{
        const { conditionId: conditionId, name: name } = condition;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9sh6.RowView), {
            key: `${listName}-condition-${conditionId}`,
            "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.metric-view.conditions.condition.condition-view-${listName}-${conditionId}`
        }, name);
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9sh6.RowEmpty), null, formatMessage((0, $axbjt.default).noConditions))));
};
const $fa4e48e51bd82d79$export$85174b1e3c85d444 = $fa4e48e51bd82d79$export$30fa3a57419c2dba;
const $fa4e48e51bd82d79$var$conditionListContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("g9sh6", function(module, exports) {

$parcel$export(module.exports, "RowView", () => $4a2a4370b61e3cb7$export$ec3ea480f1f39446);
$parcel$export(module.exports, "RowEmpty", () => $4a2a4370b61e3cb7$export$85d7730001a8996d);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a2a4370b61e3cb7$export$ec3ea480f1f39446 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16qs1os1 _2rko1l7b _2lx2vrvc _4t3i1ylp _otyr1b66 _1yt4h8dc _11q7hp5a",
            __cmplp.className
        ])
    });
});
const $4a2a4370b61e3cb7$export$85d7730001a8996d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _otyru2gc _syaz1e9r",
            __cmplp.className
        ])
    });
});

});

parcelRegister("axbjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a452b5bbafc47f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0a452b5bbafc47f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noConditions: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.conditions.condition.no-conditions",
        "defaultMessage": "No conditions"
    }
});

});



parcelRegister("2KyL3", function(module, exports) {

$parcel$export(module.exports, "GoalListView", () => $017b2528af5cb377$export$2084f441c7fd63d6);

var $eUqFw = parcelRequire("eUqFw");

var $841u6 = parcelRequire("841u6");

var $d1pCN = parcelRequire("d1pCN");
const $017b2528af5cb377$export$2084f441c7fd63d6 = ({ goals: goals })=>{
    const { defaultGoals: defaultGoals, draggableGoals: draggableGoals } = (0, $841u6.splitGoals)(goals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, draggableGoals.map((goal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1pCN.GoalView), {
            key: goal.id,
            goal: goal
        })), defaultGoals.map((goal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1pCN.GoalView), {
            key: goal.id,
            goal: goal
        })));
};

});
parcelRegister("d1pCN", function(module, exports) {

$parcel$export(module.exports, "GoalView", () => $ee7083c0fe53cba4$export$ad978c16c6f4ca6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-empty-divs */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $PtojF = parcelRequire("PtojF");

var $hIjKU = parcelRequire("hIjKU");

var $3bDmC = parcelRequire("3bDmC");

var $9ZP1E = parcelRequire("9ZP1E");

var $j9QWN = parcelRequire("j9QWN");

var $7B4GC = parcelRequire("7B4GC");

var $1GPj0 = parcelRequire("1GPj0");
const $ee7083c0fe53cba4$export$ad978c16c6f4ca6f = ({ goal: goal })=>{
    const { id: id, metricId: metricId, duration: goalDuration, calendarName: goalCalendarName, jqlQuery: goalJqlQuery, defaultGoal: defaultGoal, subGoals: subGoals = [] } = goal;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isSLAHierarchicalGoalsEnabled: isSLAHierarchicalGoalsEnabled }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    return isSLAHierarchicalGoalsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$GoalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9QWN.JqlViewField), {
        jqlQuery: goalJqlQuery,
        defaultGoal: defaultGoal,
        goalId: id,
        metricId: metricId,
        areSubGoalsPresent: !!subGoals?.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.CalendarFieldWrapper), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.GoalFieldWrapper), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ee7083c0fe53cba4$var$subGoalContainerStyles
    }, subGoals.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$PriorityContainer, null, formatMessage((0, $7B4GC.default).priorityHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, subGoals.map(({ id: subGoalID, calendarName: calendarName, duration: duration, jqlQuery: jqlQuery })=>{
        const [key, value] = jqlQuery.split('=');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$RowViewWithFF, {
            key: subGoalID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.PriorityFieldWrapper), null, (key === undefined || key.trim() === 'priority') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GPj0.PriorityViewField), {
            goalId: id,
            metricId: metricId,
            selectedPriority: value.trim()
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.CalendarFieldWrapper), null, calendarName != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bDmC.CalendarViewField), {
            calendarName: calendarName
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.GoalFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZP1E.DurationViewField), {
            duration: duration
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$RowViewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.PriorityFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GPj0.PriorityViewField), {
        placeholder: subGoals.length === 0 ? formatMessage((0, $7B4GC.default).allMatchingPriorities) : formatMessage((0, $7B4GC.default).allRemainingPriorities)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.CalendarFieldWrapper), null, goalCalendarName != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bDmC.CalendarViewField), {
        calendarName: goalCalendarName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.GoalFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZP1E.DurationViewField), {
        duration: goalDuration
    })))))), defaultGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$RowViewWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$JqlFieldWrapperWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9QWN.JqlViewField), {
        jqlQuery: goalJqlQuery,
        defaultGoal: defaultGoal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.CalendarFieldWrapper), null, goalCalendarName != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bDmC.CalendarViewField), {
        calendarName: goalCalendarName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.GoalFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZP1E.DurationViewField), {
        duration: goalDuration
    }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee7083c0fe53cba4$var$RowView, {
        "data-test-id": `servicedesk-sla-settings.ui.metrics.metric.metric-view.goals.goal.view-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.GoalFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZP1E.DurationViewField), {
        duration: goalDuration
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.CalendarFieldWrapper), null, goalCalendarName != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bDmC.CalendarViewField), {
        calendarName: goalCalendarName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.JqlFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9QWN.JqlViewField), {
        jqlQuery: goalJqlQuery,
        defaultGoal: defaultGoal
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee7083c0fe53cba4$var$RowView = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $PtojF.Row), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4h8dc _16qs1os1 _11q7hp5a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee7083c0fe53cba4$var$GoalContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt49wsv _18s81bpf _19it1htw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee7083c0fe53cba4$var$PriorityContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf",
            __cmplp.className
        ])
    });
});
const $ee7083c0fe53cba4$var$subGoalContainerStyles = (0, $1ZAYh.xcss)({
    margin: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee7083c0fe53cba4$var$JqlFieldWrapperWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlcs5v _1o9zkb7n _i0dl6xpw _u5f3u2gc _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee7083c0fe53cba4$var$RowViewWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16qs1os1 _2rko1l7b _2lx2vrvc _1tke1jfw _otyru2gc _1yt4h8dc _11q7hp5a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3bDmC", function(module, exports) {

$parcel$export(module.exports, "CalendarViewField", () => $4c6147323a33cff8$export$20f6794acbee6e9d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kMHOY = parcelRequire("kMHOY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $4c6147323a33cff8$export$20f6794acbee6e9d = ({ calendarName: calendarName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c6147323a33cff8$var$ValueContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c6147323a33cff8$var$ReadViewContainerWithFF, null, calendarName));
const $4c6147323a33cff8$var$ValueContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c6147323a33cff8$var$CalendarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4c6147323a33cff8$var$calendarIconContainerStyles,
        testId: "servicedesk-sla-settings.ui.metrics.metric.metric-view.goals.goal.calendar.calendar-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
        label: ""
    })), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c6147323a33cff8$var$CalendarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4c6147323a33cff8$var$calendarIconContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.075',
    paddingTop: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c6147323a33cff8$var$ReadViewContainerWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz48sxn _p12f1osq _1tke1yan _1nmz1hna",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9ZP1E", function(module, exports) {

$parcel$export(module.exports, "DurationViewField", () => $6e00bcd4519e1531$export$2c953dfe787065a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iXuok = parcelRequire("iXuok");
const $6e00bcd4519e1531$export$8606fb13ec8728d4 = ({ duration: duration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e00bcd4519e1531$var$ReadViewContainerwithFF, null, duration || formatMessage((0, $iXuok.default).noTarget));
};
const $6e00bcd4519e1531$export$2c953dfe787065a0 = $6e00bcd4519e1531$export$8606fb13ec8728d4;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e00bcd4519e1531$var$ReadViewContainerwithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz410nf _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iXuok", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc72044bb6413e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5dc72044bb6413e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noTarget: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.duration.no-target",
        "defaultMessage": "No target"
    }
});

});


parcelRegister("j9QWN", function(module, exports) {

$parcel$export(module.exports, "JqlViewField", () => $31343fa554f62b61$export$2713f282c16f551f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");


var $2eG9N = parcelRequire("2eG9N");

var $giAhk = parcelRequire("giAhk");

var $PtojF = parcelRequire("PtojF");

var $flFqI = parcelRequire("flFqI");

var $hIjKU = parcelRequire("hIjKU");

var $75ThD = parcelRequire("75ThD");
const $31343fa554f62b61$export$b1c07d1d226595a1 = ({ jqlQuery: jqlQuery, defaultGoal: defaultGoal, goalId: goalId = '', metricId: metricId = 0, areSubGoalsPresent: areSubGoalsPresent = false, intl: { formatMessage: formatMessage } })=>{
    const [{ isPriorityNameChanged: isPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    return(// @ts-expect-error - TS2739 - Type '{ children: Element; }' is missing the following properties from type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { editMode: boolean; placeholder: any; }, any>>': placeholder, editMode
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $PtojF.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31343fa554f62b61$var$JqlViewContainer, null, defaultGoal ? formatMessage((0, $75ThD.default).allRemainingIssues) : jqlQuery, // @ts-expect-error - TS7053
    isPriorityNameChanged?.[metricId]?.[goalId] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $75ThD.default).errorTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
            size: "medium",
            label: formatMessage((0, $75ThD.default).errorTooltip)
        }),
        appearance: "subtle"
    })), jqlQuery.toLowerCase().includes('priority') && areSubGoalsPresent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $75ThD.default).warningWhenPriorityIsPresentInJqlWithSubGoals),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
            size: "medium",
            label: ""
        }),
        appearance: "subtle"
    })))));
};
const $31343fa554f62b61$export$2713f282c16f551f = (0, $giAhk.injectIntlV2)($31343fa554f62b61$export$b1c07d1d226595a1); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31343fa554f62b61$var$JqlViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.Row), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4u2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("75ThD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b08461de0661def$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b08461de0661def$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allRemainingIssues: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.all-remaining-issues",
        "defaultMessage": "All remaining issues"
    },
    errorTooltip: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.error-tooltip",
        "defaultMessage": "This goal has one or more errors."
    },
    warningWhenPriorityIsPresentInJqlWithSubGoals: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.jql.warning-when-priority-is-present-in-jql-with-sub-goals",
        "defaultMessage": "This goal\u2019s priority field creates a conflict with one of its priority time targets."
    }
});

});


parcelRegister("7B4GC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1245695b9348370a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1245695b9348370a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    priorityHeader: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.priority-header",
        "defaultMessage": "And priority is:"
    },
    allMatchingPriorities: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.all-matching-priorities",
        "defaultMessage": "All matching priorities"
    },
    allRemainingPriorities: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.all-remaining-priorities",
        "defaultMessage": "All remaining priorities"
    }
});

});

parcelRegister("1GPj0", function(module, exports) {

$parcel$export(module.exports, "PriorityViewField", () => $815fedd35ffa76f8$export$aefee592b0d5d833);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $h28Y9 = parcelRequire("h28Y9");

var $96IgR = parcelRequire("96IgR");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $hIjKU = parcelRequire("hIjKU");

var $7sqns = parcelRequire("7sqns");

var $6SqLu = parcelRequire("6SqLu");
const $815fedd35ffa76f8$export$2adfdf634bddf828 = ({ selectedPriority: selectedPriority, placeholder: placeholder, goalId: goalId, metricId: metricId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ values: options }] = (0, $7sqns.useFetchPrioritiesService)();
    const [{ isPriorityNameChanged: isPriorityNameChanged }, { updateIsPriorityNameChanged: updateIsPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    if (placeholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$ReadViewContainerWithFF, null, placeholder);
    if (options.length === 0) return null;
    // Priority name having multiple words is always saved in double quotes.
    // Eg: `priority = "High/Medium"
    // And then the selected priority becomes '"High/Medium"' and matching it with the priority options doesnt give us anything
    // since the option is 'High/Medium', with no double quotes wrapped.
    // So, to avoid this, we need to trim those extra double quotes around.
    const selectedPriorityTrimmed = selectedPriority?.replace(/^"+|"+$/g, '') || '';
    const selectedOption = options.filter((option)=>option.value === selectedPriorityTrimmed);
    // If the project has `high`, medium` and `low` priorities
    // and `high` is selected. Later on, `high` is renamed to `highest` in priorities list, it breaks the UI
    // To handle this scenario, below code is added.
    const isPriorityChanged = selectedOption.length === 0 && selectedPriorityTrimmed.length > 0;
    if (isPriorityChanged && isPriorityNameChanged !== isPriorityChanged) updateIsPriorityNameChanged(metricId, goalId, isPriorityChanged);
    if (isPriorityChanged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$ReadViewContainerWithFF, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$PriorityContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h28Y9))), {
        label: "",
        LEGACY_size: "small",
        color: "currentColor"
    })), selectedPriorityTrimmed, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $6SqLu.default).invalidPriority),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
            size: "medium",
            label: ""
        }),
        appearance: "subtle",
        "aria-label": formatMessage((0, $6SqLu.default).invalidPriority)
    }))));
    const [{ label: label, icon: icon, value: value }] = selectedOption || [
        {
            label: '',
            icon: '',
            value: ''
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$ReadViewContainerWithFF, null, value === 'EMPTY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h28Y9))), {
        label: "",
        LEGACY_size: "small",
        color: "currentColor"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815fedd35ffa76f8$var$ImageIcon, {
        src: icon,
        alt: ""
    }), label);
};
const $815fedd35ffa76f8$export$aefee592b0d5d833 = $815fedd35ffa76f8$export$2adfdf634bddf828; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $815fedd35ffa76f8$var$ImageIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _12l2u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $815fedd35ffa76f8$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _12l2u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $815fedd35ffa76f8$var$PriorityContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.Row), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $815fedd35ffa76f8$var$ReadViewContainerWithFF = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz410nf _1nmz1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6SqLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $84e6503695b98b18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $84e6503695b98b18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidPriority: {
        "id": "servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.priority.invalid-priority",
        "defaultMessage": "This priority no longer exists. Check your Jira priorities or remove this time target."
    }
});

});





parcelRegister("74PJd", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $728bedfe301525ad$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jaTu3 = parcelRequire("jaTu3");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $eSHsi = parcelRequire("eSHsi");

var $dwj4T = parcelRequire("dwj4T");

var $96IgR = parcelRequire("96IgR");

var $ajCg0 = parcelRequire("ajCg0");

var $jG1wZ = parcelRequire("jG1wZ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $6vO9v = parcelRequire("6vO9v");

var $hIjKU = parcelRequire("hIjKU");

var $c4rDP = parcelRequire("c4rDP");

var $lNJ2n = parcelRequire("lNJ2n");

var $37Jdx = parcelRequire("37Jdx");

var $57XGX = parcelRequire("57XGX");
const $728bedfe301525ad$var$SummaryView = ({ id: id, name: name, mode: mode, setIsInitialSlaPageLoadToFalse: setIsInitialSlaPageLoadToFalse, config: config, metrics: metrics })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $5JgJ2.default)();
    const [, { updatePath: updatePath }] = (0, $lNJ2n.useMetricActions)();
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const [isDeleteModalOpen, toggleDeleteModal] = (0, $NqqMP.usePopupController)(false);
    const [, actions] = (0, $c4rDP.useGoalCounter)();
    const handleToggleView = (0, $eUqFw.useCallback)(()=>{
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'Mode' and '"collapsed"' have no overlap.
        const metricId = mode === (0, $6vO9v.COLLAPSED_MODE) ? id : null;
        setIsInitialSlaPageLoadToFalse();
        updatePath(metricId);
    }, [
        id,
        mode,
        updatePath,
        setIsInitialSlaPageLoadToFalse
    ]);
    const handleEditMetricClick = (0, $eUqFw.useCallback)(()=>{
        const calculateTotalNumberOfGoalsInProject = ()=>{
            let goalCount = 0;
            Object.keys(metrics).forEach((key)=>{
                goalCount += Object.keys(metrics[key].config.goals).length;
            });
            actions.setGoalCounter(goalCount - Object.keys(metrics).length);
        };
        updatePath(id, (0, $6vO9v.EDIT_MODE));
        calculateTotalNumberOfGoalsInProject();
    }, [
        id,
        updatePath,
        metrics,
        actions
    ]);
    const { goals: goals } = config;
    const [{ isPriorityNameChanged: isPriorityNameChanged }] = (0, $hIjKU.useSLAHierarchicalGoalsEnabled)();
    const actionButtonRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728bedfe301525ad$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728bedfe301525ad$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $728bedfe301525ad$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eSHsi))), {
        LEGACY_size: "large",
        LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        label: "",
        color: "currentColor"
    })), name, ' ', // @ts-expect-error TS-7053
    isPriorityNameChanged[id] !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $57XGX.default).errorTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R500})`,
            size: "medium",
            label: ""
        }),
        appearance: "subtle",
        "aria-label": formatMessage((0, $57XGX.default).errorTooltip)
    })) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728bedfe301525ad$var$ActionsContainer, null, Object.keys(goals).length - 1 <= 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatNumber(Object.keys(goals).length - 1), "\xa0", formatMessage((0, $57XGX.default).goal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatNumber(Object.keys(goals).length - 1), "\xa0", formatMessage((0, $57XGX.default).goals)), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $728bedfe301525ad$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleEditMetricClick,
        spacing: "compact",
        testId: `servicedesk-sla-settings.ui.metrics.summary-with-actions.edit-button-${id}`
    }, formatMessage((0, $57XGX.default).editMetric))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        shouldFlip: false,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $57XGX.default).more),
                    size: "medium"
                }),
                "data-test-id": `servicedesk-sla-settings.ui.metrics.summary-with-actions.dropdown-${id}`,
                ref: (0, $jaTu3.mergeRefs)([
                    actionButtonRef,
                    triggerRef
                ])
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: toggleDeleteModal,
        "data-test-id": "servicedesk-sla-settings.ui.metrics.summary-with-actions.delete-dropdown-item"
    }, formatMessage((0, $57XGX.default).deleteMetric)))), mode === (0, $6vO9v.COLLAPSED_MODE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: handleToggleView,
        testId: `servicedesk-sla-settings.ui.metrics.summary-with-actions.view-button-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728bedfe301525ad$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $57XGX.default).closeMetric)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: handleToggleView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($728bedfe301525ad$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
        label: formatMessage((0, $57XGX.default).expandMetric)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37Jdx.DeleteMetricModal), {
        key: id,
        isOpen: isDeleteModalOpen,
        onClose: ()=>{
            toggleDeleteModal();
            setTimeout(()=>{
                actionButtonRef?.current?.focus();
            }, 0);
        },
        metricId: id,
        metricName: name,
        baseUrl: baseUrl,
        projectKey: projectKey
    }));
};
const $728bedfe301525ad$export$46453a0401d6cd1a = $728bedfe301525ad$var$SummaryView; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728bedfe301525ad$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3i8vuz _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $728bedfe301525ad$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728bedfe301525ad$var$ChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728bedfe301525ad$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1wq8 _1nx94jg8 _syazaj1x _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $728bedfe301525ad$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syazjjyb _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $728bedfe301525ad$var$buttonContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("37Jdx", function(module, exports) {

$parcel$export(module.exports, "DeleteMetricModal", () => $bd75af7d487e1b26$export$e72fa640e1f88f07);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");

var $lNJ2n = parcelRequire("lNJ2n");

var $jwvob = parcelRequire("jwvob");

var $2BCLv = parcelRequire("2BCLv");

var $lLDG2 = parcelRequire("lLDG2");

var $MR38i = parcelRequire("MR38i");

var $1xONA = parcelRequire("1xONA");

var $FEzGj = parcelRequire("FEzGj");
const $bd75af7d487e1b26$export$abbcc9df790955a5 = ({ baseUrl: baseUrl, projectKey: projectKey, isOpen: isOpen, onClose: onClose, metricName: metricName, metricId: metricId, intl: { formatMessage: formatMessage } })=>{
    const [, { replacePath: replacePath }] = (0, $lNJ2n.useMetricActions)();
    const [, { refresh: onResourceRefresh }] = (0, $jwvob.useMetricResource)();
    const [{ loading: loadingFetchReports, error: error, data: reports }, { fetch: fetchReports }] = (0, $2BCLv.useFetchReportsService)({
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    const [{ loading: loadingRemoveMetric, error: errorRemoveMetric, data: dataRemoveMetric }, { fetch: requestRemoveMetric }] = (0, $lLDG2.useRemoveMetricService)({
        baseUrl: baseUrl,
        projectKey: projectKey
    });
    const handleDeleteMetricClick = (0, $eUqFw.useCallback)(()=>{
        requestRemoveMetric(metricId);
    }, [
        requestRemoveMetric,
        metricId
    ]);
    // get list of reports that using this metric
    (0, $eUqFw.useEffect)(()=>{
        const asyncFetchReports = async ()=>{
            await fetchReports(metricId);
        };
        if (isOpen) asyncFetchReports();
    }, [
        fetchReports,
        metricId,
        isOpen
    ]);
    // update browser history after deleting the metric
    (0, $eUqFw.useEffect)(()=>{
        if (dataRemoveMetric === true) {
            replacePath();
            onResourceRefresh();
        }
    }, [
        dataRemoveMetric,
        onResourceRefresh,
        replacePath
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error || errorRemoveMetric) onClose();
    }, [
        error,
        errorRemoveMetric,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        // @ts-expect-error TS2769 | TS2769 - No overload matches this call. | No overload matches this call.
        loading: loadingFetchReports || loadingRemoveMetric
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $1xONA.default).deleteMetricModalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $1xONA.default).deleteMetricModalBody)), loadingFetchReports === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $FEzGj.ReportListMessage), {
        projectKey: projectKey,
        metricName: metricName,
        reports: reports
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleDeleteMetricClick,
        appearance: "primary",
        testId: "servicedesk-sla-settings.ui.metrics.summary-with-actions.delete-metric-modal.delete-metric-button"
    }, formatMessage((0, $1xONA.default).deleteButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage((0, $1xONA.default).cancelButton)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MR38i.Flags), {
        error: errorRemoveMetric,
        metricName: metricName
    }));
};
const $bd75af7d487e1b26$export$e72fa640e1f88f07 = (0, $giAhk.injectIntlV2)($bd75af7d487e1b26$export$abbcc9df790955a5);

});
parcelRegister("2BCLv", function(module, exports) {

$parcel$export(module.exports, "useFetchReportsService", () => $7b844899217c25a0$export$ff39a009d9f005ba);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $bt2Pb = parcelRequire("bt2Pb");
const $7b844899217c25a0$export$ff39a009d9f005ba = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async (metricId)=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $fV97Z.performGetRequest)((0, $bt2Pb.getUrl)(baseUrl, projectKey, metricId));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaImpactedReports viewed');
            setData(response);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useFetchReportsService',
                packageName: 'jiraServicedeskSlaSettings'
            });
            setError(err);
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceData<Data>'.
            data
        },
        {
            fetch: fetch
        }
    ];
};

});
parcelRegister("bt2Pb", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6238374e74dbef48$export$94df0e59ebebf4a7);
const $6238374e74dbef48$export$94df0e59ebebf4a7 = (baseUrl, projectKey, metricId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/agent/${projectKey}/sla/metrics/reports/${metricId}?operation=getReportsForSLA`;

});


parcelRegister("lLDG2", function(module, exports) {

$parcel$export(module.exports, "useRemoveMetricService", () => $69c06a354b56bd49$export$9ebce179586a6301);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $3ftGR = parcelRequire("3ftGR");

var $6dFt0 = parcelRequire("6dFt0");
const $69c06a354b56bd49$export$9ebce179586a6301 = ({ baseUrl: baseUrl, projectKey: projectKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [isMetricRemoved, setMetricRemoved] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async (metricId)=>{
        (0, $3ftGR.jsmSLADeleteExperience).start();
        setLoading(true);
        setError(null);
        setMetricRemoved(false);
        try {
            await (0, $fV97Z.performDeleteRequest)((0, $6dFt0.getUrl)(baseUrl, projectKey, metricId));
            setMetricRemoved(true);
            setLoading(false);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaMetric deleted');
            (0, $3ftGR.jsmSLADeleteExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLoading(false);
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useRemoveMetricService',
                packageName: 'jiraServicedeskSlaSettings',
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $3ftGR.jsmSLADeleteExperience).failure();
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError'.
            error,
            data: isMetricRemoved
        },
        {
            fetch: fetch
        }
    ];
};

});
parcelRegister("6dFt0", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $922fc923a7298147$export$94df0e59ebebf4a7);
const $922fc923a7298147$export$94df0e59ebebf4a7 = (baseUrl, projectKey, metricId)=>`${baseUrl}/rest/servicedesk/1/servicedesk/agent/${projectKey}/sla/metrics/${metricId}?operation=removeMetric`;

});


parcelRegister("MR38i", function(module, exports) {

$parcel$export(module.exports, "Flags", () => $95b24864ce0ba3d7$export$434ba092ed0eee4e);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");


var $cCFSU = parcelRequire("cCFSU");

var $c8KxL = parcelRequire("c8KxL");

var $giAhk = parcelRequire("giAhk");

var $gxALP = parcelRequire("gxALP");
const $95b24864ce0ba3d7$var$FlagsComponent = ({ error: error, metricName: metricName, intl: intl })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (error) setIsOpen(true);
    }, [
        error,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c8KxL.default), {
        onDismissed: ()=>setIsOpen(false)
    }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`
        }),
        id: "error",
        key: "error",
        title: intl.formatMessage((0, $gxALP.default).errorTitle),
        description: intl.formatMessage((0, $gxALP.default).errorDescription, {
            metricName: metricName
        })
    }) : null);
};
const $95b24864ce0ba3d7$export$434ba092ed0eee4e = (0, $giAhk.injectIntlV2)($95b24864ce0ba3d7$var$FlagsComponent);

});
parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("c8KxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9f08ed55ceefb4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$4b9f08ed55ceefb4$export$2e2bcd8739ae039 = (0, $kQ0RL.FlagGroup);

});

parcelRegister("gxALP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e24eb72f9189a10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e24eb72f9189a10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.flags.error-title",
        "defaultMessage": "Problem deleting metric"
    },
    errorDescription: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.flags.error-description",
        "defaultMessage": "{metricName} couldn't be deleted. Please check your internet connection."
    }
});

});


parcelRegister("1xONA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13b538b4df9cdff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f13b538b4df9cdff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteMetricModalHeader: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-metric-modal-header",
        "defaultMessage": "Delete Metric"
    },
    deleteMetricModalBody: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-metric-modal-body",
        "defaultMessage": "Deleting this metric will remove the associated SLA from all issues in this project."
    },
    deleteButton: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.delete-button",
        "defaultMessage": "Confirm"
    },
    cancelButton: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("FEzGj", function(module, exports) {

$parcel$export(module.exports, "ReportListMessage", () => $e853803ea17ae850$export$9640c171691c855f);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $7u4fN = parcelRequire("7u4fN");

var $1H7E7 = parcelRequire("1H7E7");

var $hXuWa = parcelRequire("hXuWa");
const $e853803ea17ae850$export$9640c171691c855f = ({ projectKey: projectKey, metricName: metricName, reports: reports })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(reports)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, reports.reportList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1H7E7.default), {
        ...(0, $hXuWa.default).reviewReports,
        values: {
            tagStart: '<strong>',
            metricName: metricName,
            tagEnd: '</strong>'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, reports.reportList.map(({ id: id, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "compact",
            href: `/jira/servicedesk/projects/${projectKey}/reports/custom/${id}`
        }, name))))));
};

});
parcelRegister("hXuWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $07881722881fe8a3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $07881722881fe8a3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reviewReports: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric-modal.report-list.review-reports",
        "defaultMessage": "This will also remove the metric from reports. The following reports have a series that uses {tagStart}{metricName}{tagEnd} :"
    }
});

});



parcelRegister("57XGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df8b1d0430a37fa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1df8b1d0430a37fa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    more: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.more",
        "defaultMessage": "More"
    },
    editMetric: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.edit-metric",
        "defaultMessage": "Edit"
    },
    deleteMetric: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.delete-metric",
        "defaultMessage": "Delete"
    },
    closeMetric: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.close-metric",
        "defaultMessage": "Collapse metric"
    },
    expandMetric: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.expand-metric",
        "defaultMessage": "Expand metric"
    },
    goals: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.goals",
        "defaultMessage": "goals"
    },
    goal: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.goal",
        "defaultMessage": "goal"
    },
    errorTooltip: {
        "id": "servicedesk-sla-settings.metrics.summary-with-actions.error-tooltip",
        "defaultMessage": "This SLA has one or more errors."
    }
});

});


parcelRegister("eEgrB", function(module, exports) {

$parcel$export(module.exports, "newMetric", () => $1055b88153688107$export$c90d26e2f9c0b76a);

const $1055b88153688107$export$c90d26e2f9c0b76a = {
    name: '',
    config: {
        definition: {
            start: [],
            pause: [],
            stop: [],
            inconsistent: false
        },
        goals: {
            default: {
                jqlQuery: '',
                duration: '',
                calendarId: undefined,
                defaultGoal: true,
                timeMetricId: -1
            }
        },
        slaDisplayFormat: (0, $feae9f437bfca243$export$13ecaaf97b049384)
    }
};

});



parcelRegister("ZK4eF", function(module, exports) {

$parcel$export(module.exports, "CalendarModalWithTwoTabs", () => $ef6721ddad51d136$export$a058e85b2ff5694d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $2eG9N = parcelRequire("2eG9N");
var $4pEpX = parcelRequire("4pEpX");

var $foc4i = parcelRequire("foc4i");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $2Ba2b = parcelRequire("2Ba2b");

var $2kRnk = parcelRequire("2kRnk");

var $iSEfF = parcelRequire("iSEfF");

var $1N4bZ = parcelRequire("1N4bZ");

var $62wyb = parcelRequire("62wyb");

var $e9FBZ = parcelRequire("e9FBZ");

var $9aWE0 = parcelRequire("9aWE0");

var $4mHKz = parcelRequire("4mHKz");

var $lWEg2 = parcelRequire("lWEg2");
const $ef6721ddad51d136$var$ReusableSlaCalendarsStyles = null;
const $ef6721ddad51d136$var$Panel = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            "_1ul91osq _19pk1f4h"
        ])
    }, children);
const $ef6721ddad51d136$export$5906a9a8e80199b1 = ({ calendarsState: calendarsState, calendarsActions: calendarsActions })=>{
    const { isLoading: isLoading, isError: isError, permissionsWithTimezoneInfo: permissionsWithTimezoneInfo, calendars: calendars, selectedCalendarMode: selectedCalendarMode, selectedCalendarId: selectedCalendarId } = calendarsState;
    if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    if (isLoading || !permissionsWithTimezoneInfo || !calendars) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": "servicedesk-sla-settings.ui.reusable-calendars.calendar-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aWE0.OtherProjectCalendarList), {
        selectedCalendarId: selectedCalendarId,
        calendars: calendars,
        permissionsWithTimezone: permissionsWithTimezoneInfo,
        selectedCalendarMode: selectedCalendarMode,
        calendarsActions: calendarsActions
    }));
};
const $ef6721ddad51d136$var$CalendarModalWithTwoTabsView = ({ isCalendarModalOpen: isCalendarModalOpen, onToggleCalendarModal: onToggleCalendarModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [calendarsState, calendarsActions] = (0, $e9FBZ.useCalendarsModalStateAndActions)(isCalendarModalOpen, onToggleCalendarModal);
    const { onCreateNewRequested: onCreateNewRequested, onCopyCalendar: onCopyCalendar } = calendarsActions;
    const { permissionsWithTimezoneInfo: permissionsWithTimezoneInfo } = calendarsState;
    const [selectedTab, setSelectedTab] = (0, $eUqFw.useState)(0);
    const handleUpdate = (0, $eUqFw.useCallback)((index)=>setSelectedTab(index), [
        setSelectedTab
    ]);
    const isOtherCalendarsTabSelected = ()=>selectedTab === 1;
    const onSelectThisCalendarTab = (0, $eUqFw.useCallback)(()=>{
        handleUpdate(0);
    }, [
        handleUpdate
    ]);
    const [otherCalendarsState, otherCalendarsActions] = (0, $lWEg2.useCalendarsModalStateAndActionsOtherCalendars)(isCalendarModalOpen, isOtherCalendarsTabSelected);
    const onAddNewCalendar = (0, $eUqFw.useCallback)(()=>{
        onSelectThisCalendarTab(); // This will take you to the first tab since new calendars can only be added to the current project
        onCreateNewRequested(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onSelectThisCalendarTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62wyb.CalendarModalDialog), {
        canCreate: Boolean(permissionsWithTimezoneInfo?.canCreate),
        onAddCalendar: onAddNewCalendar,
        isOpen: isCalendarModalOpen,
        onClose: calendarsActions.onToggleCalendarModalWithNavBlocker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        id: "reusable-sla-calendars",
        selected: selectedTab,
        onChange: handleUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, formatMessage((0, $4mHKz.default).thisServiceProject)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        component: $ef6721ddad51d136$export$356a105b518990da,
        position: "right",
        content: formatMessage((0, $4mHKz.default).otherCalendarsTabTooltip),
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), null, formatMessage((0, $4mHKz.default).otherCalendarsTabTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6721ddad51d136$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "jsdSlaSettingsCalendarThisProjectTab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1N4bZ.CalendarModalMain), {
        calendarsState: calendarsState,
        calendarsActions: calendarsActions
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6721ddad51d136$var$Panel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "jsdSlaSettingsCalendarOtherCalendarsTab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6721ddad51d136$export$5906a9a8e80199b1, {
        calendarsState: (0, $2kRnk.getOtherProjectCalendarsStateWithCanCreate)(otherCalendarsState, Boolean(permissionsWithTimezoneInfo?.canCreate)),
        calendarsActions: {
            ...otherCalendarsActions,
            onSelectThisCalendarTab: onSelectThisCalendarTab,
            onCopyCalendar: onCopyCalendar
        }
    })))));
};
const $ef6721ddad51d136$export$a058e85b2ff5694d = (0, $iSEfF.withFormContextProvider)($ef6721ddad51d136$var$CalendarModalWithTwoTabsView);
const $ef6721ddad51d136$export$356a105b518990da = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6721ddad51d136$var$ReusableSlaCalendarTooltipStylesForTabsStyle, {
        ...props,
        ref: ref
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6721ddad51d136$var$ReusableSlaCalendarTooltipStylesForTabsStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4pEpX.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bpi _2rko1b66 _syaz15cr _vchh18uv _19bvu2gc _u5f31is9 _ca0qw6ab _4t3i1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f50084288d7b85a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f50084288d7b85a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStylesOld,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$442d081208938078 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStylesOld = (0, $9qnib.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $b552637a2f5925a8$var$tabListStyles : $b552637a2f5925a8$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("emR29", function(module, exports) {

$parcel$export(module.exports, "default", () => $854be789e89981e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $kgCsd = parcelRequire("kgCsd");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $854be789e89981e2$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $854be789e89981e2$export$2e2bcd8739ae039 = $854be789e89981e2$var$TabPanel;

});

parcelRegister("2kRnk", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $2a9f1d17f33d4248$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "transformResponse", () => $2a9f1d17f33d4248$export$3361e9be8093ddcc);
$parcel$export(module.exports, "getOtherProjectCalendarsStateWithCanCreate", () => $2a9f1d17f33d4248$export$e80b7a9068085d40);

var $3cieY = parcelRequire("3cieY");
const $2a9f1d17f33d4248$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/workinghours/1/internal/dialog/${projectKey}/shared`;
const $2a9f1d17f33d4248$var$transformCalendarResponseForOtherProjects = ({ workingTimes: workingTimes, holidays: holidays, ...calendarData })=>({
        ...calendarData,
        workingTimes: (0, $3cieY.mapWorkingTimesRestResponseToWorkingTimes)(workingTimes),
        holidays: (0, $3cieY.mapHolidaysRestResponseToHolidays)(holidays)
    });
const $2a9f1d17f33d4248$var$transformCalendarsResponseForOtherProjects = (request)=>request.map($2a9f1d17f33d4248$var$transformCalendarResponseForOtherProjects);
const $2a9f1d17f33d4248$export$3361e9be8093ddcc = ({ calendars: calendars, allTimezones: allTimezones, defaultTimezone: defaultTimezone, ...rest })=>({
        allTimezones: (0, $3cieY.mapTimezoneToSelectOptions)(allTimezones),
        defaultTimezone: (0, $3cieY.mapTimezoneToSelectOption)(defaultTimezone),
        calendars: $2a9f1d17f33d4248$var$transformCalendarsResponseForOtherProjects(calendars),
        ...rest
    });
const $2a9f1d17f33d4248$export$e80b7a9068085d40 = (otherCalendarsState, // Adding a new calendar/copying from other serviceDesk projects depends on this variable
canCreate)=>({
        ...otherCalendarsState,
        permissionsWithTimezoneInfo: {
            // @ts-expect-error - TS2322 - Type 'TimeZones | undefined' is not assignable to type 'TimeZones'.
            allTimezones: otherCalendarsState.permissionsWithTimezoneInfo?.allTimezones,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            dateFormat: otherCalendarsState.permissionsWithTimezoneInfo?.dateFormat,
            // @ts-expect-error - TS2322 - Type 'TimeZone | undefined' is not assignable to type 'TimeZone'.
            defaultTimezone: otherCalendarsState.permissionsWithTimezoneInfo?.defaultTimezone,
            canCreate: canCreate
        }
    });

});
parcelRegister("3cieY", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ed6464458d278fd7$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "mapTimezoneToSelectOption", () => $ed6464458d278fd7$export$5d73f74bb098c4e5);
$parcel$export(module.exports, "mapTimezoneToSelectOptions", () => $ed6464458d278fd7$export$8112c6a881820887);
$parcel$export(module.exports, "mapHolidaysRestResponseToHolidays", () => $ed6464458d278fd7$export$d7b22516b45ba564);
$parcel$export(module.exports, "mapWorkingTimesRestResponseToWorkingTimes", () => $ed6464458d278fd7$export$594b02fee19ecfb3);
$parcel$export(module.exports, "transformCalendarResponse", () => $ed6464458d278fd7$export$93f590224cfbe5ea);
$parcel$export(module.exports, "transformResponse", () => $ed6464458d278fd7$export$3361e9be8093ddcc);
$parcel$export(module.exports, "formatDate", () => $ed6464458d278fd7$export$3ae94a2503e890a1);
$parcel$export(module.exports, "sortHolidays", () => $ed6464458d278fd7$export$c8e82d80b70a6fda);
$parcel$export(module.exports, "getTimeFormatForTimePicker", () => $ed6464458d278fd7$export$409cae0f81938700);

var $ldoFd = parcelRequire("ldoFd");

var $3xcI8 = parcelRequire("3xcI8");

var $8K9kM = parcelRequire("8K9kM");

var $dbNNm = parcelRequire("dbNNm");
const $ed6464458d278fd7$export$94df0e59ebebf4a7 = (baseUrl, projectKey)=>`${baseUrl}/rest/workinghours/1/internal/dialog/${projectKey}`;
const $ed6464458d278fd7$export$5d73f74bb098c4e5 = ({ id: id, displayName: displayName })=>({
        label: displayName,
        value: id
    });
const $ed6464458d278fd7$export$8112c6a881820887 = (timezones)=>timezones.map($ed6464458d278fd7$export$5d73f74bb098c4e5);
const $ed6464458d278fd7$export$d7b22516b45ba564 = (holidaysRestResponse)=>holidaysRestResponse.map(({ recurring: recurring, ...holidayData })=>({
            ...holidayData,
            isRecurring: recurring
        }));
const $ed6464458d278fd7$export$594b02fee19ecfb3 = (workingTimesRestResponse)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    workingTimesRestResponse.reduce((workingTimesReadOnly, { weekday: weekday, start: start, end: end })=>{
        const workingTimes = workingTimesReadOnly;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(workingTimes[weekday])) workingTimes[weekday] = [];
        workingTimes[weekday].push({
            start: (0, $dbNNm.toReadableHours)(start),
            end: (0, $dbNNm.toReadableHours)(end)
        });
        return workingTimes;
    }, {});
const $ed6464458d278fd7$export$93f590224cfbe5ea = ({ workingTimes: workingTimes, holidays: holidays, ...calendarData })=>({
        ...calendarData,
        workingTimes: $ed6464458d278fd7$export$594b02fee19ecfb3(workingTimes),
        holidays: $ed6464458d278fd7$export$d7b22516b45ba564(holidays)
    });
const $ed6464458d278fd7$export$78768b73d09a0878 = (request)=>request.map($ed6464458d278fd7$export$93f590224cfbe5ea);
const $ed6464458d278fd7$export$3361e9be8093ddcc = ({ calendars: calendars, allTimezones: allTimezones, defaultTimezone: defaultTimezone, ...rest })=>({
        allTimezones: $ed6464458d278fd7$export$8112c6a881820887(allTimezones),
        defaultTimezone: $ed6464458d278fd7$export$5d73f74bb098c4e5(defaultTimezone),
        calendars: $ed6464458d278fd7$export$78768b73d09a0878(calendars),
        ...rest
    });
const $ed6464458d278fd7$export$3ae94a2503e890a1 = ({ iso8601Date: iso8601Date, locale: locale, isRecurring: isRecurring, message: message })=>{
    // date-fns doesn't support long localized date without year (https://date-fns.org/v2.27.0/docs/format)
    const pattern = isRecurring ? 'dd MMM' : 'PP';
    // If iso8601Date is undefined, new Date(iso8601Date) will throw an error. moment.js returns current date in such a scenario.
    // Required for cypress tests. In a normal scenario, iso8601Date will never be undefined.
    const parsedDate = iso8601Date ? (0, $3xcI8.default)(iso8601Date) : new Date();
    const localizedDate = (0, $8K9kM.formatWithLocale)(parsedDate, pattern, locale);
    return isRecurring ? `${message} ${localizedDate}` : `${localizedDate}`;
};
const $ed6464458d278fd7$export$c8e82d80b70a6fda = (holidays)=>{
    // Recurring holidays on top, sorted by only mm-dd part
    const recurringHolidays = holidays.filter((holiday)=>holiday.isRecurring).sort((a, b)=>a.iso8601Date.substring(5).localeCompare(b.iso8601Date.substring(5)));
    const singleDayHolidays = holidays.filter((holiday)=>!holiday.isRecurring).sort((a, b)=>a.iso8601Date.localeCompare(b.iso8601Date));
    return [
        ...recurringHolidays,
        ...singleDayHolidays
    ];
};
const $ed6464458d278fd7$export$3ea034d13be8aaed = 'HH:mm';
const $ed6464458d278fd7$export$121588a32c261ed2 = 'en_US';
const $ed6464458d278fd7$export$409cae0f81938700 = (locale)=>locale === $ed6464458d278fd7$export$121588a32c261ed2 ? $ed6464458d278fd7$export$3ea034d13be8aaed : null;

});
parcelRegister("dbNNm", function(module, exports) {

$parcel$export(module.exports, "toMilliseconds", () => $c7e96537bfbd2cf7$export$8f767fa607839182);
$parcel$export(module.exports, "toReadableHours", () => $c7e96537bfbd2cf7$export$6d3b5f2fee3517b4);
$parcel$export(module.exports, "isEmpty", () => $c7e96537bfbd2cf7$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isInvalidFormat", () => $c7e96537bfbd2cf7$export$825ac276deecb860);
$parcel$export(module.exports, "parseTime", () => $c7e96537bfbd2cf7$export$c9698ec7f05a07e1);

var $ldoFd = parcelRequire("ldoFd");

var $5YjhU = parcelRequire("5YjhU");

var $gDsgM = parcelRequire("gDsgM");
const $c7e96537bfbd2cf7$export$8f767fa607839182 = (time)=>{
    // time is in hh:mm format. Don't need a date-time utility to convert that to ms
    const [hours, minutes] = time.split(':');
    return (parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60) * 1000;
};
const $c7e96537bfbd2cf7$var$twoDigitPad = (time)=>{
    if (time < 10) return `0${time}`;
    return `${time}`;
};
const $c7e96537bfbd2cf7$export$6d3b5f2fee3517b4 = (timeInMilliseconds)=>{
    const hour = Math.floor(timeInMilliseconds / 3600000);
    const minutes = Math.floor(timeInMilliseconds % 3600000 / 60000);
    const hourString = $c7e96537bfbd2cf7$var$twoDigitPad(hour);
    const minutesString = $c7e96537bfbd2cf7$var$twoDigitPad(minutes);
    return `${hourString}:${minutesString}`;
};
const $c7e96537bfbd2cf7$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) || value.trim().length < 1;
const $c7e96537bfbd2cf7$export$825ac276deecb860 = (value)=>value === (0, $gDsgM.INVALID_DATE);
const $c7e96537bfbd2cf7$export$c9698ec7f05a07e1 = (inputTime)=>{
    // Extract time units from the input string
    const time = inputTime.replace(/^\D*(?<hour>\d{1,2})[:.-]?(?<minute>\d{1,2})?\s?(?<period>a|p|A|P)?.*$/, (input, ...args)=>{
        const { hour: hour, minute: minute = '00', period: period = '' } = args[args.length - 1];
        return `${hour}:${minute}${period}`;
    });
    // get the parse format based on whether the time has a period (am/pm)
    const format = /^.*[apAP]$/.test(time) ? 'h:mma' : 'H:mm';
    return (0, $5YjhU.default)(time, format, new Date());
};

});



parcelRegister("1N4bZ", function(module, exports) {

$parcel$export(module.exports, "CalendarModalMain", () => $190c90b60578188d$export$80c0c5a6daeb3dc1);
$parcel$export(module.exports, "CalendarContainer", () => $190c90b60578188d$export$946daa762919616e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $foc4i = parcelRequire("foc4i");

var $2Ba2b = parcelRequire("2Ba2b");

var $6vO9v = parcelRequire("6vO9v");

var $kgQcB = parcelRequire("kgQcB");

var $j1QRq = parcelRequire("j1QRq");
const $190c90b60578188d$export$80c0c5a6daeb3dc1 = ({ calendarsState: calendarsState, calendarsActions: calendarsActions })=>{
    const { isLoading: isLoading, isError: isError, permissionsWithTimezoneInfo: permissionsWithTimezoneInfo, calendars: calendars, selectedCalendarMode: selectedCalendarMode, selectedCalendarId: selectedCalendarId, copyCalendarData: copyCalendarData } = calendarsState;
    if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.GenericError), null);
    if (isLoading || !permissionsWithTimezoneInfo || !calendars) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": "servicedesk-sla-settings.ui.calendars.calendar-modal"
    }, selectedCalendarMode === (0, $6vO9v.NEW_MODE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($190c90b60578188d$export$946daa762919616e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgQcB.CalendarForm), {
        allTimezones: permissionsWithTimezoneInfo.allTimezones,
        defaultTimezone: permissionsWithTimezoneInfo.defaultTimezone,
        onCancel: calendarsActions.onReset,
        onEditCalendarSuccessful: calendarsActions.onEditCalendarSuccessful,
        calendarMode: selectedCalendarMode
    })), // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"view" | "new" | "edit" | "collapsed"' and '"clone"' have no overlap.
    (selectedCalendarMode === (0, $6vO9v.COPY_MODE) || selectedCalendarMode === (0, $6vO9v.CLONE_MODE)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($190c90b60578188d$export$946daa762919616e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgQcB.CalendarForm), {
        calendarData: copyCalendarData,
        allTimezones: permissionsWithTimezoneInfo.allTimezones,
        defaultTimezone: permissionsWithTimezoneInfo.defaultTimezone,
        onCancel: calendarsActions.onReset,
        onEditCalendarSuccessful: calendarsActions.onEditCalendarSuccessful,
        calendarMode: selectedCalendarMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1QRq.CalendarList), {
        selectedCalendarId: selectedCalendarId,
        calendars: calendars,
        permissionsWithTimezone: permissionsWithTimezoneInfo,
        selectedCalendarMode: selectedCalendarMode,
        calendarsActions: calendarsActions
    }));
};
const $190c90b60578188d$export$946daa762919616e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _19it13y8 _vchhusvi _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kgQcB", function(module, exports) {

$parcel$export(module.exports, "CalendarForm", () => $5104d5f4d5bfccf9$export$7c0370771352ef5a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $jG2Eu = parcelRequire("jG2Eu");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $6vO9v = parcelRequire("6vO9v");

var $1QELq = parcelRequire("1QELq");

var $3J0Lj = parcelRequire("3J0Lj");

var $dFULG = parcelRequire("dFULG");

var $dXthl = parcelRequire("dXthl");

var $6EG0S = parcelRequire("6EG0S");

var $iSEfF = parcelRequire("iSEfF");

var $jdYrL = parcelRequire("jdYrL");

var $bMyQV = parcelRequire("bMyQV");

var $8iHBM = parcelRequire("8iHBM");

var $4AxHa = parcelRequire("4AxHa");

var $f4eYG = parcelRequire("f4eYG");

var $i5S2d = parcelRequire("i5S2d");

var $brZeL = parcelRequire("brZeL");

var $dJzRM = parcelRequire("dJzRM");

var $6QUhf = parcelRequire("6QUhf");
const $5104d5f4d5bfccf9$export$6b0d0dcb2efcbe06 = ({ calendarData: calendarData, defaultTimezone: defaultTimezone, allTimezones: allTimezones, onCancel: onCancel, onEditCalendarSuccessful: onEditCalendarSuccessful, calendarMode: calendarMode, intl: { formatMessage: formatMessage } })=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const { id: id, name: name, timezoneId: timezoneId, holidays: initialHolidays, context: context, deletable: deletable, workingTimes: workingTimes, serviceDeskName: serviceDeskName, projectKey: OtherCalendarProjectKey } = calendarData || (0, $6EG0S.DEFAULT_CALENDAR_DATA);
    let actualProjectKey;
    let calendarNameInForm;
    switch(calendarMode){
        case 0, $6vO9v.COPY_MODE:
            calendarNameInForm = formatMessage((0, $dJzRM.default).otherProjectCalendarsCopy, {
                calendarName: name,
                serviceDeskName: serviceDeskName
            });
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
            actualProjectKey = projectKey;
            break;
        case 0, $6vO9v.CLONE_MODE:
            calendarNameInForm = formatMessage((0, $dJzRM.default).currentProjectCalendarsCopy, {
                calendarName: name
            });
            // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
            actualProjectKey = projectKey;
            break;
        // @ts-expect-error - TS2678 - Type '"other_project_calendars_edit_mode"' is not comparable to type 'Mode'.
        case 0, $6vO9v.OTHER_PROJECT_CALENDARS_EDIT_MODE:
            // We need to change the projectKey if it does not belong to the current project
            calendarNameInForm = name;
            actualProjectKey = OtherCalendarProjectKey;
            break;
        default:
            calendarNameInForm = name; // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Type 'string | undefined' is not assignable to type 'string'.
            actualProjectKey = projectKey;
            break;
    }
    const { calendarSaveFailedFlag: calendarSaveFailedFlag } = (0, $dFULG.useSLAConfigActionsFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const [{ loading: loading, error: error }, { fetch: fetch }] = (0, $bMyQV.useSaveCalendarService)(baseUrl, actualProjectKey);
    const [{ isFormDirty: isFormDirty, getNextCalendarActionCallback: getNextCalendarActionCallback }] = (0, $iSEfF.useFormContext)();
    const formRef = (0, $eUqFw.useRef)(null);
    const isCopied = calendarMode === (0, $6vO9v.COPY_MODE) || calendarMode === (0, $6vO9v.CLONE_MODE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const holidaysRef = (0, $eUqFw.useRef)(initialHolidays);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setHolidaysRef = (updatedHolidays)=>{
        holidaysRef.current = updatedHolidays;
    };
    const onSubmit = (0, $eUqFw.useCallback)(async (formData)=>{
        const holidaysPayload = holidaysRef.current.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ({ name: holidayName, iso8601Date: iso8601Date, isRecurring: isRecurring })=>({
                name: holidayName,
                iso8601Date: iso8601Date,
                recurring: isRecurring
            }));
        const payloadWithoutHolidays = (0, $brZeL.getSaveRequestPayload)(id, context, formData, isCopied);
        const payload = {
            ...payloadWithoutHolidays,
            holidays: holidaysPayload
        };
        const savedCalendarData = await fetch(payload, calendarMode);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(savedCalendarData)) onEditCalendarSuccessful({
            ...savedCalendarData,
            serviceDeskName: serviceDeskName,
            projectKey: actualProjectKey
        });
        else // Show the warning flag saying the save was unsuccessful
        calendarSaveFailedFlag();
        getNextCalendarActionCallback();
    }, [
        actualProjectKey,
        calendarMode,
        calendarSaveFailedFlag,
        context,
        fetch,
        getNextCalendarActionCallback,
        holidaysRef,
        id,
        isCopied,
        onEditCalendarSuccessful,
        serviceDeskName
    ]);
    const onCancelWithNextCalendarActionCallback = ()=>{
        onCancel();
        getNextCalendarActionCallback(); // Call the nextCalendarAction callback method
    };
    const saveMetricFromBlockerModal = (0, $eUqFw.useCallback)(()=>{
        if (formRef.current !== null) // https://github.com/final-form/react-final-form/blob/master/docs/faq.md#how-can-i-trigger-a-submit-from-outside-my-form
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        formRef.current.dispatchEvent(new Event('submit', {
            cancelable: true
        }));
    }, []);
    const [{ data: costData, error: costError, loading: costLoading }, { fetch: fetchCost }] = // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $jdYrL.useRecalculationCostService)(baseUrl, projectKey);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!costLoading && !costError && !costData) await fetchCost();
        };
        fetchData();
    }, [
        costData,
        costError,
        fetchCost,
        costLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'editSlaCalendar viewed');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, dirty: dirty, getValues: getFormValues })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            ref: formRef,
            "data-testid": "servicedesk-sla-settings.ui.calendars.editable.ak-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5104d5f4d5bfccf9$var$Spaced, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AxHa.NameField), {
            defaultName: calendarNameInForm
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4eYG.TimezoneField), {
            defaultTimeZone: defaultTimezone,
            options: allTimezones,
            selectedTimeZoneId: timezoneId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5S2d.WorkWeek), {
            workingTimes: workingTimes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8iHBM.Holidays), {
            list: holidaysRef.current,
            getFormValues: getFormValues,
            setHolidays: setHolidaysRef
        }), deletable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3J0Lj.RecalculationWarning), {
            data: costData,
            error: costError,
            loading: costLoading
        }), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, (0, $dXthl.getValidationErrorMessage)(error) || formatMessage((0, $dJzRM.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QELq.Footer), {
            type: "submit",
            onCancel: onCancel,
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            isLoading: loading
        }), (isFormDirty || dirty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6QUhf.NavBlocker), {
            onDiscard: onCancelWithNextCalendarActionCallback,
            onSave: saveMetricFromBlockerModal
        }))));
};
const $5104d5f4d5bfccf9$export$7c0370771352ef5a = (0, $giAhk.injectIntlV2)($5104d5f4d5bfccf9$export$6b0d0dcb2efcbe06); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5104d5f4d5bfccf9$var$Spaced = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _19it5zp0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6EG0S", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CALENDAR_DATA", () => $d27fd40ad9f3d011$export$d87585de303c3507);

var $dbNNm = parcelRequire("dbNNm");
const $d27fd40ad9f3d011$var$DEFAULT_START_TIME = (0, $dbNNm.toReadableHours)(32400000);
const $d27fd40ad9f3d011$var$DEFAULT_END_TIME = (0, $dbNNm.toReadableHours)(61200000);
const $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES = [
    {
        start: $d27fd40ad9f3d011$var$DEFAULT_START_TIME,
        end: $d27fd40ad9f3d011$var$DEFAULT_END_TIME
    }
];
const $d27fd40ad9f3d011$export$1dc8946932fd9b75 = {
    monday: $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES,
    tuesday: $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES,
    wednesday: $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES,
    thursday: $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES,
    friday: $d27fd40ad9f3d011$var$DEFAULT_START_AND_END_WORKING_TIMES
};
const $d27fd40ad9f3d011$export$d87585de303c3507 = {
    id: undefined,
    name: '',
    timezoneId: undefined,
    holidays: undefined,
    workingTimes: $d27fd40ad9f3d011$export$1dc8946932fd9b75
};

});

parcelRegister("bMyQV", function(module, exports) {

$parcel$export(module.exports, "useSaveCalendarService", () => $06dc035bafd5f50f$export$2b108bc677bae2d4);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $3cieY = parcelRequire("3cieY");

var $gSBHV = parcelRequire("gSBHV");
const $06dc035bafd5f50f$export$2b108bc677bae2d4 = (baseUrl, projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [data, setData] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async (saveCalendarRequest, calendarMode)=>{
        setLoading(true);
        setError(null);
        // existing calendar will use calendar id which is passed down to put api request
        // new calendar doesn't have calendar id app will perform post request for new calendar.
        const asyncRequest = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(saveCalendarRequest.id) ? (0, $fV97Z.performPostRequest) : (0, $fV97Z.performPutRequest);
        try {
            const response = await asyncRequest((0, $gSBHV.getUrl)(baseUrl, projectKey, saveCalendarRequest.id), {
                body: JSON.stringify(saveCalendarRequest)
            });
            const formattedResponse = (0, $3cieY.transformCalendarResponse)(response);
            setData(formattedResponse);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `slaCalendar ${(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(saveCalendarRequest.id) ? 'created' : 'updated'}`, {
                calendarMode: calendarMode,
                holidayCount: formattedResponse.holidays.filter((holiday)=>!holiday.isRecurring).length,
                recurringHolidayCount: formattedResponse.holidays.filter((holiday)=>holiday.isRecurring).length
            });
            return formattedResponse;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useSaveCalendarService',
                packageName: 'jiraServicedeskSlaSettings',
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    calendarMode: calendarMode
                }
            });
            return undefined;
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        projectKey,
        createAnalyticsEvent
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Data'.
            data
        },
        {
            fetch: fetch
        }
    ];
};

});
parcelRegister("gSBHV", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $5ad5c32117b78b12$export$94df0e59ebebf4a7);

var $ldoFd = parcelRequire("ldoFd");
const $5ad5c32117b78b12$export$94df0e59ebebf4a7 = (baseUrl, projectKey, calendarId)=>{
    const defaultUrl = `${baseUrl}/rest/workinghours/1/api/calendar/${projectKey}`;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(calendarId)) return `${defaultUrl}?operation=calendarCreate`;
    return `${defaultUrl}/${calendarId}?operation=calendarUpdate`;
};

});


parcelRegister("8iHBM", function(module, exports) {

$parcel$export(module.exports, "Holidays", () => $be55bb5665ff959a$export$45c7d0ed80d3e6b9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $flFqI = parcelRequire("flFqI");

var $7yDts = parcelRequire("7yDts");

var $kKZNo = parcelRequire("kKZNo");

var $hpeHR = parcelRequire("hpeHR");

var $8ruzl = parcelRequire("8ruzl");

var $hrouH = parcelRequire("hrouH");
const $be55bb5665ff959a$var$HolidaysView = ({ intl: { formatMessage: formatMessage }, list: list, getFormValues: getFormValues, setHolidays: setHolidays })=>{
    const [{ holidays: holidays }, { onAdd: onAdd, onRemove: onRemove, onSave: onSave, onImport: onImport }] = (0, $hrouH.useHolidaysState)(list, getFormValues);
    (0, $eUqFw.useEffect)(()=>{
        setHolidays(holidays);
    }, [
        holidays
    ]);
    // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Header), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, " ", formatMessage((0, $8ruzl.default).holidays), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be55bb5665ff959a$var$AddButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpeHR.ImportCalendar), {
        onImport: onImport
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7yDts.Add), {
        onAdd: onAdd
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8ruzl.default).holidaysDescription), formatMessage((0, $8ruzl.default).importHolidaysDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), Boolean(holidays.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be55bb5665ff959a$var$HeaderRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be55bb5665ff959a$var$HeaderLabel, null, formatMessage((0, $8ruzl.default).name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be55bb5665ff959a$var$HeaderLabel, null, formatMessage((0, $8ruzl.default).date)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be55bb5665ff959a$var$HeaderLabel, null, formatMessage((0, $8ruzl.default).frequency))), holidays.map(({ name: name, iso8601Date: iso8601Date, isRecurring: isRecurring = false, fieldId: fieldId, isNew: isNew })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKZNo.Holiday), {
            key: fieldId,
            fieldId: fieldId,
            defaultName: name,
            defaultDate: iso8601Date,
            isRecurring: isRecurring,
            isNew: Boolean(isNew),
            onRemove: onRemove,
            onSave: onSave
        }))));
};
const $be55bb5665ff959a$export$45c7d0ed80d3e6b9 = (0, $giAhk.injectIntlV2)($be55bb5665ff959a$var$HolidaysView);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be55bb5665ff959a$var$AddButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $be55bb5665ff959a$var$HeaderRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _727qftgi _yv0e1u50 _6a6zv2br _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $be55bb5665ff959a$var$HeaderLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _k48p8n31",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7yDts", function(module, exports) {

$parcel$export(module.exports, "Add", () => $75b8b4a59791cb8b$export$d0265b2c425512d6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $g4vPR = parcelRequire("g4vPR");
const $75b8b4a59791cb8b$var$AddView = ({ onAdd: onAdd })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.calendars.editable.fields.holidays.add.button",
        appearance: "link",
        onClick: (e, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'newAddHolidayButton');
            onAdd();
        }
    }, formatMessage((0, $g4vPR.default).addNew));
};
const $75b8b4a59791cb8b$export$d0265b2c425512d6 = $75b8b4a59791cb8b$var$AddView;

});
parcelRegister("g4vPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c967e04b4f78bd6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c967e04b4f78bd6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    add: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.add.add",
        "defaultMessage": "Add holiday"
    },
    addNew: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.add.add-new",
        "defaultMessage": "Add new"
    }
});

});


parcelRegister("kKZNo", function(module, exports) {

$parcel$export(module.exports, "Holiday", () => $d410acaccad9c070$export$5b294b506fa24869);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $NqqMP = parcelRequire("NqqMP");

var $gDsgM = parcelRequire("gDsgM");

var $1QELq = parcelRequire("1QELq");

var $eEwzU = parcelRequire("eEwzU");

var $fNBhF = parcelRequire("fNBhF");

var $bQAf5 = parcelRequire("bQAf5");

var $19n9k = parcelRequire("19n9k");

var $aO1DU = parcelRequire("aO1DU");
const $d410acaccad9c070$export$3e49a15998c929e5 = (0, $4LhB6.default);
const $d410acaccad9c070$export$5b294b506fa24869 = ({ fieldId: fieldId, isRecurring: isRecurring, defaultDate: defaultDate, defaultName: defaultName, isNew: isNew, onRemove: onRemove, onSave: onSave })=>{
    const [fieldState, setFieldState] = (0, $eUqFw.useState)(isNew ? (0, $gDsgM.NEW) : (0, $gDsgM.EXISTING));
    const [isEditing, onToggleEditing] = (0, $NqqMP.usePopupController)(isNew);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onValidate = (0, $eUqFw.useCallback)((0, $aO1DU.getValidateFunction)(fieldId), [
        fieldId
    ]);
    const onCancel = ()=>{
        if (fieldState === (0, $gDsgM.NEW)) onRemove(fieldId);
        else onToggleEditing();
    };
    const onSaveHoliday = ()=>{
        if (fieldState === (0, $gDsgM.NEW)) setFieldState((0, $gDsgM.NEW_AND_MODIFIED));
        else setFieldState((0, $gDsgM.EXISTING_AND_MODIFIED));
        onSave(fieldId);
        onToggleEditing();
    };
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d410acaccad9c070$var$EditViewContainer, {
        "data-test-id": "servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d410acaccad9c070$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQAf5.Name), {
        fieldId: fieldId,
        defaultName: defaultName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEwzU.DateField), {
        fieldId: fieldId,
        defaultDate: defaultDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNBhF.Frequency), {
        fieldId: fieldId,
        isRecurring: isRecurring
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: `${(0, $gDsgM.HOLIDAY_VALIDATION_STATE_PREFIX)}${fieldId}`,
        validate: onValidate
    }, ({ valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QELq.Footer), {
            isDisabled: !valid,
            isSecondary: true,
            onCancel: onCancel,
            onSave: onSaveHoliday
        })), fieldState !== (0, $gDsgM.NEW) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d410acaccad9c070$export$3e49a15998c929e5, {
        name: `${(0, $gDsgM.HOLIDAY_PREFIX)}${fieldId}`,
        defaultValue: {
            defaultName: defaultName,
            defaultDate: defaultDate,
            isRecurring: isRecurring
        }
    }, ()=>null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19n9k.ReadOnlyViewWithActions), {
        fieldId: fieldId,
        defaultName: defaultName,
        defaultDate: defaultDate,
        isRecurring: isRecurring,
        onEditRequested: onToggleEditing,
        onRemove: ()=>onRemove(fieldId)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $d410acaccad9c070$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _yv0e16hb _727qftgi",
            __cmplp.className
        ])
    });
});
const $d410acaccad9c070$var$EditViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8wo40 _1yt4u2gc _16qszucj _11q7hp5a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eEwzU", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $929cd49e9c6f71c6$export$d9781c7894a82487);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $jXg8H = parcelRequire("jXg8H");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $giAhk = parcelRequire("giAhk");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $gDsgM = parcelRequire("gDsgM");

var $aeKh1 = parcelRequire("aeKh1");

var $0wfQF = parcelRequire("0wfQF");
const $929cd49e9c6f71c6$export$b3c5000c67f1589e = ({ intl: { formatMessage: formatMessage }, fieldId: fieldId, defaultDate: defaultDate, useLocale: useLocale = (0, $4xHig.useLocale) })=>{
    const locale = useLocale().replace('_', '-');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: `${(0, $gDsgM.HOLIDAY_DATE_PREFIX)}${fieldId}`,
        label: formatMessage((0, $aeKh1.default).date),
        defaultValue: defaultDate,
        // @ts-expect-error - TS2322 - Type '(date: string) => string | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
        validate: (0, $0wfQF.validateDate)
    }, ({ fieldProps: { value: value, onChange: onChange }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
            locale: locale,
            defaultValue: value ? (0, $8K9kM.formatWithLocale)((0, $3xcI8.default)(value), 'yyyy-MM-dd', locale) : value,
            onChange: (selectedValue)=>{
                onChange(selectedValue);
            },
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
            isInvalid: error,
            testId: "servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday.date"
        }), error === (0, $gDsgM.EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $aeKh1.default).emptyDate)), error === (0, $gDsgM.INVALID_DATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $aeKh1.default).invalidDate))));
};
const $929cd49e9c6f71c6$export$d9781c7894a82487 = (0, $giAhk.injectIntlV2)($929cd49e9c6f71c6$export$b3c5000c67f1589e);

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $aYOOX = parcelRequire("aYOOX");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = "platform-pkg";
const $a38f1e4301a686fa$var$packageVersion = "0.0.0-use.local";
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $aYOOX.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $aYOOX.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $aYOOX.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, disabled: disabled, disabledDateFilter: disabledDateFilter, hideIcon: hideIcon = false, icon: // TODO: Resolve this typing to be more intuitive
        icon = (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $aYOOX.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $aYOOX.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        })));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $a38f1e4301a686fa$var$DatePicker = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = $a38f1e4301a686fa$var$DatePicker;

});
parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("aYOOX", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $be48f7c2ad85fcf1$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $be48f7c2ad85fcf1$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $be48f7c2ad85fcf1$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $be48f7c2ad85fcf1$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $EN9B6 = parcelRequire("EN9B6");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $jP55W = parcelRequire("jP55W");

var $7i5dr = parcelRequire("7i5dr");
const $be48f7c2ad85fcf1$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $be48f7c2ad85fcf1$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
    return newIso;
};
const $be48f7c2ad85fcf1$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
    return l10n.parseDate(date);
};
const $be48f7c2ad85fcf1$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
    const date = (0, $3xcI8.default)(value);
    return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $7i5dr.placeholderDatetime));
};

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $knRXm = parcelRequire("knRXm");


var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $c845995965375b9a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $3xcI8.default)(iso);
        return (0, $7ueqz.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $c845995965375b9a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $knRXm.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $ki32l = parcelRequire("ki32l");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $ki32l.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});



parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("aeKh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac0fcd34e03b7cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3ac0fcd34e03b7cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    date: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.date",
        "defaultMessage": "Date"
    },
    placeholder: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.placeholder",
        "defaultMessage": "DD/MM/YY"
    },
    emptyDate: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.empty-date",
        "defaultMessage": "Please provide a date"
    },
    invalidDate: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.date.invalid-date",
        "defaultMessage": "Invalid date format"
    }
});

});

parcelRegister("0wfQF", function(module, exports) {

$parcel$export(module.exports, "validateDate", () => $64f12797a1774ddf$export$ffb3d0046ef3a2);

var $gDsgM = parcelRequire("gDsgM");

var $dbNNm = parcelRequire("dbNNm");
const $64f12797a1774ddf$export$ffb3d0046ef3a2 = (date)=>{
    if ((0, $dbNNm.isEmpty)(date)) return 0, $gDsgM.EMPTY;
    if ((0, $dbNNm.isInvalidFormat)(date)) return 0, $gDsgM.INVALID_DATE;
    return undefined;
};

});


parcelRegister("fNBhF", function(module, exports) {

$parcel$export(module.exports, "Frequency", () => $fdab3e4d1770469b$export$44c95d3770756ed2);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $giAhk = parcelRequire("giAhk");

var $gDsgM = parcelRequire("gDsgM");

var $isEMg = parcelRequire("isEMg");
const $fdab3e4d1770469b$export$eadf8e8ae2f9e0c9 = ({ intl: { formatMessage: formatMessage }, fieldId: fieldId, isRecurring: isRecurring = true })=>{
    const frequencyOptions = [
        {
            label: formatMessage((0, $isEMg.default).annually),
            value: true
        },
        {
            label: formatMessage((0, $isEMg.default).oneTime),
            value: false
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: `${(0, $gDsgM.HOLIDAY_FREQUENCY_PREFIX)}${fieldId}`,
        label: formatMessage((0, $isEMg.default).frequency),
        defaultValue: frequencyOptions.find(({ value: value })=>value === isRecurring)
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...rest,
            options: frequencyOptions
        }));
};
const $fdab3e4d1770469b$export$44c95d3770756ed2 = (0, $giAhk.injectIntlV2)($fdab3e4d1770469b$export$eadf8e8ae2f9e0c9);

});
parcelRegister("isEMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9b4f47ece81629$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c9b4f47ece81629$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    repeat: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.repeat",
        "defaultMessage": "Repeat"
    },
    eachYear: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.each-year",
        "defaultMessage": "Each year"
    },
    never: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.never",
        "defaultMessage": "Never"
    },
    frequency: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.frequency",
        "defaultMessage": "Frequency"
    },
    annually: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.annually",
        "defaultMessage": "Annually"
    },
    oneTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.frequency.one-time",
        "defaultMessage": "One time"
    }
});

});


parcelRegister("bQAf5", function(module, exports) {

$parcel$export(module.exports, "Name", () => $fbbd0c76acda28a9$export$c7bd411105e2dec3);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gDsgM = parcelRequire("gDsgM");

var $dcCJR = parcelRequire("dcCJR");

var $02ci8 = parcelRequire("02ci8");
const $fbbd0c76acda28a9$export$fde3f816bbb2f967 = ({ fieldId: fieldId, defaultName: defaultName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: `${(0, $gDsgM.HOLIDAY_NAME_PREFIX)}${fieldId}`,
        label: formatMessage((0, $dcCJR.default).name),
        defaultValue: defaultName,
        // @ts-expect-error - TS2322 - Type '(name: string) => string | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
        validate: (0, $02ci8.validateName)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            maxLength: 63
        }), error === (0, $gDsgM.EMPTY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $dcCJR.default).empty))));
};
const $fbbd0c76acda28a9$export$c7bd411105e2dec3 = $fbbd0c76acda28a9$export$fde3f816bbb2f967;

});
parcelRegister("dcCJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79e21a586d6d0fa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a79e21a586d6d0fa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.name.name",
        "defaultMessage": "Name"
    },
    empty: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.name.empty",
        "defaultMessage": "Please provide a name for the holiday"
    }
});

});

parcelRegister("02ci8", function(module, exports) {

$parcel$export(module.exports, "validateName", () => $a58e2d8bbecd61aa$export$b135c3f9b9f02308);

var $gDsgM = parcelRequire("gDsgM");

var $dbNNm = parcelRequire("dbNNm");
const $a58e2d8bbecd61aa$export$b135c3f9b9f02308 = (name)=>{
    if ((0, $dbNNm.isEmpty)(name)) return 0, $gDsgM.EMPTY;
    return undefined;
};

});


parcelRegister("19n9k", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyViewWithActions", () => $1a2bf876f0f77030$export$b79a8f07e58978b8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $giAhk = parcelRequire("giAhk");

var $4xHig = parcelRequire("4xHig");

var $gDsgM = parcelRequire("gDsgM");

var $3cieY = parcelRequire("3cieY");

var $zoMKe = parcelRequire("zoMKe");

var $CWlTs = parcelRequire("CWlTs");

var $ljPzB = parcelRequire("ljPzB");
const $1a2bf876f0f77030$var$ViewRow = ({ isRecurring: isRecurring, value: value, defaultName: defaultName, onEditRequested: onEditRequested, onRemove: onRemove, fieldId: fieldId, intl: { formatMessage: formatMessage } })=>{
    const locale = (0, $4xHig.useLocale)();
    const everyText = formatMessage((0, $CWlTs.default).every);
    const formattedDate = (0, $eUqFw.useMemo)(()=>(0, $3cieY.formatDate)({
            iso8601Date: value,
            locale: locale,
            isRecurring: isRecurring,
            message: everyText
        }), [
        everyText,
        isRecurring,
        locale,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a2bf876f0f77030$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a2bf876f0f77030$export$b04be29aa201d4f5, {
        "data-test-id": `servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday-${fieldId}.read-only-view-with-actions.name`
    }, defaultName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a2bf876f0f77030$export$b04be29aa201d4f5, {
        "data-test-id": `servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday-${fieldId}.read-only-view-with-actions.date`
    }, formattedDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a2bf876f0f77030$export$b04be29aa201d4f5, null, isRecurring ? formatMessage((0, $CWlTs.default).yearly) : formatMessage((0, $CWlTs.default).never)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zoMKe.Edit), {
        onEditRequested: onEditRequested
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ljPzB.Remove), {
        onRemove: onRemove
    }));
};
const $1a2bf876f0f77030$var$IntlViewRow = (0, $giAhk.injectIntlV2)($1a2bf876f0f77030$var$ViewRow);
const $1a2bf876f0f77030$var$ViewWithActions = ({ fieldId: fieldId, isRecurring: isRecurring, defaultDate: defaultDate, defaultName: defaultName, onEditRequested: onEditRequested, onRemove: onRemove })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: `${(0, $gDsgM.HOLIDAY_PREFIX)}${fieldId}`,
        defaultValue: {
            defaultName: defaultName,
            defaultDate: defaultDate,
            isRecurring: isRecurring
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a2bf876f0f77030$var$IntlViewRow, {
            isRecurring: isRecurring,
            defaultName: defaultName,
            value: defaultDate,
            onEditRequested: onEditRequested,
            onRemove: onRemove,
            fieldId: fieldId
        }));
const $1a2bf876f0f77030$export$b79a8f07e58978b8 = (0, $giAhk.injectIntlV2)($1a2bf876f0f77030$var$ViewWithActions); // To do use replace with flex or use flex fallback for Ie11
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a2bf876f0f77030$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _727qftgi _yv0e1u50 _6a6zv2br _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1a2bf876f0f77030$export$b04be29aa201d4f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("zoMKe", function(module, exports) {

$parcel$export(module.exports, "Edit", () => $33fedf4992622b3f$export$6ed0965c9443aaa6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $89sIt = parcelRequire("89sIt");

var $giAhk = parcelRequire("giAhk");

var $8FKEt = parcelRequire("8FKEt");
const $33fedf4992622b3f$var$EditView = ({ intl: { formatMessage: formatMessage }, onEditRequested: onEditRequested })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.edit.button",
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($89sIt))), {
            size: "small",
            label: formatMessage((0, $8FKEt.default).edit)
        }),
        onClick: onEditRequested
    });
const $33fedf4992622b3f$export$6ed0965c9443aaa6 = (0, $giAhk.injectIntlV2)($33fedf4992622b3f$var$EditView);

});
parcelRegister("89sIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef570750d61ee3c$var$_react = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5ef570750d61ee3c$var$_edit = $5ef570750d61ee3c$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $5ef570750d61ee3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5ef570750d61ee3c$var$EditFilledIcon = (props)=>/*#__PURE__*/ $5ef570750d61ee3c$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $5ef570750d61ee3c$var$_edit.default
    }));
$5ef570750d61ee3c$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $5ef570750d61ee3c$var$_default = module.exports.default = $5ef570750d61ee3c$var$EditFilledIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});


parcelRegister("8FKEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7973c29943fd2eea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7973c29943fd2eea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    edit: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.edit.edit",
        "defaultMessage": "Edit holiday"
    }
});

});


parcelRegister("CWlTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0fb77cb6eb48cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3b0fb77cb6eb48cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    every: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.every",
        "defaultMessage": "Every"
    },
    yearly: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.yearly",
        "defaultMessage": "Annually"
    },
    never: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.never",
        "defaultMessage": "One Time"
    }
});

});

parcelRegister("ljPzB", function(module, exports) {

$parcel$export(module.exports, "Remove", () => $c9c319a2ca16efaa$export$6072865765515195);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $je5kZ = parcelRequire("je5kZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hmPUs = parcelRequire("hmPUs");
const $c9c319a2ca16efaa$var$RemoveView = ({ onRemove: onRemove })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.remove.button",
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: ""
        }),
        onClick: onRemove,
        "aria-label": formatMessage((0, $hmPUs.default).remove)
    });
};
const $c9c319a2ca16efaa$export$6072865765515195 = $c9c319a2ca16efaa$var$RemoveView;

});
parcelRegister("hmPUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a92a958f6618e0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $12a92a958f6618e0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remove: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.remove.remove",
        "defaultMessage": "Remove holiday"
    }
});

});



parcelRegister("aO1DU", function(module, exports) {

$parcel$export(module.exports, "getValidateFunction", () => $656539a146a9ccf5$export$3651b4299a915f80);

var $1ofJH = parcelRequire("1ofJH");

var $0wfQF = parcelRequire("0wfQF");

var $02ci8 = parcelRequire("02ci8");
const $656539a146a9ccf5$export$1b6d16b921850f9d = (holidayName, holidayDate)=>(0, $02ci8.validateName)(holidayName) || (0, $0wfQF.validateDate)(holidayDate);
const $656539a146a9ccf5$export$3651b4299a915f80 = (fieldId)=>(unUsedValue, formData)=>{
        const { name: name, iso8601Date: iso8601Date } = (0, $1ofJH.getFormHolidayValuesById)(fieldId, formData);
        return $656539a146a9ccf5$export$1b6d16b921850f9d(name, iso8601Date);
    };

});
parcelRegister("1ofJH", function(module, exports) {

$parcel$export(module.exports, "getFormHolidayValuesById", () => $630f62bafade2067$export$1c950b70353cc4b8);

var $gDsgM = parcelRequire("gDsgM");
const $630f62bafade2067$export$1c950b70353cc4b8 = (fieldId, formData)=>{
    const name = formData[`${0, $gDsgM.HOLIDAY_NAME_PREFIX}${fieldId}`];
    const iso8601Date = formData[`${0, $gDsgM.HOLIDAY_DATE_PREFIX}${fieldId}`];
    const frequency = formData[`${0, $gDsgM.HOLIDAY_FREQUENCY_PREFIX}${fieldId}`];
    return {
        fieldId: fieldId,
        name: name,
        iso8601Date: iso8601Date,
        isRecurring: frequency?.value
    };
};

});



parcelRegister("hpeHR", function(module, exports) {

$parcel$export(module.exports, "ImportCalendar", () => $f7ea88c62d8ceda7$export$f8dac7d33e8e07c3);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $dFULG = parcelRequire("dFULG");

var $7to8U = parcelRequire("7to8U");

var $6a4KC = parcelRequire("6a4KC");
const $f7ea88c62d8ceda7$var$ImportCalendarView = ({ intl: { formatMessage: formatMessage }, onImport: onImport })=>{
    const fileUploadInput = (0, $eUqFw.useRef)(null);
    const actionFlags = (0, $dFULG.useSLAConfigActionsFlags)();
    const flagMap = {
        SUCCESS: actionFlags.calendarImportSuccessFlag,
        FAILURE: actionFlags.calendarImportParserFailureFlag,
        PARTIAL_SUCCESS: actionFlags.calendarImportPartialFailureFlag
    };
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const [{ loading: loading }, { parseIcsFile: parseIcsFile }] = (0, $7to8U.useParseIcsService)(baseUrl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const browse = (event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'importIcs');
        fileUploadInput.current?.click();
    };
    const handleFileChange = async (event)=>{
        if (!event.target.files) return;
        const file = event.target.files[0];
        const response = await parseIcsFile(file);
        if (!response) {
            actionFlags.calendarImportParserServerFailureFlag();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'icsFile parsed', 'editCalendar', {
                status: 'SERVER_FAILURE'
            });
            return;
        }
        flagMap[response.status]();
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'icsFile parsed', 'editCalendar', {
            status: response.status
        });
        onImport(response.holidays.map((holiday, idx)=>({
                isRecurring: holiday.recurring,
                name: holiday.name,
                iso8601Date: holiday.iso8601Date,
                isNew: false,
                fieldId: idx
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "link",
        onClick: browse,
        isLoading: loading
    }, formatMessage((0, $6a4KC.default).importHolidayCalendar)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "file",
        hidden: true,
        ref: fileUploadInput,
        onChange: handleFileChange,
        accept: ".ics"
    }));
};
const $f7ea88c62d8ceda7$export$f8dac7d33e8e07c3 = (0, $giAhk.injectIntlV2)($f7ea88c62d8ceda7$var$ImportCalendarView);

});
parcelRegister("7to8U", function(module, exports) {

$parcel$export(module.exports, "useParseIcsService", () => $255d272de43b4242$export$f03ea7d8c5545b4d);

var $eUqFw = parcelRequire("eUqFw");

var $p461L = parcelRequire("p461L");
const $255d272de43b4242$export$f03ea7d8c5545b4d = (baseUrl)=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const parseIcsFile = (0, $eUqFw.useCallback)(async (file)=>{
        setLoading(true);
        setError(null);
        const formdata = new FormData();
        formdata.append('file', file, file.name);
        let data;
        try {
            const rawResponse = await fetch((0, $p461L.getUrl)(baseUrl), {
                body: formdata,
                headers: {
                    credentials: 'same-origin'
                },
                method: 'POST'
            });
            const textResponse = await rawResponse.text();
            data = textResponse ? JSON.parse(textResponse) : null;
        } catch (e) {
            setError(e);
        }
        setLoading(false);
        return data;
    }, [
        baseUrl
    ]);
    return [
        {
            loading: loading,
            error: error
        },
        {
            parseIcsFile: parseIcsFile
        }
    ];
};

});
parcelRegister("p461L", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $1fd8711d6eef46c1$export$94df0e59ebebf4a7);
const $1fd8711d6eef46c1$export$94df0e59ebebf4a7 = (baseUrl)=>`${baseUrl}/rest/workinghours/1/api/calendar/parseIcs?operation=calendarImport`;

});


parcelRegister("6a4KC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4807763f65111d87$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4807763f65111d87$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importHolidayCalendar: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.import.import-holiday-calendar",
        "defaultMessage": "Import ICS"
    }
});

});


parcelRegister("8ruzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7243eae12ab52385$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7243eae12ab52385$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    holidays: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holidays",
        "defaultMessage": "Holidays"
    },
    addSomeHolidays: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.add-some-holidays",
        "defaultMessage": "Add some holidays!"
    },
    holidaysDescription: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.holidays-description",
        "defaultMessage": "Add holiday dates to pause your SLAs. "
    },
    importHolidaysDescription: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.import-holidays-description",
        "defaultMessage": "Import holidays from an ICS file or add them manually."
    },
    name: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.name",
        "defaultMessage": "Name"
    },
    date: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.date",
        "defaultMessage": "Date"
    },
    frequency: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.holidays.frequency",
        "defaultMessage": "Frequency"
    }
});

});

parcelRegister("hrouH", function(module, exports) {

$parcel$export(module.exports, "useHolidaysState", () => $0c653e92af0bdc78$export$c3123c17d1c3bf96);

var $eUqFw = parcelRequire("eUqFw");

var $1ofJH = parcelRequire("1ofJH");

var $3cieY = parcelRequire("3cieY");

var $8v1Zj = parcelRequire("8v1Zj");

var $iSEfF = parcelRequire("iSEfF");
const $0c653e92af0bdc78$export$c3123c17d1c3bf96 = (list = [], getFormValues)=>{
    const [getUid] = (0, $8v1Zj.useUid)();
    const [, { setFormStatusToDirty: setFormStatusToDirty }] = (0, $iSEfF.useFormContext)();
    const [holidays, setHolidays] = (0, $eUqFw.useState)(()=>{
        const modifiedHolidayList = (0, $3cieY.sortHolidays)(list);
        return modifiedHolidayList.map((holiday)=>({
                ...holiday,
                fieldId: getUid(),
                isNew: false
            }));
    });
    const onRemove = (id)=>{
        setHolidays(holidays.filter(({ fieldId: fieldId })=>fieldId !== id));
        setFormStatusToDirty();
    };
    const onAdd = ()=>{
        setHolidays([
            ...holidays,
            {
                name: '',
                iso8601Date: '',
                isRecurring: false,
                isNew: true,
                fieldId: getUid()
            }
        ]);
        setFormStatusToDirty();
    };
    const onSave = (id)=>{
        const index = holidays.findIndex(({ fieldId: fieldId })=>fieldId === id);
        const modifiedHoliday = (0, $1ofJH.getFormHolidayValuesById)(id, getFormValues());
        const clonedHolidays = [
            ...holidays
        ];
        clonedHolidays.splice(index, 1, modifiedHoliday);
        setHolidays(clonedHolidays);
    };
    const onImport = (importedHolidays)=>{
        const modifiedImportedHolidays = importedHolidays.map((holiday)=>({
                ...holiday,
                fieldId: getUid()
            }));
        setHolidays([
            ...holidays,
            ...modifiedImportedHolidays
        ]);
        setFormStatusToDirty();
    };
    return [
        {
            holidays: holidays
        },
        {
            onAdd: onAdd,
            onRemove: onRemove,
            onSave: onSave,
            onImport: onImport
        }
    ];
};

});
parcelRegister("8v1Zj", function(module, exports) {

$parcel$export(module.exports, "useUid", () => $82449676f48af52d$export$7e57423f0df3e99);

var $eUqFw = parcelRequire("eUqFw");
const $82449676f48af52d$export$7e57423f0df3e99 = ()=>{
    const rowIndex = (0, $eUqFw.useRef)(0);
    const get = ()=>{
        rowIndex.current += 1;
        return rowIndex.current;
    };
    return [
        get
    ];
};

});



parcelRegister("4AxHa", function(module, exports) {

$parcel$export(module.exports, "NameField", () => $238261345fe172fa$export$bddb202a49c0685b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $jeetE = parcelRequire("jeetE");

var $61UUs = parcelRequire("61UUs");

var $cf2Y4 = parcelRequire("cf2Y4");


var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $gDsgM = parcelRequire("gDsgM");

var $81Ran = parcelRequire("81Ran");

var $fbzKg = parcelRequire("fbzKg");
const $238261345fe172fa$var$Name = ({ intl: { formatMessage: formatMessage }, defaultName: defaultName })=>{
    if ((0, $1ybV0.ff)('fix-jsmca11y-994-issue')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($238261345fe172fa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "aria-hidden": "true"
    }, formatMessage((0, $81Ran.default).requiredField), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $gDsgM.CALENDAR_NAME),
        label: formatMessage((0, $81Ran.default).calendarName),
        defaultValue: defaultName,
        // @ts-expect-error - TS2322 - Type '(newValue: string) => "EMPTY_NAME" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
        validate: (0, $fbzKg.onValidate),
        isRequired: true,
        "data-testid": "servicedesk-sla-settings.ui.calendars.editable.fields.name.test"
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($238261345fe172fa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "data-test-id": "servicedesk-sla-settings.ui.calendars.editable.fields.name.name-field",
            ...fieldProps,
            "aria-label": formatMessage((0, $81Ran.default).placeHolder),
            placeholder: formatMessage((0, $81Ran.default).placeHolder)
        }), error === (0, $fbzKg.EMPTY_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $81Ran.default).emptyError)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $gDsgM.CALENDAR_NAME),
        defaultValue: defaultName,
        validate: (0, $fbzKg.onValidate),
        "data-testid": "servicedesk-sla-settings.ui.calendars.editable.fields.name.test"
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($238261345fe172fa$var$Inline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($61UUs))), {
            LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
            LEGACY_size: "large",
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($238261345fe172fa$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "data-test-id": "servicedesk-sla-settings.ui.calendars.editable.fields.name.name-field",
            ...fieldProps,
            "aria-label": formatMessage((0, $81Ran.default).placeHolder),
            placeholder: formatMessage((0, $81Ran.default).placeHolder)
        }), error === (0, $fbzKg.EMPTY_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $81Ran.default).emptyError)))));
};
const $238261345fe172fa$export$bddb202a49c0685b = (0, $giAhk.injectIntlV2)($238261345fe172fa$var$Name); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $238261345fe172fa$var$Inline = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $238261345fe172fa$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("81Ran", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a5ce0f69785cda$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $26a5ce0f69785cda$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    calendarName: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.name.calendar-name",
        "defaultMessage": "Calendar name"
    },
    placeHolder: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.name.place-holder",
        "defaultMessage": "Enter the calendar name..."
    },
    emptyError: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.name.empty-error",
        "defaultMessage": "Calendar name must not be empty"
    },
    requiredField: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.name.required-field",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});

parcelRegister("fbzKg", function(module, exports) {

$parcel$export(module.exports, "EMPTY_NAME", () => $855c3f017a6a50c7$export$e420739a557ec378);
$parcel$export(module.exports, "onValidate", () => $855c3f017a6a50c7$export$d0b1421dbb7d2df3);

var $ldoFd = parcelRequire("ldoFd");
const $855c3f017a6a50c7$export$e420739a557ec378 = 'EMPTY_NAME';
const $855c3f017a6a50c7$export$d0b1421dbb7d2df3 = (newValue)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(newValue) || newValue.trim().length < 1) return $855c3f017a6a50c7$export$e420739a557ec378;
    return undefined;
};

});


parcelRegister("f4eYG", function(module, exports) {

$parcel$export(module.exports, "TimezoneField", () => $b977447671642987$export$876df0ce19311525);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gDsgM = parcelRequire("gDsgM");

var $ebgSA = parcelRequire("ebgSA");
const $b977447671642987$var$Timezone = ({ defaultTimeZone: defaultTimeZone, selectedTimeZoneId: selectedTimeZoneId, options: options })=>{
    const defaultValue = (0, $eUqFw.useMemo)(()=>{
        const timezoneId = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(selectedTimeZoneId) ? defaultTimeZone.value : selectedTimeZoneId;
        return options.find((option)=>option.value === timezoneId);
    }, [
        defaultTimeZone.value,
        options,
        selectedTimeZoneId
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "servicedesk-sla-settings.ui.calendars.editable.fields.timezone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $gDsgM.TIMEZONE),
        label: formatMessage((0, $ebgSA.default).timezone),
        defaultValue: defaultValue,
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            options: options
        }), error !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, error))));
};
const $b977447671642987$export$876df0ce19311525 = $b977447671642987$var$Timezone;

});
parcelRegister("ebgSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fafa4d0ee8c9db35$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fafa4d0ee8c9db35$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timezone: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.timezone.timezone",
        "defaultMessage": "Timezone"
    }
});

});


parcelRegister("i5S2d", function(module, exports) {

$parcel$export(module.exports, "WorkWeek", () => $9809a32b882c49a4$export$4d044bb2e66f6a07);

var $eUqFw = parcelRequire("eUqFw");

var $bKkhQ = parcelRequire("bKkhQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gDsgM = parcelRequire("gDsgM");

var $1fKjv = parcelRequire("1fKjv");

var $eklfe = parcelRequire("eklfe");
const $9809a32b882c49a4$export$ade1a09288165770 = ({ workingTimes: workingTimes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, " ", formatMessage((0, $eklfe.default).workWeek), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKkhQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $eklfe.default).openTip)), (0, $gDsgM.DAYS_OF_THE_WEEK).map((day)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1fKjv.DayWithHours), {
            key: day,
            day: day,
            defaultWorkingTimes: workingTimes[day]
        }))));
};
const $9809a32b882c49a4$export$4d044bb2e66f6a07 = $9809a32b882c49a4$export$ade1a09288165770;

});
parcelRegister("bKkhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95da9811468ff1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c95da9811468ff1e$var$formSectionDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $c95da9811468ff1e$var$formSectionWrapperStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.300'
});
const $c95da9811468ff1e$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionWrapperStyles
    }, children);
};
const $c95da9811468ff1e$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c95da9811468ff1e$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionDescription, null, description), children);
};
var $c95da9811468ff1e$export$2e2bcd8739ae039 = $c95da9811468ff1e$var$FormSection;

});

parcelRegister("1fKjv", function(module, exports) {

$parcel$export(module.exports, "DayWithHours", () => $8511a903fd6223f6$export$dae3de7e4a14051);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $flFqI = parcelRequire("flFqI");

var $lgh9v = parcelRequire("lgh9v");

var $5DMJF = parcelRequire("5DMJF");

var $cIVUJ = parcelRequire("cIVUJ");

var $cfAhC = parcelRequire("cfAhC");

var $9DqL6 = parcelRequire("9DqL6");
const $8511a903fd6223f6$export$dae3de7e4a14051 = ({ day: day, defaultWorkingTimes: defaultWorkingTimes })=>{
    const [{ workingTimes: workingTimes, isDaySelected: isDaySelected }, { onRemove: onRemove, onAdd: onAdd, setDaySelected: setDaySelected }] = (0, $9DqL6.UseWorkingTimesState)(defaultWorkingTimes, (0, $5DMJF.defaultWorkHours));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.DayColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIVUJ.DayCheckbox), {
        fieldName: day,
        defaultIsChecked: isDaySelected,
        setDaySelected: setDaySelected
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, workingTimes.map(({ fieldId: fieldId, ...value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfAhC.WithRowsActiveCellBase), {
            key: `${day}${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Grid), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5DMJF.ConnectedTimePickers), {
            day: day,
            defaultValue: value,
            fieldId: fieldId,
            isDisabled: !isDaySelected
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8511a903fd6223f6$var$RemoveColumn, null, isDaySelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfAhC.Remove), {
            day: day,
            onRemove: ()=>onRemove(fieldId)
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8511a903fd6223f6$var$addColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgh9v.Add), {
        day: day,
        isDisabled: !isDaySelected,
        onAdd: onAdd
    })));
};
const $8511a903fd6223f6$var$addColumnStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8511a903fd6223f6$var$RemoveColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0v77o _i0dl1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lgh9v", function(module, exports) {

$parcel$export(module.exports, "Add", () => $3195a6f23bf93c10$export$d0265b2c425512d6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $bkIGg = parcelRequire("bkIGg");

var $giAhk = parcelRequire("giAhk");

var $1TuOR = parcelRequire("1TuOR");
const $3195a6f23bf93c10$var$AddView = ({ intl: { formatMessage: formatMessage }, onAdd: onAdd, isDisabled: isDisabled, day: day = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.add.button",
        appearance: "subtle",
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: ""
        }),
        onClick: onAdd,
        "aria-label": formatMessage((0, $1TuOR.default).add, {
            day: day
        })
    });
const $3195a6f23bf93c10$export$d0265b2c425512d6 = (0, $giAhk.injectIntlV2)($3195a6f23bf93c10$var$AddView);

});
parcelRegister("1TuOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $732946364c51c22f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $732946364c51c22f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    add: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.add.add",
        "defaultMessage": "Add new time slot for {day}"
    }
});

});


parcelRegister("5DMJF", function(module, exports) {

$parcel$export(module.exports, "defaultWorkHours", () => $9a2a53b33e41c163$export$1c2b433b4570174e);
$parcel$export(module.exports, "ConnectedTimePickers", () => $9a2a53b33e41c163$export$ffea01afbedb609);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $gDsgM = parcelRequire("gDsgM");


var $h2Nlg = parcelRequire("h2Nlg");

var $9QAHW = parcelRequire("9QAHW");

var $n5PsE = parcelRequire("n5PsE");
const $9a2a53b33e41c163$export$1c2b433b4570174e = {
    start: (0, $e3ce90b91b449602$export$637d508950d4c3c0),
    end: (0, $e3ce90b91b449602$export$44aa4eedfdc689b3)
};
const $9a2a53b33e41c163$var$ConnectedTimePickersView = ({ intl: { formatMessage: formatMessage }, day: day, fieldId: fieldId, defaultValue: defaultValue = $9a2a53b33e41c163$export$1c2b433b4570174e, isDisabled: isDisabled })=>{
    const fieldIdPrefix = `${(0, $gDsgM.TIME_PICKER_FIELD_PREFIX)}${day}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a2a53b33e41c163$var$Inline, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a2a53b33e41c163$var$TimePickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $n5PsE.StartTime), {
        day: day,
        fieldIdPrefix: fieldIdPrefix,
        fieldId: fieldId,
        defaultValue: defaultValue.start,
        isDisabled: isDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9a2a53b33e41c163$var$spacedStyles
    }, formatMessage((0, $9QAHW.default).to)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a2a53b33e41c163$var$TimePickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2Nlg.EndTime), {
        day: day,
        fieldIdPrefix: fieldIdPrefix,
        fieldId: fieldId,
        defaultValue: defaultValue.end,
        isDisabled: isDisabled
    })));
};
const $9a2a53b33e41c163$export$ffea01afbedb609 = (0, $giAhk.injectIntlV2)($9a2a53b33e41c163$var$ConnectedTimePickersView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a2a53b33e41c163$var$Inline = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a2a53b33e41c163$var$TimePickerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $9a2a53b33e41c163$var$spacedStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.100',
    margin: 'space.100'
});

});
const $e3ce90b91b449602$export$637d508950d4c3c0 = '9:00';
const $e3ce90b91b449602$export$44aa4eedfdc689b3 = '17:00';

parcelRegister("h2Nlg", function(module, exports) {

$parcel$export(module.exports, "EndTime", () => $20bfc559bbe07b2c$export$6c89f4ce9ac06701);

var $eUqFw = parcelRequire("eUqFw");

var $9DlWJ = parcelRequire("9DlWJ");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $giAhk = parcelRequire("giAhk");

var $4xHig = parcelRequire("4xHig");

var $gDsgM = parcelRequire("gDsgM");

var $3cieY = parcelRequire("3cieY");

var $dbNNm = parcelRequire("dbNNm");

var $dYYCG = parcelRequire("dYYCG");

var $jlTMf = parcelRequire("jlTMf");
const $20bfc559bbe07b2c$export$bce343fe3fd84a7b = ({ intl: { formatMessage: formatMessage }, fieldIdPrefix: fieldIdPrefix, fieldId: fieldId, defaultValue: defaultValue, isDisabled: isDisabled, day: day = '' })=>{
    const locale = (0, $4xHig.useLocale)();
    const availableTimes = (0, $eUqFw.useMemo)((0, $jlTMf.getAvailableTimes), []);
    const parseTimeWithUserLocale = (0, $eUqFw.useCallback)((input)=>(0, $dbNNm.parseTime)(input), []);
    const name = `${fieldIdPrefix}${(0, $gDsgM.TIME_PICKER_FIELD_END)}${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: name,
        defaultValue: defaultValue,
        // @ts-expect-error - TS2322 - Type '(end: string) => "Invalid Date" | "Empty Time" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
        validate: (0, $jlTMf.onValidate)
    }, ({ fieldProps: { value: value, onChange: onChange }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9DlWJ.default), {
            locale: locale,
            defaultValue: value,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
            isInvalid: error,
            isDisabled: isDisabled,
            timeIsEditable: true,
            times: availableTimes,
            parseInputValue: parseTimeWithUserLocale,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
            timeFormat: (0, $3cieY.getTimeFormatForTimePicker)(locale),
            testId: `servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.${name}`,
            label: formatMessage((0, $dYYCG.default).endTime, {
                time: value,
                day: day
            })
        }), error === (0, $gDsgM.EMPTY_TIME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $dYYCG.default).emptyEndTime)), error === (0, $gDsgM.INVALID_DATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $dYYCG.default).invalidEndTime))));
};
const $20bfc559bbe07b2c$export$6c89f4ce9ac06701 = (0, $giAhk.injectIntlV2)($20bfc559bbe07b2c$export$bce343fe3fd84a7b);

});
parcelRegister("9DlWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $645cfbe307315b4f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $5cS2Y = parcelRequire("5cS2Y");

var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $bvbsM = parcelRequire("bvbsM");

var $2sLgt = parcelRequire("2sLgt");

var $jP55W = parcelRequire("jP55W");

var $cJOhG = parcelRequire("cJOhG");
const $645cfbe307315b4f$var$packageName = "platform-pkg";
const $645cfbe307315b4f$var$packageVersion = "0.0.0-use.local";
const $645cfbe307315b4f$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $645cfbe307315b4f$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $645cfbe307315b4f$var$packageName,
    packageVersion: $645cfbe307315b4f$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $645cfbe307315b4f$var$TimePicker = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $5Q9wj.default), onChange: providedOnChange = (0, $5Q9wj.default), onFocus: providedOnFocus = (0, $5Q9wj.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $2sLgt.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $7i5dr.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eUqFw.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eUqFw.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eUqFw.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eUqFw.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$645cfbe307315b4f$var$analyticsAttributes
    });
    (0, $eUqFw.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eUqFw.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $7i5dr.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $EN9B6.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $5cS2Y.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $28t3A.default) : (0, $5wCDk.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $7i5dr.defaultTimeFormat));
        const date = (0, $2sLgt.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $7ueqz.default)(date)) return time;
        if (timeFormat) return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $cJOhG.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $7i5dr.EmptyComponent),
        Menu: (0, $bvbsM.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $7i5dr.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    const mergedStyles = (0, $cEc3i.m)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$645cfbe307315b4f$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`,
        onKeyDown: onSelectKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        appearance: appearance,
        autoFocus: autoFocus,
        components: selectComponents,
        inputId: id,
        isClearable: true,
        isDisabled: isDisabled,
        menuIsOpen: isOpen && !isDisabled,
        menuPlacement: "auto",
        openMenuOnFocus: true,
        onBlur: onBlur,
        onCreateOption: onCreateOption,
        onChange: onChange,
        options: options,
        onFocus: onFocus,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        placeholder: placeholder || l10n.formatTime((0, $7i5dr.placeholderDatetime)),
        styles: mergedStyles,
        value: initialValue,
        spacing: spacing,
        // We need this to get things to work, even though it's not supported.
        // @ts-ignore
        fixedLayerRef: containerRef,
        isInvalid: isInvalid,
        testId: testId,
        ...otherSelectProps
    }));
});
var $645cfbe307315b4f$export$2e2bcd8739ae039 = $645cfbe307315b4f$var$TimePicker;

});
parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
const $2ab404645f53318b$var$CreatableSelect = (0, $5FjBr.default)((0, $lOwgQ.default));
var $2ab404645f53318b$export$2e2bcd8739ae039 = $2ab404645f53318b$var$CreatableSelect;

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});


parcelRegister("bvbsM", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $a097a917e7430d98$export$982ad994195b4356);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $isGDw = parcelRequire("isGDw");
const $a097a917e7430d98$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, children: children, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children),
        testId: selectProps.testId
    });

});

parcelRegister("2sLgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $092a929414a015af$export$2e2bcd8739ae039);
const $092a929414a015af$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $092a929414a015af$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $092a929414a015af$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $092a929414a015af$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $092a929414a015af$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $092a929414a015af$var$map24[hour];
    return hour;
}
function $092a929414a015af$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $092a929414a015af$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $092a929414a015af$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $092a929414a015af$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $092a929414a015af$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $092a929414a015af$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $092a929414a015af$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $092a929414a015af$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$092a929414a015af$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $092a929414a015af$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $092a929414a015af$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $092a929414a015af$export$865db99128311580(time2);
}

});


parcelRegister("dYYCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c58222d54990c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $25c58222d54990c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyEndTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.empty-end-time",
        "defaultMessage": "End time must not be empty"
    },
    invalidEndTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.invalid-end-time",
        "defaultMessage": "End time must be valid time"
    },
    endTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.end.end-time",
        "defaultMessage": "Finish time currently set as {time}. Select to define a different finish time for {day}."
    }
});

});

parcelRegister("jlTMf", function(module, exports) {

$parcel$export(module.exports, "onValidate", () => $a937841e91d1a037$export$d0b1421dbb7d2df3);
$parcel$export(module.exports, "getAvailableTimes", () => $a937841e91d1a037$export$5a89c54f9286f4b);

var $iPvRp = parcelRequire("iPvRp");

var $gDsgM = parcelRequire("gDsgM");

var $dbNNm = parcelRequire("dbNNm");
const $a937841e91d1a037$export$d0b1421dbb7d2df3 = (end)=>{
    if ((0, $dbNNm.isEmpty)(end)) return 0, $gDsgM.EMPTY_TIME;
    if ((0, $dbNNm.isInvalidFormat)(end)) return 0, $gDsgM.INVALID_DATE;
    return undefined;
};
const $a937841e91d1a037$export$5a89c54f9286f4b = ()=>{
    const times = [
        ...(0, $iPvRp.default)
    ];
    /**
        Remove 0:00 from the begining and
        add 24:00 at the last
     */ times.shift();
    times.push('24:00');
    return times;
};

});
parcelRegister("iPvRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $602440b5c7905892$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $602440b5c7905892$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});



parcelRegister("9QAHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce8dd704c109997f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce8dd704c109997f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    to: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.to",
        "defaultMessage": "to"
    }
});

});

parcelRegister("n5PsE", function(module, exports) {

$parcel$export(module.exports, "StartTime", () => $7bfb982b6869ea6a$export$d0e0ec14c917d0c);

var $eUqFw = parcelRequire("eUqFw");

var $9DlWJ = parcelRequire("9DlWJ");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $iPvRp = parcelRequire("iPvRp");

var $giAhk = parcelRequire("giAhk");

var $4xHig = parcelRequire("4xHig");

var $gDsgM = parcelRequire("gDsgM");

var $3cieY = parcelRequire("3cieY");

var $dbNNm = parcelRequire("dbNNm");

var $2tThf = parcelRequire("2tThf");

var $hMPJL = parcelRequire("hMPJL");
const $7bfb982b6869ea6a$export$536c7f6013ec0c90 = ({ intl: { formatMessage: formatMessage }, fieldIdPrefix: fieldIdPrefix, fieldId: fieldId, defaultValue: defaultValue, isDisabled: isDisabled, day: day = '' })=>{
    const locale = (0, $4xHig.useLocale)();
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onValidate = (0, $eUqFw.useCallback)((0, $hMPJL.getValidateFunction)(fieldIdPrefix, fieldId), [
        fieldId,
        fieldIdPrefix
    ]);
    const parseTimeWithUserLocale = (0, $eUqFw.useCallback)((input)=>(0, $dbNNm.parseTime)(input), []);
    const name = `${fieldIdPrefix}${(0, $gDsgM.TIME_PICKER_FIELD_START)}${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: name,
        defaultValue: defaultValue,
        // @ts-expect-error - TS2322 - Type '(start: string, formData: { [key: string]: string; }) => "Invalid Date" | "Empty Time" | "Invalid Time Range" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
        validate: onValidate
    }, ({ fieldProps: { value: value, onChange: onChange }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9DlWJ.default), {
            locale: locale,
            defaultValue: value,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
            isInvalid: error,
            isDisabled: isDisabled,
            timeIsEditable: true,
            times: (0, $iPvRp.default),
            parseInputValue: parseTimeWithUserLocale,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
            timeFormat: (0, $3cieY.getTimeFormatForTimePicker)(locale),
            testId: `servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.${name}`,
            label: formatMessage((0, $2tThf.default).startTime, {
                time: value,
                day: day
            })
        }), error === (0, $gDsgM.EMPTY_TIME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $2tThf.default).emptyStartTime)), error === (0, $gDsgM.INVALID_DATE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $2tThf.default).invalidStartTime)), error === (0, $gDsgM.INVALID_TIME_RANGE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $2tThf.default).invalidTimeRange))));
};
const $7bfb982b6869ea6a$export$d0e0ec14c917d0c = (0, $giAhk.injectIntlV2)($7bfb982b6869ea6a$export$536c7f6013ec0c90);

});
parcelRegister("2tThf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6491444a0b37df4c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6491444a0b37df4c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStartTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.start.empty-start-time",
        "defaultMessage": "Start time must not be empty"
    },
    invalidStartTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.start.invalid-start-time",
        "defaultMessage": "Start time must be valid time"
    },
    invalidTimeRange: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.start.invalid-time-range",
        "defaultMessage": "Start time must not be after End time"
    },
    startTime: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.connected-time-pickers.start.start-time",
        "defaultMessage": "Start time currently set as {time}. Select to define a different start time for {day}."
    }
});

});

parcelRegister("hMPJL", function(module, exports) {

$parcel$export(module.exports, "getValidateFunction", () => $61f723192457fc73$export$3651b4299a915f80);

var $gDsgM = parcelRequire("gDsgM");

var $dbNNm = parcelRequire("dbNNm");
const $61f723192457fc73$export$3651b4299a915f80 = (fieldIdPrefix, fieldId)=>(start, formData)=>{
        const end = formData[`${fieldIdPrefix}-end-${fieldId}`];
        if ((0, $dbNNm.isEmpty)(start)) return 0, $gDsgM.EMPTY_TIME;
        if ((0, $dbNNm.isEmpty)(start) || (0, $dbNNm.isInvalidFormat)(start)) return 0, $gDsgM.INVALID_DATE;
        // don't compare times if connected end date is invalid
        if ((0, $dbNNm.isEmpty)(end) || (0, $dbNNm.isInvalidFormat)(end)) return undefined;
        if ((0, $dbNNm.toMilliseconds)(start) >= (0, $dbNNm.toMilliseconds)(end)) return 0, $gDsgM.INVALID_TIME_RANGE;
        return undefined;
    };

});



parcelRegister("cIVUJ", function(module, exports) {

$parcel$export(module.exports, "DayCheckbox", () => $a332c61759bc0907$export$99e3ecece8dee424);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $fq5oV = parcelRequire("fq5oV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1otpf = parcelRequire("1otpf");
const $a332c61759bc0907$var$DayCheckboxView = ({ fieldName: fieldName, defaultIsChecked: defaultIsChecked, setDaySelected: setDaySelected })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fq5oV.default), {
        name: fieldName,
        defaultIsChecked: defaultIsChecked
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
            ...fieldProps,
            onChange: ({ target: { checked: checked } })=>{
                setDaySelected(checked);
            },
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ sunday: MessageDescriptorV2; saturday: MessageDescriptorV2; friday: MessageDescriptorV2; thursday: MessageDescriptorV2; wednesday: MessageDescriptorV2; tuesday: MessageDescriptorV2; monday: MessageDescriptorV2; }'.
            label: formatMessage((0, $1otpf.default)[fieldName]),
            testId: `servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.${fieldName}`
        }));
};
const $a332c61759bc0907$export$99e3ecece8dee424 = $a332c61759bc0907$var$DayCheckboxView;

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("fq5oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e274233a51aeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $f4e274233a51aeef$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eUqFw.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
$f4e274233a51aeef$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $f4e274233a51aeef$export$2e2bcd8739ae039 = $f4e274233a51aeef$var$CheckboxField;

});

parcelRegister("1otpf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3256f47298366e9b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3256f47298366e9b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    monday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.monday",
        "defaultMessage": "Monday"
    },
    tuesday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.tuesday",
        "defaultMessage": "Tuesday"
    },
    wednesday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.wednesday",
        "defaultMessage": "Wednesday"
    },
    thursday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.thursday",
        "defaultMessage": "Thursday"
    },
    friday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.friday",
        "defaultMessage": "Friday"
    },
    saturday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.saturday",
        "defaultMessage": "Saturday"
    },
    sunday: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.day.sunday",
        "defaultMessage": "Sunday"
    }
});

});


parcelRegister("cfAhC", function(module, exports) {

$parcel$export(module.exports, "Remove", () => $f11ee6312b8f2d17$export$6072865765515195);
$parcel$export(module.exports, "WithRowsActiveCellBase", () => $f11ee6312b8f2d17$export$698ee9cbb832ab1d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $je5kZ = parcelRequire("je5kZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2ukhb = parcelRequire("2ukhb");
const $f11ee6312b8f2d17$var$RemoveView = ({ onRemove: onRemove, day: day = '' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f11ee6312b8f2d17$var$RowActiveCellWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "row-active-cell-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.remove.button",
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: ""
        }),
        onClick: onRemove,
        "aria-label": formatMessage((0, $2ukhb.default).remove, {
            day: day
        })
    }));
};
const $f11ee6312b8f2d17$export$6072865765515195 = $f11ee6312b8f2d17$var$RemoveView; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $f11ee6312b8f2d17$var$RowActiveCellWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bt242v": (0, $9t7rW.default)(__cmplp.isActive ? 1 : 0)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _tzy4h749 _1mygkb7n _1h7hkb7n _16l4kb7n",
            __cmplp.className
        ])
    });
});
const $f11ee6312b8f2d17$export$698ee9cbb832ab1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ftvxkb7n _1j4akb7n _1tlvkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ukhb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be34c3dd0d15184$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8be34c3dd0d15184$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remove: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.day-with-working-times.remove.remove",
        "defaultMessage": "Remove {day} time slot"
    }
});

});


parcelRegister("9DqL6", function(module, exports) {

$parcel$export(module.exports, "UseWorkingTimesState", () => $1b1497ebfb56f1ec$export$904a138be5951e77);

var $eUqFw = parcelRequire("eUqFw");

var $8v1Zj = parcelRequire("8v1Zj");

var $iSEfF = parcelRequire("iSEfF");
const $1b1497ebfb56f1ec$export$904a138be5951e77 = (defaultWorkingTimes, defaultWorkHours)=>{
    const [getUid] = (0, $8v1Zj.useUid)();
    const [, { setFormStatusToDirty: setFormStatusToDirty }] = (0, $iSEfF.useFormContext)();
    const [isDaySelected, setDaySelected] = (0, $eUqFw.useState)(Boolean(defaultWorkingTimes));
    const [workingTimes, setWorkingTimes] = (0, $eUqFw.useState)(()=>(defaultWorkingTimes || [
            defaultWorkHours
        ]).map((defaultWorkingTime)=>({
                ...defaultWorkingTime,
                fieldId: getUid()
            })));
    const onRemove = (id)=>{
        setWorkingTimes(workingTimes.filter(({ fieldId: fieldId })=>fieldId !== id));
        setFormStatusToDirty();
    };
    const onAdd = ()=>{
        setWorkingTimes([
            ...workingTimes,
            {
                ...defaultWorkHours,
                fieldId: getUid()
            }
        ]);
        setFormStatusToDirty();
    };
    return [
        {
            workingTimes: workingTimes,
            isDaySelected: isDaySelected
        },
        {
            onRemove: onRemove,
            onAdd: onAdd,
            setDaySelected: setDaySelected
        }
    ];
};

});


parcelRegister("eklfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ee37b9189b76d5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c2ee37b9189b76d5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workWeek: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.work-week",
        "defaultMessage": "Work week"
    },
    openTip: {
        "id": "servicedesk-sla-settings.calendars.editable.fields.work-week.open-tip",
        "defaultMessage": "Select the days of the week this calendar will use."
    }
});

});


parcelRegister("brZeL", function(module, exports) {

$parcel$export(module.exports, "getSaveRequestPayload", () => $1ece4f12cc91d6f6$export$2a66d013d861dc79);

var $gDsgM = parcelRequire("gDsgM");

var $k3Edr = parcelRequire("k3Edr");
const $1ece4f12cc91d6f6$export$2a66d013d861dc79 = (idCurrent, context, formData, isCopied)=>{
    // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number | undefined'.
    const id = isCopied ? undefined : idCurrent; // If it is copied from other service desk projects, do not use the id of the other project calendar
    const formKeys = Object.keys(formData);
    const name = formData[0, $gDsgM.CALENDAR_NAME];
    const timezoneId = formData[0, $gDsgM.TIMEZONE].value;
    const workingTimes = (0, $k3Edr.getWorkingTimes)(formKeys, formData);
    const holidays = (0, $k3Edr.getHolidays)(formKeys, formData);
    return {
        id: id,
        context: context,
        name: name,
        timezoneId: timezoneId,
        workingTimes: workingTimes,
        holidays: holidays
    };
};

});
parcelRegister("k3Edr", function(module, exports) {

$parcel$export(module.exports, "getWorkingTimes", () => $a036031655f363e3$export$66bfcef4f0aacb39);
$parcel$export(module.exports, "getHolidays", () => $a036031655f363e3$export$605f12f3153f5662);

var $ldoFd = parcelRequire("ldoFd");

var $gDsgM = parcelRequire("gDsgM");
const $a036031655f363e3$var$mapToId = (value)=>{
    const id = value.split('-').pop();
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return id;
};
const $a036031655f363e3$var$toMilliseconds = (value)=>{
    // value is time in hh:mm format. Don't need a date-time utility to convert that to ms
    const [hours, minutes] = value.split(':');
    return (parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60) * 1000;
};
const $a036031655f363e3$var$filterAndMapToId = (values, fieldPrefix)=>values.filter((key)=>key.startsWith(fieldPrefix)).map($a036031655f363e3$var$mapToId);
const $a036031655f363e3$var$filterMatchingWeekdays = (workingTimes, workingTimeToBeAdded)=>workingTimes.filter(({ weekday: weekday, start: start, end: end })=>weekday === workingTimeToBeAdded.weekday && workingTimeToBeAdded.end >= start && workingTimeToBeAdded.start <= end);
// time pickers usually have human readable values i.e in HH:MM
// this utils will extract the selected day & connected time pickers and normalize to milliseconds
// result will be sorted based on start times
const $a036031655f363e3$var$mapSelectedStartAndEndTimesToMilliSeconds = (formKeys, formData)=>{
    const selectedDays = (0, $gDsgM.DAYS_OF_THE_WEEK).filter((day)=>formData[day]);
    return selectedDays // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((workingTimes, selectedDay)=>{
        const connectedTimePickerIds = $a036031655f363e3$var$filterAndMapToId(formKeys, `${(0, $gDsgM.TIME_PICKER_FIELD_PREFIX)}${selectedDay}${(0, $gDsgM.TIME_PICKER_FIELD_START)}`);
        connectedTimePickerIds.forEach((timePickerId)=>{
            const start = formData[`${0, $gDsgM.TIME_PICKER_FIELD_PREFIX}${selectedDay}${0, $gDsgM.TIME_PICKER_FIELD_START}${timePickerId}`];
            const end = formData[`${0, $gDsgM.TIME_PICKER_FIELD_PREFIX}${selectedDay}${0, $gDsgM.TIME_PICKER_FIELD_END}${timePickerId}`];
            workingTimes.push({
                weekday: selectedDay,
                start: $a036031655f363e3$var$toMilliseconds(start),
                end: $a036031655f363e3$var$toMilliseconds(end)
            });
        });
        return workingTimes;
    }, []).sort((first, second)=>first.start - second.start);
};
// mergeIntervalsByDay utils will try to merge working times
// e.g: 9AM-17PM and 17PM-20PM will be merged to 9AM-20PM
const $a036031655f363e3$var$mergeIntervalsByDay = (workingTimes, workingTimeToBeAdded)=>{
    const [mergeableWorkingTime] = $a036031655f363e3$var$filterMatchingWeekdays(workingTimes, workingTimeToBeAdded);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(mergeableWorkingTime)) workingTimes.push(workingTimeToBeAdded);
    else {
        mergeableWorkingTime.start = mergeableWorkingTime.start < workingTimeToBeAdded.start ? mergeableWorkingTime.start : workingTimeToBeAdded.start;
        mergeableWorkingTime.end = mergeableWorkingTime.end > workingTimeToBeAdded.end ? mergeableWorkingTime.end : workingTimeToBeAdded.end;
    }
    return workingTimes;
};
const $a036031655f363e3$export$66bfcef4f0aacb39 = (formKeys, formData)=>{
    const selectedDays = $a036031655f363e3$var$mapSelectedStartAndEndTimesToMilliSeconds(formKeys, formData);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return selectedDays.reduce((workingTimes, workingTimeToBeAdded)=>$a036031655f363e3$var$mergeIntervalsByDay(workingTimes, workingTimeToBeAdded), []);
};
const $a036031655f363e3$export$605f12f3153f5662 = (formKeys, formData)=>{
    const holidayIds = $a036031655f363e3$var$filterAndMapToId(formKeys, `${(0, $gDsgM.HOLIDAY_PREFIX)}`);
    return holidayIds.map((id)=>{
        const { defaultDate: defaultDate, defaultName: defaultName, isRecurring: isRecurring } = formData[`${0, $gDsgM.HOLIDAY_PREFIX}${id}`];
        return {
            name: defaultName,
            iso8601Date: defaultDate,
            recurring: isRecurring
        };
    });
};

});


parcelRegister("dJzRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7ba11bb4efabee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bc7ba11bb4efabee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "servicedesk-sla-settings.calendars.editable.error-message",
        "defaultMessage": "Something has gone wrong. An error has occurred."
    },
    otherProjectCalendarsCopy: {
        "id": "servicedesk-sla-settings.calendars.editable.other-project-calendars-copy",
        "defaultMessage": "Copy of {calendarName} (from {serviceDeskName})"
    },
    currentProjectCalendarsCopy: {
        "id": "servicedesk-sla-settings.calendars.editable.current-project-calendars-copy",
        "defaultMessage": "Copy of {calendarName}"
    }
});

});

parcelRegister("6QUhf", function(module, exports) {

$parcel$export(module.exports, "NavBlocker", () => $758616cf68d30d4b$export$30c4ffbbf7e17b91);

var $eUqFw = parcelRequire("eUqFw");

var $jlCQ4 = parcelRequire("jlCQ4");

var $lSAth = parcelRequire("lSAth");

var $kTZFI = parcelRequire("kTZFI");

var $iSEfF = parcelRequire("iSEfF");
const $758616cf68d30d4b$export$30c4ffbbf7e17b91 = ({ onSave: onSave, onDiscard: onDiscard })=>{
    const [, { onRegisterBlock: onRegisterBlock }] = (0, $iSEfF.useFormContext)();
    (0, $eUqFw.useEffect)(()=>()=>{
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            onRegisterBlock();
        }, [
        onRegisterBlock
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTZFI.default), {
        onUnload: (0, $jlCQ4.onUnload),
        onRegisterBlock: onRegisterBlock,
        prompt: (0, $lSAth.default).promptText,
        onDiscard: onDiscard,
        onSave: onSave,
        withSaveButton: true,
        isDirty: true
    });
};

});


parcelRegister("j1QRq", function(module, exports) {

$parcel$export(module.exports, "CalendarList", () => $19345ab0b5f483df$export$4f11c40a41d93606);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lGLse = parcelRequire("lGLse");

var $6vO9v = parcelRequire("6vO9v");

var $gDsgM = parcelRequire("gDsgM");

var $aqeGo = parcelRequire("aqeGo");

var $kgQcB = parcelRequire("kgQcB");

var $ho6XR = parcelRequire("ho6XR");
const $19345ab0b5f483df$export$c8e72f6db1315a07 = ({ calendar: calendar, permissionsWithTimezone: permissionsWithTimezone, isSelected: isSelected, selectedCalendarMode: selectedCalendarMode, calendarsActions: calendarsActions })=>{
    const { id: id } = calendar;
    const { onToggleViewRequested: onToggleViewRequested, onEditRequested: onEditRequested, onEditCalendarSuccessful: onEditCalendarSuccessful, onDeleteCalendarSuccessful: onDeleteCalendarSuccessful, onReset: onReset, onCloneCalendar: onCloneCalendar } = calendarsActions;
    const mode = isSelected ? selectedCalendarMode : (0, $6vO9v.COLLAPSED_MODE);
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const userTimezone = (loggedInUser && loggedInUser.timeZone) ?? (0, $gDsgM.DEFAULT_TIMEZONE);
    const dataTestId = `servicedesk-sla-settings.ui.calendars.calendar-${id}`;
    switch(mode){
        case 0, $6vO9v.VIEW_MODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19345ab0b5f483df$var$CalendarContainer, {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ho6XR.Summary), {
                calendar: calendar,
                onEditRequested: ()=>onEditRequested(id),
                onToggleDetails: ()=>onToggleViewRequested(id),
                onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
                onCloneCalendar: onCloneCalendar,
                canCloneCalendar: Boolean(permissionsWithTimezone?.canCreate),
                userTimeZone: userTimezone,
                isOpen: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqeGo.CalendarView), {
                calendar: calendar,
                permissionsWithTimezone: permissionsWithTimezone
            }));
        case 0, $6vO9v.EDIT_MODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19345ab0b5f483df$var$CalendarContainer, {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgQcB.CalendarForm), {
                allTimezones: permissionsWithTimezone.allTimezones,
                defaultTimezone: permissionsWithTimezone.defaultTimezone,
                calendarData: calendar,
                onCancel: onReset,
                onEditCalendarSuccessful: onEditCalendarSuccessful,
                calendarMode: mode
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19345ab0b5f483df$var$CalendarContainer, {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ho6XR.Summary), {
                calendar: calendar,
                onEditRequested: ()=>onEditRequested(id),
                onToggleDetails: ()=>onToggleViewRequested(id),
                onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
                onCloneCalendar: onCloneCalendar,
                canCloneCalendar: Boolean(permissionsWithTimezone?.canCreate),
                userTimeZone: userTimezone,
                isOpen: false
            }));
    }
};
const $19345ab0b5f483df$export$4f11c40a41d93606 = ({ calendars: calendars, permissionsWithTimezone: permissionsWithTimezone, selectedCalendarMode: selectedCalendarMode, calendarsActions: calendarsActions, selectedCalendarId: selectedCalendarId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, calendars.reduce((calendarList, calender, calenderKey)=>{
        calendarList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19345ab0b5f483df$export$c8e72f6db1315a07, {
            key: calenderKey,
            calendar: calender,
            selectedCalendarMode: selectedCalendarMode,
            isSelected: selectedCalendarId === calender.id,
            permissionsWithTimezone: permissionsWithTimezone,
            calendarsActions: calendarsActions
        }));
        return calendarList;
    }, []));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19345ab0b5f483df$var$CalendarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _19it13y8 _vchhusvi _18s81bpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aqeGo", function(module, exports) {

$parcel$export(module.exports, "CalendarView", () => $5ddcbbc2888fac24$export$b573856c46cc9357);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kmFyW = parcelRequire("kmFyW");

var $2RVVI = parcelRequire("2RVVI");

var $lIQhN = parcelRequire("lIQhN");
const $5ddcbbc2888fac24$export$b573856c46cc9357 = ({ calendar: calendar, permissionsWithTimezone: permissionsWithTimezone })=>{
    const { id: id, timezoneId: timezoneId, workingTimes: workingTimes, holidays: holidays } = calendar;
    const { allTimezones: allTimezones } = permissionsWithTimezone;
    const timezone = (0, $eUqFw.useMemo)(()=>allTimezones.find((zone)=>zone.value === timezoneId), [
        allTimezones,
        timezoneId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ddcbbc2888fac24$var$Container, {
        "data-testid": `servicedesk-sla-settings.ui.calendars.calendar.details-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVVI.Timezone), {
        timezone: timezone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIQhN.WorkWeek), {
        workingTimes: workingTimes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmFyW.HolidaysView), {
        holidays: holidays
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ddcbbc2888fac24$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8pxbi _n3tdpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kmFyW", function(module, exports) {

$parcel$export(module.exports, "HolidaysView", () => $53be2bdc72b2caeb$export$c61b922805814b0a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $flFqI = parcelRequire("flFqI");

var $3cieY = parcelRequire("3cieY");

var $fA42K = parcelRequire("fA42K");

var $3SDPn = parcelRequire("3SDPn");
const $53be2bdc72b2caeb$var$Holiday = ({ intl: { formatMessage: formatMessage }, holidays: holidays })=>{
    if (!holidays.length) return null;
    const sortedHolidays = (0, $3cieY.sortHolidays)(holidays);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53be2bdc72b2caeb$var$HolidayHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, " ", formatMessage((0, $3SDPn.default).holidaysHeader), " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53be2bdc72b2caeb$var$HolidaysGrid, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $3SDPn.default).name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $3SDPn.default).date))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $3SDPn.default).frequency))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53be2bdc72b2caeb$var$HolidaysGrid, null, sortedHolidays.map((holiday, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fA42K.HolidayView), {
            key: index,
            holiday: holiday
        }))));
};
const $53be2bdc72b2caeb$export$c61b922805814b0a = (0, $giAhk.injectIntlV2)($53be2bdc72b2caeb$var$Holiday); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $53be2bdc72b2caeb$var$HolidaysGrid = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _19pku2gc",
            __cmplp.className
        ])
    });
});
const $53be2bdc72b2caeb$var$HolidayHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $flFqI.Header), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1on0 _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fA42K", function(module, exports) {

$parcel$export(module.exports, "HolidayView", () => $fc4f4bc7baf414bd$export$14a27154bef6a50);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $4xHig = parcelRequire("4xHig");

var $flFqI = parcelRequire("flFqI");

var $3cieY = parcelRequire("3cieY");

var $3SDPn = parcelRequire("3SDPn");
const $fc4f4bc7baf414bd$export$80d77e5eb758f14b = ({ intl: { formatMessage: formatMessage }, holiday: holiday })=>{
    const locale = (0, $4xHig.useLocale)().replace('_', '-');
    const { name: name, iso8601Date: iso8601Date, isRecurring: isRecurring } = holiday;
    const prefix = formatMessage((0, $3SDPn.default).every);
    const formattedDate = (0, $eUqFw.useMemo)(()=>(0, $3cieY.formatDate)({
            iso8601Date: iso8601Date,
            locale: locale,
            isRecurring: isRecurring,
            message: prefix
        }), [
        iso8601Date,
        locale,
        isRecurring,
        prefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc4f4bc7baf414bd$export$981ee20d8c51dfd0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), {
        "data-testid": `servicedesk-sla-settings.ui.calendars.calendar.holidays.grid-row-${name}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, formattedDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, formatMessage(isRecurring ? (0, $3SDPn.default).annually : (0, $3SDPn.default).oneTime))));
};
const $fc4f4bc7baf414bd$export$14a27154bef6a50 = (0, $giAhk.injectIntlV2)($fc4f4bc7baf414bd$export$80d77e5eb758f14b);
const $fc4f4bc7baf414bd$export$981ee20d8c51dfd0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3SDPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9e5d815ed8b516$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9f9e5d815ed8b516$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    holidaysHeader: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.holidays-header",
        "defaultMessage": "Holidays"
    },
    every: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.every",
        "defaultMessage": "Every"
    },
    oneTime: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.one-time",
        "defaultMessage": "One time"
    },
    annually: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.annually",
        "defaultMessage": "Annually"
    },
    name: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.name",
        "defaultMessage": "Name"
    },
    date: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.date",
        "defaultMessage": "Date"
    },
    frequency: {
        "id": "servicedesk-sla-settings.calendars.calendar.holidays.frequency",
        "defaultMessage": "Frequency"
    }
});

});



parcelRegister("2RVVI", function(module, exports) {

$parcel$export(module.exports, "Timezone", () => $c4638a3ca71fe53c$export$5242477c0ef6dc66);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $flFqI = parcelRequire("flFqI");

var $bx0yX = parcelRequire("bx0yX");
const $c4638a3ca71fe53c$var$TimezoneView = ({ timezone: timezone })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!timezone) return null;
    const { label: label } = timezone;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Header), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, " ", formatMessage((0, $bx0yX.default).timezoneHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c4638a3ca71fe53c$var$TimezoneValue, {
        "data-test-id": "servicedesk-sla-settings.ui.calendars.calendar.timezone"
    }, label));
};
const $c4638a3ca71fe53c$export$5242477c0ef6dc66 = $c4638a3ca71fe53c$var$TimezoneView;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4638a3ca71fe53c$var$TimezoneValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bx0yX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d42ae4998808282$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d42ae4998808282$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timezoneHeader: {
        "id": "servicedesk-sla-settings.calendars.calendar.timezone.timezone-header",
        "defaultMessage": "Timezone"
    }
});

});


parcelRegister("lIQhN", function(module, exports) {

$parcel$export(module.exports, "WorkWeek", () => $d9b01ee5838dc2e3$export$4d044bb2e66f6a07);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $gDsgM = parcelRequire("gDsgM");

var $flFqI = parcelRequire("flFqI");

var $iDrv6 = parcelRequire("iDrv6");

var $5HHHV = parcelRequire("5HHHV");
const $d9b01ee5838dc2e3$var$WorkWeekView = ({ intl: { formatMessage: formatMessage }, workingTimes: workingTimes })=>{
    if (!workingTimes) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Header), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, " ", formatMessage((0, $5HHHV.default).workingTimesHeader), " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9b01ee5838dc2e3$var$WorkingTimesGrid, null, (0, $gDsgM.DAYS_OF_THE_WEEK).map((day)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iDrv6.DayWithHours), {
            key: day,
            day: day,
            defaultWorkingTimes: workingTimes[day]
        }))));
};
const $d9b01ee5838dc2e3$export$4d044bb2e66f6a07 = (0, $giAhk.injectIntlV2)($d9b01ee5838dc2e3$var$WorkWeekView); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9b01ee5838dc2e3$var$WorkingTimesGrid = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iDrv6", function(module, exports) {

$parcel$export(module.exports, "DayWithHours", () => $c333bae9e741f60c$export$dae3de7e4a14051);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $flFqI = parcelRequire("flFqI");

var $5HHHV = parcelRequire("5HHHV");
const $c333bae9e741f60c$export$85d541941fd34f93 = ({ intl: { formatMessage: formatMessage }, day: day, defaultWorkingTimes: defaultWorkingTimes })=>{
    if (!defaultWorkingTimes) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c333bae9e741f60c$var$WorkingTimesGrid, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.DayColumn), null, formatMessage((0, $5HHHV.default)[day])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Column), null, defaultWorkingTimes.map(({ start: start, end: end })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $flFqI.Grid), {
            key: `${day}${start}${end}`,
            "data-test-id": `servicedesk-sla-settings.ui.calendars.calendar.work-week.grid-${day}`
        }, start, " ", formatMessage((0, $5HHHV.default).to), " ", end)))));
};
const $c333bae9e741f60c$export$dae3de7e4a14051 = (0, $giAhk.injectIntlV2)($c333bae9e741f60c$export$85d541941fd34f93);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c333bae9e741f60c$var$WorkingTimesGrid = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rn8 _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5HHHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef22e33ab62bc72$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ef22e33ab62bc72$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workingTimesHeader: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.working-times-header",
        "defaultMessage": "Work week"
    },
    to: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.to",
        "defaultMessage": "to"
    },
    monday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.monday",
        "defaultMessage": "Monday"
    },
    tuesday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.tuesday",
        "defaultMessage": "Tuesday"
    },
    wednesday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.wednesday",
        "defaultMessage": "Wednesday"
    },
    thursday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.thursday",
        "defaultMessage": "Thursday"
    },
    friday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.friday",
        "defaultMessage": "Friday"
    },
    saturday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.saturday",
        "defaultMessage": "Saturday"
    },
    sunday: {
        "id": "servicedesk-sla-settings.calendars.calendar.work-week.sunday",
        "defaultMessage": "Sunday"
    }
});

});




parcelRegister("ho6XR", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $bcddb93be1080594$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $61UUs = parcelRequire("61UUs");

var $dwj4T = parcelRequire("dwj4T");

var $ajCg0 = parcelRequire("ajCg0");

var $jG1wZ = parcelRequire("jG1wZ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $ebD7Y = parcelRequire("ebD7Y");

var $flFqI = parcelRequire("flFqI");

var $eu0UR = parcelRequire("eu0UR");

var $4BaYU = parcelRequire("4BaYU");

var $lrHmu = parcelRequire("lrHmu");
const $bcddb93be1080594$var$dataTestIdPrefix = 'servicedesk-sla-settings.ui.calendars.summary-with-actions';
const $bcddb93be1080594$var$EMPTY_TOOLTIP = '';
const $bcddb93be1080594$export$62e18bd6876a548d = ({ calendarId: calendarId, activeCalendarContent: activeCalendarContent, deleteCalendarContent: deleteCalendarContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        component: (0, $flFqI.ReusableSlaCalendarTooltipStyles),
        content: activeCalendarContent,
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        isDisabled: true,
        "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.new-delete-button-${calendarId}`
    }, deleteCalendarContent)));
const $bcddb93be1080594$var$SummaryView = ({ isOpen: isOpen, calendar: calendar, onToggleDetails: onToggleDetails, onDeleteCalendarSuccessful: onDeleteCalendarSuccessful, onEditRequested: onEditRequested, onCloneCalendar: onCloneCalendar, canCloneCalendar: canCloneCalendar, userTimeZone: userTimeZone })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    const [isDeleteModalOpen, toggleDeleteModal] = (0, $NqqMP.usePopupController)(false);
    const { id: calendarId, name: name, canDelete: canDelete, canUpdate: canUpdate, deletable: deletable, lastUpdatedEpoch: lastUpdatedEpoch, createdEpoch: createdEpoch } = calendar;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getCalendarIconTooltipContent = ()=>{
        if (!lastUpdatedEpoch) {
            if (createdEpoch) {
                const createdEpochTooltipString = (0, $eu0UR.getCalendarIconTooltipContentUtil)(createdEpoch, userTimeZone);
                return formatMessage((0, $lrHmu.default).createdOn, {
                    date: createdEpochTooltipString
                });
            }
            return $bcddb93be1080594$var$EMPTY_TOOLTIP;
        }
        const updatedEpochTooltipString = (0, $eu0UR.getCalendarIconTooltipContentUtil)(lastUpdatedEpoch, userTimeZone);
        return formatMessage((0, $lrHmu.default).updatedOn, {
            date: updatedEpochTooltipString
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$var$TextContainer, {
        "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.calendar-name-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bcddb93be1080594$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        component: (0, $flFqI.ReusableSlaCalendarTooltipStyles),
        content: getCalendarIconTooltipContent(),
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($61UUs))), {
        LEGACY_size: "large",
        LEGACY_primaryColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        label: "",
        color: "currentColor"
    }))), name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        shouldFlip: false,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.menu-button-${calendarId}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "",
                    size: "medium"
                }),
                ref: triggerRef,
                "aria-label": formatMessage((0, $lrHmu.default).more, {
                    name: name
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onEditRequested,
        "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.edit-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).editCalendar))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canCloneCalendar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'copySLACalendar clicked');
            onCloneCalendar(calendar);
        },
        "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.clone-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).cloneCalendars))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canDelete
    }, deletable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: toggleDeleteModal,
        "data-test-id": `${$bcddb93be1080594$var$dataTestIdPrefix}.delete-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).deleteCalendar)) : // Extracting the logic into DeleteDropdown for better readability
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$export$62e18bd6876a548d, {
        calendarId: calendarId,
        activeCalendarContent: formatMessage((0, $lrHmu.default).activeCalendar),
        deleteCalendarContent: formatMessage((0, $lrHmu.default).deleteCalendar)
    })))), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onToggleDetails,
        testId: `${$bcddb93be1080594$var$dataTestIdPrefix}.toggle-button-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
        label: formatMessage((0, $lrHmu.default).hideDetails, {
            name: name
        })
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onToggleDetails,
        testId: `${$bcddb93be1080594$var$dataTestIdPrefix}.toggle-button-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bcddb93be1080594$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $lrHmu.default).showDetails, {
            name: name
        })
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4BaYU.DeleteCalendarModal), {
        key: calendarId,
        isOpen: isDeleteModalOpen,
        onClose: toggleDeleteModal,
        calendarId: calendarId,
        calendarName: name,
        baseUrl: baseUrl,
        isOtherProjectCalendar: false,
        onDeleteCalendarSuccessful: onDeleteCalendarSuccessful
    }));
};
const $bcddb93be1080594$export$46453a0401d6cd1a = $bcddb93be1080594$var$SummaryView; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcddb93be1080594$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3i8vuz _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $bcddb93be1080594$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcddb93be1080594$var$ChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcddb93be1080594$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1wq8 _1nx94jg8 _syazaj1x _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcddb93be1080594$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syazjjyb _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eu0UR", function(module, exports) {

$parcel$export(module.exports, "getCalendarIconTooltipContentUtil", () => $1674dae3fdb824b0$export$c0f8877ccd7704af);
$parcel$export(module.exports, "OtherProjectCalendarsSummary", () => $1674dae3fdb824b0$export$2be3845b1fbede5d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $61UUs = parcelRequire("61UUs");

var $dwj4T = parcelRequire("dwj4T");

var $ajCg0 = parcelRequire("ajCg0");

var $jG1wZ = parcelRequire("jG1wZ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $2eG9N = parcelRequire("2eG9N");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7d1RI = parcelRequire("7d1RI");

var $NqqMP = parcelRequire("NqqMP");

var $ebD7Y = parcelRequire("ebD7Y");

var $flFqI = parcelRequire("flFqI");

var $4BaYU = parcelRequire("4BaYU");

var $lrHmu = parcelRequire("lrHmu");
const $1674dae3fdb824b0$export$c0f8877ccd7704af = (epoch, userTimeZone)=>{
    const updatedDataTz = (0, $bbmZl.default)(epoch, userTimeZone);
    return (0, $4p54N.default)(updatedDataTz, 'MMM dd, yyyy', {
        timeZone: userTimeZone
    });
};
const $1674dae3fdb824b0$var$dataTestIdPrefix = 'servicedesk-sla-settings.ui.reusable-sla-calendars.summary-with-actions';
const $1674dae3fdb824b0$var$EMPTY_TOOLTIP = '';
const $1674dae3fdb824b0$var$SummaryViewOtherProjectCalendars = ({ isOpen: isOpen, calendar: calendar, onToggleDetails: onToggleDetails, onSelectThisCalendarTab: onSelectThisCalendarTab, onCopyCalendar: onCopyCalendar, canCopyCalendar: canCopyCalendar, onEditRequested: onEditRequested, onDeleteCalendarSuccessful: onDeleteCalendarSuccessful, isJiraAdmin: isJiraAdmin, userTimeZone: userTimeZone, intl: { formatMessage: formatMessage } })=>{
    const { baseUrl: baseUrl } = (0, $7d1RI.useCommonPageContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { id: calendarId, name: name, serviceDeskName: serviceDeskName, canUpdate: canUpdate, canDelete: canDelete, deletable: deletable, lastUpdatedEpoch: lastUpdatedEpoch, createdEpoch: createdEpoch } = calendar;
    const [isDeleteModalOpen, toggleDeleteModal] = (0, $NqqMP.usePopupController)(false);
    const getCalendarIconTooltipContent = ()=>{
        if (!lastUpdatedEpoch) {
            if (createdEpoch) {
                const createdEpochTooltipString = $1674dae3fdb824b0$export$c0f8877ccd7704af(createdEpoch, userTimeZone);
                return formatMessage((0, $lrHmu.default).createdOn, {
                    date: createdEpochTooltipString
                });
            }
            return $1674dae3fdb824b0$var$EMPTY_TOOLTIP;
        }
        const updatedEpochTooltipString = $1674dae3fdb824b0$export$c0f8877ccd7704af(lastUpdatedEpoch, userTimeZone);
        return formatMessage((0, $lrHmu.default).updatedOn, {
            date: updatedEpochTooltipString
        });
    };
    const handleOnClickCopyCalendar = ()=>{
        onSelectThisCalendarTab(); // Go to the first tab
        onCopyCalendar(calendar);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'copySLACalendarFromOtherProject clicked');
    };
    const Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        shouldFlip: false,
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.menu-button-${calendarId}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "",
                    size: "medium"
                }),
                ref: triggerRef,
                "aria-label": formatMessage((0, $lrHmu.default).more, {
                    name: name
                })
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onEditRequested,
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.jira-admins.edit-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).editCalendar))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canCopyCalendar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleOnClickCopyCalendar,
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.jira-admins.copy-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).copyCalendars))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canDelete
    }, deletable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: toggleDeleteModal,
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.jira-admins-delete-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).deleteCalendar)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        component: (0, $flFqI.ReusableSlaCalendarTooltipStyles),
        content: formatMessage((0, $lrHmu.default).activeCalendar),
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        isDisabled: true,
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.jira-admins-activate-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).deleteCalendar))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$TextContainer, {
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.calendar-name-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1674dae3fdb824b0$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        component: (0, $flFqI.ReusableSlaCalendarTooltipStyles),
        content: getCalendarIconTooltipContent(),
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($61UUs))), {
        LEGACY_size: "large",
        LEGACY_primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        label: "",
        color: "currentColor"
    }))), name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$CalendarInfoContainer, null, formatMessage((0, $lrHmu.default).from, {
        serviceDeskName: serviceDeskName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$ActionsContainer, null, isJiraAdmin ? Dropdown : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canCopyCalendar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleOnClickCopyCalendar,
        "data-test-id": `${$1674dae3fdb824b0$var$dataTestIdPrefix}.copy-button-${calendarId}`
    }, formatMessage((0, $lrHmu.default).copyCalendars))), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onToggleDetails,
        testId: `${$1674dae3fdb824b0$var$dataTestIdPrefix}.toggle-button-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
        label: formatMessage((0, $lrHmu.default).hideDetails, {
            name: name
        })
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onToggleDetails,
        testId: `${$1674dae3fdb824b0$var$dataTestIdPrefix}.toggle-button-${calendarId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1674dae3fdb824b0$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $lrHmu.default).showDetails, {
            name: name
        })
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4BaYU.DeleteCalendarModal), {
        key: calendarId,
        isOpen: isDeleteModalOpen,
        onClose: toggleDeleteModal,
        calendarId: calendarId,
        calendarName: name,
        baseUrl: baseUrl,
        onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
        isOtherProjectCalendar: true
    }));
};
const $1674dae3fdb824b0$export$2be3845b1fbede5d = (0, $giAhk.injectIntlV2)($1674dae3fdb824b0$var$SummaryViewOtherProjectCalendars); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1674dae3fdb824b0$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3i8vuz _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $1674dae3fdb824b0$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1674dae3fdb824b0$var$ChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1674dae3fdb824b0$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybpxbi _k48pbfng _zg8l4jg8 _1nx94jg8 _1dyz4jg8 _syazaj1x _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1674dae3fdb824b0$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syazjjyb _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1674dae3fdb824b0$var$CalendarInfoContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazaj1x _1wybu2gc _k48powjs _18u01b66 _ca0q1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4BaYU", function(module, exports) {

$parcel$export(module.exports, "DeleteCalendarModal", () => $d8cecbb5a8c767f6$export$1d4a842ea8eddeef);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $giAhk = parcelRequire("giAhk");

var $k2StT = parcelRequire("k2StT");

var $g29m0 = parcelRequire("g29m0");
const $d8cecbb5a8c767f6$var$DeleteCalendarModalComponent = ({ baseUrl: baseUrl, isOpen: isOpen, onClose: onClose, calendarName: calendarName, calendarId: calendarId, onDeleteCalendarSuccessful: onDeleteCalendarSuccessful, isOtherProjectCalendar: isOtherProjectCalendar, intl: { formatMessage: formatMessage } })=>{
    const [{ loading: loading, error: error }, { deleteCalendar: deleteCalendar }] = (0, $k2StT.useDeleteCalendarService)(baseUrl);
    const handleDeleteCalendarClick = (0, $eUqFw.useCallback)(async ()=>{
        const response = await deleteCalendar(calendarId, isOtherProjectCalendar);
        if (response) {
            // Calling onClose to toggle DeleteCalendarModal
            onClose();
            onDeleteCalendarSuccessful(calendarId);
        }
    }, [
        deleteCalendar,
        calendarId,
        isOtherProjectCalendar,
        onClose,
        onDeleteCalendarSuccessful
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        // @ts-expect-error - Property 'loading' does not exist on props
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $g29m0.default).deleteCalendarModalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $g29m0.default).deleteCalendarModalBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, calendarName)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $g29m0.default).errorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleDeleteCalendarClick,
        appearance: "primary",
        testId: "servicedesk-sla-settings.ui.calendars.summary-with-actions.delete-modal.delete-calendar-button"
    }, formatMessage((0, $g29m0.default).deleteButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage((0, $g29m0.default).cancelButton))))));
};
const $d8cecbb5a8c767f6$export$1d4a842ea8eddeef = (0, $giAhk.injectIntlV2)($d8cecbb5a8c767f6$var$DeleteCalendarModalComponent);

});
parcelRegister("k2StT", function(module, exports) {

$parcel$export(module.exports, "useDeleteCalendarService", () => $84774ebc36af2c79$export$92804b2d556bc0a0);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $jAKBz = parcelRequire("jAKBz");
const $84774ebc36af2c79$export$92804b2d556bc0a0 = (baseUrl)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const deleteCalendar = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'isOtherProjectCalendar' implicitly has an 'any' type.
    async (calendarId, isOtherProjectCalendar)=>{
        setLoading(true);
        setError(null);
        try {
            await (0, $fV97Z.performDeleteRequest)((0, $jAKBz.getUrl)(baseUrl, calendarId));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaCalendar deleted', {
                isOtherProjectCalendar: isOtherProjectCalendar
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useDeleteCalendarService',
                packageName: 'jiraServicedeskSlaSettings',
                attributes: {
                    isOtherProjectCalendar: isOtherProjectCalendar
                }
            });
            return false;
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
            error
        },
        {
            deleteCalendar: deleteCalendar
        }
    ];
};

});
parcelRegister("jAKBz", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $10c651897b252dcb$export$94df0e59ebebf4a7);
const $10c651897b252dcb$export$94df0e59ebebf4a7 = (baseUrl, calendarId)=>`${baseUrl}/rest/workinghours/1/api/calendar/${calendarId}?operation=deleteCalendar`;

});


parcelRegister("g29m0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22d45626614408b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e22d45626614408b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleteCalendarModalHeader: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-calendar-modal-header",
        "defaultMessage": "Delete Calendar"
    },
    deleteCalendarModalBody: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-calendar-modal-body",
        "defaultMessage": "Are you sure you wish to delete this calendar:"
    },
    deleteButton: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-button",
        "defaultMessage": "Confirm"
    },
    cancelButton: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    errorMessage: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.error-message",
        "defaultMessage": "Something has gone wrong. An error has occurred."
    }
});

});


parcelRegister("lrHmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2a9a47ea0e8e26f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a2a9a47ea0e8e26f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    more: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.more",
        "defaultMessage": "More actions for {name}"
    },
    editCalendar: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.edit-calendar",
        "defaultMessage": "Edit"
    },
    deleteCalendar: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.delete-calendar",
        "defaultMessage": "Delete"
    },
    activeCalendar: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.active-calendar",
        "defaultMessage": "In use"
    },
    showDetails: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.show-details",
        "defaultMessage": "Show details of {name}"
    },
    hideDetails: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.hide-details",
        "defaultMessage": "Hide details of {name}"
    },
    copyCalendars: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.copy-calendars",
        "defaultMessage": "Copy to this service project"
    },
    cloneCalendars: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.clone-calendars",
        "defaultMessage": "Copy"
    },
    createdOn: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.created-on",
        "defaultMessage": "Created on {date}"
    },
    updatedOn: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.updated-on",
        "defaultMessage": "Updated on {date}"
    },
    from: {
        "id": "servicedesk-sla-settings.calendars.summary-with-actions.from",
        "defaultMessage": "from {serviceDeskName}"
    }
});

});





parcelRegister("62wyb", function(module, exports) {

$parcel$export(module.exports, "CalendarModalDialog", () => $5e3d83f522ebe420$export$1e5e9fb7a5ac48b5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kGQen = parcelRequire("kGQen");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ebD7Y = parcelRequire("ebD7Y");

var $9TZwM = parcelRequire("9TZwM");
const $5e3d83f522ebe420$var$CalendarModalDialogView = ({ isOpen: isOpen, canCreate: canCreate, onClose: onClose, onAddCalendar: onAddCalendar, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebD7Y.HasPermission), {
        hasPermission: canCreate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onAddCalendar,
        testId: "servicedesk-sla-settings.ui.calendars.modal.add-button"
    }, formatMessage((0, $9TZwM.default).addCalendar))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose,
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Close"
        }),
        testId: "servicedesk-sla-settings.ui.calendars.modal.close-button"
    }));
    const header = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e3d83f522ebe420$var$HeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
            actions: actions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $5e3d83f522ebe420$var$calendarHeadingStyles
        }, formatMessage((0, $9TZwM.default).caledarTitle))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        height: "100%",
        autoFocus: true,
        onClose: onClose
    }, header(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, children))));
};
const $5e3d83f522ebe420$export$1e5e9fb7a5ac48b5 = $5e3d83f522ebe420$var$CalendarModalDialogView; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e3d83f522ebe420$var$HeaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41lhn",
            __cmplp.className
        ])
    });
});
const $5e3d83f522ebe420$var$calendarHeadingStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("9TZwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df4c77c5b19cc85$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4df4c77c5b19cc85$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    caledarTitle: {
        "id": "servicedesk-sla-settings.calendars.modal.caledar-title",
        "defaultMessage": "Calendars"
    },
    addCalendar: {
        "id": "servicedesk-sla-settings.calendars.modal.add-calendar",
        "defaultMessage": "Add calendar"
    }
});

});


parcelRegister("e9FBZ", function(module, exports) {

$parcel$export(module.exports, "useCalendarsModalStateAndActions", () => $aa6b0e210e172b5e$export$fd8363fb3a91f187);

var $eUqFw = parcelRequire("eUqFw");

var $7d1RI = parcelRequire("7d1RI");

var $6vO9v = parcelRequire("6vO9v");

var $dFULG = parcelRequire("dFULG");

var $iSEfF = parcelRequire("iSEfF");

var $jwvob = parcelRequire("jwvob");

var $cFNve = parcelRequire("cFNve");

var $eEjes = parcelRequire("eEjes");
const $aa6b0e210e172b5e$export$fd8363fb3a91f187 = (isCalendarModalOpen, onToggleCalendarModal)=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const [selectedCalendarId, setSelectedCalendarId] = (0, $eUqFw.useState)();
    const [selectedCalendarMode, setSelectedCalendarMode] = (0, $eUqFw.useState)((0, $6vO9v.VIEW_MODE));
    const [permissionsWithTimezoneInfo, setPermissionsWithTimezoneInfo] = (0, $eUqFw.useState)();
    const [calendars, setCalendars] = (0, $eUqFw.useState)();
    // @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $cFNve.useWorkingHoursService)(baseUrl, projectKey);
    const [{ data: metricsResource }, { update: updateCalendarsDataInMetricResource }] = (0, $jwvob.useMetricResource)();
    const [{ showNavBlocker: showNavBlocker }, { setNextCalendarActionCallback: setNextCalendarActionCallback }] = (0, $iSEfF.useFormContext)();
    const [copyCalendarData, setCopyCalendarData] = (0, $eUqFw.useState)(); // state for holding calendars from both the current and other service desk projects
    const { calendarSaveSuccessFlag: calendarSaveSuccessFlag, calendarDeleteSuccessFlag: calendarDeleteSuccessFlag } = (0, $dFULG.useSLAConfigActionsFlags)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (isCalendarModalOpen && !data && !loading) await fetch();
        };
        fetchData();
    }, [
        calendars,
        data,
        fetch,
        isCalendarModalOpen,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data) {
            const { calendars: calendarData, ...permissionsAndTimezoneData } = data;
            setCalendars(calendarData);
            setPermissionsWithTimezoneInfo(permissionsAndTimezoneData);
        }
    }, [
        data
    ]);
    // Metric list uses calendarRefs resource data
    // on successful update to the calendar update the resource to reflect the same in metrics
    const updateCalendarsData = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'updatedCalendarList' implicitly has an 'any' type.
    (updatedCalendarList)=>{
        setCalendars(updatedCalendarList);
        updateCalendarsDataInMetricResource((previous)=>({
                ...previous,
                calendarRefs: (0, $eEjes.transformToCalendarRefs)(updatedCalendarList, metricsResource?.calendarRefs)
            }));
    }, [
        metricsResource,
        updateCalendarsDataInMetricResource
    ]);
    const resetNextCalendarActionCallback = (0, $eUqFw.useCallback)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setNextCalendarActionCallback(()=>{});
    }, [
        setNextCalendarActionCallback
    ]);
    const onToggleViewRequestedHelper = (0, $eUqFw.useCallback)((calendarId)=>{
        const shouldCollapse = selectedCalendarId === calendarId && selectedCalendarMode !== (0, $6vO9v.COLLAPSED_MODE);
        if (shouldCollapse) {
            setSelectedCalendarId(undefined);
            setSelectedCalendarMode((0, $6vO9v.COLLAPSED_MODE));
        } else {
            setSelectedCalendarId(calendarId);
            setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
        }
    }, [
        selectedCalendarId,
        selectedCalendarMode
    ]);
    // onToggleViewRequested verify whether form is dirty or not
    // if form is dirty show confirmation modal
    const onToggleViewRequested = (0, $eUqFw.useCallback)((calendarId)=>{
        if (showNavBlocker) {
            // This would add the onToggleViewRequested method to the calendar callback
            setNextCalendarActionCallback(()=>{
                onToggleViewRequestedHelper(calendarId);
                resetNextCalendarActionCallback();
            });
            showNavBlocker();
        } else onToggleViewRequestedHelper(calendarId);
    }, [
        showNavBlocker,
        setNextCalendarActionCallback,
        onToggleViewRequestedHelper,
        resetNextCalendarActionCallback
    ]);
    const onEditRequestedHelper = (0, $eUqFw.useCallback)((calendarId)=>{
        setSelectedCalendarId(calendarId);
        setSelectedCalendarMode((0, $6vO9v.EDIT_MODE));
    }, []);
    // onEditRequested verify whether form is dirty or not
    // if form is dirty show confirmation modal
    const onEditRequested = (0, $eUqFw.useCallback)((calendarId)=>{
        // if nav blocker is in place assume app has a nav blocker in place
        // nav blocker needs to be displayed on change mode actions
        if (showNavBlocker) {
            // This would add the onEditRequested method to the calendar callback
            setNextCalendarActionCallback(()=>{
                onEditRequestedHelper(calendarId);
                resetNextCalendarActionCallback();
            });
            showNavBlocker();
        } else onEditRequestedHelper(calendarId);
    }, [
        onEditRequestedHelper,
        resetNextCalendarActionCallback,
        setNextCalendarActionCallback,
        showNavBlocker
    ]);
    const onCreateNewRequestedHelper = (0, $eUqFw.useCallback)(()=>{
        setSelectedCalendarId(undefined);
        setSelectedCalendarMode((0, $6vO9v.NEW_MODE));
    }, []);
    // onCreateNewRequested verify whether form is dirty or not
    // if form is dirty show confirmation modal
    const onCreateNewRequested = (0, $eUqFw.useCallback)(()=>{
        if (showNavBlocker) {
            // This would add the onCreateNewRequested method to the calendar callback
            setNextCalendarActionCallback(()=>{
                onCreateNewRequestedHelper();
                resetNextCalendarActionCallback();
            });
            showNavBlocker();
        } else onCreateNewRequestedHelper();
    }, [
        onCreateNewRequestedHelper,
        resetNextCalendarActionCallback,
        setNextCalendarActionCallback,
        showNavBlocker
    ]);
    // onEditCalendarSuccessful is invoked after modifyCalendar Async is successful
    const onEditCalendarSuccessful = (0, $eUqFw.useCallback)((modifiedCalendar)=>{
        // @ts-expect-error - TS2488 - Type 'unknown' must have a '[Symbol.iterator]()' method that returns an iterator.
        const updatedCalendarList = [
            ...calendars || []
        ];
        const modifiedIndex = updatedCalendarList.findIndex(({ id: id })=>id === modifiedCalendar.id);
        //  for new calendar en try append the data to calendar refs
        //  else replace the calendar data
        if (modifiedIndex === -1) updatedCalendarList.push(modifiedCalendar);
        else updatedCalendarList.splice(modifiedIndex, 1, modifiedCalendar);
        setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
        updateCalendarsData(updatedCalendarList);
        calendarSaveSuccessFlag(modifiedCalendar.name, modifiedIndex === -1);
    }, [
        calendars,
        updateCalendarsData,
        calendarSaveSuccessFlag
    ]);
    // onDeleteCalendarSuccessful is invoked after deleteCalendar Async is successful
    const onDeleteCalendarSuccessful = (0, $eUqFw.useCallback)((calendarID)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const deletedCalendar = calendars?.find((calendar)=>calendar.id === calendarID);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const updatedCalendarList = calendars?.filter((calendar)=>calendarID !== calendar.id);
        setCalendars(updatedCalendarList);
        updateCalendarsData(updatedCalendarList);
        deletedCalendar && calendarDeleteSuccessFlag(deletedCalendar.name);
    }, [
        calendars,
        updateCalendarsData,
        calendarDeleteSuccessFlag
    ]);
    // onReset reset the state to defaults
    const onReset = (0, $eUqFw.useCallback)(()=>{
        setSelectedCalendarId(undefined);
        setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
    }, []);
    const onToggleCalendarModalWithNavBlocker = (0, $eUqFw.useCallback)(async ()=>{
        if (showNavBlocker) {
            setNextCalendarActionCallback(()=>{
                setSelectedCalendarId(undefined);
                setSelectedCalendarMode((0, $6vO9v.COLLAPSED_MODE));
                onToggleCalendarModal(); // Add the next callback
                resetNextCalendarActionCallback();
            });
            showNavBlocker();
        } else onToggleCalendarModal();
    }, [
        showNavBlocker,
        setNextCalendarActionCallback,
        onToggleCalendarModal,
        resetNextCalendarActionCallback
    ]);
    const setCopyOrCloneCalendarDataUtil = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (calendar, mode)=>{
        setSelectedCalendarMode(mode);
        setSelectedCalendarId(undefined);
        setCopyCalendarData(calendar);
    }, []);
    // This is for copying calendars from other service desk projects
    const onCopyCalendar = (0, $eUqFw.useCallback)((copyCalendar)=>{
        setCopyOrCloneCalendarDataUtil(copyCalendar, (0, $6vO9v.COPY_MODE));
    }, [
        setCopyOrCloneCalendarDataUtil
    ]);
    const onCloneCalendar = (0, $eUqFw.useCallback)((copyCalendar)=>{
        setCopyOrCloneCalendarDataUtil(copyCalendar, (0, $6vO9v.CLONE_MODE));
    }, [
        setCopyOrCloneCalendarDataUtil
    ]);
    const state = {
        selectedCalendarId: selectedCalendarId,
        selectedCalendarMode: selectedCalendarMode,
        permissionsWithTimezoneInfo: permissionsWithTimezoneInfo,
        calendars: calendars,
        isLoading: loading,
        isError: Boolean(error),
        copyCalendarData: copyCalendarData
    };
    const actions = {
        onToggleViewRequested: onToggleViewRequested,
        onEditRequested: onEditRequested,
        onCreateNewRequested: onCreateNewRequested,
        onEditCalendarSuccessful: onEditCalendarSuccessful,
        onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
        onReset: onReset,
        onToggleCalendarModalWithNavBlocker: onToggleCalendarModalWithNavBlocker,
        onCopyCalendar: onCopyCalendar,
        onCloneCalendar: onCloneCalendar
    };
    // @ts-expect-error - TS2322 - Type '{ selectedCalendarId: unknown; selectedCalendarMode: string; permissionsWithTimezoneInfo: unknown; calendars: unknown; isLoading: boolean; isError: boolean; copyCalendarData: unknown; }' is not assignable to type 'CalendarsModalState'.
    return [
        state,
        actions
    ];
};

});
parcelRegister("cFNve", function(module, exports) {

$parcel$export(module.exports, "useWorkingHoursService", () => $040155d31c689772$export$cc67fe85f8ee0460);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $3cieY = parcelRequire("3cieY");
const $040155d31c689772$export$cc67fe85f8ee0460 = (baseUrl, projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [data, setData] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $fV97Z.performGetRequest)((0, $3cieY.getUrl)(baseUrl, projectKey));
            const workingHours = (0, $3cieY.transformResponse)(response);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'slaCalendar viewed', {
                numberOfCalendars: workingHours?.calendars.length
            });
            setData(workingHours);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useWorkingHoursService',
                packageName: 'jiraServicedeskSlaSettings'
            });
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'WorkingHoursServiceData'.
            data
        },
        {
            fetch: fetch
        }
    ];
};

});

parcelRegister("eEjes", function(module, exports) {

$parcel$export(module.exports, "transformToCalendarRefs", () => $13436ce51c06a9f7$export$d11c1ccbd103318d);
const $13436ce51c06a9f7$export$d11c1ccbd103318d = (updatedCalendarsList = [], calendarRefsInResource = [])=>{
    const defaultCalendar = calendarRefsInResource.find((calendar)=>calendar.default);
    const transformedCalendarRefs = updatedCalendarsList.map(({ id: id, name: name })=>({
            id: id,
            name: name,
            default: false
        }));
    if (!defaultCalendar) return transformedCalendarRefs;
    return [
        ...transformedCalendarRefs,
        defaultCalendar
    ];
};

});


parcelRegister("9aWE0", function(module, exports) {

$parcel$export(module.exports, "OtherProjectCalendarList", () => $3d9d41a87301f572$export$bb164615eb5f5f80);

var $eUqFw = parcelRequire("eUqFw");

var $c7H0g = parcelRequire("c7H0g");

var $lGLse = parcelRequire("lGLse");

var $6vO9v = parcelRequire("6vO9v");

var $gDsgM = parcelRequire("gDsgM");

var $1N4bZ = parcelRequire("1N4bZ");

var $aqeGo = parcelRequire("aqeGo");

var $kgQcB = parcelRequire("kgQcB");

var $eu0UR = parcelRequire("eu0UR");
const $3d9d41a87301f572$export$dd4cdcaeba49a9e6 = ({ calendar: calendar, permissionsWithTimezone: permissionsWithTimezone, isSelected: isSelected, selectedCalendarMode: selectedCalendarMode, calendarsActions: calendarsActions })=>{
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { id: id } = calendar;
    const { onToggleViewRequested: onToggleViewRequested, onSelectThisCalendarTab: onSelectThisCalendarTab, onCopyCalendar: onCopyCalendar, onEditCalendarSuccessful: onEditCalendarSuccessful, onEditRequested: onEditRequested, onReset: onReset, onDeleteCalendarSuccessful: onDeleteCalendarSuccessful } = calendarsActions;
    const mode = isSelected ? selectedCalendarMode : (0, $6vO9v.COLLAPSED_MODE);
    const userTimezone = (loggedInUser && loggedInUser.timeZone) ?? (0, $gDsgM.DEFAULT_TIMEZONE);
    const dataTestId = `servicedesk-sla-settings.ui.reusable-sla-calendars.calendar-${id}`;
    switch(mode){
        case 0, $6vO9v.VIEW_MODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1N4bZ.CalendarContainer), {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eu0UR.OtherProjectCalendarsSummary), {
                calendar: calendar,
                onToggleDetails: ()=>onToggleViewRequested(id),
                onSelectThisCalendarTab: onSelectThisCalendarTab,
                onCopyCalendar: onCopyCalendar,
                canCopyCalendar: permissionsWithTimezone.canCreate,
                onEditRequested: ()=>onEditRequested(id),
                onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
                isJiraAdmin: isJiraAdmin,
                userTimeZone: userTimezone,
                isOpen: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqeGo.CalendarView), {
                calendar: calendar,
                permissionsWithTimezone: permissionsWithTimezone
            }));
        case 0, $6vO9v.OTHER_PROJECT_CALENDARS_EDIT_MODE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1N4bZ.CalendarContainer), {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgQcB.CalendarForm), {
                allTimezones: permissionsWithTimezone.allTimezones,
                defaultTimezone: permissionsWithTimezone.defaultTimezone,
                calendarData: calendar,
                onCancel: onReset,
                onEditCalendarSuccessful: onEditCalendarSuccessful,
                // @ts-expect-error - TS2322 - Type '"other_project_calendars_edit_mode"' is not assignable to type 'Mode'.
                calendarMode: mode
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1N4bZ.CalendarContainer), {
                "data-test-id": dataTestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eu0UR.OtherProjectCalendarsSummary), {
                calendar: calendar,
                onToggleDetails: ()=>onToggleViewRequested(id),
                onSelectThisCalendarTab: onSelectThisCalendarTab,
                onCopyCalendar: onCopyCalendar,
                canCopyCalendar: permissionsWithTimezone.canCreate,
                onEditRequested: ()=>onEditRequested(id),
                onDeleteCalendarSuccessful: onDeleteCalendarSuccessful,
                isJiraAdmin: isJiraAdmin,
                userTimeZone: userTimezone,
                isOpen: false
            }));
    }
};
const $3d9d41a87301f572$export$bb164615eb5f5f80 = ({ calendars: calendars, permissionsWithTimezone: permissionsWithTimezone, selectedCalendarMode: selectedCalendarMode, calendarsActions: calendarsActions, selectedCalendarId: selectedCalendarId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, calendars.reduce((calendarList, calender, calenderKey)=>{
        calendarList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d9d41a87301f572$export$dd4cdcaeba49a9e6, {
            key: calenderKey,
            calendar: calender,
            selectedCalendarMode: selectedCalendarMode,
            isSelected: selectedCalendarId === calender.id,
            permissionsWithTimezone: permissionsWithTimezone,
            calendarsActions: calendarsActions
        }));
        return calendarList;
    }, []));

});

parcelRegister("4mHKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f90b2c7095b2360$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f90b2c7095b2360$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    thisServiceProject: {
        "id": "servicedesk-sla-settings.reusable-calendars.this-service-project",
        "defaultMessage": "This service project"
    },
    otherCalendarsTabTitle: {
        "id": "servicedesk-sla-settings.reusable-calendars.other-calendars-tab-title",
        "defaultMessage": "Other calendars"
    },
    otherCalendarsTabTooltip: {
        "id": "servicedesk-sla-settings.reusable-calendars.other-calendars-tab-tooltip",
        "defaultMessage": "Save time by copying calendars from other service projects"
    }
});

});

parcelRegister("lWEg2", function(module, exports) {

$parcel$export(module.exports, "useCalendarsModalStateAndActionsOtherCalendars", () => $8579931275744bfe$export$b50da212ea2af10f);

var $eUqFw = parcelRequire("eUqFw");

var $7d1RI = parcelRequire("7d1RI");

var $6vO9v = parcelRequire("6vO9v");

var $dFULG = parcelRequire("dFULG");

var $bBcMB = parcelRequire("bBcMB");
const $8579931275744bfe$export$b50da212ea2af10f = (isCalendarModalOpen, isOtherCalendarsTabSelected)=>{
    const { baseUrl: baseUrl, projectKey: projectKey } = (0, $7d1RI.useCommonPageContext)();
    const [selectedCalendarId, setSelectedCalendarId] = (0, $eUqFw.useState)();
    const [selectedCalendarMode, setSelectedCalendarMode] = (0, $eUqFw.useState)((0, $6vO9v.VIEW_MODE));
    const [calendars, setCalendars] = (0, $eUqFw.useState)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $bBcMB.useWorkingHoursServiceOtherProjectCalendars)(// @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    baseUrl, projectKey);
    const [permissionsWithTimezoneInfo, setPermissionsWithTimezoneInfo] = (0, $eUqFw.useState)();
    const { calendarSaveSuccessFlag: calendarSaveSuccessFlag, calendarDeleteSuccessFlag: calendarDeleteSuccessFlag } = (0, $dFULG.useSLAConfigActionsFlags)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            if (isCalendarModalOpen && isOtherCalendarsTabSelected() && !data && !error) await fetch();
        };
        fetchData();
    }, [
        data,
        error,
        fetch,
        isCalendarModalOpen,
        isOtherCalendarsTabSelected,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data) {
            const { calendars: calendarData, ...permissionsAndTimezoneData } = data;
            setCalendars(calendarData);
            setPermissionsWithTimezoneInfo(permissionsAndTimezoneData);
        }
    }, [
        data
    ]);
    const onToggleViewRequestedHelper = (0, $eUqFw.useCallback)((calendarId)=>{
        const shouldCollapse = selectedCalendarId === calendarId && selectedCalendarMode !== (0, $6vO9v.COLLAPSED_MODE);
        if (shouldCollapse) {
            setSelectedCalendarId(undefined);
            setSelectedCalendarMode((0, $6vO9v.COLLAPSED_MODE));
        } else {
            setSelectedCalendarId(calendarId);
            setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
        }
    }, [
        selectedCalendarId,
        selectedCalendarMode
    ]);
    const onToggleViewRequested = (0, $eUqFw.useCallback)((calendarId)=>{
        onToggleViewRequestedHelper(calendarId);
    }, [
        onToggleViewRequestedHelper
    ]);
    const onEditRequestedHelper = (0, $eUqFw.useCallback)((calendarId)=>{
        setSelectedCalendarId(calendarId);
        setSelectedCalendarMode((0, $6vO9v.OTHER_PROJECT_CALENDARS_EDIT_MODE));
    }, []);
    const onEditRequested = (0, $eUqFw.useCallback)((calendarId)=>{
        onEditRequestedHelper(calendarId);
    }, [
        onEditRequestedHelper
    ]);
    // onEditCalendarSuccessful is invoked after modifyCalendar Async is successful
    const onEditCalendarSuccessful = (0, $eUqFw.useCallback)((modifiedCalendar)=>{
        // @ts-expect-error - TS2488 - Type 'unknown' must have a '[Symbol.iterator]()' method that returns an iterator.
        const updatedCalendarList = [
            ...calendars || []
        ];
        const modifiedIndex = updatedCalendarList.findIndex(({ id: id })=>id === modifiedCalendar.id);
        if (modifiedIndex === -1) updatedCalendarList.push(modifiedCalendar);
        else updatedCalendarList.splice(modifiedIndex, 1, modifiedCalendar);
        setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
        setCalendars(updatedCalendarList);
        calendarSaveSuccessFlag(modifiedCalendar?.name, false); // Since calendars of other projects can only be edited
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        calendars
    ]);
    // onReset reset the state to defaults
    const onReset = (0, $eUqFw.useCallback)(()=>{
        setSelectedCalendarId(undefined);
        setSelectedCalendarMode((0, $6vO9v.VIEW_MODE));
    }, []);
    // onDeleteCalendarSuccessful is invoked after deleteCalendar Async is successful
    const onDeleteCalendarSuccessful = (0, $eUqFw.useCallback)((calendarID)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const deletedCalendar = calendars?.find((calendar)=>calendar.id === calendarID);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const updatedCalendarList = calendars?.filter((calendar)=>calendarID !== calendar.id);
        setCalendars(updatedCalendarList);
        deletedCalendar && calendarDeleteSuccessFlag(deletedCalendar.name);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        calendars
    ]);
    const state = {
        selectedCalendarId: selectedCalendarId,
        selectedCalendarMode: selectedCalendarMode,
        calendars: calendars,
        isLoading: loading,
        isError: Boolean(error),
        permissionsWithTimezoneInfo: permissionsWithTimezoneInfo
    };
    const actions = {
        onToggleViewRequested: onToggleViewRequested,
        onReset: onReset,
        onEditRequested: onEditRequested,
        onEditCalendarSuccessful: onEditCalendarSuccessful,
        onDeleteCalendarSuccessful: onDeleteCalendarSuccessful
    };
    // @ts-expect-error - TS2322 - Type '{ selectedCalendarId: unknown; selectedCalendarMode: OtherProjectCalendarMode; calendars: unknown; isLoading: boolean; isError: boolean; permissionsWithTimezoneInfo: unknown; }' is not assignable to type 'OtherProjectCalendarsModalState'.
    return [
        state,
        actions
    ];
};

});
parcelRegister("bBcMB", function(module, exports) {

$parcel$export(module.exports, "useWorkingHoursServiceOtherProjectCalendars", () => $e64da76b8eeb30c8$export$634d31842fe1ae1a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fV97Z = parcelRequire("fV97Z");

var $2kRnk = parcelRequire("2kRnk");
const $e64da76b8eeb30c8$export$634d31842fe1ae1a = (baseUrl, projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [data, setData] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $fV97Z.performGetRequest)((0, $2kRnk.getUrl)(baseUrl, projectKey));
            const workingHours = (0, $2kRnk.transformResponse)(response);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'OtherProjectSlaCalendars viewed', {
                siteCalendarCount: workingHours.calendars.length
            });
            setData(workingHours);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $guiFP.trackFetchErrors)({
                error: err,
                id: 'useWorkingHoursServiceOtherProjectCalendars',
                packageName: 'jiraServicedeskSlaSettings'
            });
        } finally{
            setLoading(false);
        }
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectKey
    ]);
    return [
        {
            loading: loading,
            error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ServiceError | undefined'.
            error,
            data: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'OtherProjectWorkingHoursServiceData'.
            data
        },
        {
            fetch: fetch
        }
    ];
};

});





parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});







//# sourceMappingURL=async-project-settings-service-desk-sla-settings.2139beb5.js.map
